var Rz = Object.defineProperty;
var Iz = (n, e, t) => e in n ? Rz(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Zt = (n, e, t) => Iz(n, typeof e != "symbol" ? e + "" : e, t);
import { jsx as b, jsxs as j, Fragment as ln } from "react/jsx-runtime";
import { FileSelectorModal as xl, imageToFile as Pz, useFileUploaderManager as jz, isAcceptTypeValid as yc, fileInputAcceptTypes as vc, FileTypeEnum as xc, FileSourceEnum as Bz } from "@systemeio/file-manager";
import * as Kn from "react";
import _e, { useRef as Oi, useState as xe, useDebugValue as hh, useEffect as Ge, forwardRef as Fz, useLayoutEffect as qz, createContext as Sl, useContext as fh, useMemo as we, useTransition as Hz, Fragment as Vz, useCallback as Uz } from "react";
import Wz, { flushSync as ph } from "react-dom";
import { twMerge as K, twJoin as Ee } from "tailwind-merge";
import { Hint as wl, LanguageCodeEnum as Na, FormInputUrl as mh, Tooltip as ne, FormInput as Kz, toast as ao, ListBoxSelect as Ft, Popover as go, FormSelectInline as Sc, ColorPicker as _o, NeutralButton as gh, NeutralTypeEnum as _h, PrimaryButton as bo } from "@systemeio/ui";
import { CheckIcon as Cl, ArrowDownIcon as bh, CloseIcon as kh, DotsIcon as Zz } from "@systemeio/ui/icons";
import { isValidUrl as yh, normalizeToHex as Tl } from "@systemeio/util";
import { FocusTrapFeatures as ko, FocusTrap as vh } from "@headlessui/react";
var T = /* @__PURE__ */ ((n) => (n.Document = "Document", n.Paragraph = "Paragraph", n.Text = "Text", n.TextStyle = "TextStyle", n.FontFamily = "FontFamily", n.Heading = "Heading", n.Bold = "Bold", n.Italic = "Italic", n.Strike = "Strike", n.Underline = "Underline", n.BulletList = "BulletList", n.OrderedList = "OrderedList", n.ListItem = "ListItem", n.TextAlign = "TextAlign", n.Link = "Link", n.SimpleLink = "SimpleLink", n.History = "History", n.TextColor = "TextColor", n.TextBackgroundColor = "TextBackgroundColor", n.FontSize = "FontSize", n.Indent = "Indent", n.HardBreak = "HardBreak", n.SimpleHardBreak = "SimpleHardBreak", n.Substitution = "Substitution", n.SpecialCharacters = "SpecialCharacters", n.Image = "Image", n.DropCursor = "DropCursor", n.CharacterCount = "CharacterCount", n))(T || {});
const ks = [
  T.Document,
  T.Paragraph,
  T.Text,
  T.History
], Gz = [
  ...ks,
  T.Bold,
  T.Italic,
  T.Strike,
  T.Underline,
  T.BulletList,
  T.OrderedList,
  T.ListItem,
  T.HardBreak
], Jz = [
  ...ks,
  ...Gz,
  T.TextStyle,
  T.FontFamily,
  T.Heading,
  T.TextAlign,
  T.Link,
  T.TextColor,
  T.TextBackgroundColor,
  T.FontSize,
  T.Indent,
  T.HardBreak,
  T.SpecialCharacters,
  T.Image,
  T.DropCursor
], Kj = [
  ...Jz,
  T.Substitution
], Zj = [
  ...ks,
  T.Substitution,
  T.CharacterCount,
  T.SimpleLink,
  T.SimpleHardBreak
];
function Be(n) {
  this.content = n;
}
Be.prototype = {
  constructor: Be,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var i = t && t != n ? this.remove(t) : this, r = i.find(n), o = i.content.slice();
    return r == -1 ? o.push(t || n, e) : (o[r + 1] = e, t && (o[r] = t)), new Be(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Be(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Be([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Be(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var i = this.remove(e), r = i.content.slice(), o = i.find(n);
    return r.splice(o == -1 ? r.length : o, 0, e, t), new Be(r);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Be.from(n), n.size ? new Be(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Be.from(n), n.size ? new Be(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Be.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Be.from = function(n) {
  if (n instanceof Be) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new Be(e);
};
function xh(n, e, t) {
  for (let i = 0; ; i++) {
    if (i == n.childCount || i == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let r = n.child(i), o = e.child(i);
    if (r == o) {
      t += r.nodeSize;
      continue;
    }
    if (!r.sameMarkup(o))
      return t;
    if (r.isText && r.text != o.text) {
      for (let s = 0; r.text[s] == o.text[s]; s++)
        t++;
      return t;
    }
    if (r.content.size || o.content.size) {
      let s = xh(r.content, o.content, t + 1);
      if (s != null)
        return s;
    }
    t += r.nodeSize;
  }
}
function Sh(n, e, t, i) {
  for (let r = n.childCount, o = e.childCount; ; ) {
    if (r == 0 || o == 0)
      return r == o ? null : { a: t, b: i };
    let s = n.child(--r), a = e.child(--o), l = s.nodeSize;
    if (s == a) {
      t -= l, i -= l;
      continue;
    }
    if (!s.sameMarkup(a))
      return { a: t, b: i };
    if (s.isText && s.text != a.text) {
      let c = 0, u = Math.min(s.text.length, a.text.length);
      for (; c < u && s.text[s.text.length - c - 1] == a.text[a.text.length - c - 1]; )
        c++, t--, i--;
      return { a: t, b: i };
    }
    if (s.content.size || a.content.size) {
      let c = Sh(s.content, a.content, t - 1, i - 1);
      if (c)
        return c;
    }
    t -= l, i -= l;
  }
}
class O {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let i = 0; i < e.length; i++)
        this.size += e[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, i, r = 0, o) {
    for (let s = 0, a = 0; a < t; s++) {
      let l = this.content[s], c = a + l.nodeSize;
      if (c > e && i(l, r + a, o || null, s) !== !1 && l.content.size) {
        let u = a + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, t - u), i, r + u);
      }
      a = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, i, r) {
    let o = "", s = !0;
    return this.nodesBetween(e, t, (a, l) => {
      let c = a.isText ? a.text.slice(Math.max(e, l) - l, t - l) : a.isLeaf ? r ? typeof r == "function" ? r(a) : r : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && c || a.isTextblock) && i && (s ? s = !1 : o += i), o += c;
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, i = e.firstChild, r = this.content.slice(), o = 0;
    for (t.isText && t.sameMarkup(i) && (r[r.length - 1] = t.withText(t.text + i.text), o = 1); o < e.content.length; o++)
      r.push(e.content[o]);
    return new O(r, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let i = [], r = 0;
    if (t > e)
      for (let o = 0, s = 0; s < t; o++) {
        let a = this.content[o], l = s + a.nodeSize;
        l > e && ((s < e || l > t) && (a.isText ? a = a.cut(Math.max(0, e - s), Math.min(a.text.length, t - s)) : a = a.cut(Math.max(0, e - s - 1), Math.min(a.content.size, t - s - 1))), i.push(a), r += a.nodeSize), s = l;
      }
    return new O(i, r);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? O.empty : e == 0 && t == this.content.length ? this : new O(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let i = this.content[e];
    if (i == t)
      return this;
    let r = this.content.slice(), o = this.size + t.nodeSize - i.nodeSize;
    return r[e] = t, new O(r, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new O([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new O(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, i = 0; t < this.content.length; t++) {
      let r = this.content[t];
      e(r, i, t), i += r.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return xh(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, i = e.size) {
    return Sh(this, e, t, i);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return Br(0, e);
    if (e == this.size)
      return Br(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, i = 0; ; t++) {
      let r = this.child(t), o = i + r.nodeSize;
      if (o >= e)
        return o == e ? Br(t + 1, o) : Br(t, i);
      i = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return O.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new O(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return O.empty;
    let t, i = 0;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      i += o.nodeSize, r && o.isText && e[r - 1].sameMarkup(o) ? (t || (t = e.slice(0, r)), t[t.length - 1] = o.withText(t[t.length - 1].text + o.text)) : t && t.push(o);
    }
    return new O(t || e, i);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return O.empty;
    if (e instanceof O)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new O([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
O.empty = new O([], 0);
const Us = { index: 0, offset: 0 };
function Br(n, e) {
  return Us.index = n, Us.offset = e, Us;
}
function yo(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let i = 0; i < n.length; i++)
      if (!yo(n[i], e[i]))
        return !1;
  } else {
    for (let i in n)
      if (!(i in e) || !yo(n[i], e[i]))
        return !1;
    for (let i in e)
      if (!(i in n))
        return !1;
  }
  return !0;
}
let fe = class Da {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, i = !1;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      if (this.eq(o))
        return e;
      if (this.type.excludes(o.type))
        t || (t = e.slice(0, r));
      else {
        if (o.type.excludes(this.type))
          return e;
        !i && o.type.rank > this.type.rank && (t || (t = e.slice(0, r)), t.push(this), i = !0), t && t.push(o);
      }
    }
    return t || (t = e.slice()), i || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && yo(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let i = e.marks[t.type];
    if (!i)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let r = i.create(t.attrs);
    return i.checkAttrs(r.attrs), r;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let i = 0; i < e.length; i++)
      if (!e[i].eq(t[i]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Da.none;
    if (e instanceof Da)
      return [e];
    let t = e.slice();
    return t.sort((i, r) => i.type.rank - r.type.rank), t;
  }
};
fe.none = [];
class vo extends Error {
}
class N {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, i) {
    this.content = e, this.openStart = t, this.openEnd = i;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let i = Ch(this.content, e + this.openStart, t);
    return i && new N(i, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new N(wh(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return N.empty;
    let i = t.openStart || 0, r = t.openEnd || 0;
    if (typeof i != "number" || typeof r != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new N(O.fromJSON(e, t.content), i, r);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let i = 0, r = 0;
    for (let o = e.firstChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.firstChild)
      i++;
    for (let o = e.lastChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.lastChild)
      r++;
    return new N(e, i, r);
  }
}
N.empty = new N(O.empty, 0, 0);
function wh(n, e, t) {
  let { index: i, offset: r } = n.findIndex(e), o = n.maybeChild(i), { index: s, offset: a } = n.findIndex(t);
  if (r == e || o.isText) {
    if (a != t && !n.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (i != s)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(i, o.copy(wh(o.content, e - r - 1, t - r - 1)));
}
function Ch(n, e, t, i) {
  let { index: r, offset: o } = n.findIndex(e), s = n.maybeChild(r);
  if (o == e || s.isText)
    return i && !i.canReplace(r, r, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let a = Ch(s.content, e - o - 1, t, s);
  return a && n.replaceChild(r, s.copy(a));
}
function Yz(n, e, t) {
  if (t.openStart > n.depth)
    throw new vo("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new vo("Inconsistent open depths");
  return Th(n, e, t, 0);
}
function Th(n, e, t, i) {
  let r = n.index(i), o = n.node(i);
  if (r == e.index(i) && i < n.depth - t.openStart) {
    let s = Th(n, e, t, i + 1);
    return o.copy(o.content.replaceChild(r, s));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == i && e.depth == i) {
      let s = n.parent, a = s.content;
      return ti(s, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: s, end: a } = Xz(t, n);
      return ti(o, Eh(n, s, a, e, i));
    }
  else return ti(o, xo(n, e, i));
}
function Oh(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new vo("Cannot join " + e.type.name + " onto " + n.type.name);
}
function Ra(n, e, t) {
  let i = n.node(t);
  return Oh(i, e.node(t)), i;
}
function ei(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function Ji(n, e, t, i) {
  let r = (e || n).node(t), o = 0, s = e ? e.index(t) : r.childCount;
  n && (o = n.index(t), n.depth > t ? o++ : n.textOffset && (ei(n.nodeAfter, i), o++));
  for (let a = o; a < s; a++)
    ei(r.child(a), i);
  e && e.depth == t && e.textOffset && ei(e.nodeBefore, i);
}
function ti(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function Eh(n, e, t, i, r) {
  let o = n.depth > r && Ra(n, e, r + 1), s = i.depth > r && Ra(t, i, r + 1), a = [];
  return Ji(null, n, r, a), o && s && e.index(r) == t.index(r) ? (Oh(o, s), ei(ti(o, Eh(n, e, t, i, r + 1)), a)) : (o && ei(ti(o, xo(n, e, r + 1)), a), Ji(e, t, r, a), s && ei(ti(s, xo(t, i, r + 1)), a)), Ji(i, null, r, a), new O(a);
}
function xo(n, e, t) {
  let i = [];
  if (Ji(null, n, t, i), n.depth > t) {
    let r = Ra(n, e, t + 1);
    ei(ti(r, xo(n, e, t + 1)), i);
  }
  return Ji(e, null, t, i), new O(i);
}
function Xz(n, e) {
  let t = e.depth - n.openStart, r = e.node(t).copy(n.content);
  for (let o = t - 1; o >= 0; o--)
    r = e.node(o).copy(O.from(r));
  return {
    start: r.resolveNoCache(n.openStart + t),
    end: r.resolveNoCache(r.content.size - n.openEnd - t)
  };
}
class hr {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.pos = e, this.path = t, this.parentOffset = i, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let i = this.pos - this.path[this.path.length - 1], r = e.child(t);
    return i ? e.child(t).cut(i) : r;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let i = this.path[t * 3], r = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let o = 0; o < e; o++)
      r += i.child(o).nodeSize;
    return r;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return fe.none;
    if (this.textOffset)
      return e.child(t).marks;
    let i = e.maybeChild(t - 1), r = e.maybeChild(t);
    if (!i) {
      let a = i;
      i = r, r = a;
    }
    let o = i.marks;
    for (var s = 0; s < o.length; s++)
      o[s].type.spec.inclusive === !1 && (!r || !o[s].isInSet(r.marks)) && (o = o[s--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let i = t.marks, r = e.parent.maybeChild(e.index());
    for (var o = 0; o < i.length; o++)
      i[o].type.spec.inclusive === !1 && (!r || !i[o].isInSet(r.marks)) && (i = i[o--].removeFromSet(i));
    return i;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let i = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); i >= 0; i--)
      if (e.pos <= this.end(i) && (!t || t(this.node(i))))
        return new So(this, e, i);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let i = [], r = 0, o = t;
    for (let s = e; ; ) {
      let { index: a, offset: l } = s.content.findIndex(o), c = o - l;
      if (i.push(s, a, r + l), !c || (s = s.child(a), s.isText))
        break;
      o = c - 1, r += l + 1;
    }
    return new hr(t, i, o);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let i = wc.get(e);
    if (i)
      for (let o = 0; o < i.elts.length; o++) {
        let s = i.elts[o];
        if (s.pos == t)
          return s;
      }
    else
      wc.set(e, i = new Qz());
    let r = i.elts[i.i] = hr.resolve(e, t);
    return i.i = (i.i + 1) % eA, r;
  }
}
class Qz {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const eA = 12, wc = /* @__PURE__ */ new WeakMap();
class So {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, i) {
    this.$from = e, this.$to = t, this.depth = i;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const tA = /* @__PURE__ */ Object.create(null);
let rn = class Ia {
  /**
  @internal
  */
  constructor(e, t, i, r = fe.none) {
    this.type = e, this.attrs = t, this.marks = r, this.content = i || O.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, i, r = 0) {
    this.content.nodesBetween(e, t, i, r, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, t, i, r) {
    return this.content.textBetween(e, t, i, r);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, i) {
    return this.type == e && yo(this.attrs, t || e.defaultAttrs || tA) && fe.sameSet(this.marks, i || fe.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Ia(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Ia(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, i = !1) {
    if (e == t)
      return N.empty;
    let r = this.resolve(e), o = this.resolve(t), s = i ? 0 : r.sharedDepth(t), a = r.start(s), c = r.node(s).content.cut(r.pos - a, o.pos - a);
    return new N(c, r.depth - s, o.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, i) {
    return Yz(this.resolve(e), this.resolve(t), i);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: i, offset: r } = t.content.findIndex(e);
      if (t = t.maybeChild(i), !t)
        return null;
      if (r == e || t.isText)
        return t;
      e -= r + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: i } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: i };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: i } = this.content.findIndex(e);
    if (i < e)
      return { node: this.content.child(t), index: t, offset: i };
    let r = this.content.child(t - 1);
    return { node: r, index: t - 1, offset: i - r.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return hr.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return hr.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, i) {
    let r = !1;
    return t > e && this.nodesBetween(e, t, (o) => (i.isInSet(o.marks) && (r = !0), !r)), r;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Mh(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, i = O.empty, r = 0, o = i.childCount) {
    let s = this.contentMatchAt(e).matchFragment(i, r, o), a = s && s.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let l = r; l < o; l++)
      if (!this.type.allowsMarks(i.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, i, r) {
    if (r && !this.type.allowsMarks(r))
      return !1;
    let o = this.contentMatchAt(e).matchType(i), s = o && o.matchFragment(this.content, t);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = fe.none;
    for (let t = 0; t < this.marks.length; t++) {
      let i = this.marks[t];
      i.type.checkAttrs(i.attrs), e = i.addToSet(e);
    }
    if (!fe.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let i;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      i = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, i);
    }
    let r = O.fromJSON(e, t.content), o = e.nodeType(t.type).create(t.attrs, r, i);
    return o.type.checkAttrs(o.attrs), o;
  }
};
rn.prototype.text = void 0;
class wo extends rn {
  /**
  @internal
  */
  constructor(e, t, i, r) {
    if (super(e, t, null, r), !i)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = i;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Mh(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new wo(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new wo(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function Mh(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class si {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let i = new nA(e, t);
    if (i.next == null)
      return si.empty;
    let r = $h(i);
    i.next && i.err("Unexpected trailing text");
    let o = cA(lA(r));
    return uA(o, i), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, i = e.childCount) {
    let r = this;
    for (let o = t; r && o < i; o++)
      r = r.matchType(e.child(o).type);
    return r;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let i = 0; i < e.next.length; i++)
        if (this.next[t].type == e.next[i].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, i = 0) {
    let r = [this];
    function o(s, a) {
      let l = s.matchFragment(e, i);
      if (l && (!t || l.validEnd))
        return O.from(a.map((c) => c.createAndFill()));
      for (let c = 0; c < s.next.length; c++) {
        let { type: u, next: d } = s.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && r.indexOf(d) == -1) {
          r.push(d);
          let h = o(d, a.concat(u));
          if (h)
            return h;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let i = 0; i < this.wrapCache.length; i += 2)
      if (this.wrapCache[i] == e)
        return this.wrapCache[i + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), i = [{ match: this, type: null, via: null }];
    for (; i.length; ) {
      let r = i.shift(), o = r.match;
      if (o.matchType(e)) {
        let s = [];
        for (let a = r; a.type; a = a.via)
          s.push(a.type);
        return s.reverse();
      }
      for (let s = 0; s < o.next.length; s++) {
        let { type: a, next: l } = o.next[s];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!r.type || l.validEnd) && (i.push({ match: a.contentMatch, type: a, via: r }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(i) {
      e.push(i);
      for (let r = 0; r < i.next.length; r++)
        e.indexOf(i.next[r].next) == -1 && t(i.next[r].next);
    }
    return t(this), e.map((i, r) => {
      let o = r + (i.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < i.next.length; s++)
        o += (s ? ", " : "") + i.next[s].type.name + "->" + e.indexOf(i.next[s].next);
      return o;
    }).join(`
`);
  }
}
si.empty = new si(!0);
class nA {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function $h(n) {
  let e = [];
  do
    e.push(iA(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function iA(n) {
  let e = [];
  do
    e.push(rA(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function rA(n) {
  let e = aA(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = oA(n, e);
    else
      break;
  return e;
}
function Cc(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function oA(n, e) {
  let t = Cc(n), i = t;
  return n.eat(",") && (n.next != "}" ? i = Cc(n) : i = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: i, expr: e };
}
function sA(n, e) {
  let t = n.nodeTypes, i = t[e];
  if (i)
    return [i];
  let r = [];
  for (let o in t) {
    let s = t[o];
    s.isInGroup(e) && r.push(s);
  }
  return r.length == 0 && n.err("No node type or group '" + e + "' found"), r;
}
function aA(n) {
  if (n.eat("(")) {
    let e = $h(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = sA(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function lA(n) {
  let e = [[]];
  return r(o(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function i(s, a, l) {
    let c = { term: l, to: a };
    return e[s].push(c), c;
  }
  function r(s, a) {
    s.forEach((l) => l.to = a);
  }
  function o(s, a) {
    if (s.type == "choice")
      return s.exprs.reduce((l, c) => l.concat(o(c, a)), []);
    if (s.type == "seq")
      for (let l = 0; ; l++) {
        let c = o(s.exprs[l], a);
        if (l == s.exprs.length - 1)
          return c;
        r(c, a = t());
      }
    else if (s.type == "star") {
      let l = t();
      return i(a, l), r(o(s.expr, l), l), [i(l)];
    } else if (s.type == "plus") {
      let l = t();
      return r(o(s.expr, a), l), r(o(s.expr, l), l), [i(l)];
    } else {
      if (s.type == "opt")
        return [i(a)].concat(o(s.expr, a));
      if (s.type == "range") {
        let l = a;
        for (let c = 0; c < s.min; c++) {
          let u = t();
          r(o(s.expr, l), u), l = u;
        }
        if (s.max == -1)
          r(o(s.expr, l), l);
        else
          for (let c = s.min; c < s.max; c++) {
            let u = t();
            i(l, u), r(o(s.expr, l), u), l = u;
          }
        return [i(l)];
      } else {
        if (s.type == "name")
          return [i(a, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function zh(n, e) {
  return e - n;
}
function Tc(n, e) {
  let t = [];
  return i(e), t.sort(zh);
  function i(r) {
    let o = n[r];
    if (o.length == 1 && !o[0].term)
      return i(o[0].to);
    t.push(r);
    for (let s = 0; s < o.length; s++) {
      let { term: a, to: l } = o[s];
      !a && t.indexOf(l) == -1 && i(l);
    }
  }
}
function cA(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(Tc(n, 0));
  function t(i) {
    let r = [];
    i.forEach((s) => {
      n[s].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let c;
        for (let u = 0; u < r.length; u++)
          r[u][0] == a && (c = r[u][1]);
        Tc(n, l).forEach((u) => {
          c || r.push([a, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let o = e[i.join(",")] = new si(i.indexOf(n.length - 1) > -1);
    for (let s = 0; s < r.length; s++) {
      let a = r[s][1].sort(zh);
      o.next.push({ type: r[s][0], next: e[a.join(",")] || t(a) });
    }
    return o;
  }
}
function uA(n, e) {
  for (let t = 0, i = [n]; t < i.length; t++) {
    let r = i[t], o = !r.validEnd, s = [];
    for (let a = 0; a < r.next.length; a++) {
      let { type: l, next: c } = r.next[a];
      s.push(l.name), o && !(l.isText || l.hasRequiredAttrs()) && (o = !1), i.indexOf(c) == -1 && i.push(c);
    }
    o && e.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Ah(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let i = n[t];
    if (!i.hasDefault)
      return null;
    e[t] = i.default;
  }
  return e;
}
function Lh(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let i in n) {
    let r = e && e[i];
    if (r === void 0) {
      let o = n[i];
      if (o.hasDefault)
        r = o.default;
      else
        throw new RangeError("No value supplied for attribute " + i);
    }
    t[i] = r;
  }
  return t;
}
function Nh(n, e, t, i) {
  for (let r in e)
    if (!(r in n))
      throw new RangeError(`Unsupported attribute ${r} for ${t} of type ${r}`);
  for (let r in n) {
    let o = n[r];
    o.validate && o.validate(e[r]);
  }
}
function Dh(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let i in e)
      t[i] = new hA(n, i, e[i]);
  return t;
}
let Oc = class Rh {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.name = e, this.schema = t, this.spec = i, this.markSet = null, this.groups = i.group ? i.group.split(" ") : [], this.attrs = Dh(e, i.attrs), this.defaultAttrs = Ah(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(i.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == si.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Lh(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, i) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new rn(this, this.computeAttrs(e), O.from(t), fe.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, i) {
    return t = O.from(t), this.checkContent(t), new rn(this, this.computeAttrs(e), t, fe.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, i) {
    if (e = this.computeAttrs(e), t = O.from(t), t.size) {
      let s = this.contentMatch.fillBefore(t);
      if (!s)
        return null;
      t = s.append(t);
    }
    let r = this.contentMatch.matchFragment(t), o = r && r.fillBefore(O.empty, !0);
    return o ? new rn(this, e, t.append(o), fe.setFrom(i)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let i = 0; i < e.childCount; i++)
      if (!this.allowsMarks(e.child(i).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Nh(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let i = 0; i < e.length; i++)
      this.allowsMarkType(e[i].type) ? t && t.push(e[i]) : t || (t = e.slice(0, i));
    return t ? t.length ? t : fe.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let i = /* @__PURE__ */ Object.create(null);
    e.forEach((o, s) => i[o] = new Rh(o, t, s));
    let r = t.spec.topNode || "doc";
    if (!i[r])
      throw new RangeError("Schema is missing its top node type ('" + r + "')");
    if (!i.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in i.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return i;
  }
};
function dA(n, e, t) {
  let i = t.split("|");
  return (r) => {
    let o = r === null ? "null" : typeof r;
    if (i.indexOf(o) < 0)
      throw new RangeError(`Expected value of type ${i} for attribute ${e} on type ${n}, got ${o}`);
  };
}
class hA {
  constructor(e, t, i) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(i, "default"), this.default = i.default, this.validate = typeof i.validate == "string" ? dA(e, t, i.validate) : i.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class ys {
  /**
  @internal
  */
  constructor(e, t, i, r) {
    this.name = e, this.rank = t, this.schema = i, this.spec = r, this.attrs = Dh(e, r.attrs), this.excluded = null;
    let o = Ah(this.attrs);
    this.instance = o ? new fe(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new fe(this, Lh(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let i = /* @__PURE__ */ Object.create(null), r = 0;
    return e.forEach((o, s) => i[o] = new ys(o, r++, t, s)), i;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Nh(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Ih {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let r in e)
      t[r] = e[r];
    t.nodes = Be.from(e.nodes), t.marks = Be.from(e.marks || {}), this.nodes = Oc.compile(this.spec.nodes, this), this.marks = ys.compile(this.spec.marks, this);
    let i = /* @__PURE__ */ Object.create(null);
    for (let r in this.nodes) {
      if (r in this.marks)
        throw new RangeError(r + " can not be both a node and a mark");
      let o = this.nodes[r], s = o.spec.content || "", a = o.spec.marks;
      if (o.contentMatch = i[s] || (i[s] = si.parse(s, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!o.isInline || !o.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = o;
      }
      o.markSet = a == "_" ? null : a ? Ec(this, a.split(" ")) : a == "" || !o.inlineContent ? [] : null;
    }
    for (let r in this.marks) {
      let o = this.marks[r], s = o.spec.excludes;
      o.excluded = s == null ? [o] : s == "" ? [] : Ec(this, s.split(" "));
    }
    this.nodeFromJSON = (r) => rn.fromJSON(this, r), this.markFromJSON = (r) => fe.fromJSON(this, r), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, i, r) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Oc) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, i, r);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let i = this.nodes.text;
    return new wo(i, i.defaultAttrs, e, fe.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function Ec(n, e) {
  let t = [];
  for (let i = 0; i < e.length; i++) {
    let r = e[i], o = n.marks[r], s = o;
    if (o)
      t.push(o);
    else
      for (let a in n.marks) {
        let l = n.marks[a];
        (r == "_" || l.spec.group && l.spec.group.split(" ").indexOf(r) > -1) && t.push(s = l);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + e[i] + "'");
  }
  return t;
}
function fA(n) {
  return n.tag != null;
}
function pA(n) {
  return n.style != null;
}
class Mn {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let i = this.matchedStyles = [];
    t.forEach((r) => {
      if (fA(r))
        this.tags.push(r);
      else if (pA(r)) {
        let o = /[^=]*/.exec(r.style)[0];
        i.indexOf(o) < 0 && i.push(o), this.styles.push(r);
      }
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let o = e.nodes[r.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let i = new $c(this, t, !1);
    return i.addAll(e, fe.none, t.from, t.to), i.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let i = new $c(this, t, !0);
    return i.addAll(e, fe.none, t.from, t.to), N.maxOpen(i.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, i) {
    for (let r = i ? this.tags.indexOf(i) + 1 : 0; r < this.tags.length; r++) {
      let o = this.tags[r];
      if (_A(e, o.tag) && (o.namespace === void 0 || e.namespaceURI == o.namespace) && (!o.context || t.matchesContext(o.context))) {
        if (o.getAttrs) {
          let s = o.getAttrs(e);
          if (s === !1)
            continue;
          o.attrs = s || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, i, r) {
    for (let o = r ? this.styles.indexOf(r) + 1 : 0; o < this.styles.length; o++) {
      let s = this.styles[o], a = s.style;
      if (!(a.indexOf(e) != 0 || s.context && !i.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (s.getAttrs) {
          let l = s.getAttrs(t);
          if (l === !1)
            continue;
          s.attrs = l || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function i(r) {
      let o = r.priority == null ? 50 : r.priority, s = 0;
      for (; s < t.length; s++) {
        let a = t[s];
        if ((a.priority == null ? 50 : a.priority) < o)
          break;
      }
      t.splice(s, 0, r);
    }
    for (let r in e.marks) {
      let o = e.marks[r].spec.parseDOM;
      o && o.forEach((s) => {
        i(s = zc(s)), s.mark || s.ignore || s.clearMark || (s.mark = r);
      });
    }
    for (let r in e.nodes) {
      let o = e.nodes[r].spec.parseDOM;
      o && o.forEach((s) => {
        i(s = zc(s)), s.node || s.ignore || s.mark || (s.node = r);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Mn(e, Mn.schemaRules(e)));
  }
}
const Ph = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, mA = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, jh = { ol: !0, ul: !0 }, fr = 1, Pa = 2, Yi = 4;
function Mc(n, e, t) {
  return e != null ? (e ? fr : 0) | (e === "full" ? Pa : 0) : n && n.whitespace == "pre" ? fr | Pa : t & ~Yi;
}
class Fr {
  constructor(e, t, i, r, o, s) {
    this.type = e, this.attrs = t, this.marks = i, this.solid = r, this.options = s, this.content = [], this.activeMarks = fe.none, this.match = o || (s & Yi ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(O.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let i = this.type.contentMatch, r;
        return (r = i.findWrapping(e.type)) ? (this.match = i, r) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & fr)) {
      let i = this.content[this.content.length - 1], r;
      if (i && i.isText && (r = /[ \t\r\n\u000c]+$/.exec(i.text))) {
        let o = i;
        i.text.length == r[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - r[0].length));
      }
    }
    let t = O.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(O.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !Ph.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class $c {
  constructor(e, t, i) {
    this.parser = e, this.options = t, this.isOpen = i, this.open = 0, this.localPreserveWS = !1;
    let r = t.topNode, o, s = Mc(null, t.preserveWhitespace, 0) | (i ? Yi : 0);
    r ? o = new Fr(r.type, r.attrs, fe.none, !0, t.topMatch || r.type.contentMatch, s) : i ? o = new Fr(null, null, fe.none, !0, null, s) : o = new Fr(e.schema.topNodeType, null, fe.none, !0, null, s), this.nodes = [o], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let i = e.nodeValue, r = this.top, o = r.options & Pa ? "full" : this.localPreserveWS || (r.options & fr) > 0, { schema: s } = this.parser;
    if (o === "full" || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(i)) {
      if (o)
        if (o === "full")
          i = i.replace(/\r\n?/g, `
`);
        else if (s.linebreakReplacement && /[\r\n]/.test(i) && this.top.findWrapping(s.linebreakReplacement.create())) {
          let a = i.split(/\r?\n|\r/);
          for (let l = 0; l < a.length; l++)
            l && this.insertNode(s.linebreakReplacement.create(), t, !0), a[l] && this.insertNode(s.text(a[l]), t, !/\S/.test(a[l]));
          i = "";
        } else
          i = i.replace(/\r?\n|\r/g, " ");
      else if (i = i.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(i) && this.open == this.nodes.length - 1) {
        let a = r.content[r.content.length - 1], l = e.previousSibling;
        (!a || l && l.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (i = i.slice(1));
      }
      i && this.insertNode(s.text(i), t, !/\S/.test(i)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, i) {
    let r = this.localPreserveWS, o = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = e.nodeName.toLowerCase(), a;
    jh.hasOwnProperty(s) && this.parser.normalizeLists && gA(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, i));
    e: if (l ? l.ignore : mA.hasOwnProperty(s))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (Ph.hasOwnProperty(s))
        o.content.length && o.content[0].isInline && this.open && (this.open--, o = this.top), c = !0, o.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let d = l && l.skip ? t : this.readStyles(e, t);
      d && this.addAll(e, d), c && this.sync(o), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, t);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = r;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let i = e.style;
    if (i && i.length)
      for (let r = 0; r < this.parser.matchedStyles.length; r++) {
        let o = this.parser.matchedStyles[r], s = i.getPropertyValue(o);
        if (s)
          for (let a = void 0; ; ) {
            let l = this.parser.matchStyle(o, s, this, a);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((c) => !l.clearMark(c)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              a = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, i, r) {
    let o, s;
    if (t.node)
      if (s = this.parser.schema.nodes[t.node], s.isLeaf)
        this.insertNode(s.create(t.attrs), i, e.nodeName == "BR") || this.leafFallback(e, i);
      else {
        let l = this.enter(s, t.attrs || null, i, t.preserveWhitespace);
        l && (o = !0, i = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      i = i.concat(l.create(t.attrs));
    }
    let a = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (r)
      this.addElement(e, i, r);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, i, !1));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, i), this.findAround(e, l, !1);
    }
    o && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, i, r) {
    let o = i || 0;
    for (let s = i ? e.childNodes[i] : e.firstChild, a = r == null ? null : e.childNodes[r]; s != a; s = s.nextSibling, ++o)
      this.findAtPoint(e, o), this.addDOM(s, t);
    this.findAtPoint(e, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, i) {
    let r, o;
    for (let s = this.open, a = 0; s >= 0; s--) {
      let l = this.nodes[s], c = l.findWrapping(e);
      if (c && (!r || r.length > c.length + a) && (r = c, o = l, !c.length))
        break;
      if (l.solid) {
        if (i)
          break;
        a += 2;
      }
    }
    if (!r)
      return null;
    this.sync(o);
    for (let s = 0; s < r.length; s++)
      t = this.enterInner(r[s], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, i) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let o = this.textblockFromContext();
      o && (t = this.enterInner(o, null, t));
    }
    let r = this.findPlace(e, t, i);
    if (r) {
      this.closeExtra();
      let o = this.top;
      o.match && (o.match = o.match.matchType(e.type));
      let s = fe.none;
      for (let a of r.concat(e.marks))
        (o.type ? o.type.allowsMarkType(a.type) : Ac(a.type, e.type)) && (s = a.addToSet(s));
      return o.content.push(e.mark(s)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, i, r) {
    let o = this.findPlace(e.create(t), i, !1);
    return o && (o = this.enterInner(e, t, i, !0, r)), o;
  }
  // Open a node of the given type
  enterInner(e, t, i, r = !1, o) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(e);
    let a = Mc(e, o, s.options);
    s.options & Yi && s.content.length == 0 && (a |= Yi);
    let l = fe.none;
    return i = i.filter((c) => (s.type ? s.type.allowsMarkType(c.type) : Ac(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new Fr(e, t, l, r, null, a)), this.open++, i;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= fr);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let i = this.nodes[t].content;
      for (let r = i.length - 1; r >= 0; r--)
        e += i[r].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].node == e && this.find[i].offset == t && (this.find[i].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, i) {
    if (e != t && this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && t.compareDocumentPosition(this.find[r].node) & (i ? 2 : 4) && (this.find[r].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), i = this.options.context, r = !this.isOpen && (!i || i.parent.type == this.nodes[0].type), o = -(i ? i.depth + 1 : 0) + (r ? 0 : 1), s = (a, l) => {
      for (; a >= 0; a--) {
        let c = t[a];
        if (c == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; l >= o; l--)
            if (s(a - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && r ? this.nodes[l].type : i && l >= o ? i.node(l - o).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return s(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let i = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (i && i.isTextblock && i.defaultAttrs)
          return i;
      }
    for (let t in this.parser.schema.nodes) {
      let i = this.parser.schema.nodes[t];
      if (i.isTextblock && i.defaultAttrs)
        return i;
    }
  }
}
function gA(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let i = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    i && jh.hasOwnProperty(i) && t ? (t.appendChild(e), e = t) : i == "li" ? t = e : i && (t = null);
  }
}
function _A(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function zc(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function Ac(n, e) {
  let t = e.schema.nodes;
  for (let i in t) {
    let r = t[i];
    if (!r.allowsMarkType(n))
      continue;
    let o = [], s = (a) => {
      o.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: c, next: u } = a.edge(l);
        if (c == e || o.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(r.contentMatch))
      return !0;
  }
}
class di {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, i) {
    i || (i = Ws(t).createDocumentFragment());
    let r = i, o = [];
    return e.forEach((s) => {
      if (o.length || s.marks.length) {
        let a = 0, l = 0;
        for (; a < o.length && l < s.marks.length; ) {
          let c = s.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(o[a][0]) || c.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < o.length; )
          r = o.pop()[1];
        for (; l < s.marks.length; ) {
          let c = s.marks[l++], u = this.serializeMark(c, s.isInline, t);
          u && (o.push([c, r]), r.appendChild(u.dom), r = u.contentDOM || u.dom);
        }
      }
      r.appendChild(this.serializeNodeInner(s, t));
    }), i;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: i, contentDOM: r } = lo(Ws(t), this.nodes[e.type.name](e), null, e.attrs);
    if (r) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, r);
    }
    return i;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let i = this.serializeNodeInner(e, t);
    for (let r = e.marks.length - 1; r >= 0; r--) {
      let o = this.serializeMark(e.marks[r], e.isInline, t);
      o && ((o.contentDOM || o.dom).appendChild(i), i = o.dom);
    }
    return i;
  }
  /**
  @internal
  */
  serializeMark(e, t, i = {}) {
    let r = this.marks[e.type.name];
    return r && lo(Ws(i), r(e, t), null, e.attrs);
  }
  static renderSpec(e, t, i = null, r) {
    return lo(e, t, i, r);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new di(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = Lc(e.nodes);
    return t.text || (t.text = (i) => i.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Lc(e.marks);
  }
}
function Lc(n) {
  let e = {};
  for (let t in n) {
    let i = n[t].spec.toDOM;
    i && (e[t] = i);
  }
  return e;
}
function Ws(n) {
  return n.document || window.document;
}
const Nc = /* @__PURE__ */ new WeakMap();
function bA(n) {
  let e = Nc.get(n);
  return e === void 0 && Nc.set(n, e = kA(n)), e;
}
function kA(n) {
  let e = null;
  function t(i) {
    if (i && typeof i == "object")
      if (Array.isArray(i))
        if (typeof i[0] == "string")
          e || (e = []), e.push(i);
        else
          for (let r = 0; r < i.length; r++)
            t(i[r]);
      else
        for (let r in i)
          t(i[r]);
  }
  return t(n), e;
}
function lo(n, e, t, i) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let r = e[0], o;
  if (typeof r != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (i && (o = bA(i)) && o.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = r.indexOf(" ");
  s > 0 && (t = r.slice(0, s), r = r.slice(s + 1));
  let a, l = t ? n.createElementNS(t, r) : n.createElement(r), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let d in c)
      if (c[d] != null) {
        let h = d.indexOf(" ");
        h > 0 ? l.setAttributeNS(d.slice(0, h), d.slice(h + 1), c[d]) : d == "style" && l.style ? l.style.cssText = c[d] : l.setAttribute(d, c[d]);
      }
  }
  for (let d = u; d < e.length; d++) {
    let h = e[d];
    if (h === 0) {
      if (d < e.length - 1 || d > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: f, contentDOM: p } = lo(n, h, t, i);
      if (l.appendChild(f), p) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = p;
      }
    }
  }
  return { dom: l, contentDOM: a };
}
const Bh = 65535, Fh = Math.pow(2, 16);
function yA(n, e) {
  return n + e * Fh;
}
function Dc(n) {
  return n & Bh;
}
function vA(n) {
  return (n - (n & Bh)) / Fh;
}
const qh = 1, Hh = 2, co = 4, Vh = 8;
class ja {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.pos = e, this.delInfo = t, this.recover = i;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Vh) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (qh | co)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Hh | co)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & co) > 0;
  }
}
class ut {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && ut.empty)
      return ut.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, i = Dc(e);
    if (!this.inverted)
      for (let r = 0; r < i; r++)
        t += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[i * 3] + t + vA(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, i) {
    let r = 0, o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[a + o], u = this.ranges[a + s], d = l + c;
      if (e <= d) {
        let h = c ? e == l ? -1 : e == d ? 1 : t : t, f = l + r + (h < 0 ? 0 : u);
        if (i)
          return f;
        let p = e == (t < 0 ? l : d) ? null : yA(a / 3, e - l), m = e == l ? Hh : e == d ? qh : co;
        return (t < 0 ? e != l : e != d) && (m |= Vh), new ja(f, m, p);
      }
      r += u - c;
    }
    return i ? e + r : new ja(e + r, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let i = 0, r = Dc(t), o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[a + o], u = l + c;
      if (e <= u && a == r * 3)
        return !0;
      i += this.ranges[a + s] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let r = 0, o = 0; r < this.ranges.length; r += 3) {
      let s = this.ranges[r], a = s - (this.inverted ? o : 0), l = s + (this.inverted ? 0 : o), c = this.ranges[r + t], u = this.ranges[r + i];
      e(a, a + c, l, l + u), o += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new ut(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? ut.empty : new ut(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
ut.empty = new ut([]);
class pr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, i = 0, r = e ? e.length : 0) {
    this.mirror = t, this.from = i, this.to = r, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new pr(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, i = this._maps.length; t < e._maps.length; t++) {
      let r = e.getMirror(t);
      this.appendMap(e._maps[t], r != null && r < t ? i + r : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, i = this._maps.length + e._maps.length; t >= 0; t--) {
      let r = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), r != null && r > t ? i - r - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new pr();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let i = this.from; i < this.to; i++)
      e = this._maps[i].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, i) {
    let r = 0;
    for (let o = this.from; o < this.to; o++) {
      let s = this._maps[o], a = s.mapResult(e, t);
      if (a.recover != null) {
        let l = this.getMirror(o);
        if (l != null && l > o && l < this.to) {
          o = l, e = this._maps[l].recover(a.recover);
          continue;
        }
      }
      r |= a.delInfo, e = a.pos;
    }
    return i ? e : new ja(e, r, null);
  }
}
const Ks = /* @__PURE__ */ Object.create(null);
class Je {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return ut.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let i = Ks[t.stepType];
    if (!i)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return i.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in Ks)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Ks[e] = t, t.prototype.jsonID = e, t;
  }
}
class Me {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Me(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Me(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, i, r) {
    try {
      return Me.ok(e.replace(t, i, r));
    } catch (o) {
      if (o instanceof vo)
        return Me.fail(o.message);
      throw o;
    }
  }
}
function Ol(n, e, t) {
  let i = [];
  for (let r = 0; r < n.childCount; r++) {
    let o = n.child(r);
    o.content.size && (o = o.copy(Ol(o.content, e, o))), o.isInline && (o = e(o, t, r)), i.push(o);
  }
  return O.fromArray(i);
}
class wn extends Je {
  /**
  Create a mark step.
  */
  constructor(e, t, i) {
    super(), this.from = e, this.to = t, this.mark = i;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), i = e.resolve(this.from), r = i.node(i.sharedDepth(this.to)), o = new N(Ol(t.content, (s, a) => !s.isAtom || !a.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), r), t.openStart, t.openEnd);
    return Me.fromReplace(e, this.from, this.to, o);
  }
  invert() {
    return new Pt(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new wn(t.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof wn && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new wn(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new wn(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Je.jsonID("addMark", wn);
class Pt extends Je {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, i) {
    super(), this.from = e, this.to = t, this.mark = i;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), i = new N(Ol(t.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), e), t.openStart, t.openEnd);
    return Me.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new wn(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new Pt(t.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof Pt && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Pt(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Pt(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Je.jsonID("removeMark", Pt);
class Cn extends Je {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Me.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Me.fromReplace(e, this.pos, this.pos + 1, new N(O.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let i = this.mark.addToSet(t.marks);
      if (i.length == t.marks.length) {
        for (let r = 0; r < t.marks.length; r++)
          if (!t.marks[r].isInSet(i))
            return new Cn(this.pos, t.marks[r]);
        return new Cn(this.pos, this.mark);
      }
    }
    return new ai(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Cn(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Cn(t.pos, e.markFromJSON(t.mark));
  }
}
Je.jsonID("addNodeMark", Cn);
class ai extends Je {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Me.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Me.fromReplace(e, this.pos, this.pos + 1, new N(O.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Cn(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ai(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ai(t.pos, e.markFromJSON(t.mark));
  }
}
Je.jsonID("removeNodeMark", ai);
class Ne extends Je {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, i, r = !1) {
    super(), this.from = e, this.to = t, this.slice = i, this.structure = r;
  }
  apply(e) {
    return this.structure && Ba(e, this.from, this.to) ? Me.fail("Structure replace would overwrite content") : Me.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new ut([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Ne(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deletedAcross && i.deletedAcross ? null : new Ne(t.pos, Math.max(t.pos, i.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof Ne) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? N.empty : new N(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Ne(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? N.empty : new N(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Ne(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Ne(t.from, t.to, N.fromJSON(e, t.slice), !!t.structure);
  }
}
Je.jsonID("replace", Ne);
class De extends Je {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, i, r, o, s, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = i, this.gapTo = r, this.slice = o, this.insert = s, this.structure = a;
  }
  apply(e) {
    if (this.structure && (Ba(e, this.from, this.gapFrom) || Ba(e, this.gapTo, this.to)))
      return Me.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Me.fail("Gap is not a flat range");
    let i = this.slice.insertAt(this.insert, t.content);
    return i ? Me.fromReplace(e, this.from, this.to, i) : Me.fail("Content does not fit in gap");
  }
  getMap() {
    return new ut([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new De(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1), r = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), o = this.to == this.gapTo ? i.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && i.deletedAcross || r < t.pos || o > i.pos ? null : new De(t.pos, i.pos, r, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new De(t.from, t.to, t.gapFrom, t.gapTo, N.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
Je.jsonID("replaceAround", De);
function Ba(n, e, t) {
  let i = n.resolve(e), r = t - e, o = i.depth;
  for (; r > 0 && o > 0 && i.indexAfter(o) == i.node(o).childCount; )
    o--, r--;
  if (r > 0) {
    let s = i.node(o).maybeChild(i.indexAfter(o));
    for (; r > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, r--;
    }
  }
  return !1;
}
function xA(n, e, t, i) {
  let r = [], o = [], s, a;
  n.doc.nodesBetween(e, t, (l, c, u) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!i.isInSet(d) && u.type.allowsMarkType(i.type)) {
      let h = Math.max(c, e), f = Math.min(c + l.nodeSize, t), p = i.addToSet(d);
      for (let m = 0; m < d.length; m++)
        d[m].isInSet(p) || (s && s.to == h && s.mark.eq(d[m]) ? s.to = f : r.push(s = new Pt(h, f, d[m])));
      a && a.to == h ? a.to = f : o.push(a = new wn(h, f, i));
    }
  }), r.forEach((l) => n.step(l)), o.forEach((l) => n.step(l));
}
function SA(n, e, t, i) {
  let r = [], o = 0;
  n.doc.nodesBetween(e, t, (s, a) => {
    if (!s.isInline)
      return;
    o++;
    let l = null;
    if (i instanceof ys) {
      let c = s.marks, u;
      for (; u = i.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else i ? i.isInSet(s.marks) && (l = [i]) : l = s.marks;
    if (l && l.length) {
      let c = Math.min(a + s.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let d = l[u], h;
        for (let f = 0; f < r.length; f++) {
          let p = r[f];
          p.step == o - 1 && d.eq(r[f].style) && (h = p);
        }
        h ? (h.to = c, h.step = o) : r.push({ style: d, from: Math.max(a, e), to: c, step: o });
      }
    }
  }), r.forEach((s) => n.step(new Pt(s.from, s.to, s.style)));
}
function El(n, e, t, i = t.contentMatch, r = !0) {
  let o = n.doc.nodeAt(e), s = [], a = e + 1;
  for (let l = 0; l < o.childCount; l++) {
    let c = o.child(l), u = a + c.nodeSize, d = i.matchType(c.type);
    if (!d)
      s.push(new Ne(a, u, N.empty));
    else {
      i = d;
      for (let h = 0; h < c.marks.length; h++)
        t.allowsMarkType(c.marks[h].type) || n.step(new Pt(a, u, c.marks[h]));
      if (r && c.isText && t.whitespace != "pre") {
        let h, f = /\r?\n|\r/g, p;
        for (; h = f.exec(c.text); )
          p || (p = new N(O.from(t.schema.text(" ", t.allowedMarks(c.marks))), 0, 0)), s.push(new Ne(a + h.index, a + h.index + h[0].length, p));
      }
    }
    a = u;
  }
  if (!i.validEnd) {
    let l = i.fillBefore(O.empty, !0);
    n.replace(a, a, new N(l, 0, 0));
  }
  for (let l = s.length - 1; l >= 0; l--)
    n.step(s[l]);
}
function wA(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function Bi(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let i = n.depth; ; --i) {
    let r = n.$from.node(i), o = n.$from.index(i), s = n.$to.indexAfter(i);
    if (i < n.depth && r.canReplace(o, s, t))
      return i;
    if (i == 0 || r.type.spec.isolating || !wA(r, o, s))
      break;
  }
  return null;
}
function CA(n, e, t) {
  let { $from: i, $to: r, depth: o } = e, s = i.before(o + 1), a = r.after(o + 1), l = s, c = a, u = O.empty, d = 0;
  for (let p = o, m = !1; p > t; p--)
    m || i.index(p) > 0 ? (m = !0, u = O.from(i.node(p).copy(u)), d++) : l--;
  let h = O.empty, f = 0;
  for (let p = o, m = !1; p > t; p--)
    m || r.after(p + 1) < r.end(p) ? (m = !0, h = O.from(r.node(p).copy(h)), f++) : c++;
  n.step(new De(l, c, s, a, new N(u.append(h), d, f), u.size - d, !0));
}
function Ml(n, e, t = null, i = n) {
  let r = TA(n, e), o = r && OA(i, e);
  return o ? r.map(Rc).concat({ type: e, attrs: t }).concat(o.map(Rc)) : null;
}
function Rc(n) {
  return { type: n, attrs: null };
}
function TA(n, e) {
  let { parent: t, startIndex: i, endIndex: r } = n, o = t.contentMatchAt(i).findWrapping(e);
  if (!o)
    return null;
  let s = o.length ? o[0] : e;
  return t.canReplaceWith(i, r, s) ? o : null;
}
function OA(n, e) {
  let { parent: t, startIndex: i, endIndex: r } = n, o = t.child(i), s = e.contentMatch.findWrapping(o.type);
  if (!s)
    return null;
  let l = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let c = i; l && c < r; c++)
    l = l.matchType(t.child(c).type);
  return !l || !l.validEnd ? null : s;
}
function EA(n, e, t) {
  let i = O.empty;
  for (let s = t.length - 1; s >= 0; s--) {
    if (i.size) {
      let a = t[s].type.contentMatch.matchFragment(i);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    i = O.from(t[s].type.create(t[s].attrs, i));
  }
  let r = e.start, o = e.end;
  n.step(new De(r, o, r, o, new N(i, 0, 0), t.length, !0));
}
function MA(n, e, t, i, r) {
  if (!i.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = n.steps.length;
  n.doc.nodesBetween(e, t, (s, a) => {
    let l = typeof r == "function" ? r(s) : r;
    if (s.isTextblock && !s.hasMarkup(i, l) && $A(n.doc, n.mapping.slice(o).map(a), i)) {
      let c = null;
      if (i.schema.linebreakReplacement) {
        let f = i.whitespace == "pre", p = !!i.contentMatch.matchType(i.schema.linebreakReplacement);
        f && !p ? c = !1 : !f && p && (c = !0);
      }
      c === !1 && Wh(n, s, a, o), El(n, n.mapping.slice(o).map(a, 1), i, void 0, c === null);
      let u = n.mapping.slice(o), d = u.map(a, 1), h = u.map(a + s.nodeSize, 1);
      return n.step(new De(d, h, d + 1, h - 1, new N(O.from(i.create(l, null, s.marks)), 0, 0), 1, !0)), c === !0 && Uh(n, s, a, o), !1;
    }
  });
}
function Uh(n, e, t, i) {
  e.forEach((r, o) => {
    if (r.isText) {
      let s, a = /\r?\n|\r/g;
      for (; s = a.exec(r.text); ) {
        let l = n.mapping.slice(i).map(t + 1 + o + s.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function Wh(n, e, t, i) {
  e.forEach((r, o) => {
    if (r.type == r.type.schema.linebreakReplacement) {
      let s = n.mapping.slice(i).map(t + 1 + o);
      n.replaceWith(s, s + 1, e.type.schema.text(`
`));
    }
  });
}
function $A(n, e, t) {
  let i = n.resolve(e), r = i.index();
  return i.parent.canReplaceWith(r, r + 1, t);
}
function zA(n, e, t, i, r) {
  let o = n.doc.nodeAt(e);
  if (!o)
    throw new RangeError("No node at given position");
  t || (t = o.type);
  let s = t.create(i, null, r || o.marks);
  if (o.isLeaf)
    return n.replaceWith(e, e + o.nodeSize, s);
  if (!t.validContent(o.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new De(e, e + o.nodeSize, e + 1, e + o.nodeSize - 1, new N(O.from(s), 0, 0), 1, !0));
}
function on(n, e, t = 1, i) {
  let r = n.resolve(e), o = r.depth - t, s = i && i[i.length - 1] || r.parent;
  if (o < 0 || r.parent.type.spec.isolating || !r.parent.canReplace(r.index(), r.parent.childCount) || !s.type.validContent(r.parent.content.cutByIndex(r.index(), r.parent.childCount)))
    return !1;
  for (let c = r.depth - 1, u = t - 2; c > o; c--, u--) {
    let d = r.node(c), h = r.index(c);
    if (d.type.spec.isolating)
      return !1;
    let f = d.content.cutByIndex(h, d.childCount), p = i && i[u + 1];
    p && (f = f.replaceChild(0, p.type.create(p.attrs)));
    let m = i && i[u] || d;
    if (!d.canReplace(h + 1, d.childCount) || !m.type.validContent(f))
      return !1;
  }
  let a = r.indexAfter(o), l = i && i[0];
  return r.node(o).canReplaceWith(a, a, l ? l.type : r.node(o + 1).type);
}
function AA(n, e, t = 1, i) {
  let r = n.doc.resolve(e), o = O.empty, s = O.empty;
  for (let a = r.depth, l = r.depth - t, c = t - 1; a > l; a--, c--) {
    o = O.from(r.node(a).copy(o));
    let u = i && i[c];
    s = O.from(u ? u.type.create(u.attrs, s) : r.node(a).copy(s));
  }
  n.step(new Ne(e, e, new N(o.append(s), t, t), !0));
}
function Dn(n, e) {
  let t = n.resolve(e), i = t.index();
  return Kh(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(i, i + 1);
}
function LA(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: i } = n.type.schema;
  for (let r = 0; r < e.childCount; r++) {
    let o = e.child(r), s = o.type == i ? n.type.schema.nodes.text : o.type;
    if (t = t.matchType(s), !t || !n.type.allowsMarks(o.marks))
      return !1;
  }
  return t.validEnd;
}
function Kh(n, e) {
  return !!(n && e && !n.isLeaf && LA(n, e));
}
function vs(n, e, t = -1) {
  let i = n.resolve(e);
  for (let r = i.depth; ; r--) {
    let o, s, a = i.index(r);
    if (r == i.depth ? (o = i.nodeBefore, s = i.nodeAfter) : t > 0 ? (o = i.node(r + 1), a++, s = i.node(r).maybeChild(a)) : (o = i.node(r).maybeChild(a - 1), s = i.node(r + 1)), o && !o.isTextblock && Kh(o, s) && i.node(r).canReplace(a, a + 1))
      return e;
    if (r == 0)
      break;
    e = t < 0 ? i.before(r) : i.after(r);
  }
}
function NA(n, e, t) {
  let i = null, { linebreakReplacement: r } = n.doc.type.schema, o = n.doc.resolve(e - t), s = o.node().type;
  if (r && s.inlineContent) {
    let u = s.whitespace == "pre", d = !!s.contentMatch.matchType(r);
    u && !d ? i = !1 : !u && d && (i = !0);
  }
  let a = n.steps.length;
  if (i === !1) {
    let u = n.doc.resolve(e + t);
    Wh(n, u.node(), u.before(), a);
  }
  s.inlineContent && El(n, e + t - 1, s, o.node().contentMatchAt(o.index()), i == null);
  let l = n.mapping.slice(a), c = l.map(e - t);
  if (n.step(new Ne(c, l.map(e + t, -1), N.empty, !0)), i === !0) {
    let u = n.doc.resolve(c);
    Uh(n, u.node(), u.before(), n.steps.length);
  }
  return n;
}
function DA(n, e, t) {
  let i = n.resolve(e);
  if (i.parent.canReplaceWith(i.index(), i.index(), t))
    return e;
  if (i.parentOffset == 0)
    for (let r = i.depth - 1; r >= 0; r--) {
      let o = i.index(r);
      if (i.node(r).canReplaceWith(o, o, t))
        return i.before(r + 1);
      if (o > 0)
        return null;
    }
  if (i.parentOffset == i.parent.content.size)
    for (let r = i.depth - 1; r >= 0; r--) {
      let o = i.indexAfter(r);
      if (i.node(r).canReplaceWith(o, o, t))
        return i.after(r + 1);
      if (o < i.node(r).childCount)
        return null;
    }
  return null;
}
function Zh(n, e, t) {
  let i = n.resolve(e);
  if (!t.content.size)
    return e;
  let r = t.content;
  for (let o = 0; o < t.openStart; o++)
    r = r.firstChild.content;
  for (let o = 1; o <= (t.openStart == 0 && t.size ? 2 : 1); o++)
    for (let s = i.depth; s >= 0; s--) {
      let a = s == i.depth ? 0 : i.pos <= (i.start(s + 1) + i.end(s + 1)) / 2 ? -1 : 1, l = i.index(s) + (a > 0 ? 1 : 0), c = i.node(s), u = !1;
      if (o == 1)
        u = c.canReplace(l, l, r);
      else {
        let d = c.contentMatchAt(l).findWrapping(r.firstChild.type);
        u = d && c.canReplaceWith(l, l, d[0]);
      }
      if (u)
        return a == 0 ? i.pos : a < 0 ? i.before(s + 1) : i.after(s + 1);
    }
  return null;
}
function xs(n, e, t = e, i = N.empty) {
  if (e == t && !i.size)
    return null;
  let r = n.resolve(e), o = n.resolve(t);
  return Gh(r, o, i) ? new Ne(e, t, i) : new RA(r, o, i).fit();
}
function Gh(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class RA {
  constructor(e, t, i) {
    this.$from = e, this.$to = t, this.unplaced = i, this.frontier = [], this.placed = O.empty;
    for (let r = 0; r <= e.depth; r++) {
      let o = e.node(r);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(e.indexAfter(r))
      });
    }
    for (let r = e.depth; r > 0; r--)
      this.placed = O.from(e.node(r).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, i = this.$from, r = this.close(e < 0 ? this.$to : i.doc.resolve(e));
    if (!r)
      return null;
    let o = this.placed, s = i.depth, a = r.depth;
    for (; s && a && o.childCount == 1; )
      o = o.firstChild.content, s--, a--;
    let l = new N(o, s, a);
    return e > -1 ? new De(i.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || i.pos != this.$to.pos ? new Ne(i.pos, r.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, i = 0, r = this.unplaced.openEnd; i < e; i++) {
      let o = t.firstChild;
      if (t.childCount > 1 && (r = 0), o.type.spec.isolating && r <= i) {
        e = i;
        break;
      }
      t = o.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let i = t == 1 ? e : this.unplaced.openStart; i >= 0; i--) {
        let r, o = null;
        i ? (o = Zs(this.unplaced.content, i - 1).firstChild, r = o.content) : r = this.unplaced.content;
        let s = r.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: c } = this.frontier[a], u, d = null;
          if (t == 1 && (s ? c.matchType(s.type) || (d = c.fillBefore(O.from(s), !1)) : o && l.compatibleContent(o.type)))
            return { sliceDepth: i, frontierDepth: a, parent: o, inject: d };
          if (t == 2 && s && (u = c.findWrapping(s.type)))
            return { sliceDepth: i, frontierDepth: a, parent: o, wrap: u };
          if (o && c.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: i } = this.unplaced, r = Zs(e, t);
    return !r.childCount || r.firstChild.isLeaf ? !1 : (this.unplaced = new N(e, t + 1, Math.max(i, r.size + t >= e.size - i ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: i } = this.unplaced, r = Zs(e, t);
    if (r.childCount <= 1 && t > 0) {
      let o = e.size - t <= t + r.size;
      this.unplaced = new N(Ui(e, t - 1, 1), t - 1, o ? t - 1 : i);
    } else
      this.unplaced = new N(Ui(e, t, 1), t, i);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: i, inject: r, wrap: o }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (o)
      for (let m = 0; m < o.length; m++)
        this.openFrontierNode(o[m]);
    let s = this.unplaced, a = i ? i.content : s.content, l = s.openStart - e, c = 0, u = [], { match: d, type: h } = this.frontier[t];
    if (r) {
      for (let m = 0; m < r.childCount; m++)
        u.push(r.child(m));
      d = d.matchFragment(r);
    }
    let f = a.size + e - (s.content.size - s.openEnd);
    for (; c < a.childCount; ) {
      let m = a.child(c), g = d.matchType(m.type);
      if (!g)
        break;
      c++, (c > 1 || l == 0 || m.content.size) && (d = g, u.push(Jh(m.mark(h.allowedMarks(m.marks)), c == 1 ? l : 0, c == a.childCount ? f : -1)));
    }
    let p = c == a.childCount;
    p || (f = -1), this.placed = Wi(this.placed, t, O.from(u)), this.frontier[t].match = d, p && f < 0 && i && i.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, g = a; m < f; m++) {
      let k = g.lastChild;
      this.frontier.push({ type: k.type, match: k.contentMatchAt(k.childCount) }), g = k.content;
    }
    this.unplaced = p ? e == 0 ? N.empty : new N(Ui(s.content, e - 1, 1), e - 1, f < 0 ? s.openEnd : e - 1) : new N(Ui(s.content, e, c), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !Gs(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: i } = this.$to, r = this.$to.after(i);
    for (; i > 1 && r == this.$to.end(--i); )
      ++r;
    return r;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: i, type: r } = this.frontier[t], o = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), s = Gs(e, t, r, i, o);
      if (s) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: l, type: c } = this.frontier[a], u = Gs(e, a, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: s, move: o ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Wi(this.placed, t.depth, t.fit)), e = t.move;
    for (let i = t.depth + 1; i <= e.depth; i++) {
      let r = e.node(i), o = r.type.contentMatch.fillBefore(r.content, !0, e.index(i));
      this.openFrontierNode(r.type, r.attrs, o);
    }
    return e;
  }
  openFrontierNode(e, t = null, i) {
    let r = this.frontier[this.depth];
    r.match = r.match.matchType(e), this.placed = Wi(this.placed, this.depth, O.from(e.create(t, i))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(O.empty, !0);
    t.childCount && (this.placed = Wi(this.placed, this.frontier.length, t));
  }
}
function Ui(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Ui(n.firstChild.content, e - 1, t)));
}
function Wi(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Wi(n.lastChild.content, e - 1, t)));
}
function Zs(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function Jh(n, e, t) {
  if (e <= 0)
    return n;
  let i = n.content;
  return e > 1 && (i = i.replaceChild(0, Jh(i.firstChild, e - 1, i.childCount == 1 ? t - 1 : 0))), e > 0 && (i = n.type.contentMatch.fillBefore(i).append(i), t <= 0 && (i = i.append(n.type.contentMatch.matchFragment(i).fillBefore(O.empty, !0)))), n.copy(i);
}
function Gs(n, e, t, i, r) {
  let o = n.node(e), s = r ? n.indexAfter(e) : n.index(e);
  if (s == o.childCount && !t.compatibleContent(o.type))
    return null;
  let a = i.fillBefore(o.content, !0, s);
  return a && !IA(t, o.content, s) ? a : null;
}
function IA(n, e, t) {
  for (let i = t; i < e.childCount; i++)
    if (!n.allowsMarks(e.child(i).marks))
      return !0;
  return !1;
}
function PA(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function jA(n, e, t, i) {
  if (!i.size)
    return n.deleteRange(e, t);
  let r = n.doc.resolve(e), o = n.doc.resolve(t);
  if (Gh(r, o, i))
    return n.step(new Ne(e, t, i));
  let s = Xh(r, n.doc.resolve(t));
  s[s.length - 1] == 0 && s.pop();
  let a = -(r.depth + 1);
  s.unshift(a);
  for (let h = r.depth, f = r.pos - 1; h > 0; h--, f--) {
    let p = r.node(h).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    s.indexOf(h) > -1 ? a = h : r.before(h) == f && s.splice(1, 0, -h);
  }
  let l = s.indexOf(a), c = [], u = i.openStart;
  for (let h = i.content, f = 0; ; f++) {
    let p = h.firstChild;
    if (c.push(p), f == i.openStart)
      break;
    h = p.content;
  }
  for (let h = u - 1; h >= 0; h--) {
    let f = c[h], p = PA(f.type);
    if (p && !f.sameMarkup(r.node(Math.abs(a) - 1)))
      u = h;
    else if (p || !f.type.isTextblock)
      break;
  }
  for (let h = i.openStart; h >= 0; h--) {
    let f = (h + u + 1) % (i.openStart + 1), p = c[f];
    if (p)
      for (let m = 0; m < s.length; m++) {
        let g = s[(m + l) % s.length], k = !0;
        g < 0 && (k = !1, g = -g);
        let v = r.node(g - 1), S = r.index(g - 1);
        if (v.canReplaceWith(S, S, p.type, p.marks))
          return n.replace(r.before(g), k ? o.after(g) : t, new N(Yh(i.content, 0, i.openStart, f), f, i.openEnd));
      }
  }
  let d = n.steps.length;
  for (let h = s.length - 1; h >= 0 && (n.replace(e, t, i), !(n.steps.length > d)); h--) {
    let f = s[h];
    f < 0 || (e = r.before(f), t = o.after(f));
  }
}
function Yh(n, e, t, i, r) {
  if (e < t) {
    let o = n.firstChild;
    n = n.replaceChild(0, o.copy(Yh(o.content, e + 1, t, i, o)));
  }
  if (e > i) {
    let o = r.contentMatchAt(0), s = o.fillBefore(n).append(n);
    n = s.append(o.matchFragment(s).fillBefore(O.empty, !0));
  }
  return n;
}
function BA(n, e, t, i) {
  if (!i.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let r = DA(n.doc, e, i.type);
    r != null && (e = t = r);
  }
  n.replaceRange(e, t, new N(O.from(i), 0, 0));
}
function FA(n, e, t) {
  let i = n.doc.resolve(e), r = n.doc.resolve(t), o = Xh(i, r);
  for (let s = 0; s < o.length; s++) {
    let a = o[s], l = s == o.length - 1;
    if (l && a == 0 || i.node(a).type.contentMatch.validEnd)
      return n.delete(i.start(a), r.end(a));
    if (a > 0 && (l || i.node(a - 1).canReplace(i.index(a - 1), r.indexAfter(a - 1))))
      return n.delete(i.before(a), r.after(a));
  }
  for (let s = 1; s <= i.depth && s <= r.depth; s++)
    if (e - i.start(s) == i.depth - s && t > i.end(s) && r.end(s) - t != r.depth - s && i.start(s - 1) == r.start(s - 1) && i.node(s - 1).canReplace(i.index(s - 1), r.index(s - 1)))
      return n.delete(i.before(s), t);
  n.delete(e, t);
}
function Xh(n, e) {
  let t = [], i = Math.min(n.depth, e.depth);
  for (let r = i; r >= 0; r--) {
    let o = n.start(r);
    if (o < n.pos - (n.depth - r) || e.end(r) > e.pos + (e.depth - r) || n.node(r).type.spec.isolating || e.node(r).type.spec.isolating)
      break;
    (o == e.start(r) || r == n.depth && r == e.depth && n.parent.inlineContent && e.parent.inlineContent && r && e.start(r - 1) == o - 1) && t.push(r);
  }
  return t;
}
class Ei extends Je {
  /**
  Construct an attribute step.
  */
  constructor(e, t, i) {
    super(), this.pos = e, this.attr = t, this.value = i;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Me.fail("No node at attribute step's position");
    let i = /* @__PURE__ */ Object.create(null);
    for (let o in t.attrs)
      i[o] = t.attrs[o];
    i[this.attr] = this.value;
    let r = t.type.create(i, null, t.marks);
    return Me.fromReplace(e, this.pos, this.pos + 1, new N(O.from(r), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return ut.empty;
  }
  invert(e) {
    return new Ei(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ei(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Ei(t.pos, t.attr, t.value);
  }
}
Je.jsonID("attr", Ei);
class mr extends Je {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let r in e.attrs)
      t[r] = e.attrs[r];
    t[this.attr] = this.value;
    let i = e.type.create(t, e.content, e.marks);
    return Me.ok(i);
  }
  getMap() {
    return ut.empty;
  }
  invert(e) {
    return new mr(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new mr(t.attr, t.value);
  }
}
Je.jsonID("docAttr", mr);
let $i = class extends Error {
};
$i = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
$i.prototype = Object.create(Error.prototype);
$i.prototype.constructor = $i;
$i.prototype.name = "TransformError";
class Qh {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new pr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new $i(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, i = N.empty) {
    let r = xs(this.doc, e, t, i);
    return r && this.step(r), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, i) {
    return this.replace(e, t, new N(O.from(i), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, N.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, i) {
    return jA(this, e, t, i), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, i) {
    return BA(this, e, t, i), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return FA(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return CA(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return NA(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return EA(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, i, r = null) {
    return MA(this, e, t, i, r), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, i = null, r) {
    return zA(this, e, t, i, r), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, i) {
    return this.step(new Ei(e, t, i)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new mr(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Cn(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let i = this.doc.nodeAt(e);
    if (!i)
      throw new RangeError("No node at position " + e);
    if (t instanceof fe)
      t.isInSet(i.marks) && this.step(new ai(e, t));
    else {
      let r = i.marks, o, s = [];
      for (; o = t.isInSet(r); )
        s.push(new ai(e, o)), r = o.removeFromSet(r);
      for (let a = s.length - 1; a >= 0; a--)
        this.step(s[a]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, i) {
    return AA(this, e, t, i), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, i) {
    return xA(this, e, t, i), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, i) {
    return SA(this, e, t, i), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, i) {
    return El(this, e, t, i), this;
  }
}
const Js = /* @__PURE__ */ Object.create(null);
class ie {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, i) {
    this.$anchor = e, this.$head = t, this.ranges = i || [new qA(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = N.empty) {
    let i = t.content.lastChild, r = null;
    for (let a = 0; a < t.openEnd; a++)
      r = i, i = i.lastChild;
    let o = e.steps.length, s = this.ranges;
    for (let a = 0; a < s.length; a++) {
      let { $from: l, $to: c } = s[a], u = e.mapping.slice(o);
      e.replaceRange(u.map(l.pos), u.map(c.pos), a ? N.empty : t), a == 0 && jc(e, o, (i ? i.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let i = e.steps.length, r = this.ranges;
    for (let o = 0; o < r.length; o++) {
      let { $from: s, $to: a } = r[o], l = e.mapping.slice(i), c = l.map(s.pos), u = l.map(a.pos);
      o ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, t), jc(e, i, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, i = !1) {
    let r = e.parent.inlineContent ? new Y(e) : xi(e.node(0), e.parent, e.pos, e.index(), t, i);
    if (r)
      return r;
    for (let o = e.depth - 1; o >= 0; o--) {
      let s = t < 0 ? xi(e.node(0), e.node(o), e.before(o + 1), e.index(o), t, i) : xi(e.node(0), e.node(o), e.after(o + 1), e.index(o) + 1, t, i);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new ot(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return xi(e, e, 0, 0, 1) || new ot(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return xi(e, e, e.content.size, e.childCount, -1) || new ot(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let i = Js[t.type];
    if (!i)
      throw new RangeError(`No selection type ${t.type} defined`);
    return i.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in Js)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return Js[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Y.between(this.$anchor, this.$head).getBookmark();
  }
}
ie.prototype.visible = !0;
class qA {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let Ic = !1;
function Pc(n) {
  !Ic && !n.parent.inlineContent && (Ic = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class Y extends ie {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    Pc(e), Pc(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let i = e.resolve(t.map(this.head));
    if (!i.parent.inlineContent)
      return ie.near(i);
    let r = e.resolve(t.map(this.anchor));
    return new Y(r.parent.inlineContent ? r : i, i);
  }
  replace(e, t = N.empty) {
    if (super.replace(e, t), t == N.empty) {
      let i = this.$from.marksAcross(this.$to);
      i && e.ensureMarks(i);
    }
  }
  eq(e) {
    return e instanceof Y && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Ss(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Y(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, i = t) {
    let r = e.resolve(t);
    return new this(r, i == t ? r : e.resolve(i));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, i) {
    let r = e.pos - t.pos;
    if ((!i || r) && (i = r >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let o = ie.findFrom(t, i, !0) || ie.findFrom(t, -i, !0);
      if (o)
        t = o.$head;
      else
        return ie.near(t, i);
    }
    return e.parent.inlineContent || (r == 0 ? e = t : (e = (ie.findFrom(e, -i, !0) || ie.findFrom(e, i, !0)).$anchor, e.pos < t.pos != r < 0 && (e = t))), new Y(e, t);
  }
}
ie.jsonID("text", Y);
class Ss {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Ss(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Y.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class F extends ie {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, i = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, i), this.node = t;
  }
  map(e, t) {
    let { deleted: i, pos: r } = t.mapResult(this.anchor), o = e.resolve(r);
    return i ? ie.near(o) : new F(o);
  }
  content() {
    return new N(O.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof F && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new $l(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new F(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new F(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
F.prototype.visible = !1;
ie.jsonID("node", F);
class $l {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: i } = e.mapResult(this.anchor);
    return t ? new Ss(i, i) : new $l(i);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), i = t.nodeAfter;
    return i && F.isSelectable(i) ? new F(t) : ie.near(t);
  }
}
class ot extends ie {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = N.empty) {
    if (t == N.empty) {
      e.delete(0, e.doc.content.size);
      let i = ie.atStart(e.doc);
      i.eq(e.selection) || e.setSelection(i);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new ot(e);
  }
  map(e) {
    return new ot(e);
  }
  eq(e) {
    return e instanceof ot;
  }
  getBookmark() {
    return HA;
  }
}
ie.jsonID("all", ot);
const HA = {
  map() {
    return this;
  },
  resolve(n) {
    return new ot(n);
  }
};
function xi(n, e, t, i, r, o = !1) {
  if (e.inlineContent)
    return Y.create(n, t);
  for (let s = i - (r > 0 ? 0 : 1); r > 0 ? s < e.childCount : s >= 0; s += r) {
    let a = e.child(s);
    if (a.isAtom) {
      if (!o && F.isSelectable(a))
        return F.create(n, t - (r < 0 ? a.nodeSize : 0));
    } else {
      let l = xi(n, a, t + r, r < 0 ? a.childCount : 0, r, o);
      if (l)
        return l;
    }
    t += a.nodeSize * r;
  }
  return null;
}
function jc(n, e, t) {
  let i = n.steps.length - 1;
  if (i < e)
    return;
  let r = n.steps[i];
  if (!(r instanceof Ne || r instanceof De))
    return;
  let o = n.mapping.maps[i], s;
  o.forEach((a, l, c, u) => {
    s == null && (s = u);
  }), n.setSelection(ie.near(n.doc.resolve(s), t));
}
const Bc = 1, qr = 2, Fc = 4;
class VA extends Qh {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Bc) & ~qr, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Bc) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= qr, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return fe.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & qr) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~qr, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let i = this.selection;
    return t && (e = e.mark(this.storedMarks || (i.empty ? i.$from.marks() : i.$from.marksAcross(i.$to) || fe.none))), i.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, i) {
    let r = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(r.text(e), !0) : this.deleteSelection();
    {
      if (i == null && (i = t), !e)
        return this.deleteRange(t, i);
      let o = this.storedMarks;
      if (!o) {
        let s = this.doc.resolve(t);
        o = i == t ? s.marks() : s.marksAcross(this.doc.resolve(i));
      }
      return this.replaceRangeWith(t, i, r.text(e, o)), !this.selection.empty && this.selection.to == t + e.length && this.setSelection(ie.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Fc, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Fc) > 0;
  }
}
function qc(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Ki {
  constructor(e, t, i) {
    this.name = e, this.init = qc(t.init, i), this.apply = qc(t.apply, i);
  }
}
const UA = [
  new Ki("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Ki("selection", {
    init(n, e) {
      return n.selection || ie.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Ki("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, i) {
      return i.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Ki("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class Ys {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = UA.slice(), t && t.forEach((i) => {
      if (this.pluginsByKey[i.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + i.key + ")");
      this.plugins.push(i), this.pluginsByKey[i.key] = i, i.spec.state && this.fields.push(new Ki(i.key, i.spec.state, i));
    });
  }
}
class Ti {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let i = 0; i < this.config.plugins.length; i++)
      if (i != t) {
        let r = this.config.plugins[i];
        if (r.spec.filterTransaction && !r.spec.filterTransaction.call(r, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], i = this.applyInner(e), r = null;
    for (; ; ) {
      let o = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let a = this.config.plugins[s];
        if (a.spec.appendTransaction) {
          let l = r ? r[s].n : 0, c = r ? r[s].state : this, u = l < t.length && a.spec.appendTransaction.call(a, l ? t.slice(l) : t, c, i);
          if (u && i.filterTransaction(u, s)) {
            if (u.setMeta("appendedTransaction", e), !r) {
              r = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                r.push(d < s ? { state: i, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), i = i.applyInner(u), o = !0;
          }
          r && (r[s] = { state: i, n: t.length });
        }
      }
      if (!o)
        return { state: i, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Ti(this.config), i = this.config.fields;
    for (let r = 0; r < i.length; r++) {
      let o = i[r];
      t[o.name] = o.apply(e, this[o.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new VA(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new Ys(e.doc ? e.doc.type.schema : e.schema, e.plugins), i = new Ti(t);
    for (let r = 0; r < t.fields.length; r++)
      i[t.fields[r].name] = t.fields[r].init(e, i);
    return i;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new Ys(this.schema, e.plugins), i = t.fields, r = new Ti(t);
    for (let o = 0; o < i.length; o++) {
      let s = i[o].name;
      r[s] = this.hasOwnProperty(s) ? this[s] : i[o].init(e, r);
    }
    return r;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((i) => i.toJSON())), e && typeof e == "object")
      for (let i in e) {
        if (i == "doc" || i == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let r = e[i], o = r.spec.state;
        o && o.toJSON && (t[i] = o.toJSON.call(r, this[r.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, i) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let r = new Ys(e.schema, e.plugins), o = new Ti(r);
    return r.fields.forEach((s) => {
      if (s.name == "doc")
        o.doc = rn.fromJSON(e.schema, t.doc);
      else if (s.name == "selection")
        o.selection = ie.fromJSON(o.doc, t.selection);
      else if (s.name == "storedMarks")
        t.storedMarks && (o.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (i)
          for (let a in i) {
            let l = i[a], c = l.spec.state;
            if (l.key == s.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              o[s.name] = c.fromJSON.call(l, e, t[a], o);
              return;
            }
          }
        o[s.name] = s.init(e, o);
      }
    }), o;
  }
}
function ef(n, e, t) {
  for (let i in n) {
    let r = n[i];
    r instanceof Function ? r = r.bind(e) : i == "handleDOMEvents" && (r = ef(r, e, {})), t[i] = r;
  }
  return t;
}
class $e {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && ef(e.props, this, this.props), this.key = e.key ? e.key.key : tf("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Xs = /* @__PURE__ */ Object.create(null);
function tf(n) {
  return n in Xs ? n + "$" + ++Xs[n] : (Xs[n] = 0, n + "$");
}
class Ve {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = tf(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Fe = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, zi = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Fa = null;
const Qt = function(n, e, t) {
  let i = Fa || (Fa = document.createRange());
  return i.setEnd(n, t ?? n.nodeValue.length), i.setStart(n, e || 0), i;
}, WA = function() {
  Fa = null;
}, li = function(n, e, t, i) {
  return t && (Hc(n, e, t, i, -1) || Hc(n, e, t, i, 1));
}, KA = /^(img|br|input|textarea|hr)$/i;
function Hc(n, e, t, i, r) {
  for (var o; ; ) {
    if (n == t && e == i)
      return !0;
    if (e == (r < 0 ? 0 : bt(n))) {
      let s = n.parentNode;
      if (!s || s.nodeType != 1 || zr(n) || KA.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = Fe(n) + (r < 0 ? 0 : 1), n = s;
    } else if (n.nodeType == 1) {
      let s = n.childNodes[e + (r < 0 ? -1 : 0)];
      if (s.nodeType == 1 && s.contentEditable == "false")
        if (!((o = s.pmViewDesc) === null || o === void 0) && o.ignoreForSelection)
          e += r;
        else
          return !1;
      else
        n = s, e = r < 0 ? bt(n) : 0;
    } else
      return !1;
  }
}
function bt(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function ZA(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = bt(n);
    } else if (n.parentNode && !zr(n))
      e = Fe(n), n = n.parentNode;
    else
      return null;
  }
}
function GA(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !zr(n))
      e = Fe(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function JA(n, e, t) {
  for (let i = e == 0, r = e == bt(n); i || r; ) {
    if (n == t)
      return !0;
    let o = Fe(n);
    if (n = n.parentNode, !n)
      return !1;
    i = i && o == 0, r = r && o == bt(n);
  }
}
function zr(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const ws = function(n) {
  return n.focusNode && li(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Zn(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function YA(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function XA(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let i = n.caretPositionFromPoint(e, t);
      if (i)
        return { node: i.offsetNode, offset: Math.min(bt(i.offsetNode), i.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let i = n.caretRangeFromPoint(e, t);
    if (i)
      return { node: i.startContainer, offset: Math.min(bt(i.startContainer), i.startOffset) };
  }
}
const qt = typeof navigator < "u" ? navigator : null, Vc = typeof document < "u" ? document : null, Rn = qt && qt.userAgent || "", qa = /Edge\/(\d+)/.exec(Rn), nf = /MSIE \d/.exec(Rn), Ha = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Rn), st = !!(nf || Ha || qa), $n = nf ? document.documentMode : Ha ? +Ha[1] : qa ? +qa[1] : 0, kt = !st && /gecko\/(\d+)/i.test(Rn);
kt && +(/Firefox\/(\d+)/.exec(Rn) || [0, 0])[1];
const Va = !st && /Chrome\/(\d+)/.exec(Rn), Ze = !!Va, rf = Va ? +Va[1] : 0, Xe = !st && !!qt && /Apple Computer/.test(qt.vendor), Ai = Xe && (/Mobile\/\w+/.test(Rn) || !!qt && qt.maxTouchPoints > 2), _t = Ai || (qt ? /Mac/.test(qt.platform) : !1), QA = qt ? /Win/.test(qt.platform) : !1, tn = /Android \d/.test(Rn), Ar = !!Vc && "webkitFontSmoothing" in Vc.documentElement.style, eL = Ar ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function tL(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function Gt(n, e) {
  return typeof n == "number" ? n : n[e];
}
function nL(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, i = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * i
  };
}
function Uc(n, e, t) {
  let i = n.someProp("scrollThreshold") || 0, r = n.someProp("scrollMargin") || 5, o = n.dom.ownerDocument;
  for (let s = t || n.dom; s; ) {
    if (s.nodeType != 1) {
      s = zi(s);
      continue;
    }
    let a = s, l = a == o.body, c = l ? tL(o) : nL(a), u = 0, d = 0;
    if (e.top < c.top + Gt(i, "top") ? d = -(c.top - e.top + Gt(r, "top")) : e.bottom > c.bottom - Gt(i, "bottom") && (d = e.bottom - e.top > c.bottom - c.top ? e.top + Gt(r, "top") - c.top : e.bottom - c.bottom + Gt(r, "bottom")), e.left < c.left + Gt(i, "left") ? u = -(c.left - e.left + Gt(r, "left")) : e.right > c.right - Gt(i, "right") && (u = e.right - c.right + Gt(r, "right")), u || d)
      if (l)
        o.defaultView.scrollBy(u, d);
      else {
        let f = a.scrollLeft, p = a.scrollTop;
        d && (a.scrollTop += d), u && (a.scrollLeft += u);
        let m = a.scrollLeft - f, g = a.scrollTop - p;
        e = { left: e.left - m, top: e.top - g, right: e.right - m, bottom: e.bottom - g };
      }
    let h = l ? "fixed" : getComputedStyle(s).position;
    if (/^(fixed|sticky)$/.test(h))
      break;
    s = h == "absolute" ? s.offsetParent : zi(s);
  }
}
function iL(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), i, r;
  for (let o = (e.left + e.right) / 2, s = t + 1; s < Math.min(innerHeight, e.bottom); s += 5) {
    let a = n.root.elementFromPoint(o, s);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= t - 20) {
      i = a, r = l.top;
      break;
    }
  }
  return { refDOM: i, refTop: r, stack: of(n.dom) };
}
function of(n) {
  let e = [], t = n.ownerDocument;
  for (let i = n; i && (e.push({ dom: i, top: i.scrollTop, left: i.scrollLeft }), n != t); i = zi(i))
    ;
  return e;
}
function rL({ refDOM: n, refTop: e, stack: t }) {
  let i = n ? n.getBoundingClientRect().top : 0;
  sf(t, i == 0 ? 0 : i - e);
}
function sf(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: i, top: r, left: o } = n[t];
    i.scrollTop != r + e && (i.scrollTop = r + e), i.scrollLeft != o && (i.scrollLeft = o);
  }
}
let pi = null;
function oL(n) {
  if (n.setActive)
    return n.setActive();
  if (pi)
    return n.focus(pi);
  let e = of(n);
  n.focus(pi == null ? {
    get preventScroll() {
      return pi = { preventScroll: !0 }, !0;
    }
  } : void 0), pi || (pi = !1, sf(e, 0));
}
function af(n, e) {
  let t, i = 2e8, r, o = 0, s = e.top, a = e.top, l, c;
  for (let u = n.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let h;
    if (u.nodeType == 1)
      h = u.getClientRects();
    else if (u.nodeType == 3)
      h = Qt(u).getClientRects();
    else
      continue;
    for (let f = 0; f < h.length; f++) {
      let p = h[f];
      if (p.top <= s && p.bottom >= a) {
        s = Math.max(p.bottom, s), a = Math.min(p.top, a);
        let m = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (m < i) {
          t = u, i = m, r = m && t.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, u.nodeType == 1 && m && (o = d + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = u, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !t && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (o = d + 1);
    }
  }
  return !t && l && (t = l, r = c, i = 0), t && t.nodeType == 3 ? sL(t, r) : !t || i && t.nodeType == 1 ? { node: n, offset: o } : af(t, r);
}
function sL(n, e) {
  let t = n.nodeValue.length, i = document.createRange();
  for (let r = 0; r < t; r++) {
    i.setEnd(n, r + 1), i.setStart(n, r);
    let o = bn(i, 1);
    if (o.top != o.bottom && zl(e, o))
      return { node: n, offset: r + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function zl(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function aL(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function lL(n, e, t) {
  let { node: i, offset: r } = af(e, t), o = -1;
  if (i.nodeType == 1 && !i.firstChild) {
    let s = i.getBoundingClientRect();
    o = s.left != s.right && t.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(i, r, o);
}
function cL(n, e, t, i) {
  let r = -1;
  for (let o = e, s = !1; o != n.dom; ) {
    let a = n.docView.nearestDesc(o, !0), l;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = a.dom.getBoundingClientRect()).width || l.height) && (a.node.isBlock && a.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(a.dom.nodeName) && (!s && l.left > i.left || l.top > i.top ? r = a.posBefore : (!s && l.right < i.left || l.bottom < i.top) && (r = a.posAfter), s = !0), !a.contentDOM && r < 0 && !a.node.isText))
      return (a.node.isBlock ? i.top < (l.top + l.bottom) / 2 : i.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    o = a.dom.parentNode;
  }
  return r > -1 ? r : n.docView.posFromDOM(e, t, -1);
}
function lf(n, e, t) {
  let i = n.childNodes.length;
  if (i && t.top < t.bottom)
    for (let r = Math.max(0, Math.min(i - 1, Math.floor(i * (e.top - t.top) / (t.bottom - t.top)) - 2)), o = r; ; ) {
      let s = n.childNodes[o];
      if (s.nodeType == 1) {
        let a = s.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let c = a[l];
          if (zl(e, c))
            return lf(s, e, c);
        }
      }
      if ((o = (o + 1) % i) == r)
        break;
    }
  return n;
}
function uL(n, e) {
  let t = n.dom.ownerDocument, i, r = 0, o = XA(t, e.left, e.top);
  o && ({ node: i, offset: r } = o);
  let s = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!s || !n.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let c = n.dom.getBoundingClientRect();
    if (!zl(e, c) || (s = lf(n.dom, e, c), !s))
      return null;
  }
  if (Xe)
    for (let c = s; i && c; c = zi(c))
      c.draggable && (i = void 0);
  if (s = aL(s, e), i) {
    if (kt && i.nodeType == 1 && (r = Math.min(r, i.childNodes.length), r < i.childNodes.length)) {
      let u = i.childNodes[r], d;
      u.nodeName == "IMG" && (d = u.getBoundingClientRect()).right <= e.left && d.bottom > e.top && r++;
    }
    let c;
    Ar && r && i.nodeType == 1 && (c = i.childNodes[r - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && r--, i == n.dom && r == i.childNodes.length - 1 && i.lastChild.nodeType == 1 && e.top > i.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (r == 0 || i.nodeType != 1 || i.childNodes[r - 1].nodeName != "BR") && (a = cL(n, i, r, e));
  }
  a == null && (a = lL(n, s, e));
  let l = n.docView.nearestDesc(s, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function Wc(n) {
  return n.top < n.bottom || n.left < n.right;
}
function bn(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let i = t[e < 0 ? 0 : t.length - 1];
    if (Wc(i))
      return i;
  }
  return Array.prototype.find.call(t, Wc) || n.getBoundingClientRect();
}
const dL = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function cf(n, e, t) {
  let { node: i, offset: r, atom: o } = n.docView.domFromPos(e, t < 0 ? -1 : 1), s = Ar || kt;
  if (i.nodeType == 3)
    if (s && (dL.test(i.nodeValue) || (t < 0 ? !r : r == i.nodeValue.length))) {
      let l = bn(Qt(i, r, r), t);
      if (kt && r && /\s/.test(i.nodeValue[r - 1]) && r < i.nodeValue.length) {
        let c = bn(Qt(i, r - 1, r - 1), -1);
        if (c.top == l.top) {
          let u = bn(Qt(i, r, r + 1), -1);
          if (u.top != l.top)
            return Fi(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = r, c = r, u = t < 0 ? 1 : -1;
      return t < 0 && !r ? (c++, u = -1) : t >= 0 && r == i.nodeValue.length ? (l--, u = 1) : t < 0 ? l-- : c++, Fi(bn(Qt(i, l, c), u), u < 0);
    }
  if (!n.state.doc.resolve(e - (o || 0)).parent.inlineContent) {
    if (o == null && r && (t < 0 || r == bt(i))) {
      let l = i.childNodes[r - 1];
      if (l.nodeType == 1)
        return Qs(l.getBoundingClientRect(), !1);
    }
    if (o == null && r < bt(i)) {
      let l = i.childNodes[r];
      if (l.nodeType == 1)
        return Qs(l.getBoundingClientRect(), !0);
    }
    return Qs(i.getBoundingClientRect(), t >= 0);
  }
  if (o == null && r && (t < 0 || r == bt(i))) {
    let l = i.childNodes[r - 1], c = l.nodeType == 3 ? Qt(l, bt(l) - (s ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return Fi(bn(c, 1), !1);
  }
  if (o == null && r < bt(i)) {
    let l = i.childNodes[r];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Qt(l, 0, s ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return Fi(bn(c, -1), !0);
  }
  return Fi(bn(i.nodeType == 3 ? Qt(i) : i, -t), t >= 0);
}
function Fi(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function Qs(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function uf(n, e, t) {
  let i = n.state, r = n.root.activeElement;
  i != e && n.updateState(e), r != n.dom && n.focus();
  try {
    return t();
  } finally {
    i != e && n.updateState(i), r != n.dom && r && r.focus();
  }
}
function hL(n, e, t) {
  let i = e.selection, r = t == "up" ? i.$from : i.$to;
  return uf(n, e, () => {
    let { node: o } = n.docView.domFromPos(r.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(o, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        o = a.contentDOM || a.dom;
        break;
      }
      o = a.dom.parentNode;
    }
    let s = cf(n, r.pos, 1);
    for (let a = o.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = Qt(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (t == "up" ? s.top - u.top > (u.bottom - s.top) * 2 : u.bottom - s.bottom > (s.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const fL = /[\u0590-\u08ac]/;
function pL(n, e, t) {
  let { $head: i } = e.selection;
  if (!i.parent.isTextblock)
    return !1;
  let r = i.parentOffset, o = !r, s = r == i.parent.content.size, a = n.domSelection();
  return a ? !fL.test(i.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? o : s : uf(n, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: d } = n.domSelectionRange(), h = a.caretBidiLevel;
    a.modify("move", t, "character");
    let f = i.depth ? n.docView.domAfterPos(i.before()) : n.dom, { focusNode: p, focusOffset: m } = n.domSelectionRange(), g = p && !f.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && c == m;
    try {
      a.collapse(u, d), l && (l != u || c != d) && a.extend && a.extend(l, c);
    } catch {
    }
    return h != null && (a.caretBidiLevel = h), g;
  }) : i.pos == i.start() || i.pos == i.end();
}
let Kc = null, Zc = null, Gc = !1;
function mL(n, e, t) {
  return Kc == e && Zc == t ? Gc : (Kc = e, Zc = t, Gc = t == "up" || t == "down" ? hL(n, e, t) : pL(n, e, t));
}
const yt = 0, Jc = 1, Jn = 2, Ht = 3;
class Lr {
  constructor(e, t, i, r) {
    this.parent = e, this.children = t, this.dom = i, this.contentDOM = r, this.dirty = yt, i.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, i) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, i = this.posAtStart; ; t++) {
      let r = this.children[t];
      if (r == e)
        return i;
      i += r.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, i) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (i < 0) {
        let o, s;
        if (e == this.contentDOM)
          o = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.previousSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let o, s;
        if (e == this.contentDOM)
          o = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.nextSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let r;
    if (e == this.dom && this.contentDOM)
      r = t > Fe(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      r = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            r = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (r == null && t == e.childNodes.length)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            r = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return r ?? i > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let i = !0, r = e; r; r = r.parentNode) {
      let o = this.getDesc(r), s;
      if (o && (!t || o.node))
        if (i && (s = o.nodeDOM) && !(s.nodeType == 1 ? s.contains(e.nodeType == 1 ? e : e.parentNode) : s == e))
          i = !1;
        else
          return o;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let i = t; i; i = i.parent)
      if (i == this)
        return t;
  }
  posFromDOM(e, t, i) {
    for (let r = e; r; r = r.parentNode) {
      let o = this.getDesc(r);
      if (o)
        return o.localPosFromDOM(e, t, i);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, i = 0; t < this.children.length; t++) {
      let r = this.children[t], o = i + r.size;
      if (i == e && o != i) {
        for (; !r.border && r.children.length; )
          for (let s = 0; s < r.children.length; s++) {
            let a = r.children[s];
            if (a.size) {
              r = a;
              break;
            }
          }
        return r;
      }
      if (e < o)
        return r.descAt(e - i - r.border);
      i = o;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let i = 0, r = 0;
    for (let o = 0; i < this.children.length; i++) {
      let s = this.children[i], a = o + s.size;
      if (a > e || s instanceof hf) {
        r = e - o;
        break;
      }
      o = a;
    }
    if (r)
      return this.children[i].domFromPos(r - this.children[i].border, t);
    for (let o; i && !(o = this.children[i - 1]).size && o instanceof df && o.side >= 0; i--)
      ;
    if (t <= 0) {
      let o, s = !0;
      for (; o = i ? this.children[i - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); i--, s = !1)
        ;
      return o && t && s && !o.border && !o.domAtom ? o.domFromPos(o.size, t) : { node: this.contentDOM, offset: o ? Fe(o.dom) + 1 : 0 };
    } else {
      let o, s = !0;
      for (; o = i < this.children.length ? this.children[i] : null, !(!o || o.dom.parentNode == this.contentDOM); i++, s = !1)
        ;
      return o && s && !o.border && !o.domAtom ? o.domFromPos(0, t) : { node: this.contentDOM, offset: o ? Fe(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, i = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let r = -1, o = -1;
    for (let s = i, a = 0; ; a++) {
      let l = this.children[a], c = s + l.size;
      if (r == -1 && e <= c) {
        let u = s + l.border;
        if (e >= u && t <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, u);
        e = s;
        for (let d = a; d > 0; d--) {
          let h = this.children[d - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            r = Fe(h.dom) + 1;
            break;
          }
          e -= h.size;
        }
        r == -1 && (r = 0);
      }
      if (r > -1 && (c > t || a == this.children.length - 1)) {
        t = c;
        for (let u = a + 1; u < this.children.length; u++) {
          let d = this.children[u];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            o = Fe(d.dom);
            break;
          }
          t += d.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      s = c;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: r, toOffset: o };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: i } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || i == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[i];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, i, r = !1) {
    let o = Math.min(e, t), s = Math.max(e, t);
    for (let f = 0, p = 0; f < this.children.length; f++) {
      let m = this.children[f], g = p + m.size;
      if (o > p && s < g)
        return m.setSelection(e - p - m.border, t - p - m.border, i, r);
      p = g;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = t == e ? a : this.domFromPos(t, t ? -1 : 1), c = i.root.getSelection(), u = i.domSelectionRange(), d = !1;
    if ((kt || Xe) && e == t) {
      let { node: f, offset: p } = a;
      if (f.nodeType == 3) {
        if (d = !!(p && f.nodeValue[p - 1] == `
`), d && p == f.nodeValue.length)
          for (let m = f, g; m; m = m.parentNode) {
            if (g = m.nextSibling) {
              g.nodeName == "BR" && (a = l = { node: g.parentNode, offset: Fe(g) + 1 });
              break;
            }
            let k = m.pmViewDesc;
            if (k && k.node && k.node.isBlock)
              break;
          }
      } else {
        let m = f.childNodes[p - 1];
        d = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (kt && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let f = u.focusNode.childNodes[u.focusOffset];
      f && f.contentEditable == "false" && (r = !0);
    }
    if (!(r || d && Xe) && li(a.node, a.offset, u.anchorNode, u.anchorOffset) && li(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let h = !1;
    if ((c.extend || e == t) && !(d && kt)) {
      c.collapse(a.node, a.offset);
      try {
        e != t && c.extend(l.node, l.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (e > t) {
        let p = a;
        a = l, l = p;
      }
      let f = document.createRange();
      f.setEnd(l.node, l.offset), f.setStart(a.node, a.offset), c.removeAllRanges(), c.addRange(f);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let i = 0, r = 0; r < this.children.length; r++) {
      let o = this.children[r], s = i + o.size;
      if (i == s ? e <= s && t >= i : e < s && t > i) {
        let a = i + o.border, l = s - o.border;
        if (e >= a && t <= l) {
          this.dirty = e == i || t == s ? Jn : Jc, e == a && t == l && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = Ht : o.markDirty(e - a, t - a);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? Jn : Ht;
      }
      i = s;
    }
    this.dirty = Jn;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let i = e == 1 ? Jn : Jc;
      t.dirty < i && (t.dirty = i);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class df extends Lr {
  constructor(e, t, i, r) {
    let o, s = t.type.toDOM;
    if (typeof s == "function" && (s = s(i, () => {
      if (!o)
        return r;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !t.type.spec.raw) {
      if (s.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(s), s = a;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(e, [], s, null), this.widget = t, this.widget = t, o = this;
  }
  matchesWidget(e) {
    return this.dirty == yt && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class gL extends Lr {
  constructor(e, t, i, r) {
    super(e, [], t, null), this.textDOM = i, this.text = r;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class ci extends Lr {
  constructor(e, t, i, r, o) {
    super(e, [], i, r), this.mark = t, this.spec = o;
  }
  static create(e, t, i, r) {
    let o = r.nodeViews[t.type.name], s = o && o(t, r, i);
    return (!s || !s.dom) && (s = di.renderSpec(document, t.type.spec.toDOM(t, i), null, t.attrs)), new ci(e, t, s.dom, s.contentDOM || s.dom, s);
  }
  parseRule() {
    return this.dirty & Ht || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Ht && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != yt) {
      let i = this.parent;
      for (; !i.node; )
        i = i.parent;
      i.dirty < this.dirty && (i.dirty = this.dirty), this.dirty = yt;
    }
  }
  slice(e, t, i) {
    let r = ci.create(this.parent, this.mark, !0, i), o = this.children, s = this.size;
    t < s && (o = Wa(o, t, s, i)), e > 0 && (o = Wa(o, 0, e, i));
    for (let a = 0; a < o.length; a++)
      o[a].parent = r;
    return r.children = o, r;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class zn extends Lr {
  constructor(e, t, i, r, o, s, a, l, c) {
    super(e, [], o, s), this.node = t, this.outerDeco = i, this.innerDeco = r, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, i, r, o, s) {
    let a = o.nodeViews[t.type.name], l, c = a && a(t, o, () => {
      if (!l)
        return s;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, i, r), u = c && c.dom, d = c && c.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: d } = di.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !d && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let h = u;
    return u = mf(u, i, t), c ? l = new _L(e, t, i, r, u, d || null, h, c, o, s + 1) : t.isText ? new Cs(e, t, i, r, u, h, o) : new zn(e, t, i, r, u, d || null, h, o, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let i = this.children[t];
        if (this.dom.contains(i.dom.parentNode)) {
          e.contentElement = i.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => O.empty);
    }
    return e;
  }
  matchesNode(e, t, i) {
    return this.dirty == yt && e.eq(this.node) && Co(t, this.outerDeco) && i.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let i = this.node.inlineContent, r = t, o = e.composing ? this.localCompositionInfo(e, t) : null, s = o && o.pos > -1 ? o : null, a = o && o.pos < 0, l = new kL(this, s && s.node, e);
    xL(this.node, this.innerDeco, (c, u, d) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, i, e) : c.type.side >= 0 && !d && l.syncToMarks(u == this.node.childCount ? fe.none : this.node.child(u).marks, i, e), l.placeWidget(c, e, r);
    }, (c, u, d, h) => {
      l.syncToMarks(c.marks, i, e);
      let f;
      l.findNodeMatch(c, u, d, h) || a && e.state.selection.from > r && e.state.selection.to < r + c.nodeSize && (f = l.findIndexWithChild(o.node)) > -1 && l.updateNodeAt(c, u, d, f, e) || l.updateNextNode(c, u, d, e, h, r) || l.addNode(c, u, d, e, r), r += c.nodeSize;
    }), l.syncToMarks([], i, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Jn) && (s && this.protectLocalComposition(e, s), ff(this.contentDOM, this.children, e), Ai && SL(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: i, to: r } = e.state.selection;
    if (!(e.state.selection instanceof Y) || i < t || r > t + this.node.content.size)
      return null;
    let o = e.input.compositionNode;
    if (!o || !this.dom.contains(o.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = o.nodeValue, a = wL(this.node.content, s, i - t, r - t);
      return a < 0 ? null : { node: o, pos: a, text: s };
    } else
      return { node: o, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: i, text: r }) {
    if (this.getDesc(t))
      return;
    let o = t;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let s = new gL(this, o, t, r);
    e.input.compositionNodes.push(s), this.children = Wa(this.children, i, i + r.length, e, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, i, r) {
    return this.dirty == Ht || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, i, r), !0);
  }
  updateInner(e, t, i, r) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = i, this.contentDOM && this.updateChildren(r, this.posAtStart), this.dirty = yt;
  }
  updateOuterDeco(e) {
    if (Co(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, i = this.dom;
    this.dom = pf(this.dom, this.nodeDOM, Ua(this.outerDeco, this.node, t), Ua(e, this.node, t)), this.dom != i && (i.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Yc(n, e, t, i, r) {
  mf(i, e, n);
  let o = new zn(void 0, n, e, t, i, i, i, r, 0);
  return o.contentDOM && o.updateChildren(r, 0), o;
}
class Cs extends zn {
  constructor(e, t, i, r, o, s, a) {
    super(e, t, i, r, o, null, s, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, i, r) {
    return this.dirty == Ht || this.dirty != yt && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != yt || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, r.trackWrites == this.nodeDOM && (r.trackWrites = null)), this.node = e, this.dirty = yt, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, i) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, i);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, i) {
    let r = this.node.cut(e, t), o = document.createTextNode(r.text);
    return new Cs(this.parent, r, this.outerDeco, this.innerDeco, o, o, i);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Ht);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class hf extends Lr {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == yt && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class _L extends zn {
  constructor(e, t, i, r, o, s, a, l, c, u) {
    super(e, t, i, r, o, s, a, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, i, r) {
    if (this.dirty == Ht)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let o = this.spec.update(e, t, i);
      return o && this.updateInner(e, t, i, r), o;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, i, r);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, i, r) {
    this.spec.setSelection ? this.spec.setSelection(e, t, i.root) : super.setSelection(e, t, i, r);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function ff(n, e, t) {
  let i = n.firstChild, r = !1;
  for (let o = 0; o < e.length; o++) {
    let s = e[o], a = s.dom;
    if (a.parentNode == n) {
      for (; a != i; )
        i = Xc(i), r = !0;
      i = i.nextSibling;
    } else
      r = !0, n.insertBefore(a, i);
    if (s instanceof ci) {
      let l = i ? i.previousSibling : n.lastChild;
      ff(s.contentDOM, s.children, t), i = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; i; )
    i = Xc(i), r = !0;
  r && t.trackWrites == n && (t.trackWrites = null);
}
const Xi = function(n) {
  n && (this.nodeName = n);
};
Xi.prototype = /* @__PURE__ */ Object.create(null);
const Yn = [new Xi()];
function Ua(n, e, t) {
  if (n.length == 0)
    return Yn;
  let i = t ? Yn[0] : new Xi(), r = [i];
  for (let o = 0; o < n.length; o++) {
    let s = n[o].type.attrs;
    if (s) {
      s.nodeName && r.push(i = new Xi(s.nodeName));
      for (let a in s) {
        let l = s[a];
        l != null && (t && r.length == 1 && r.push(i = new Xi(e.isInline ? "span" : "div")), a == "class" ? i.class = (i.class ? i.class + " " : "") + l : a == "style" ? i.style = (i.style ? i.style + ";" : "") + l : a != "nodeName" && (i[a] = l));
      }
    }
  }
  return r;
}
function pf(n, e, t, i) {
  if (t == Yn && i == Yn)
    return e;
  let r = e;
  for (let o = 0; o < i.length; o++) {
    let s = i[o], a = t[o];
    if (o) {
      let l;
      a && a.nodeName == s.nodeName && r != n && (l = r.parentNode) && l.nodeName.toLowerCase() == s.nodeName || (l = document.createElement(s.nodeName), l.pmIsDeco = !0, l.appendChild(r), a = Yn[0]), r = l;
    }
    bL(r, a || Yn[0], s);
  }
  return r;
}
function bL(n, e, t) {
  for (let i in e)
    i != "class" && i != "style" && i != "nodeName" && !(i in t) && n.removeAttribute(i);
  for (let i in t)
    i != "class" && i != "style" && i != "nodeName" && t[i] != e[i] && n.setAttribute(i, t[i]);
  if (e.class != t.class) {
    let i = e.class ? e.class.split(" ").filter(Boolean) : [], r = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < i.length; o++)
      r.indexOf(i[o]) == -1 && n.classList.remove(i[o]);
    for (let o = 0; o < r.length; o++)
      i.indexOf(r[o]) == -1 && n.classList.add(r[o]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let i = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, r;
      for (; r = i.exec(e.style); )
        n.style.removeProperty(r[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function mf(n, e, t) {
  return pf(n, n, Yn, Ua(e, t, n.nodeType != 1));
}
function Co(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function Xc(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class kL {
  constructor(e, t, i) {
    this.lock = t, this.view = i, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = yL(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let i = e; i < t; i++)
        this.top.children[i].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, i) {
    let r = 0, o = this.stack.length >> 1, s = Math.min(o, e.length);
    for (; r < s && (r == o - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(e[r]) && e[r].type.spec.spanning !== !1; )
      r++;
    for (; r < o; )
      this.destroyRest(), this.top.dirty = yt, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[o]) && !this.isLocked(c.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = ci.create(this.top, e[o], t, i);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, i, r) {
    let o = -1, s;
    if (r >= this.preMatch.index && (s = this.preMatch.matches[r - this.preMatch.index]).parent == this.top && s.matchesNode(e, t, i))
      o = this.top.children.indexOf(s, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let c = this.top.children[a];
        if (c.matchesNode(e, t, i) && !this.preMatch.matched.has(c)) {
          o = a;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(e, t, i, r, o) {
    let s = this.top.children[r];
    return s.dirty == Ht && s.dom == s.contentDOM && (s.dirty = Jn), s.update(e, t, i, o) ? (this.destroyBetween(this.index, r), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let i = e.pmViewDesc;
        if (i) {
          for (let r = this.index; r < this.top.children.length; r++)
            if (this.top.children[r] == i)
              return r;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, i, r, o, s) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof zn) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != o)
          return !1;
        let u = l.dom, d, h = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != Ht && Co(t, l.outerDeco));
        if (!h && l.update(e, t, i, r))
          return this.destroyBetween(this.index, a), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!h && (d = this.recreateWrapper(l, e, t, i, r, s)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = d, d.contentDOM && (d.dirty = Jn, d.updateChildren(r, s + 1), d.dirty = yt), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, i, r, o, s) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !Co(i, e.outerDeco) || !r.eq(e.innerDeco))
      return null;
    let a = zn.create(this.top, t, i, r, o, s);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, i, r, o) {
    let s = zn.create(this.top, e, t, i, r, o);
    s.contentDOM && s.updateChildren(r, o + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(e, t, i) {
    let r = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (r && r.matchesWidget(e) && (e == r.widget || !r.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new df(this.top, e, t, i);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof ci; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof Cs) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Xe || Ze) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let i = document.createElement(e);
      e == "IMG" && (i.className = "ProseMirror-separator", i.alt = ""), e == "BR" && (i.className = "ProseMirror-trailingBreak");
      let r = new hf(this.top, [], i, null);
      t != this.top ? t.children.push(r) : t.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function yL(n, e) {
  let t = e, i = t.children.length, r = n.childCount, o = /* @__PURE__ */ new Map(), s = [];
  e: for (; r > 0; ) {
    let a;
    for (; ; )
      if (i) {
        let c = t.children[i - 1];
        if (c instanceof ci)
          t = c, i = c.children.length;
        else {
          a = c, i--;
          break;
        }
      } else {
        if (t == e)
          break e;
        i = t.parent.children.indexOf(t), t = t.parent;
      }
    let l = a.node;
    if (l) {
      if (l != n.child(r - 1))
        break;
      --r, o.set(a, r), s.push(a);
    }
  }
  return { index: r, matched: o, matches: s.reverse() };
}
function vL(n, e) {
  return n.type.side - e.type.side;
}
function xL(n, e, t, i) {
  let r = e.locals(n), o = 0;
  if (r.length == 0) {
    for (let c = 0; c < n.childCount; c++) {
      let u = n.child(c);
      i(u, r, e.forChild(o, u), c), o += u.nodeSize;
    }
    return;
  }
  let s = 0, a = [], l = null;
  for (let c = 0; ; ) {
    let u, d;
    for (; s < r.length && r[s].to == o; ) {
      let g = r[s++];
      g.widget && (u ? (d || (d = [u])).push(g) : u = g);
    }
    if (u)
      if (d) {
        d.sort(vL);
        for (let g = 0; g < d.length; g++)
          t(d[g], c, !!l);
      } else
        t(u, c, !!l);
    let h, f;
    if (l)
      f = -1, h = l, l = null;
    else if (c < n.childCount)
      f = c, h = n.child(c++);
    else
      break;
    for (let g = 0; g < a.length; g++)
      a[g].to <= o && a.splice(g--, 1);
    for (; s < r.length && r[s].from <= o && r[s].to > o; )
      a.push(r[s++]);
    let p = o + h.nodeSize;
    if (h.isText) {
      let g = p;
      s < r.length && r[s].from < g && (g = r[s].from);
      for (let k = 0; k < a.length; k++)
        a[k].to < g && (g = a[k].to);
      g < p && (l = h.cut(g - o), h = h.cut(0, g - o), p = g, f = -1);
    } else
      for (; s < r.length && r[s].to < p; )
        s++;
    let m = h.isInline && !h.isLeaf ? a.filter((g) => !g.inline) : a.slice();
    i(h, m, e.forChild(o, h), f), o = p;
  }
}
function SL(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function wL(n, e, t, i) {
  for (let r = 0, o = 0; r < n.childCount && o <= i; ) {
    let s = n.child(r++), a = o;
    if (o += s.nodeSize, !s.isText)
      continue;
    let l = s.text;
    for (; r < n.childCount; ) {
      let c = n.child(r++);
      if (o += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (o >= t) {
      if (o >= i && l.slice(i - e.length - a, i - a) == e)
        return i - e.length;
      let c = a < i ? l.lastIndexOf(e, i - a - 1) : -1;
      if (c >= 0 && c + e.length + a >= t)
        return a + c;
      if (t == i && l.length >= i + e.length - a && l.slice(i - a, i - a + e.length) == e)
        return i;
    }
  }
  return -1;
}
function Wa(n, e, t, i, r) {
  let o = [];
  for (let s = 0, a = 0; s < n.length; s++) {
    let l = n[s], c = a, u = a += l.size;
    c >= t || u <= e ? o.push(l) : (c < e && o.push(l.slice(0, e - c, i)), r && (o.push(r), r = void 0), u > t && o.push(l.slice(t - c, l.size, i)));
  }
  return o;
}
function Al(n, e = null) {
  let t = n.domSelectionRange(), i = n.state.doc;
  if (!t.focusNode)
    return null;
  let r = n.docView.nearestDesc(t.focusNode), o = r && r.size == 0, s = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (s < 0)
    return null;
  let a = i.resolve(s), l, c;
  if (ws(t)) {
    for (l = s; r && !r.node; )
      r = r.parent;
    let d = r.node;
    if (r && d.isAtom && F.isSelectable(d) && r.parent && !(d.isInline && JA(t.focusNode, t.focusOffset, r.dom))) {
      let h = r.posBefore;
      c = new F(s == h ? a : i.resolve(h));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let d = s, h = s;
      for (let f = 0; f < t.rangeCount; f++) {
        let p = t.getRangeAt(f);
        d = Math.min(d, n.docView.posFromDOM(p.startContainer, p.startOffset, 1)), h = Math.max(h, n.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, s] = h == n.state.selection.anchor ? [h, d] : [d, h], a = i.resolve(s);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = i.resolve(l);
  if (!c) {
    let d = e == "pointer" || n.state.selection.head < a.pos && !o ? 1 : -1;
    c = Ll(n, u, a, d);
  }
  return c;
}
function gf(n) {
  return n.editable ? n.hasFocus() : bf(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function sn(n, e = !1) {
  let t = n.state.selection;
  if (_f(n, t), !!gf(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && Ze) {
      let i = n.domSelectionRange(), r = n.domObserver.currentSelection;
      if (i.anchorNode && r.anchorNode && li(i.anchorNode, i.anchorOffset, r.anchorNode, r.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      TL(n);
    else {
      let { anchor: i, head: r } = t, o, s;
      Qc && !(t instanceof Y) && (t.$from.parent.inlineContent || (o = eu(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (s = eu(n, t.to))), n.docView.setSelection(i, r, n, e), Qc && (o && tu(o), s && tu(s)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && CL(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const Qc = Xe || Ze && rf < 63;
function eu(n, e) {
  let { node: t, offset: i } = n.docView.domFromPos(e, 0), r = i < t.childNodes.length ? t.childNodes[i] : null, o = i ? t.childNodes[i - 1] : null;
  if (Xe && r && r.contentEditable == "false")
    return ea(r);
  if ((!r || r.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (r)
      return ea(r);
    if (o)
      return ea(o);
  }
}
function ea(n) {
  return n.contentEditable = "true", Xe && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function tu(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function CL(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), i = t.anchorNode, r = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != i || t.anchorOffset != r) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!gf(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function TL(n) {
  let e = n.domSelection();
  if (!e)
    return;
  let t = n.cursorWrapper.dom, i = t.nodeName == "IMG";
  i ? e.collapse(t.parentNode, Fe(t) + 1) : e.collapse(t, 0), !i && !n.state.selection.visible && st && $n <= 11 && (t.disabled = !0, t.disabled = !1);
}
function _f(n, e) {
  if (e instanceof F) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (nu(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    nu(n);
}
function nu(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function Ll(n, e, t, i) {
  return n.someProp("createSelectionBetween", (r) => r(n, e, t)) || Y.between(e, t, i);
}
function iu(n) {
  return n.editable && !n.hasFocus() ? !1 : bf(n);
}
function bf(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function OL(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return li(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function Ka(n, e) {
  let { $anchor: t, $head: i } = n.selection, r = e > 0 ? t.max(i) : t.min(i), o = r.parent.inlineContent ? r.depth ? n.doc.resolve(e > 0 ? r.after() : r.before()) : null : r;
  return o && ie.findFrom(o, e);
}
function kn(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function ru(n, e, t) {
  let i = n.state.selection;
  if (i instanceof Y)
    if (t.indexOf("s") > -1) {
      let { $head: r } = i, o = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter;
      if (!o || o.isText || !o.isLeaf)
        return !1;
      let s = n.state.doc.resolve(r.pos + o.nodeSize * (e < 0 ? -1 : 1));
      return kn(n, new Y(i.$anchor, s));
    } else if (i.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let r = Ka(n.state, e);
        return r && r instanceof F ? kn(n, r) : !1;
      } else if (!(_t && t.indexOf("m") > -1)) {
        let r = i.$head, o = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter, s;
        if (!o || o.isText)
          return !1;
        let a = e < 0 ? r.pos - o.nodeSize : r.pos;
        return o.isAtom || (s = n.docView.descAt(a)) && !s.contentDOM ? F.isSelectable(o) ? kn(n, new F(e < 0 ? n.state.doc.resolve(r.pos - o.nodeSize) : r)) : Ar ? kn(n, new Y(n.state.doc.resolve(e < 0 ? a : a + o.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (i instanceof F && i.node.isInline)
      return kn(n, new Y(e > 0 ? i.$to : i.$from));
    {
      let r = Ka(n.state, e);
      return r ? kn(n, r) : !1;
    }
  }
}
function To(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Qi(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function mi(n, e) {
  return e < 0 ? EL(n) : ML(n);
}
function EL(n) {
  let e = n.domSelectionRange(), t = e.focusNode, i = e.focusOffset;
  if (!t)
    return;
  let r, o, s = !1;
  for (kt && t.nodeType == 1 && i < To(t) && Qi(t.childNodes[i], -1) && (s = !0); ; )
    if (i > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[i - 1];
        if (Qi(a, -1))
          r = t, o = --i;
        else if (a.nodeType == 3)
          t = a, i = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (kf(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && Qi(a, -1); )
          r = t.parentNode, o = Fe(a), a = a.previousSibling;
        if (a)
          t = a, i = To(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          i = 0;
        }
      }
    }
  s ? Za(n, t, i) : r && Za(n, r, o);
}
function ML(n) {
  let e = n.domSelectionRange(), t = e.focusNode, i = e.focusOffset;
  if (!t)
    return;
  let r = To(t), o, s;
  for (; ; )
    if (i < r) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[i];
      if (Qi(a, 1))
        o = t, s = ++i;
      else
        break;
    } else {
      if (kf(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && Qi(a, 1); )
          o = a.parentNode, s = Fe(a) + 1, a = a.nextSibling;
        if (a)
          t = a, i = 0, r = To(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          i = r = 0;
        }
      }
    }
  o && Za(n, o, s);
}
function kf(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function $L(n, e) {
  for (; n && e == n.childNodes.length && !zr(n); )
    e = Fe(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function zL(n, e) {
  for (; n && !e && !zr(n); )
    e = Fe(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function Za(n, e, t) {
  if (e.nodeType != 3) {
    let o, s;
    (s = $L(e, t)) ? (e = s, t = 0) : (o = zL(e, t)) && (e = o, t = o.nodeValue.length);
  }
  let i = n.domSelection();
  if (!i)
    return;
  if (ws(i)) {
    let o = document.createRange();
    o.setEnd(e, t), o.setStart(e, t), i.removeAllRanges(), i.addRange(o);
  } else i.extend && i.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: r } = n;
  setTimeout(() => {
    n.state == r && sn(n);
  }, 50);
}
function ou(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(Ze || QA) && t.parent.inlineContent) {
    let r = n.coordsAtPos(e);
    if (e > t.start()) {
      let o = n.coordsAtPos(e - 1), s = (o.top + o.bottom) / 2;
      if (s > r.top && s < r.bottom && Math.abs(o.left - r.left) > 1)
        return o.left < r.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let o = n.coordsAtPos(e + 1), s = (o.top + o.bottom) / 2;
      if (s > r.top && s < r.bottom && Math.abs(o.left - r.left) > 1)
        return o.left > r.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function su(n, e, t) {
  let i = n.state.selection;
  if (i instanceof Y && !i.empty || t.indexOf("s") > -1 || _t && t.indexOf("m") > -1)
    return !1;
  let { $from: r, $to: o } = i;
  if (!r.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let s = Ka(n.state, e);
    if (s && s instanceof F)
      return kn(n, s);
  }
  if (!r.parent.inlineContent) {
    let s = e < 0 ? r : o, a = i instanceof ot ? ie.near(s, e) : ie.findFrom(s, e);
    return a ? kn(n, a) : !1;
  }
  return !1;
}
function au(n, e) {
  if (!(n.state.selection instanceof Y))
    return !0;
  let { $head: t, $anchor: i, empty: r } = n.state.selection;
  if (!t.sameParent(i))
    return !0;
  if (!r)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let o = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (o && !o.isText) {
    let s = n.state.tr;
    return e < 0 ? s.delete(t.pos - o.nodeSize, t.pos) : s.delete(t.pos, t.pos + o.nodeSize), n.dispatch(s), !0;
  }
  return !1;
}
function lu(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function AL(n) {
  if (!Xe || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let i = e.firstChild;
    lu(n, i, "true"), setTimeout(() => lu(n, i, "false"), 20);
  }
  return !1;
}
function LL(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function NL(n, e) {
  let t = e.keyCode, i = LL(e);
  if (t == 8 || _t && t == 72 && i == "c")
    return au(n, -1) || mi(n, -1);
  if (t == 46 && !e.shiftKey || _t && t == 68 && i == "c")
    return au(n, 1) || mi(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || _t && t == 66 && i == "c") {
    let r = t == 37 ? ou(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return ru(n, r, i) || mi(n, r);
  } else if (t == 39 || _t && t == 70 && i == "c") {
    let r = t == 39 ? ou(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return ru(n, r, i) || mi(n, r);
  } else {
    if (t == 38 || _t && t == 80 && i == "c")
      return su(n, -1, i) || mi(n, -1);
    if (t == 40 || _t && t == 78 && i == "c")
      return AL(n) || su(n, 1, i) || mi(n, 1);
    if (i == (_t ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function Nl(n, e) {
  n.someProp("transformCopied", (f) => {
    e = f(e, n);
  });
  let t = [], { content: i, openStart: r, openEnd: o } = e;
  for (; r > 1 && o > 1 && i.childCount == 1 && i.firstChild.childCount == 1; ) {
    r--, o--;
    let f = i.firstChild;
    t.push(f.type.name, f.attrs != f.type.defaultAttrs ? f.attrs : null), i = f.content;
  }
  let s = n.someProp("clipboardSerializer") || di.fromSchema(n.state.schema), a = Cf(), l = a.createElement("div");
  l.appendChild(s.serializeFragment(i, { document: a }));
  let c = l.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = wf[c.nodeName.toLowerCase()]); ) {
    for (let f = u.length - 1; f >= 0; f--) {
      let p = a.createElement(u[f]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), d++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${r} ${o}${d ? ` -${d}` : ""} ${JSON.stringify(t)}`);
  let h = n.someProp("clipboardTextSerializer", (f) => f(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: h, slice: e };
}
function yf(n, e, t, i, r) {
  let o = r.parent.type.spec.code, s, a;
  if (!t && !e)
    return null;
  let l = !!e && (i || o || !t);
  if (l) {
    if (n.someProp("transformPastedText", (h) => {
      e = h(e, o || i, n);
    }), o)
      return a = new N(O.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), n.someProp("transformPasted", (h) => {
        a = h(a, n, !0);
      }), a;
    let d = n.someProp("clipboardTextParser", (h) => h(e, r, i, n));
    if (d)
      a = d;
    else {
      let h = r.marks(), { schema: f } = n.state, p = di.fromSchema(f);
      s = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let g = s.appendChild(document.createElement("p"));
        m && g.appendChild(p.serializeNode(f.text(m, h)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (d) => {
      t = d(t, n);
    }), s = PL(t), Ar && jL(s);
  let c = s && s.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let h = s.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      s = h;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || Mn.fromSchema(n.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(l || u),
    context: r,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !DL.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    a = BL(cu(a, +u[1], +u[2]), u[4]);
  else if (a = N.maxOpen(RL(a.content, r), !0), a.openStart || a.openEnd) {
    let d = 0, h = 0;
    for (let f = a.content.firstChild; d < a.openStart && !f.type.spec.isolating; d++, f = f.firstChild)
      ;
    for (let f = a.content.lastChild; h < a.openEnd && !f.type.spec.isolating; h++, f = f.lastChild)
      ;
    a = cu(a, d, h);
  }
  return n.someProp("transformPasted", (d) => {
    a = d(a, n, l);
  }), a;
}
const DL = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function RL(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let r = e.node(t).contentMatchAt(e.index(t)), o, s = [];
    if (n.forEach((a) => {
      if (!s)
        return;
      let l = r.findWrapping(a.type), c;
      if (!l)
        return s = null;
      if (c = s.length && o.length && xf(l, o, a, s[s.length - 1], 0))
        s[s.length - 1] = c;
      else {
        s.length && (s[s.length - 1] = Sf(s[s.length - 1], o.length));
        let u = vf(a, l);
        s.push(u), r = r.matchType(u.type), o = l;
      }
    }), s)
      return O.from(s);
  }
  return n;
}
function vf(n, e, t = 0) {
  for (let i = e.length - 1; i >= t; i--)
    n = e[i].create(null, O.from(n));
  return n;
}
function xf(n, e, t, i, r) {
  if (r < n.length && r < e.length && n[r] == e[r]) {
    let o = xf(n, e, t, i.lastChild, r + 1);
    if (o)
      return i.copy(i.content.replaceChild(i.childCount - 1, o));
    if (i.contentMatchAt(i.childCount).matchType(r == n.length - 1 ? t.type : n[r + 1]))
      return i.copy(i.content.append(O.from(vf(t, n, r + 1))));
  }
}
function Sf(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, Sf(n.lastChild, e - 1)), i = n.contentMatchAt(n.childCount).fillBefore(O.empty, !0);
  return n.copy(t.append(i));
}
function Ga(n, e, t, i, r, o) {
  let s = e < 0 ? n.firstChild : n.lastChild, a = s.content;
  return n.childCount > 1 && (o = 0), r < i - 1 && (a = Ga(a, e, t, i, r + 1, o)), r >= t && (a = e < 0 ? s.contentMatchAt(0).fillBefore(a, o <= r).append(a) : a.append(s.contentMatchAt(s.childCount).fillBefore(O.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, s.copy(a));
}
function cu(n, e, t) {
  return e < n.openStart && (n = new N(Ga(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new N(Ga(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const wf = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let uu = null;
function Cf() {
  return uu || (uu = document.implementation.createHTMLDocument("title"));
}
let ta = null;
function IL(n) {
  let e = window.trustedTypes;
  return e ? (ta || (ta = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), ta.createHTML(n)) : n;
}
function PL(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = Cf().createElement("div"), i = /<([a-z][^>\s]+)/i.exec(n), r;
  if ((r = i && wf[i[1].toLowerCase()]) && (n = r.map((o) => "<" + o + ">").join("") + n + r.map((o) => "</" + o + ">").reverse().join("")), t.innerHTML = IL(n), r)
    for (let o = 0; o < r.length; o++)
      t = t.querySelector(r[o]) || t;
  return t;
}
function jL(n) {
  let e = n.querySelectorAll(Ze ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let i = e[t];
    i.childNodes.length == 1 && i.textContent == " " && i.parentNode && i.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), i);
  }
}
function BL(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, i;
  try {
    i = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: r, openStart: o, openEnd: s } = n;
  for (let a = i.length - 2; a >= 0; a -= 2) {
    let l = t.nodes[i[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    r = O.from(l.create(i[a + 1], r)), o++, s++;
  }
  return new N(r, o, s);
}
const Qe = {}, et = {}, FL = { touchstart: !0, touchmove: !0 };
class qL {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function HL(n) {
  for (let e in Qe) {
    let t = Qe[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (i) => {
      UL(n, i) && !Dl(n, i) && (n.editable || !(i.type in et)) && t(n, i);
    }, FL[e] ? { passive: !0 } : void 0);
  }
  Xe && n.dom.addEventListener("input", () => null), Ja(n);
}
function Tn(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function VL(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function Ja(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (i) => Dl(n, i));
  });
}
function Dl(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let i = t[e.type];
    return i ? i(n, e) || e.defaultPrevented : !1;
  });
}
function UL(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function WL(n, e) {
  !Dl(n, e) && Qe[e.type] && (n.editable || !(e.type in et)) && Qe[e.type](n, e);
}
et.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Of(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(tn && Ze && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), Ai && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let i = Date.now();
      n.input.lastIOSEnter = i, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == i && (n.someProp("handleKeyDown", (r) => r(n, Zn(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (i) => i(n, t)) || NL(n, t) ? t.preventDefault() : Tn(n, "key");
};
et.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
et.keypress = (n, e) => {
  let t = e;
  if (Of(n, t) || !t.charCode || t.ctrlKey && !t.altKey || _t && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (r) => r(n, t))) {
    t.preventDefault();
    return;
  }
  let i = n.state.selection;
  if (!(i instanceof Y) || !i.$from.sameParent(i.$to)) {
    let r = String.fromCharCode(t.charCode), o = () => n.state.tr.insertText(r).scrollIntoView();
    !/[\r\n]/.test(r) && !n.someProp("handleTextInput", (s) => s(n, i.$from.pos, i.$to.pos, r, o)) && n.dispatch(o()), t.preventDefault();
  }
};
function Ts(n) {
  return { left: n.clientX, top: n.clientY };
}
function KL(n, e) {
  let t = e.x - n.clientX, i = e.y - n.clientY;
  return t * t + i * i < 100;
}
function Rl(n, e, t, i, r) {
  if (i == -1)
    return !1;
  let o = n.state.doc.resolve(i);
  for (let s = o.depth + 1; s > 0; s--)
    if (n.someProp(e, (a) => s > o.depth ? a(n, t, o.nodeAfter, o.before(s), r, !0) : a(n, t, o.node(s), o.before(s), r, !1)))
      return !0;
  return !1;
}
function Mi(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let i = n.state.tr.setSelection(e);
  i.setMeta("pointer", !0), n.dispatch(i);
}
function ZL(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), i = t.nodeAfter;
  return i && i.isAtom && F.isSelectable(i) ? (Mi(n, new F(t)), !0) : !1;
}
function GL(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, i, r;
  t instanceof F && (i = t.node);
  let o = n.state.doc.resolve(e);
  for (let s = o.depth + 1; s > 0; s--) {
    let a = s > o.depth ? o.nodeAfter : o.node(s);
    if (F.isSelectable(a)) {
      i && t.$from.depth > 0 && s >= t.$from.depth && o.before(t.$from.depth + 1) == t.$from.pos ? r = o.before(t.$from.depth) : r = o.before(s);
      break;
    }
  }
  return r != null ? (Mi(n, F.create(n.state.doc, r)), !0) : !1;
}
function JL(n, e, t, i, r) {
  return Rl(n, "handleClickOn", e, t, i) || n.someProp("handleClick", (o) => o(n, e, i)) || (r ? GL(n, t) : ZL(n, t));
}
function YL(n, e, t, i) {
  return Rl(n, "handleDoubleClickOn", e, t, i) || n.someProp("handleDoubleClick", (r) => r(n, e, i));
}
function XL(n, e, t, i) {
  return Rl(n, "handleTripleClickOn", e, t, i) || n.someProp("handleTripleClick", (r) => r(n, e, i)) || QL(n, t, i);
}
function QL(n, e, t) {
  if (t.button != 0)
    return !1;
  let i = n.state.doc;
  if (e == -1)
    return i.inlineContent ? (Mi(n, Y.create(i, 0, i.content.size)), !0) : !1;
  let r = i.resolve(e);
  for (let o = r.depth + 1; o > 0; o--) {
    let s = o > r.depth ? r.nodeAfter : r.node(o), a = r.before(o);
    if (s.inlineContent)
      Mi(n, Y.create(i, a + 1, a + 1 + s.content.size));
    else if (F.isSelectable(s))
      Mi(n, F.create(i, a));
    else
      continue;
    return !0;
  }
}
function Il(n) {
  return Oo(n);
}
const Tf = _t ? "metaKey" : "ctrlKey";
Qe.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let i = Il(n), r = Date.now(), o = "singleClick";
  r - n.input.lastClick.time < 500 && KL(t, n.input.lastClick) && !t[Tf] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? o = "doubleClick" : n.input.lastClick.type == "doubleClick" && (o = "tripleClick")), n.input.lastClick = { time: r, x: t.clientX, y: t.clientY, type: o, button: t.button };
  let s = n.posAtCoords(Ts(t));
  s && (o == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new eN(n, s, t, !!i)) : (o == "doubleClick" ? YL : XL)(n, s.pos, s.inside, t) ? t.preventDefault() : Tn(n, "pointer"));
};
class eN {
  constructor(e, t, i, r) {
    this.view = e, this.pos = t, this.event = i, this.flushed = r, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!i[Tf], this.allowDefault = i.shiftKey;
    let o, s;
    if (t.inside > -1)
      o = e.state.doc.nodeAt(t.inside), s = t.inside;
    else {
      let u = e.state.doc.resolve(t.pos);
      o = u.parent, s = u.depth ? u.before() : 0;
    }
    const a = r ? null : i.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l && l.nodeDOM.nodeType == 1 ? l.nodeDOM : null;
    let { selection: c } = e.state;
    (i.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || c instanceof F && c.from <= s && c.to > s) && (this.mightDrag = {
      node: o,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && kt && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Tn(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => sn(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Ts(e))), this.updateAllowDefault(e), this.allowDefault || !t ? Tn(this.view, "pointer") : JL(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Xe && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Ze && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Mi(this.view, ie.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : Tn(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Tn(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Qe.touchstart = (n) => {
  n.input.lastTouch = Date.now(), Il(n), Tn(n, "pointer");
};
Qe.touchmove = (n) => {
  n.input.lastTouch = Date.now(), Tn(n, "pointer");
};
Qe.contextmenu = (n) => Il(n);
function Of(n, e) {
  return n.composing ? !0 : Xe && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const tN = tn ? 5e3 : -1;
et.compositionstart = et.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof Y && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((i) => i.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), Oo(n, !0), n.markCursor = null;
    else if (Oo(n, !e.selection.empty), kt && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let i = n.domSelectionRange();
      for (let r = i.focusNode, o = i.focusOffset; r && r.nodeType == 1 && o != 0; ) {
        let s = o < 0 ? r.lastChild : r.childNodes[o - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(s, s.nodeValue.length);
          break;
        } else
          r = s, o = -1;
      }
    }
    n.input.composing = !0;
  }
  Ef(n, tN);
};
et.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, Ef(n, 20));
};
function Ef(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Oo(n), e));
}
function Mf(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = iN()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function nN(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = ZA(e.focusNode, e.focusOffset), i = GA(e.focusNode, e.focusOffset);
  if (t && i && t != i) {
    let r = i.pmViewDesc, o = n.domObserver.lastChangedTextNode;
    if (t == o || i == o)
      return o;
    if (!r || !r.isText(i.nodeValue))
      return i;
    if (n.input.compositionNode == i) {
      let s = t.pmViewDesc;
      if (!(!s || !s.isText(t.nodeValue)))
        return i;
    }
  }
  return t || i;
}
function iN() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Oo(n, e = !1) {
  if (!(tn && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), Mf(n), e || n.docView && n.docView.dirty) {
      let t = Al(n), i = n.state.selection;
      return t && !t.eq(i) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !i.$from.node(i.$from.sharedDepth(i.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function rN(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let i = getSelection(), r = document.createRange();
  r.selectNodeContents(e), n.dom.blur(), i.removeAllRanges(), i.addRange(r), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const gr = st && $n < 15 || Ai && eL < 604;
Qe.copy = et.cut = (n, e) => {
  let t = e, i = n.state.selection, r = t.type == "cut";
  if (i.empty)
    return;
  let o = gr ? null : t.clipboardData, s = i.content(), { dom: a, text: l } = Nl(n, s);
  o ? (t.preventDefault(), o.clearData(), o.setData("text/html", a.innerHTML), o.setData("text/plain", l)) : rN(n, a), r && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function oN(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function sN(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, i = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (i.contentEditable = "true"), i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.focus();
  let r = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), i.parentNode && i.parentNode.removeChild(i), t ? _r(n, i.value, null, r, e) : _r(n, i.textContent, i.innerHTML, r, e);
  }, 50);
}
function _r(n, e, t, i, r) {
  let o = yf(n, e, t, i, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, r, o || N.empty)))
    return !0;
  if (!o)
    return !1;
  let s = oN(o), a = s ? n.state.tr.replaceSelectionWith(s, i) : n.state.tr.replaceSelection(o);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function $f(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
et.paste = (n, e) => {
  let t = e;
  if (n.composing && !tn)
    return;
  let i = gr ? null : t.clipboardData, r = n.input.shiftKey && n.input.lastKeyCode != 45;
  i && _r(n, $f(i), i.getData("text/html"), r, t) ? t.preventDefault() : sN(n, t);
};
class zf {
  constructor(e, t, i) {
    this.slice = e, this.move = t, this.node = i;
  }
}
const aN = _t ? "altKey" : "ctrlKey";
function Af(n, e) {
  let t = n.someProp("dragCopies", (i) => !i(e));
  return t ?? !e[aN];
}
Qe.dragstart = (n, e) => {
  let t = e, i = n.input.mouseDown;
  if (i && i.done(), !t.dataTransfer)
    return;
  let r = n.state.selection, o = r.empty ? null : n.posAtCoords(Ts(t)), s;
  if (!(o && o.pos >= r.from && o.pos <= (r instanceof F ? r.to - 1 : r.to))) {
    if (i && i.mightDrag)
      s = F.create(n.state.doc, i.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let d = n.docView.nearestDesc(t.target, !0);
      d && d.node.type.spec.draggable && d != n.docView && (s = F.create(n.state.doc, d.posBefore));
    }
  }
  let a = (s || n.state.selection).content(), { dom: l, text: c, slice: u } = Nl(n, a);
  (!t.dataTransfer.files.length || !Ze || rf > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(gr ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", gr || t.dataTransfer.setData("text/plain", c), n.dragging = new zf(u, Af(n, t), s);
};
Qe.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
et.dragover = et.dragenter = (n, e) => e.preventDefault();
et.drop = (n, e) => {
  let t = e, i = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let r = n.posAtCoords(Ts(t));
  if (!r)
    return;
  let o = n.state.doc.resolve(r.pos), s = i && i.slice;
  s ? n.someProp("transformPasted", (p) => {
    s = p(s, n, !1);
  }) : s = yf(n, $f(t.dataTransfer), gr ? null : t.dataTransfer.getData("text/html"), !1, o);
  let a = !!(i && Af(n, t));
  if (n.someProp("handleDrop", (p) => p(n, t, s || N.empty, a))) {
    t.preventDefault();
    return;
  }
  if (!s)
    return;
  t.preventDefault();
  let l = s ? Zh(n.state.doc, o.pos, s) : o.pos;
  l == null && (l = o.pos);
  let c = n.state.tr;
  if (a) {
    let { node: p } = i;
    p ? p.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), d = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, h = c.doc;
  if (d ? c.replaceRangeWith(u, u, s.content.firstChild) : c.replaceRange(u, u, s), c.doc.eq(h))
    return;
  let f = c.doc.resolve(u);
  if (d && F.isSelectable(s.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new F(f));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((m, g, k, v) => p = v), c.setSelection(Ll(n, f, c.doc.resolve(p)));
  }
  n.focus(), n.dispatch(c.setMeta("uiEvent", "drop"));
};
Qe.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && sn(n);
  }, 20));
};
Qe.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
Qe.beforeinput = (n, e) => {
  if (Ze && tn && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: i } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != i || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (o) => o(n, Zn(8, "Backspace")))))
        return;
      let { $cursor: r } = n.state.selection;
      r && r.pos > 0 && n.dispatch(n.state.tr.delete(r.pos - 1, r.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in et)
  Qe[n] = et[n];
function br(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class Eo {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || ni, this.side = this.spec.side || 0;
  }
  map(e, t, i, r) {
    let { pos: o, deleted: s } = e.mapResult(t.from + r, this.side < 0 ? -1 : 1);
    return s ? null : new $t(o - i, o - i, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Eo && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && br(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class An {
  constructor(e, t) {
    this.attrs = e, this.spec = t || ni;
  }
  map(e, t, i, r) {
    let o = e.map(t.from + r, this.spec.inclusiveStart ? -1 : 1) - i, s = e.map(t.to + r, this.spec.inclusiveEnd ? 1 : -1) - i;
    return o >= s ? null : new $t(o, s, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof An && br(this.attrs, e.attrs) && br(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof An;
  }
  destroy() {
  }
}
class Pl {
  constructor(e, t) {
    this.attrs = e, this.spec = t || ni;
  }
  map(e, t, i, r) {
    let o = e.mapResult(t.from + r, 1);
    if (o.deleted)
      return null;
    let s = e.mapResult(t.to + r, -1);
    return s.deleted || s.pos <= o.pos ? null : new $t(o.pos - i, s.pos - i, this);
  }
  valid(e, t) {
    let { index: i, offset: r } = e.content.findIndex(t.from), o;
    return r == t.from && !(o = e.child(i)).isText && r + o.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof Pl && br(this.attrs, e.attrs) && br(this.spec, e.spec);
  }
  destroy() {
  }
}
class $t {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.from = e, this.to = t, this.type = i;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new $t(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, i) {
    return this.type.map(e, this, t, i);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, i) {
    return new $t(e, e, new Eo(t, i));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, i, r) {
    return new $t(e, t, new An(i, r));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, i, r) {
    return new $t(e, t, new Pl(i, r));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof An;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Eo;
  }
}
const Si = [], ni = {};
class Le {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : Si, this.children = t.length ? t : Si;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? Mo(t, e, 0, ni) : Ue;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, i) {
    let r = [];
    return this.findInner(e ?? 0, t ?? 1e9, r, 0, i), r;
  }
  findInner(e, t, i, r, o) {
    for (let s = 0; s < this.local.length; s++) {
      let a = this.local[s];
      a.from <= t && a.to >= e && (!o || o(a.spec)) && i.push(a.copy(a.from + r, a.to + r));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < t && this.children[s + 1] > e) {
        let a = this.children[s] + 1;
        this.children[s + 2].findInner(e - a, t - a, i, r + a, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, i) {
    return this == Ue || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, i || ni);
  }
  /**
  @internal
  */
  mapInner(e, t, i, r, o) {
    let s;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, i, r);
      l && l.type.valid(t, l) ? (s || (s = [])).push(l) : o.onRemove && o.onRemove(this.local[a].spec);
    }
    return this.children.length ? lN(this.children, s || [], e, t, i, r, o) : s ? new Le(s.sort(ii), Si) : Ue;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == Ue ? Le.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, i) {
    let r, o = 0;
    e.forEach((a, l) => {
      let c = l + i, u;
      if (u = Nf(t, a, c)) {
        for (r || (r = this.children.slice()); o < r.length && r[o] < l; )
          o += 3;
        r[o] == l ? r[o + 2] = r[o + 2].addInner(a, u, c + 1) : r.splice(o, 0, l, l + a.nodeSize, Mo(u, a, c + 1, ni)), o += 3;
      }
    });
    let s = Lf(o ? Df(t) : t, -i);
    for (let a = 0; a < s.length; a++)
      s[a].type.valid(e, s[a]) || s.splice(a--, 1);
    return new Le(s.length ? this.local.concat(s).sort(ii) : this.local, r || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Ue ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let i = this.children, r = this.local;
    for (let o = 0; o < i.length; o += 3) {
      let s, a = i[o] + t, l = i[o + 1] + t;
      for (let u = 0, d; u < e.length; u++)
        (d = e[u]) && d.from > a && d.to < l && (e[u] = null, (s || (s = [])).push(d));
      if (!s)
        continue;
      i == this.children && (i = this.children.slice());
      let c = i[o + 2].removeInner(s, a + 1);
      c != Ue ? i[o + 2] = c : (i.splice(o, 3), o -= 3);
    }
    if (r.length) {
      for (let o = 0, s; o < e.length; o++)
        if (s = e[o])
          for (let a = 0; a < r.length; a++)
            r[a].eq(s, t) && (r == this.local && (r = this.local.slice()), r.splice(a--, 1));
    }
    return i == this.children && r == this.local ? this : r.length || i.length ? new Le(r, i) : Ue;
  }
  forChild(e, t) {
    if (this == Ue)
      return this;
    if (t.isLeaf)
      return Le.empty;
    let i, r;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (i = this.children[a + 2]);
        break;
      }
    let o = e + 1, s = o + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < s && l.to > o && l.type instanceof An) {
        let c = Math.max(o, l.from) - o, u = Math.min(s, l.to) - o;
        c < u && (r || (r = [])).push(l.copy(c, u));
      }
    }
    if (r) {
      let a = new Le(r.sort(ii), Si);
      return i ? new xn([a, i]) : a;
    }
    return i || Ue;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof Le) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return jl(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Ue)
      return Si;
    if (e.inlineContent || !this.local.some(An.is))
      return this.local;
    let t = [];
    for (let i = 0; i < this.local.length; i++)
      this.local[i].type instanceof An || t.push(this.local[i]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
Le.empty = new Le([], []);
Le.removeOverlap = jl;
const Ue = Le.empty;
class xn {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const i = this.members.map((r) => r.map(e, t, ni));
    return xn.from(i);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return Le.empty;
    let i = [];
    for (let r = 0; r < this.members.length; r++) {
      let o = this.members[r].forChild(e, t);
      o != Ue && (o instanceof xn ? i = i.concat(o.members) : i.push(o));
    }
    return xn.from(i);
  }
  eq(e) {
    if (!(e instanceof xn) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, i = !0;
    for (let r = 0; r < this.members.length; r++) {
      let o = this.members[r].localsInner(e);
      if (o.length)
        if (!t)
          t = o;
        else {
          i && (t = t.slice(), i = !1);
          for (let s = 0; s < o.length; s++)
            t.push(o[s]);
        }
    }
    return t ? jl(i ? t : t.sort(ii)) : Si;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Ue;
      case 1:
        return e[0];
      default:
        return new xn(e.every((t) => t instanceof Le) ? e : e.reduce((t, i) => t.concat(i instanceof Le ? i : i.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function lN(n, e, t, i, r, o, s) {
  let a = n.slice();
  for (let c = 0, u = o; c < t.maps.length; c++) {
    let d = 0;
    t.maps[c].forEach((h, f, p, m) => {
      let g = m - p - (f - h);
      for (let k = 0; k < a.length; k += 3) {
        let v = a[k + 1];
        if (v < 0 || h > v + u - d)
          continue;
        let S = a[k] + u - d;
        f >= S ? a[k + 1] = h <= S ? -2 : -1 : h >= u && g && (a[k] += g, a[k + 1] += g);
      }
      d += g;
    }), u = t.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < a.length; c += 3)
    if (a[c + 1] < 0) {
      if (a[c + 1] == -2) {
        l = !0, a[c + 1] = -1;
        continue;
      }
      let u = t.map(n[c] + o), d = u - r;
      if (d < 0 || d >= i.content.size) {
        l = !0;
        continue;
      }
      let h = t.map(n[c + 1] + o, -1), f = h - r, { index: p, offset: m } = i.content.findIndex(d), g = i.maybeChild(p);
      if (g && m == d && m + g.nodeSize == f) {
        let k = a[c + 2].mapInner(t, g, u + 1, n[c] + o + 1, s);
        k != Ue ? (a[c] = d, a[c + 1] = f, a[c + 2] = k) : (a[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = cN(a, n, e, t, r, o, s), u = Mo(c, i, 0, s);
    e = u.local;
    for (let d = 0; d < a.length; d += 3)
      a[d + 1] < 0 && (a.splice(d, 3), d -= 3);
    for (let d = 0, h = 0; d < u.children.length; d += 3) {
      let f = u.children[d];
      for (; h < a.length && a[h] < f; )
        h += 3;
      a.splice(h, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new Le(e.sort(ii), a);
}
function Lf(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let i = 0; i < n.length; i++) {
    let r = n[i];
    t.push(new $t(r.from + e, r.to + e, r.type));
  }
  return t;
}
function cN(n, e, t, i, r, o, s) {
  function a(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let d = l.local[u].map(i, r, c);
      d ? t.push(d) : s.onRemove && s.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      a(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && a(n[l + 2], e[l] + o + 1);
  return t;
}
function Nf(n, e, t) {
  if (e.isLeaf)
    return null;
  let i = t + e.nodeSize, r = null;
  for (let o = 0, s; o < n.length; o++)
    (s = n[o]) && s.from > t && s.to < i && ((r || (r = [])).push(s), n[o] = null);
  return r;
}
function Df(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function Mo(n, e, t, i) {
  let r = [], o = !1;
  e.forEach((a, l) => {
    let c = Nf(n, a, l + t);
    if (c) {
      o = !0;
      let u = Mo(c, a, t + l + 1, i);
      u != Ue && r.push(l, l + a.nodeSize, u);
    }
  });
  let s = Lf(o ? Df(n) : n, -t).sort(ii);
  for (let a = 0; a < s.length; a++)
    s[a].type.valid(e, s[a]) || (i.onRemove && i.onRemove(s[a].spec), s.splice(a--, 1));
  return s.length || r.length ? new Le(s, r) : Ue;
}
function ii(n, e) {
  return n.from - e.from || n.to - e.to;
}
function jl(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let i = e[t];
    if (i.from != i.to)
      for (let r = t + 1; r < e.length; r++) {
        let o = e[r];
        if (o.from == i.from) {
          o.to != i.to && (e == n && (e = n.slice()), e[r] = o.copy(o.from, i.to), du(e, r + 1, o.copy(i.to, o.to)));
          continue;
        } else {
          o.from < i.to && (e == n && (e = n.slice()), e[t] = i.copy(i.from, o.from), du(e, r, i.copy(o.from, i.to)));
          break;
        }
      }
  }
  return e;
}
function du(n, e, t) {
  for (; e < n.length && ii(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function na(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let i = t(n.state);
    i && i != Ue && e.push(i);
  }), n.cursorWrapper && e.push(Le.create(n.state.doc, [n.cursorWrapper.deco])), xn.from(e);
}
const uN = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, dN = st && $n <= 11;
class hN {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class fN {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new hN(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((i) => {
      for (let r = 0; r < i.length; r++)
        this.queue.push(i[r]);
      st && $n <= 11 && i.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), dN && (this.onCharData = (i) => {
      this.queue.push({ target: i.target, type: "characterData", oldValue: i.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, uN)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (iu(this.view)) {
      if (this.suppressingSelectionUpdates)
        return sn(this.view);
      if (st && $n <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && li(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), i;
    for (let o = e.focusNode; o; o = zi(o))
      t.add(o);
    for (let o = e.anchorNode; o; o = zi(o))
      if (t.has(o)) {
        i = o;
        break;
      }
    let r = i && this.view.docView.nearestDesc(i);
    if (r && r.ignoreMutation({
      type: "selection",
      target: i.nodeType == 3 ? i.parentNode : i
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let i = e.domSelectionRange(), r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(i) && iu(e) && !this.ignoreSelectionChange(i), o = -1, s = -1, a = !1, l = [];
    if (e.editable)
      for (let u = 0; u < t.length; u++) {
        let d = this.registerMutation(t[u], l);
        d && (o = o < 0 ? d.from : Math.min(d.from, o), s = s < 0 ? d.to : Math.max(d.to, s), d.typeOver && (a = !0));
      }
    if (kt && l.length) {
      let u = l.filter((d) => d.nodeName == "BR");
      if (u.length == 2) {
        let [d, h] = u;
        d.parentNode && d.parentNode.parentNode == h.parentNode ? h.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let h of u) {
          let f = h.parentNode;
          f && f.nodeName == "LI" && (!d || gN(e, d) != f) && h.remove();
        }
      }
    }
    let c = null;
    o < 0 && r && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && ws(i) && (c = Al(e)) && c.eq(ie.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, sn(e), this.currentSelection.set(i), e.scrollToSelection()) : (o > -1 || r) && (o > -1 && (e.docView.markDirty(o, s), pN(e)), this.handleDOMChange(o, s, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(i) || sn(e), this.currentSelection.set(i));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let i = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (i == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !i || i.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let d = e.addedNodes[u];
        t.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (i.contentDOM && i.contentDOM != i.dom && !i.contentDOM.contains(e.target))
        return { from: i.posBefore, to: i.posAfter };
      let r = e.previousSibling, o = e.nextSibling;
      if (st && $n <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: d, nextSibling: h } = e.addedNodes[u];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (r = d), (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (o = h);
        }
      let s = r && r.parentNode == e.target ? Fe(r) + 1 : 0, a = i.localPosFromDOM(e.target, s, -1), l = o && o.parentNode == e.target ? Fe(o) : e.target.childNodes.length, c = i.localPosFromDOM(e.target, l, 1);
      return { from: a, to: c };
    } else return e.type == "attributes" ? { from: i.posAtStart - i.border, to: i.posAtEnd + i.border } : (this.lastChangedTextNode = e.target, {
      from: i.posAtStart,
      to: i.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let hu = /* @__PURE__ */ new WeakMap(), fu = !1;
function pN(n) {
  if (!hu.has(n) && (hu.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = kt, fu)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), fu = !0;
  }
}
function pu(n, e) {
  let t = e.startContainer, i = e.startOffset, r = e.endContainer, o = e.endOffset, s = n.domAtPos(n.state.selection.anchor);
  return li(s.node, s.offset, r, o) && ([t, i, r, o] = [r, o, t, i]), { anchorNode: t, anchorOffset: i, focusNode: r, focusOffset: o };
}
function mN(n, e) {
  if (e.getComposedRanges) {
    let r = e.getComposedRanges(n.root)[0];
    if (r)
      return pu(n, r);
  }
  let t;
  function i(r) {
    r.preventDefault(), r.stopImmediatePropagation(), t = r.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", i, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", i, !0), t ? pu(n, t) : null;
}
function gN(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let i = n.docView.nearestDesc(t, !0);
    if (i && i.node.isBlock)
      return t;
  }
  return null;
}
function _N(n, e, t) {
  let { node: i, fromOffset: r, toOffset: o, from: s, to: a } = n.docView.parseRange(e, t), l = n.domSelectionRange(), c, u = l.anchorNode;
  if (u && n.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], ws(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), Ze && n.input.lastKeyCode === 8)
    for (let g = o; g > r; g--) {
      let k = i.childNodes[g - 1], v = k.pmViewDesc;
      if (k.nodeName == "BR" && !v) {
        o = g;
        break;
      }
      if (!v || v.size)
        break;
    }
  let d = n.state.doc, h = n.someProp("domParser") || Mn.fromSchema(n.state.schema), f = d.resolve(s), p = null, m = h.parse(i, {
    topNode: f.parent,
    topMatch: f.parent.contentMatchAt(f.index()),
    topOpen: !0,
    from: r,
    to: o,
    preserveWhitespace: f.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: bN,
    context: f
  });
  if (c && c[0].pos != null) {
    let g = c[0].pos, k = c[1] && c[1].pos;
    k == null && (k = g), p = { anchor: g + s, head: k + s };
  }
  return { doc: m, sel: p, from: s, to: a };
}
function bN(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (Xe && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || Xe && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const kN = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function yN(n, e, t, i, r) {
  let o = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let w = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, $ = Al(n, w);
    if ($ && !n.state.selection.eq($)) {
      if (Ze && tn && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (z) => z(n, Zn(13, "Enter"))))
        return;
      let A = n.state.tr.setSelection($);
      w == "pointer" ? A.setMeta("pointer", !0) : w == "key" && A.scrollIntoView(), o && A.setMeta("composition", o), n.dispatch(A);
    }
    return;
  }
  let s = n.state.doc.resolve(e), a = s.sharedDepth(t);
  e = s.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let l = n.state.selection, c = _N(n, e, t), u = n.state.doc, d = u.slice(c.from, c.to), h, f;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (h = n.state.selection.to, f = "end") : (h = n.state.selection.from, f = "start"), n.input.lastKeyCode = null;
  let p = SN(d.content, c.doc.content, c.from, h, f);
  if (p && n.input.domChangeCount++, (Ai && n.input.lastIOSEnter > Date.now() - 225 || tn) && r.some((w) => w.nodeType == 1 && !kN.test(w.nodeName)) && (!p || p.endA >= p.endB) && n.someProp("handleKeyDown", (w) => w(n, Zn(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (i && l instanceof Y && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let w = mu(n, n.state.doc, c.sel);
        if (w && !w.eq(n.state.selection)) {
          let $ = n.state.tr.setSelection(w);
          o && $.setMeta("composition", o), n.dispatch($);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && p.start == p.endB && n.state.selection instanceof Y && (p.start > n.state.selection.from && p.start <= n.state.selection.from + 2 && n.state.selection.from >= c.from ? p.start = n.state.selection.from : p.endA < n.state.selection.to && p.endA >= n.state.selection.to - 2 && n.state.selection.to <= c.to && (p.endB += n.state.selection.to - p.endA, p.endA = n.state.selection.to)), st && $n <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let m = c.doc.resolveNoCache(p.start - c.from), g = c.doc.resolveNoCache(p.endB - c.from), k = u.resolve(p.start), v = m.sameParent(g) && m.parent.inlineContent && k.end() >= p.endA;
  if ((Ai && n.input.lastIOSEnter > Date.now() - 225 && (!v || r.some((w) => w.nodeName == "DIV" || w.nodeName == "P")) || !v && m.pos < c.doc.content.size && (!m.sameParent(g) || !m.parent.inlineContent) && m.pos < g.pos && !/\S/.test(c.doc.textBetween(m.pos, g.pos, "", ""))) && n.someProp("handleKeyDown", (w) => w(n, Zn(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > p.start && xN(u, p.start, p.endA, m, g) && n.someProp("handleKeyDown", (w) => w(n, Zn(8, "Backspace")))) {
    tn && Ze && n.domObserver.suppressSelectionUpdates();
    return;
  }
  Ze && p.endB == p.start && (n.input.lastChromeDelete = Date.now()), tn && !v && m.start() != g.start() && g.parentOffset == 0 && m.depth == g.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, g = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(w) {
      return w(n, Zn(13, "Enter"));
    });
  }, 20));
  let S = p.start, _ = p.endA, x = (w) => {
    let $ = w || n.state.tr.replace(S, _, c.doc.slice(p.start - c.from, p.endB - c.from));
    if (c.sel) {
      let A = mu(n, $.doc, c.sel);
      A && !(Ze && n.composing && A.empty && (p.start != p.endB || n.input.lastChromeDelete < Date.now() - 100) && (A.head == S || A.head == $.mapping.map(_) - 1) || st && A.empty && A.head == S) && $.setSelection(A);
    }
    return o && $.setMeta("composition", o), $.scrollIntoView();
  }, y;
  if (v)
    if (m.pos == g.pos) {
      st && $n <= 11 && m.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => sn(n), 20));
      let w = x(n.state.tr.delete(S, _)), $ = u.resolve(p.start).marksAcross(u.resolve(p.endA));
      $ && w.ensureMarks($), n.dispatch(w);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (y = vN(m.parent.content.cut(m.parentOffset, g.parentOffset), k.parent.content.cut(k.parentOffset, p.endA - k.start())))
    ) {
      let w = x(n.state.tr);
      y.type == "add" ? w.addMark(S, _, y.mark) : w.removeMark(S, _, y.mark), n.dispatch(w);
    } else if (m.parent.child(m.index()).isText && m.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let w = m.parent.textBetween(m.parentOffset, g.parentOffset), $ = () => x(n.state.tr.insertText(w, S, _));
      n.someProp("handleTextInput", (A) => A(n, S, _, w, $)) || n.dispatch($());
    } else
      n.dispatch(x());
  else
    n.dispatch(x());
}
function mu(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : Ll(n, e.resolve(t.anchor), e.resolve(t.head));
}
function vN(n, e) {
  let t = n.firstChild.marks, i = e.firstChild.marks, r = t, o = i, s, a, l;
  for (let u = 0; u < i.length; u++)
    r = i[u].removeFromSet(r);
  for (let u = 0; u < t.length; u++)
    o = t[u].removeFromSet(o);
  if (r.length == 1 && o.length == 0)
    a = r[0], s = "add", l = (u) => u.mark(a.addToSet(u.marks));
  else if (r.length == 0 && o.length == 1)
    a = o[0], s = "remove", l = (u) => u.mark(a.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (O.from(c).eq(n))
    return { mark: a, type: s };
}
function xN(n, e, t, i, r) {
  if (
    // The content must have shrunk
    t - e <= r.pos - i.pos || // newEnd must point directly at or after the end of the block that newStart points into
    ia(i, !0, !1) < r.pos
  )
    return !1;
  let o = n.resolve(e);
  if (!i.parent.isTextblock) {
    let a = o.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let s = n.resolve(ia(o, !0, !0));
  return !s.parent.isTextblock || s.pos > t || ia(s, !0, !1) < t ? !1 : i.parent.content.cut(i.parentOffset).eq(s.parent.content);
}
function ia(n, e, t) {
  let i = n.depth, r = e ? n.end() : n.pos;
  for (; i > 0 && (e || n.indexAfter(i) == n.node(i).childCount); )
    i--, r++, e = !1;
  if (t) {
    let o = n.node(i).maybeChild(n.indexAfter(i));
    for (; o && !o.isLeaf; )
      o = o.firstChild, r++;
  }
  return r;
}
function SN(n, e, t, i, r) {
  let o = n.findDiffStart(e, t);
  if (o == null)
    return null;
  let { a: s, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (r == "end") {
    let l = Math.max(0, o - Math.min(s, a));
    i -= s + l - o;
  }
  if (s < o && n.size < e.size) {
    let l = i <= o && i >= s ? o - i : 0;
    o -= l, o && o < e.size && gu(e.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), a = o + (a - s), s = o;
  } else if (a < o) {
    let l = i <= o && i >= a ? o - i : 0;
    o -= l, o && o < n.size && gu(n.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), s = o + (s - a), a = o;
  }
  return { start: o, endA: s, endB: a };
}
function gu(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class Rf {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new qL(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(vu), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = ku(this), bu(this), this.nodeViews = yu(this), this.docView = Yc(this.state.doc, _u(this), na(this), this.dom, this), this.domObserver = new fN(this, (i, r, o, s) => yN(this, i, r, o, s)), this.domObserver.start(), HL(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Ja(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(vu), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let i in this._props)
      t[i] = this._props[i];
    t.state = this.state;
    for (let i in e)
      t[i] = e[i];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var i;
    let r = this.state, o = !1, s = !1;
    e.storedMarks && this.composing && (Mf(this), s = !0), this.state = e;
    let a = r.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let f = yu(this);
      CN(f, this.nodeViews) && (this.nodeViews = f, o = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && Ja(this), this.editable = ku(this), bu(this);
    let l = na(this), c = _u(this), u = r.plugins != e.plugins && !r.doc.eq(e.doc) ? "reset" : e.scrollToSelection > r.scrollToSelection ? "to selection" : "preserve", d = o || !this.docView.matchesNode(e.doc, c, l);
    (d || !e.selection.eq(r.selection)) && (s = !0);
    let h = u == "preserve" && s && this.dom.style.overflowAnchor == null && iL(this);
    if (s) {
      this.domObserver.stop();
      let f = d && (st || Ze) && !this.composing && !r.selection.empty && !e.selection.empty && wN(r.selection, e.selection);
      if (d) {
        let p = Ze ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = nN(this)), (o || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = Yc(e.doc, c, l, this.dom, this)), p && !this.trackWrites && (f = !0);
      }
      f || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && OL(this)) ? sn(this, f) : (_f(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(r), !((i = this.dragging) === null || i === void 0) && i.node && !r.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, r), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : h && rL(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof F) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && Uc(this, t.getBoundingClientRect(), e);
      } else
        Uc(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let i = this.directPlugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let i = this.state.plugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let i = this.pluginViews[t];
        i.update && i.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let i = e.node, r = -1;
    if (this.state.doc.nodeAt(i.from) == i.node)
      r = i.from;
    else {
      let o = i.from + (this.state.doc.content.size - t.doc.content.size);
      (o > 0 && this.state.doc.nodeAt(o)) == i.node && (r = o);
    }
    this.dragging = new zf(e.slice, e.move, r < 0 ? void 0 : F.create(this.state.doc, r));
  }
  someProp(e, t) {
    let i = this._props && this._props[e], r;
    if (i != null && (r = t ? t(i) : i))
      return r;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let a = this.directPlugins[s].props[e];
      if (a != null && (r = t ? t(a) : a))
        return r;
    }
    let o = this.state.plugins;
    if (o)
      for (let s = 0; s < o.length; s++) {
        let a = o[s].props[e];
        if (a != null && (r = t ? t(a) : a))
          return r;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (st) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && oL(this.dom), sn(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return uL(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return cf(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, i = -1) {
    let r = this.docView.posFromDOM(e, t, i);
    if (r == null)
      throw new RangeError("DOM position not inside the editor");
    return r;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return mL(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return _r(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return _r(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return Nl(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (VL(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], na(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, WA());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return WL(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Xe && this.root.nodeType === 11 && YA(this.dom.ownerDocument) == this.dom && mN(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
Rf.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function _u(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let i in t)
        i == "class" ? e.class += " " + t[i] : i == "style" ? e.style = (e.style ? e.style + ";" : "") + t[i] : !e[i] && i != "contenteditable" && i != "nodeName" && (e[i] = String(t[i]));
  }), e.translate || (e.translate = "no"), [$t.node(0, n.state.doc.content.size, e)];
}
function bu(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: $t.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function ku(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function wN(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function yu(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(i) {
    for (let r in i)
      Object.prototype.hasOwnProperty.call(e, r) || (e[r] = i[r]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function CN(n, e) {
  let t = 0, i = 0;
  for (let r in n) {
    if (n[r] != e[r])
      return !0;
    t++;
  }
  for (let r in e)
    i++;
  return t != i;
}
function vu(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Ln = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, $o = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, TN = typeof navigator < "u" && /Mac/.test(navigator.platform), ON = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var qe = 0; qe < 10; qe++) Ln[48 + qe] = Ln[96 + qe] = String(qe);
for (var qe = 1; qe <= 24; qe++) Ln[qe + 111] = "F" + qe;
for (var qe = 65; qe <= 90; qe++)
  Ln[qe] = String.fromCharCode(qe + 32), $o[qe] = String.fromCharCode(qe);
for (var ra in Ln) $o.hasOwnProperty(ra) || ($o[ra] = Ln[ra]);
function EN(n) {
  var e = TN && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || ON && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? $o : Ln)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const MN = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), $N = typeof navigator < "u" && /Win/.test(navigator.platform);
function zN(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let i, r, o, s;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      MN ? s = !0 : r = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return i && (t = "Alt-" + t), r && (t = "Ctrl-" + t), s && (t = "Meta-" + t), o && (t = "Shift-" + t), t;
}
function AN(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[zN(t)] = n[t];
  return e;
}
function oa(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function LN(n) {
  return new $e({ props: { handleKeyDown: NN(n) } });
}
function NN(n) {
  let e = AN(n);
  return function(t, i) {
    let r = EN(i), o, s = e[oa(r, i)];
    if (s && s(t.state, t.dispatch, t))
      return !0;
    if (r.length == 1 && r != " ") {
      if (i.shiftKey) {
        let a = e[oa(r, i, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((i.altKey || i.metaKey || i.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !($N && i.ctrlKey && i.altKey) && (o = Ln[i.keyCode]) && o != r) {
        let a = e[oa(o, i)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const Bl = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function If(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const Pf = (n, e, t) => {
  let i = If(n, t);
  if (!i)
    return !1;
  let r = Fl(i);
  if (!r) {
    let s = i.blockRange(), a = s && Bi(s);
    return a == null ? !1 : (e && e(n.tr.lift(s, a).scrollIntoView()), !0);
  }
  let o = r.nodeBefore;
  if (Kf(n, r, e, -1))
    return !0;
  if (i.parent.content.size == 0 && (Li(o, "end") || F.isSelectable(o)))
    for (let s = i.depth; ; s--) {
      let a = xs(n.doc, i.before(s), i.after(s), N.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = n.tr.step(a);
          l.setSelection(Li(o, "end") ? ie.findFrom(l.doc.resolve(l.mapping.map(r.pos, -1)), -1) : F.create(l.doc, r.pos - o.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || i.node(s - 1).childCount > 1)
        break;
    }
  return o.isAtom && r.depth == i.depth - 1 ? (e && e(n.tr.delete(r.pos - o.nodeSize, r.pos).scrollIntoView()), !0) : !1;
}, DN = (n, e, t) => {
  let i = If(n, t);
  if (!i)
    return !1;
  let r = Fl(i);
  return r ? jf(n, r, e) : !1;
}, RN = (n, e, t) => {
  let i = Ff(n, t);
  if (!i)
    return !1;
  let r = ql(i);
  return r ? jf(n, r, e) : !1;
};
function jf(n, e, t) {
  let i = e.nodeBefore, r = i, o = e.pos - 1;
  for (; !r.isTextblock; o--) {
    if (r.type.spec.isolating)
      return !1;
    let u = r.lastChild;
    if (!u)
      return !1;
    r = u;
  }
  let s = e.nodeAfter, a = s, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let c = xs(n.doc, o, l, N.empty);
  if (!c || c.from != o || c instanceof Ne && c.slice.size >= l - o)
    return !1;
  if (t) {
    let u = n.tr.step(c);
    u.setSelection(Y.create(u.doc, o)), t(u.scrollIntoView());
  }
  return !0;
}
function Li(n, e, t = !1) {
  for (let i = n; i; i = e == "start" ? i.firstChild : i.lastChild) {
    if (i.isTextblock)
      return !0;
    if (t && i.childCount != 1)
      return !1;
  }
  return !1;
}
const Bf = (n, e, t) => {
  let { $head: i, empty: r } = n.selection, o = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : i.parentOffset > 0)
      return !1;
    o = Fl(i);
  }
  let s = o && o.nodeBefore;
  return !s || !F.isSelectable(s) ? !1 : (e && e(n.tr.setSelection(F.create(n.doc, o.pos - s.nodeSize)).scrollIntoView()), !0);
};
function Fl(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function Ff(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const qf = (n, e, t) => {
  let i = Ff(n, t);
  if (!i)
    return !1;
  let r = ql(i);
  if (!r)
    return !1;
  let o = r.nodeAfter;
  if (Kf(n, r, e, 1))
    return !0;
  if (i.parent.content.size == 0 && (Li(o, "start") || F.isSelectable(o))) {
    let s = xs(n.doc, i.before(), i.after(), N.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let a = n.tr.step(s);
        a.setSelection(Li(o, "start") ? ie.findFrom(a.doc.resolve(a.mapping.map(r.pos)), 1) : F.create(a.doc, a.mapping.map(r.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && r.depth == i.depth - 1 ? (e && e(n.tr.delete(r.pos, r.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, Hf = (n, e, t) => {
  let { $head: i, empty: r } = n.selection, o = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : i.parentOffset < i.parent.content.size)
      return !1;
    o = ql(i);
  }
  let s = o && o.nodeAfter;
  return !s || !F.isSelectable(s) ? !1 : (e && e(n.tr.setSelection(F.create(n.doc, o.pos)).scrollIntoView()), !0);
};
function ql(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const IN = (n, e) => {
  let t = n.selection, i = t instanceof F, r;
  if (i) {
    if (t.node.isTextblock || !Dn(n.doc, t.from))
      return !1;
    r = t.from;
  } else if (r = vs(n.doc, t.from, -1), r == null)
    return !1;
  if (e) {
    let o = n.tr.join(r);
    i && o.setSelection(F.create(o.doc, r - n.doc.resolve(r).nodeBefore.nodeSize)), e(o.scrollIntoView());
  }
  return !0;
}, PN = (n, e) => {
  let t = n.selection, i;
  if (t instanceof F) {
    if (t.node.isTextblock || !Dn(n.doc, t.to))
      return !1;
    i = t.to;
  } else if (i = vs(n.doc, t.to, 1), i == null)
    return !1;
  return e && e(n.tr.join(i).scrollIntoView()), !0;
}, jN = (n, e) => {
  let { $from: t, $to: i } = n.selection, r = t.blockRange(i), o = r && Bi(r);
  return o == null ? !1 : (e && e(n.tr.lift(r, o).scrollIntoView()), !0);
}, Vf = (n, e) => {
  let { $head: t, $anchor: i } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(i) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function Hl(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const BN = (n, e) => {
  let { $head: t, $anchor: i } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(i))
    return !1;
  let r = t.node(-1), o = t.indexAfter(-1), s = Hl(r.contentMatchAt(o));
  if (!s || !r.canReplaceWith(o, o, s))
    return !1;
  if (e) {
    let a = t.after(), l = n.tr.replaceWith(a, a, s.createAndFill());
    l.setSelection(ie.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, Uf = (n, e) => {
  let t = n.selection, { $from: i, $to: r } = t;
  if (t instanceof ot || i.parent.inlineContent || r.parent.inlineContent)
    return !1;
  let o = Hl(r.parent.contentMatchAt(r.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (e) {
    let s = (!i.parentOffset && r.index() < r.parent.childCount ? i : r).pos, a = n.tr.insert(s, o.createAndFill());
    a.setSelection(Y.create(a.doc, s + 1)), e(a.scrollIntoView());
  }
  return !0;
}, Wf = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let o = t.before();
    if (on(n.doc, o))
      return e && e(n.tr.split(o).scrollIntoView()), !0;
  }
  let i = t.blockRange(), r = i && Bi(i);
  return r == null ? !1 : (e && e(n.tr.lift(i, r).scrollIntoView()), !0);
};
function FN(n) {
  return (e, t) => {
    let { $from: i, $to: r } = e.selection;
    if (e.selection instanceof F && e.selection.node.isBlock)
      return !i.parentOffset || !on(e.doc, i.pos) ? !1 : (t && t(e.tr.split(i.pos).scrollIntoView()), !0);
    if (!i.depth)
      return !1;
    let o = [], s, a, l = !1, c = !1;
    for (let f = i.depth; ; f--)
      if (i.node(f).isBlock) {
        l = i.end(f) == i.pos + (i.depth - f), c = i.start(f) == i.pos - (i.depth - f), a = Hl(i.node(f - 1).contentMatchAt(i.indexAfter(f - 1))), o.unshift(l && a ? { type: a } : null), s = f;
        break;
      } else {
        if (f == 1)
          return !1;
        o.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof Y || e.selection instanceof ot) && u.deleteSelection();
    let d = u.mapping.map(i.pos), h = on(u.doc, d, o.length, o);
    if (h || (o[0] = a ? { type: a } : null, h = on(u.doc, d, o.length, o)), !h)
      return !1;
    if (u.split(d, o.length, o), !l && c && i.node(s).type != a) {
      let f = u.mapping.map(i.before(s)), p = u.doc.resolve(f);
      a && i.node(s - 1).canReplaceWith(p.index(), p.index() + 1, a) && u.setNodeMarkup(u.mapping.map(i.before(s)), a);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const qN = FN(), HN = (n, e) => {
  let { $from: t, to: i } = n.selection, r, o = t.sharedDepth(i);
  return o == 0 ? !1 : (r = t.before(o), e && e(n.tr.setSelection(F.create(n.doc, r))), !0);
};
function VN(n, e, t) {
  let i = e.nodeBefore, r = e.nodeAfter, o = e.index();
  return !i || !r || !i.type.compatibleContent(r.type) ? !1 : !i.content.size && e.parent.canReplace(o - 1, o) ? (t && t(n.tr.delete(e.pos - i.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(o, o + 1) || !(r.isTextblock || Dn(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function Kf(n, e, t, i) {
  let r = e.nodeBefore, o = e.nodeAfter, s, a, l = r.type.spec.isolating || o.type.spec.isolating;
  if (!l && VN(n, e, t))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (s = (a = r.contentMatchAt(r.childCount)).findWrapping(o.type)) && a.matchType(s[0] || o.type).validEnd) {
    if (t) {
      let f = e.pos + o.nodeSize, p = O.empty;
      for (let k = s.length - 1; k >= 0; k--)
        p = O.from(s[k].create(null, p));
      p = O.from(r.copy(p));
      let m = n.tr.step(new De(e.pos - 1, f, e.pos, f, new N(p, 1, 0), s.length, !0)), g = m.doc.resolve(f + 2 * s.length);
      g.nodeAfter && g.nodeAfter.type == r.type && Dn(m.doc, g.pos) && m.join(g.pos), t(m.scrollIntoView());
    }
    return !0;
  }
  let u = o.type.spec.isolating || i > 0 && l ? null : ie.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), h = d && Bi(d);
  if (h != null && h >= e.depth)
    return t && t(n.tr.lift(d, h).scrollIntoView()), !0;
  if (c && Li(o, "start", !0) && Li(r, "end")) {
    let f = r, p = [];
    for (; p.push(f), !f.isTextblock; )
      f = f.lastChild;
    let m = o, g = 1;
    for (; !m.isTextblock; m = m.firstChild)
      g++;
    if (f.canReplace(f.childCount, f.childCount, m.content)) {
      if (t) {
        let k = O.empty;
        for (let S = p.length - 1; S >= 0; S--)
          k = O.from(p[S].copy(k));
        let v = n.tr.step(new De(e.pos - p.length, e.pos + o.nodeSize, e.pos + g, e.pos + o.nodeSize - g, new N(k, p.length, 0), 0, !0));
        t(v.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Zf(n) {
  return function(e, t) {
    let i = e.selection, r = n < 0 ? i.$from : i.$to, o = r.depth;
    for (; r.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return r.node(o).isTextblock ? (t && t(e.tr.setSelection(Y.create(e.doc, n < 0 ? r.start(o) : r.end(o)))), !0) : !1;
  };
}
const UN = Zf(-1), WN = Zf(1);
function KN(n, e = null) {
  return function(t, i) {
    let { $from: r, $to: o } = t.selection, s = r.blockRange(o), a = s && Ml(s, n, e);
    return a ? (i && i(t.tr.wrap(s, a).scrollIntoView()), !0) : !1;
  };
}
function xu(n, e = null) {
  return function(t, i) {
    let r = !1;
    for (let o = 0; o < t.selection.ranges.length && !r; o++) {
      let { $from: { pos: s }, $to: { pos: a } } = t.selection.ranges[o];
      t.doc.nodesBetween(s, a, (l, c) => {
        if (r)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            r = !0;
          else {
            let u = t.doc.resolve(c), d = u.index();
            r = u.parent.canReplaceWith(d, d + 1, n);
          }
      });
    }
    if (!r)
      return !1;
    if (i) {
      let o = t.tr;
      for (let s = 0; s < t.selection.ranges.length; s++) {
        let { $from: { pos: a }, $to: { pos: l } } = t.selection.ranges[s];
        o.setBlockType(a, l, n, e);
      }
      i(o.scrollIntoView());
    }
    return !0;
  };
}
function Vl(...n) {
  return function(e, t, i) {
    for (let r = 0; r < n.length; r++)
      if (n[r](e, t, i))
        return !0;
    return !1;
  };
}
Vl(Bl, Pf, Bf);
Vl(Bl, qf, Hf);
Vl(Vf, Uf, Wf, qN);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function ZN(n, e = null) {
  return function(t, i) {
    let { $from: r, $to: o } = t.selection, s = r.blockRange(o);
    if (!s)
      return !1;
    let a = i ? t.tr : null;
    return GN(a, s, n, e) ? (i && i(a.scrollIntoView()), !0) : !1;
  };
}
function GN(n, e, t, i = null) {
  let r = !1, o = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = s.resolve(e.start - 2);
    o = new So(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new So(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), r = !0;
  }
  let a = Ml(o, t, i, e);
  return a ? (n && JN(n, e, a, r, t), !0) : !1;
}
function JN(n, e, t, i, r) {
  let o = O.empty;
  for (let u = t.length - 1; u >= 0; u--)
    o = O.from(t[u].type.create(t[u].attrs, o));
  n.step(new De(e.start - (i ? 2 : 0), e.end, e.start, e.end, new N(o, 0, 0), t.length, !0));
  let s = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == r && (s = u + 1);
  let a = t.length - s, l = e.start + t.length - (i ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, d = e.endIndex, h = !0; u < d; u++, h = !1)
    !h && on(n.doc, l, a) && (n.split(l, a), l += 2 * a), l += c.child(u).nodeSize;
  return n;
}
function YN(n) {
  return function(e, t) {
    let { $from: i, $to: r } = e.selection, o = i.blockRange(r, (s) => s.childCount > 0 && s.firstChild.type == n);
    return o ? t ? i.node(o.depth - 1).type == n ? XN(e, t, n, o) : QN(e, t, o) : !0 : !1;
  };
}
function XN(n, e, t, i) {
  let r = n.tr, o = i.end, s = i.$to.end(i.depth);
  o < s && (r.step(new De(o - 1, s, o, s, new N(O.from(t.create(null, i.parent.copy())), 1, 0), 1, !0)), i = new So(r.doc.resolve(i.$from.pos), r.doc.resolve(s), i.depth));
  const a = Bi(i);
  if (a == null)
    return !1;
  r.lift(i, a);
  let l = r.doc.resolve(r.mapping.map(o, -1) - 1);
  return Dn(r.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && r.join(l.pos), e(r.scrollIntoView()), !0;
}
function QN(n, e, t) {
  let i = n.tr, r = t.parent;
  for (let f = t.end, p = t.endIndex - 1, m = t.startIndex; p > m; p--)
    f -= r.child(p).nodeSize, i.delete(f - 1, f + 1);
  let o = i.doc.resolve(t.start), s = o.nodeAfter;
  if (i.mapping.map(t.end) != t.start + o.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, l = t.endIndex == r.childCount, c = o.node(-1), u = o.index(-1);
  if (!c.canReplace(u + (a ? 0 : 1), u + 1, s.content.append(l ? O.empty : O.from(r))))
    return !1;
  let d = o.pos, h = d + s.nodeSize;
  return i.step(new De(d - (a ? 1 : 0), h + (l ? 1 : 0), d + 1, h - 1, new N((a ? O.empty : O.from(r.copy(O.empty))).append(l ? O.empty : O.from(r.copy(O.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(i.scrollIntoView()), !0;
}
function eD(n) {
  return function(e, t) {
    let { $from: i, $to: r } = e.selection, o = i.blockRange(r, (c) => c.childCount > 0 && c.firstChild.type == n);
    if (!o)
      return !1;
    let s = o.startIndex;
    if (s == 0)
      return !1;
    let a = o.parent, l = a.child(s - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let c = l.lastChild && l.lastChild.type == a.type, u = O.from(c ? n.create() : null), d = new N(O.from(n.create(null, O.from(a.type.create(null, u)))), c ? 3 : 1, 0), h = o.start, f = o.end;
      t(e.tr.step(new De(h - (c ? 3 : 1), f, h, f, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Os(n) {
  const { state: e, transaction: t } = n;
  let { selection: i } = t, { doc: r } = t, { storedMarks: o } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return o;
    },
    get selection() {
      return i;
    },
    get doc() {
      return r;
    },
    get tr() {
      return i = t.selection, r = t.doc, o = t.storedMarks, t;
    }
  };
}
class Es {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: i } = this, { view: r } = t, { tr: o } = i, s = this.buildProps(o);
    return Object.fromEntries(Object.entries(e).map(([a, l]) => [a, (...u) => {
      const d = l(...u)(s);
      return !o.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(o), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: i, editor: r, state: o } = this, { view: s } = r, a = [], l = !!e, c = e || o.tr, u = () => (!l && t && !c.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(c), a.every((h) => h === !0)), d = {
      ...Object.fromEntries(Object.entries(i).map(([h, f]) => [h, (...m) => {
        const g = this.buildProps(c, t), k = f(...m)(g);
        return a.push(k), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: t, state: i } = this, r = !1, o = e || i.tr, s = this.buildProps(o, r);
    return {
      ...Object.fromEntries(Object.entries(t).map(([l, c]) => [l, (...u) => c(...u)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(o, r)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: i, editor: r, state: o } = this, { view: s } = r, a = {
      tr: e,
      editor: r,
      view: s,
      state: Os({
        state: o,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(i).map(([l, c]) => [l, (...u) => c(...u)(a)]));
      }
    };
    return a;
  }
}
let tD = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const i = this.callbacks[e];
    return i && i.forEach((r) => r.apply(this, t)), this;
  }
  off(e, t) {
    const i = this.callbacks[e];
    return i && (t ? this.callbacks[e] = i.filter((r) => r !== t) : delete this.callbacks[e]), this;
  }
  once(e, t) {
    const i = (...r) => {
      this.off(e, i), t.apply(this, r);
    };
    return this.on(e, i);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
};
function D(n, e, t) {
  return n.config[e] === void 0 && n.parent ? D(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? D(n.parent, e, t) : null
  }) : n.config[e];
}
function Ms(n) {
  const e = n.filter((r) => r.type === "extension"), t = n.filter((r) => r.type === "node"), i = n.filter((r) => r.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: i
  };
}
function Gf(n) {
  const e = [], { nodeExtensions: t, markExtensions: i } = Ms(n), r = [...t, ...i], o = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage,
      extensions: r
    }, l = D(s, "addGlobalAttributes", a);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((d) => {
        Object.entries(u.attributes).forEach(([h, f]) => {
          e.push({
            type: d,
            name: h,
            attribute: {
              ...o,
              ...f
            }
          });
        });
      });
    });
  }), r.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, l = D(s, "addAttributes", a);
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, d]) => {
      const h = {
        ...o,
        ...d
      };
      typeof (h == null ? void 0 : h.default) == "function" && (h.default = h.default()), h != null && h.isRequired && (h == null ? void 0 : h.default) === void 0 && delete h.default, e.push({
        type: s.name,
        name: u,
        attribute: h
      });
    });
  }), e;
}
function Ie(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function ke(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const i = { ...e };
    return Object.entries(t).forEach(([r, o]) => {
      if (!i[r]) {
        i[r] = o;
        return;
      }
      if (r === "class") {
        const a = o ? String(o).split(" ") : [], l = i[r] ? i[r].split(" ") : [], c = a.filter((u) => !l.includes(u));
        i[r] = [...l, ...c].join(" ");
      } else if (r === "style") {
        const a = o ? o.split(";").map((u) => u.trim()).filter(Boolean) : [], l = i[r] ? i[r].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, h] = u.split(":").map((f) => f.trim());
          c.set(d, h);
        }), a.forEach((u) => {
          const [d, h] = u.split(":").map((f) => f.trim());
          c.set(d, h);
        }), i[r] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        i[r] = o;
    }), i;
  }, {});
}
function zo(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, i) => ke(t, i), {});
}
function Jf(n) {
  return typeof n == "function";
}
function ee(n, e = void 0, ...t) {
  return Jf(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function nD(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function iD(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function Su(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const i = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (i === !1)
        return !1;
      const r = e.reduce((o, s) => {
        const a = s.attribute.parseHTML ? s.attribute.parseHTML(t) : iD(t.getAttribute(s.name));
        return a == null ? o : {
          ...o,
          [s.name]: a
        };
      }, {});
      return { ...i, ...r };
    }
  };
}
function wu(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && nD(t) ? !1 : t != null)
  );
}
function Yf(n, e) {
  var t;
  const i = Gf(n), { nodeExtensions: r, markExtensions: o } = Ms(n), s = (t = r.find((c) => D(c, "topNode"))) === null || t === void 0 ? void 0 : t.name, a = Object.fromEntries(r.map((c) => {
    const u = i.filter((k) => k.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, h = n.reduce((k, v) => {
      const S = D(v, "extendNodeSchema", d);
      return {
        ...k,
        ...S ? S(c) : {}
      };
    }, {}), f = wu({
      ...h,
      content: ee(D(c, "content", d)),
      marks: ee(D(c, "marks", d)),
      group: ee(D(c, "group", d)),
      inline: ee(D(c, "inline", d)),
      atom: ee(D(c, "atom", d)),
      selectable: ee(D(c, "selectable", d)),
      draggable: ee(D(c, "draggable", d)),
      code: ee(D(c, "code", d)),
      whitespace: ee(D(c, "whitespace", d)),
      linebreakReplacement: ee(D(c, "linebreakReplacement", d)),
      defining: ee(D(c, "defining", d)),
      isolating: ee(D(c, "isolating", d)),
      attrs: Object.fromEntries(u.map((k) => {
        var v;
        return [k.name, { default: (v = k == null ? void 0 : k.attribute) === null || v === void 0 ? void 0 : v.default }];
      }))
    }), p = ee(D(c, "parseHTML", d));
    p && (f.parseDOM = p.map((k) => Su(k, u)));
    const m = D(c, "renderHTML", d);
    m && (f.toDOM = (k) => m({
      node: k,
      HTMLAttributes: zo(k, u)
    }));
    const g = D(c, "renderText", d);
    return g && (f.toText = g), [c.name, f];
  })), l = Object.fromEntries(o.map((c) => {
    const u = i.filter((g) => g.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, h = n.reduce((g, k) => {
      const v = D(k, "extendMarkSchema", d);
      return {
        ...g,
        ...v ? v(c) : {}
      };
    }, {}), f = wu({
      ...h,
      inclusive: ee(D(c, "inclusive", d)),
      excludes: ee(D(c, "excludes", d)),
      group: ee(D(c, "group", d)),
      spanning: ee(D(c, "spanning", d)),
      code: ee(D(c, "code", d)),
      attrs: Object.fromEntries(u.map((g) => {
        var k;
        return [g.name, { default: (k = g == null ? void 0 : g.attribute) === null || k === void 0 ? void 0 : k.default }];
      }))
    }), p = ee(D(c, "parseHTML", d));
    p && (f.parseDOM = p.map((g) => Su(g, u)));
    const m = D(c, "renderHTML", d);
    return m && (f.toDOM = (g) => m({
      mark: g,
      HTMLAttributes: zo(g, u)
    })), [c.name, f];
  }));
  return new Ih({
    topNode: s,
    nodes: a,
    marks: l
  });
}
function sa(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Cu(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function $s(n, e) {
  const t = di.fromSchema(e).serializeFragment(n), r = document.implementation.createHTMLDocument().createElement("div");
  return r.appendChild(t), r.innerHTML;
}
const rD = (n, e = 500) => {
  let t = "";
  const i = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, i - e), i, (r, o, s, a) => {
    var l, c;
    const u = ((c = (l = r.type.spec).toText) === null || c === void 0 ? void 0 : c.call(l, {
      node: r,
      pos: o,
      parent: s,
      index: a
    })) || r.textContent || "%leaf%";
    t += r.isAtom && !r.isText ? u : u.slice(0, Math.max(0, i - o));
  }), t;
};
function Ul(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class Wl {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const oD = (n, e) => {
  if (Ul(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const i = [t.text];
  return i.index = t.index, i.input = n, i.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), i.push(t.replaceWith)), i;
};
function Hr(n) {
  var e;
  const { editor: t, from: i, to: r, text: o, rules: s, plugin: a } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(i);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let u = !1;
  const d = rD(c) + o;
  return s.forEach((h) => {
    if (u)
      return;
    const f = oD(d, h.find);
    if (!f)
      return;
    const p = l.state.tr, m = Os({
      state: l.state,
      transaction: p
    }), g = {
      from: i - (f[0].length - o.length),
      to: r
    }, { commands: k, chain: v, can: S } = new Es({
      editor: t,
      state: m
    });
    h.handler({
      state: m,
      range: g,
      match: f,
      commands: k,
      chain: v,
      can: S
    }) === null || !p.steps.length || (p.setMeta(a, {
      transform: p,
      from: i,
      to: r,
      text: o
    }), l.dispatch(p), u = !0);
  }), u;
}
function sD(n) {
  const { editor: e, rules: t } = n, i = new $e({
    state: {
      init() {
        return null;
      },
      apply(r, o, s) {
        const a = r.getMeta(i);
        if (a)
          return a;
        const l = r.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = $s(O.from(u), s.schema);
          const { from: d } = l, h = d + u.length;
          Hr({
            editor: e,
            from: d,
            to: h,
            text: u,
            rules: t,
            plugin: i
          });
        }), r.selectionSet || r.docChanged ? null : o;
      }
    },
    props: {
      handleTextInput(r, o, s, a) {
        return Hr({
          editor: e,
          from: o,
          to: s,
          text: a,
          rules: t,
          plugin: i
        });
      },
      handleDOMEvents: {
        compositionend: (r) => (setTimeout(() => {
          const { $cursor: o } = r.state.selection;
          o && Hr({
            editor: e,
            from: o.pos,
            to: o.pos,
            text: "",
            rules: t,
            plugin: i
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(r, o) {
        if (o.key !== "Enter")
          return !1;
        const { $cursor: s } = r.state.selection;
        return s ? Hr({
          editor: e,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: t,
          plugin: i
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return i;
}
function aD(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function Vr(n) {
  return aD(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function zs(n, e) {
  const t = { ...n };
  return Vr(n) && Vr(e) && Object.keys(e).forEach((i) => {
    Vr(e[i]) && Vr(n[i]) ? t[i] = zs(n[i], e[i]) : t[i] = e[i];
  }), t;
}
class Vt {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ee(D(this, "addOptions", {
      name: this.name
    }))), this.storage = ee(D(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Vt(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => zs(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Vt(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = ee(D(t, "addOptions", {
      name: t.name
    })), t.storage = ee(D(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: i } = e.state, r = e.state.selection.$from;
    if (r.pos === r.end()) {
      const s = r.marks();
      if (!!!s.find((c) => (c == null ? void 0 : c.type.name) === t.name))
        return !1;
      const l = s.find((c) => (c == null ? void 0 : c.type.name) === t.name);
      return l && i.removeStoredMark(l), i.insertText(" ", r.pos), e.view.dispatch(i), !0;
    }
    return !1;
  }
}
function lD(n) {
  return typeof n == "number";
}
class cD {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const uD = (n, e, t) => {
  if (Ul(e))
    return [...n.matchAll(e)];
  const i = e(n, t);
  return i ? i.map((r) => {
    const o = [r.text];
    return o.index = r.index, o.input = n, o.data = r.data, r.replaceWith && (r.text.includes(r.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), o.push(r.replaceWith)), o;
  }) : [];
};
function dD(n) {
  const { editor: e, state: t, from: i, to: r, rule: o, pasteEvent: s, dropEvent: a } = n, { commands: l, chain: c, can: u } = new Es({
    editor: e,
    state: t
  }), d = [];
  return t.doc.nodesBetween(i, r, (f, p) => {
    if (!f.isTextblock || f.type.spec.code)
      return;
    const m = Math.max(i, p), g = Math.min(r, p + f.content.size), k = f.textBetween(m - p, g - p, void 0, "￼");
    uD(k, o.find, s).forEach((S) => {
      if (S.index === void 0)
        return;
      const _ = m + S.index + 1, x = _ + S[0].length, y = {
        from: t.tr.mapping.map(_),
        to: t.tr.mapping.map(x)
      }, w = o.handler({
        state: t,
        range: y,
        match: S,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: s,
        dropEvent: a
      });
      d.push(w);
    });
  }), d.every((f) => f !== null);
}
let Ur = null;
const hD = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) === null || e === void 0 || e.setData("text/html", n), t;
};
function fD(n) {
  const { editor: e, rules: t } = n;
  let i = null, r = !1, o = !1, s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const l = ({ state: u, from: d, to: h, rule: f, pasteEvt: p }) => {
    const m = u.tr, g = Os({
      state: u,
      transaction: m
    });
    if (!(!dD({
      editor: e,
      state: g,
      from: Math.max(d - 1, 0),
      to: h.b - 1,
      rule: f,
      pasteEvent: p,
      dropEvent: a
    }) || !m.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
    }
  };
  return t.map((u) => new $e({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const h = (p) => {
        var m;
        i = !((m = d.dom.parentElement) === null || m === void 0) && m.contains(p.target) ? d.dom.parentElement : null, i && (Ur = e);
      }, f = () => {
        Ur && (Ur = null);
      };
      return window.addEventListener("dragstart", h), window.addEventListener("dragend", f), {
        destroy() {
          window.removeEventListener("dragstart", h), window.removeEventListener("dragend", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, h) => {
          if (o = i === d.dom.parentElement, a = h, !o) {
            const f = Ur;
            f != null && f.isEditable && setTimeout(() => {
              const p = f.state.selection;
              p && f.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, h) => {
          var f;
          const p = (f = h.clipboardData) === null || f === void 0 ? void 0 : f.getData("text/html");
          return s = h, r = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, h, f) => {
      const p = d[0], m = p.getMeta("uiEvent") === "paste" && !r, g = p.getMeta("uiEvent") === "drop" && !o, k = p.getMeta("applyPasteRules"), v = !!k;
      if (!m && !g && !v)
        return;
      if (v) {
        let { text: x } = k;
        typeof x == "string" ? x = x : x = $s(O.from(x), f.schema);
        const { from: y } = k, w = y + x.length, $ = hD(x);
        return l({
          rule: u,
          state: f,
          from: y,
          to: { b: w },
          pasteEvt: $
        });
      }
      const S = h.doc.content.findDiffStart(f.doc.content), _ = h.doc.content.findDiffEnd(f.doc.content);
      if (!(!lD(S) || !_ || S === _.b))
        return l({
          rule: u,
          state: f,
          from: S,
          to: _,
          pasteEvt: s
        });
    }
  }));
}
function pD(n) {
  const e = n.filter((t, i) => n.indexOf(t) !== i);
  return Array.from(new Set(e));
}
class Xn {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = Xn.resolve(e), this.schema = Yf(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const t = Xn.sort(Xn.flatten(e)), i = pD(t.map((r) => r.name));
    return i.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${i.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((t) => {
      const i = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, r = D(t, "addExtensions", i);
      return r ? [t, ...this.flatten(r())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((i, r) => {
      const o = D(i, "priority") || 100, s = D(r, "priority") || 100;
      return o > s ? -1 : o < s ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const i = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: sa(t.name, this.schema)
      }, r = D(t, "addCommands", i);
      return r ? {
        ...e,
        ...r()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, t = Xn.sort([...this.extensions].reverse()), i = [], r = [], o = t.map((s) => {
      const a = {
        name: s.name,
        options: s.options,
        storage: s.storage,
        editor: e,
        type: sa(s.name, this.schema)
      }, l = [], c = D(s, "addKeyboardShortcuts", a);
      let u = {};
      if (s.type === "mark" && D(s, "exitable", a) && (u.ArrowRight = () => Vt.handleExit({ editor: e, mark: s })), c) {
        const m = Object.fromEntries(Object.entries(c()).map(([g, k]) => [g, () => k({ editor: e })]));
        u = { ...u, ...m };
      }
      const d = LN(u);
      l.push(d);
      const h = D(s, "addInputRules", a);
      Cu(s, e.options.enableInputRules) && h && i.push(...h());
      const f = D(s, "addPasteRules", a);
      Cu(s, e.options.enablePasteRules) && f && r.push(...f());
      const p = D(s, "addProseMirrorPlugins", a);
      if (p) {
        const m = p();
        l.push(...m);
      }
      return l;
    }).flat();
    return [
      sD({
        editor: e,
        rules: i
      }),
      ...fD({
        editor: e,
        rules: r
      }),
      ...o
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Gf(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = Ms(this.extensions);
    return Object.fromEntries(t.filter((i) => !!D(i, "addNodeView")).map((i) => {
      const r = this.attributes.filter((l) => l.type === i.name), o = {
        name: i.name,
        options: i.options,
        storage: i.storage,
        editor: e,
        type: Ie(i.name, this.schema)
      }, s = D(i, "addNodeView", o);
      if (!s)
        return [];
      const a = (l, c, u, d, h) => {
        const f = zo(l, r);
        return s()({
          // pass-through
          node: l,
          view: c,
          getPos: u,
          decorations: d,
          innerDecorations: h,
          // tiptap-specific
          editor: e,
          extension: i,
          HTMLAttributes: f
        });
      };
      return [i.name, a];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const i = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: sa(e.name, this.schema)
      };
      e.type === "mark" && (!((t = ee(D(e, "keepOnSplit", i))) !== null && t !== void 0) || t) && this.splittableMarks.push(e.name);
      const r = D(e, "onBeforeCreate", i), o = D(e, "onCreate", i), s = D(e, "onUpdate", i), a = D(e, "onSelectionUpdate", i), l = D(e, "onTransaction", i), c = D(e, "onFocus", i), u = D(e, "onBlur", i), d = D(e, "onDestroy", i);
      r && this.editor.on("beforeCreate", r), o && this.editor.on("create", o), s && this.editor.on("update", s), a && this.editor.on("selectionUpdate", a), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), d && this.editor.on("destroy", d);
    });
  }
}
class Ce {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ee(D(this, "addOptions", {
      name: this.name
    }))), this.storage = ee(D(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Ce(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => zs(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Ce({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = ee(D(t, "addOptions", {
      name: t.name
    })), t.storage = ee(D(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function Xf(n, e, t) {
  const { from: i, to: r } = e, { blockSeparator: o = `

`, textSerializers: s = {} } = t || {};
  let a = "";
  return n.nodesBetween(i, r, (l, c, u, d) => {
    var h;
    l.isBlock && c > i && (a += o);
    const f = s == null ? void 0 : s[l.type.name];
    if (f)
      return u && (a += f({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (a += (h = l == null ? void 0 : l.text) === null || h === void 0 ? void 0 : h.slice(Math.max(i, c) - c, r - c));
  }), a;
}
function Qf(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const mD = Ce.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new $e({
        key: new Ve("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: i, selection: r } = e, { ranges: o } = r, s = Math.min(...o.map((u) => u.$from.pos)), a = Math.max(...o.map((u) => u.$to.pos)), l = Qf(t);
            return Xf(i, { from: s, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), gD = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), _D = (n = !1) => ({ commands: e }) => e.setContent("", n), bD = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: i } = e, { ranges: r } = i;
  return t && r.forEach(({ $from: o, $to: s }) => {
    n.doc.nodesBetween(o.pos, s.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), h = c.resolve(u.map(l + a.nodeSize)), f = d.blockRange(h);
      if (!f)
        return;
      const p = Bi(f);
      if (a.type.isTextblock) {
        const { defaultType: m } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(f.start, m);
      }
      (p || p === 0) && e.lift(f, p);
    });
  }), !0;
}, kD = (n) => (e) => n(e), yD = () => ({ state: n, dispatch: e }) => Uf(n, e), vD = (n, e) => ({ editor: t, tr: i }) => {
  const { state: r } = t, o = r.doc.slice(n.from, n.to);
  i.deleteRange(n.from, n.to);
  const s = i.mapping.map(e);
  return i.insert(s, o.content), i.setSelection(new Y(i.doc.resolve(Math.max(s - 1, 0)))), !0;
}, xD = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, i = t.$anchor.node();
  if (i.content.size > 0)
    return !1;
  const r = n.selection.$anchor;
  for (let o = r.depth; o > 0; o -= 1)
    if (r.node(o).type === i.type) {
      if (e) {
        const a = r.before(o), l = r.after(o);
        n.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, SD = (n) => ({ tr: e, state: t, dispatch: i }) => {
  const r = Ie(n, t.schema), o = e.selection.$anchor;
  for (let s = o.depth; s > 0; s -= 1)
    if (o.node(s).type === r) {
      if (i) {
        const l = o.before(s), c = o.after(s);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, wD = (n) => ({ tr: e, dispatch: t }) => {
  const { from: i, to: r } = n;
  return t && e.delete(i, r), !0;
}, CD = () => ({ state: n, dispatch: e }) => Bl(n, e), TD = () => ({ commands: n }) => n.keyboardShortcut("Enter"), OD = () => ({ state: n, dispatch: e }) => BN(n, e);
function Ao(n, e, t = { strict: !0 }) {
  const i = Object.keys(e);
  return i.length ? i.every((r) => t.strict ? e[r] === n[r] : Ul(e[r]) ? e[r].test(n[r]) : e[r] === n[r]) : !0;
}
function ep(n, e, t = {}) {
  return n.find((i) => i.type === e && Ao(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((r) => [r, i.attrs[r]])),
    t
  ));
}
function Tu(n, e, t = {}) {
  return !!ep(n, e, t);
}
function Kl(n, e, t) {
  var i;
  if (!n || !e)
    return;
  let r = n.parent.childAfter(n.parentOffset);
  if ((!r.node || !r.node.marks.some((u) => u.type === e)) && (r = n.parent.childBefore(n.parentOffset)), !r.node || !r.node.marks.some((u) => u.type === e) || (t = t || ((i = r.node.marks[0]) === null || i === void 0 ? void 0 : i.attrs), !ep([...r.node.marks], e, t)))
    return;
  let s = r.index, a = n.start() + r.offset, l = s + 1, c = a + r.node.nodeSize;
  for (; s > 0 && Tu([...n.parent.child(s - 1).marks], e, t); )
    s -= 1, a -= n.parent.child(s).nodeSize;
  for (; l < n.parent.childCount && Tu([...n.parent.child(l).marks], e, t); )
    c += n.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: c
  };
}
function In(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const ED = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  const o = In(n, i.schema), { doc: s, selection: a } = t, { $from: l, from: c, to: u } = a;
  if (r) {
    const d = Kl(l, o, e);
    if (d && d.from <= c && d.to >= u) {
      const h = Y.create(s, d.from, d.to);
      t.setSelection(h);
    }
  }
  return !0;
}, MD = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let i = 0; i < t.length; i += 1)
    if (t[i](e))
      return !0;
  return !1;
};
function Zl(n) {
  return n instanceof Y;
}
function nn(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function tp(n, e = null) {
  if (!e)
    return null;
  const t = ie.atStart(n), i = ie.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return i;
  const r = t.from, o = i.to;
  return e === "all" ? Y.create(n, nn(0, r, o), nn(n.content.size, r, o)) : Y.create(n, nn(e, r, o), nn(e, r, o));
}
function np() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function As() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const $D = (n = null, e = {}) => ({ editor: t, view: i, tr: r, dispatch: o }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    (As() || np()) && i.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (i.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (i.hasFocus() && n === null || n === !1)
    return !0;
  if (o && n === null && !Zl(t.state.selection))
    return s(), !0;
  const a = tp(r.doc, n) || t.state.selection, l = t.state.selection.eq(a);
  return o && (l || r.setSelection(a), l && r.storedMarks && r.setStoredMarks(r.storedMarks), s()), !0;
}, zD = (n, e) => (t) => n.every((i, r) => e(i, { ...t, index: r })), AD = (n, e) => ({ tr: t, commands: i }) => i.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), ip = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const i = e[t];
    i.nodeType === 3 && i.nodeValue && /^(\n\s\s|\n)$/.test(i.nodeValue) ? n.removeChild(i) : i.nodeType === 1 && ip(i);
  }
  return n;
};
function Wr(n) {
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return ip(t);
}
function kr(n, e, t) {
  if (n instanceof rn || n instanceof O)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const i = typeof n == "object" && n !== null, r = typeof n == "string";
  if (i)
    try {
      if (Array.isArray(n) && n.length > 0)
        return O.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const s = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && s.check(), s;
    } catch (o) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: o });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", o), kr("", e, t);
    }
  if (r) {
    if (t.errorOnInvalidContent) {
      let s = !1, a = "";
      const l = new Ih({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, a = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? Mn.fromSchema(l).parseSlice(Wr(n), t.parseOptions) : Mn.fromSchema(l).parse(Wr(n), t.parseOptions), t.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const o = Mn.fromSchema(e);
    return t.slice ? o.parseSlice(Wr(n), t.parseOptions).content : o.parse(Wr(n), t.parseOptions);
  }
  return kr("", e, t);
}
function LD(n, e, t) {
  const i = n.steps.length - 1;
  if (i < e)
    return;
  const r = n.steps[i];
  if (!(r instanceof Ne || r instanceof De))
    return;
  const o = n.mapping.maps[i];
  let s = 0;
  o.forEach((a, l, c, u) => {
    s === 0 && (s = u);
  }), n.setSelection(ie.near(n.doc.resolve(s), t));
}
const ND = (n) => !("type" in n), DD = (n, e, t) => ({ tr: i, dispatch: r, editor: o }) => {
  var s;
  if (r) {
    t = {
      parseOptions: o.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    const l = (g) => {
      o.emit("contentError", {
        editor: o,
        error: g,
        disableCollaboration: () => {
          o.storage.collaboration && (o.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !o.options.enableContentCheck && o.options.emitContentError)
      try {
        kr(e, o.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (g) {
        l(g);
      }
    try {
      a = kr(e, o.schema, {
        parseOptions: c,
        errorOnInvalidContent: (s = t.errorOnInvalidContent) !== null && s !== void 0 ? s : o.options.enableContentCheck
      });
    } catch (g) {
      return l(g), !1;
    }
    let { from: u, to: d } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, h = !0, f = !0;
    if ((ND(a) ? a : [a]).forEach((g) => {
      g.check(), h = h ? g.isText && g.marks.length === 0 : !1, f = f ? g.isBlock : !1;
    }), u === d && f) {
      const { parent: g } = i.doc.resolve(u);
      g.isTextblock && !g.type.spec.code && !g.childCount && (u -= 1, d += 1);
    }
    let m;
    if (h) {
      if (Array.isArray(e))
        m = e.map((g) => g.text || "").join("");
      else if (e instanceof O) {
        let g = "";
        e.forEach((k) => {
          k.text && (g += k.text);
        }), m = g;
      } else typeof e == "object" && e && e.text ? m = e.text : m = e;
      i.insertText(m, u, d);
    } else
      m = a, i.replaceWith(u, d, m);
    t.updateSelection && LD(i, i.steps.length - 1, -1), t.applyInputRules && i.setMeta("applyInputRules", { from: u, text: m }), t.applyPasteRules && i.setMeta("applyPasteRules", { from: u, text: m });
  }
  return !0;
}, RD = () => ({ state: n, dispatch: e }) => IN(n, e), ID = () => ({ state: n, dispatch: e }) => PN(n, e), PD = () => ({ state: n, dispatch: e }) => Pf(n, e), jD = () => ({ state: n, dispatch: e }) => qf(n, e), BD = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const i = vs(n.doc, n.selection.$from.pos, -1);
    return i == null ? !1 : (t.join(i, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, FD = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const i = vs(n.doc, n.selection.$from.pos, 1);
    return i == null ? !1 : (t.join(i, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, qD = () => ({ state: n, dispatch: e }) => DN(n, e), HD = () => ({ state: n, dispatch: e }) => RN(n, e);
function rp() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function VD(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let i, r, o, s;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      As() || rp() ? s = !0 : r = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return i && (t = `Alt-${t}`), r && (t = `Ctrl-${t}`), s && (t = `Meta-${t}`), o && (t = `Shift-${t}`), t;
}
const UD = (n) => ({ editor: e, view: t, tr: i, dispatch: r }) => {
  const o = VD(n).split(/-(?!$)/), s = o.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), a = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (c) => c(t, a));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(i.mapping);
    u && r && i.maybeStep(u);
  }), !0;
};
function yr(n, e, t = {}) {
  const { from: i, to: r, empty: o } = n.selection, s = e ? Ie(e, n.schema) : null, a = [];
  n.doc.nodesBetween(i, r, (d, h) => {
    if (d.isText)
      return;
    const f = Math.max(i, h), p = Math.min(r, h + d.nodeSize);
    a.push({
      node: d,
      from: f,
      to: p
    });
  });
  const l = r - i, c = a.filter((d) => s ? s.name === d.node.type.name : !0).filter((d) => Ao(d.node.attrs, t, { strict: !1 }));
  return o ? !!c.length : c.reduce((d, h) => d + h.to - h.from, 0) >= l;
}
const WD = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Ie(n, t.schema);
  return yr(t, r, e) ? jN(t, i) : !1;
}, KD = () => ({ state: n, dispatch: e }) => Wf(n, e), ZD = (n) => ({ state: e, dispatch: t }) => {
  const i = Ie(n, e.schema);
  return YN(i)(e, t);
}, GD = () => ({ state: n, dispatch: e }) => Vf(n, e);
function Ls(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function Ou(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((i, r) => (t.includes(r) || (i[r] = n[r]), i), {});
}
const JD = (n, e) => ({ tr: t, state: i, dispatch: r }) => {
  let o = null, s = null;
  const a = Ls(typeof n == "string" ? n : n.name, i.schema);
  return a ? (a === "node" && (o = Ie(n, i.schema)), a === "mark" && (s = In(n, i.schema)), r && t.selection.ranges.forEach((l) => {
    i.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      o && o === c.type && t.setNodeMarkup(u, void 0, Ou(c.attrs, e)), s && c.marks.length && c.marks.forEach((d) => {
        s === d.type && t.addMark(u, u + c.nodeSize, s.create(Ou(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, YD = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), XD = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new ot(n.doc);
    n.setSelection(t);
  }
  return !0;
}, QD = () => ({ state: n, dispatch: e }) => Bf(n, e), e6 = () => ({ state: n, dispatch: e }) => Hf(n, e), t6 = () => ({ state: n, dispatch: e }) => HN(n, e), n6 = () => ({ state: n, dispatch: e }) => WN(n, e), i6 = () => ({ state: n, dispatch: e }) => UN(n, e);
function Ya(n, e, t = {}, i = {}) {
  return kr(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: i.errorOnInvalidContent
  });
}
const r6 = (n, e = !1, t = {}, i = {}) => ({ editor: r, tr: o, dispatch: s, commands: a }) => {
  var l, c;
  const { doc: u } = o;
  if (t.preserveWhitespace !== "full") {
    const d = Ya(n, r.schema, t, {
      errorOnInvalidContent: (l = i.errorOnInvalidContent) !== null && l !== void 0 ? l : r.options.enableContentCheck
    });
    return s && o.replaceWith(0, u.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return s && o.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: u.content.size }, n, {
    parseOptions: t,
    errorOnInvalidContent: (c = i.errorOnInvalidContent) !== null && c !== void 0 ? c : r.options.enableContentCheck
  });
};
function op(n, e) {
  const t = In(e, n.schema), { from: i, to: r, empty: o } = n.selection, s = [];
  o ? (n.storedMarks && s.push(...n.storedMarks), s.push(...n.selection.$head.marks())) : n.doc.nodesBetween(i, r, (l) => {
    s.push(...l.marks);
  });
  const a = s.find((l) => l.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function o6(n, e) {
  const t = new Qh(n);
  return e.forEach((i) => {
    i.steps.forEach((r) => {
      t.step(r);
    });
  }), t;
}
function s6(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function sp(n, e, t) {
  const i = [];
  return n.nodesBetween(e.from, e.to, (r, o) => {
    t(r) && i.push({
      node: r,
      pos: o
    });
  }), i;
}
function a6(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const i = n.node(t);
    if (e(i))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: i
      };
  }
}
function Gl(n) {
  return (e) => a6(e.$from, n);
}
function l6(n, e) {
  const t = Xn.resolve(n);
  return Yf(t, e);
}
function c6(n, e) {
  const t = l6(e), i = rn.fromJSON(t, n);
  return $s(i.content, t);
}
function u6(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return Xf(n, t, e);
}
function d6(n, e) {
  const t = Ie(e, n.schema), { from: i, to: r } = n.selection, o = [];
  n.doc.nodesBetween(i, r, (a) => {
    o.push(a);
  });
  const s = o.reverse().find((a) => a.type.name === t.name);
  return s ? { ...s.attrs } : {};
}
function ap(n, e) {
  const t = Ls(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? d6(n, e) : t === "mark" ? op(n, e) : {};
}
function h6(n, e = JSON.stringify) {
  const t = {};
  return n.filter((i) => {
    const r = e(i);
    return Object.prototype.hasOwnProperty.call(t, r) ? !1 : t[r] = !0;
  });
}
function f6(n) {
  const e = h6(n);
  return e.length === 1 ? e : e.filter((t, i) => !e.filter((o, s) => s !== i).some((o) => t.oldRange.from >= o.oldRange.from && t.oldRange.to <= o.oldRange.to && t.newRange.from >= o.newRange.from && t.newRange.to <= o.newRange.to));
}
function p6(n) {
  const { mapping: e, steps: t } = n, i = [];
  return e.maps.forEach((r, o) => {
    const s = [];
    if (r.ranges.length)
      r.forEach((a, l) => {
        s.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = t[o];
      if (a === void 0 || l === void 0)
        return;
      s.push({ from: a, to: l });
    }
    s.forEach(({ from: a, to: l }) => {
      const c = e.slice(o).map(a, -1), u = e.slice(o).map(l), d = e.invert().map(c, -1), h = e.invert().map(u);
      i.push({
        oldRange: {
          from: d,
          to: h
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), f6(i);
}
function Jl(n, e, t) {
  const i = [];
  return n === e ? t.resolve(n).marks().forEach((r) => {
    const o = t.resolve(n), s = Kl(o, r.type);
    s && i.push({
      mark: r,
      ...s
    });
  }) : t.nodesBetween(n, e, (r, o) => {
    !r || (r == null ? void 0 : r.nodeSize) === void 0 || i.push(...r.marks.map((s) => ({
      from: o,
      to: o + r.nodeSize,
      mark: s
    })));
  }), i;
}
function uo(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([i]) => {
    const r = n.find((o) => o.type === e && o.name === i);
    return r ? r.attribute.keepOnSplit : !1;
  }));
}
function Xa(n, e, t = {}) {
  const { empty: i, ranges: r } = n.selection, o = e ? In(e, n.schema) : null;
  if (i)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((d) => o ? o.name === d.type.name : !0).find((d) => Ao(d.attrs, t, { strict: !1 }));
  let s = 0;
  const a = [];
  if (r.forEach(({ $from: d, $to: h }) => {
    const f = d.pos, p = h.pos;
    n.doc.nodesBetween(f, p, (m, g) => {
      if (!m.isText && !m.marks.length)
        return;
      const k = Math.max(f, g), v = Math.min(p, g + m.nodeSize), S = v - k;
      s += S, a.push(...m.marks.map((_) => ({
        mark: _,
        from: k,
        to: v
      })));
    });
  }), s === 0)
    return !1;
  const l = a.filter((d) => o ? o.name === d.mark.type.name : !0).filter((d) => Ao(d.mark.attrs, t, { strict: !1 })).reduce((d, h) => d + h.to - h.from, 0), c = a.filter((d) => o ? d.mark.type !== o && d.mark.type.excludes(o) : !0).reduce((d, h) => d + h.to - h.from, 0);
  return (l > 0 ? l + c : l) >= s;
}
function m6(n, e, t = {}) {
  if (!e)
    return yr(n, null, t) || Xa(n, null, t);
  const i = Ls(e, n.schema);
  return i === "node" ? yr(n, e, t) : i === "mark" ? Xa(n, e, t) : !1;
}
function Eu(n, e) {
  const { nodeExtensions: t } = Ms(e), i = t.find((s) => s.name === n);
  if (!i)
    return !1;
  const r = {
    name: i.name,
    options: i.options,
    storage: i.storage
  }, o = ee(D(i, "group", r));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function Yl(n, { checkChildren: e = !0, ignoreWhitespace: t = !1 } = {}) {
  var i;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((i = n.text) !== null && i !== void 0 ? i : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let r = !0;
    return n.content.forEach((o) => {
      r !== !1 && (Yl(o, { ignoreWhitespace: t, checkChildren: e }) || (r = !1));
    }), r;
  }
  return !1;
}
function g6(n) {
  return n instanceof F;
}
function _6(n, e, t) {
  const r = n.state.doc.content.size, o = nn(e, 0, r), s = nn(t, 0, r), a = n.coordsAtPos(o), l = n.coordsAtPos(s, -1), c = Math.min(a.top, l.top), u = Math.max(a.bottom, l.bottom), d = Math.min(a.left, l.left), h = Math.max(a.right, l.right), f = h - d, p = u - c, k = {
    top: c,
    bottom: u,
    left: d,
    right: h,
    width: f,
    height: p,
    x: d,
    y: c
  };
  return {
    ...k,
    toJSON: () => k
  };
}
function b6(n, e, t) {
  var i;
  const { selection: r } = e;
  let o = null;
  if (Zl(r) && (o = r.$cursor), o) {
    const a = (i = n.storedMarks) !== null && i !== void 0 ? i : o.marks();
    return !!t.isInSet(a) || !a.some((l) => l.type.excludes(t));
  }
  const { ranges: s } = r;
  return s.some(({ $from: a, $to: l }) => {
    let c = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, l.pos, (u, d, h) => {
      if (c)
        return !1;
      if (u.isInline) {
        const f = !h || h.type.allowsMarkType(t), p = !!t.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(t));
        c = f && p;
      }
      return !c;
    }), c;
  });
}
const k6 = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  const { selection: o } = t, { empty: s, ranges: a } = o, l = In(n, i.schema);
  if (r)
    if (s) {
      const c = op(i, l);
      t.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      a.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        i.doc.nodesBetween(u, d, (h, f) => {
          const p = Math.max(f, u), m = Math.min(f + h.nodeSize, d);
          h.marks.find((k) => k.type === l) ? h.marks.forEach((k) => {
            l === k.type && t.addMark(p, m, l.create({
              ...k.attrs,
              ...e
            }));
          }) : t.addMark(p, m, l.create(e));
        });
      });
  return b6(i, t, l);
}, y6 = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), v6 = (n, e = {}) => ({ state: t, dispatch: i, chain: r }) => {
  const o = Ie(n, t.schema);
  let s;
  return t.selection.$anchor.sameParent(t.selection.$head) && (s = t.selection.$anchor.parent.attrs), o.isTextblock ? r().command(({ commands: a }) => xu(o, { ...s, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => xu(o, { ...s, ...e })(a, i)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, x6 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: i } = e, r = nn(n, 0, i.content.size), o = F.create(i, r);
    e.setSelection(o);
  }
  return !0;
}, S6 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: i } = e, { from: r, to: o } = typeof n == "number" ? { from: n, to: n } : n, s = Y.atStart(i).from, a = Y.atEnd(i).to, l = nn(r, s, a), c = nn(o, s, a), u = Y.create(i, l, c);
    e.setSelection(u);
  }
  return !0;
}, w6 = (n) => ({ state: e, dispatch: t }) => {
  const i = Ie(n, e.schema);
  return eD(i)(e, t);
};
function Mu(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const i = t.filter((r) => e == null ? void 0 : e.includes(r.type.name));
    n.tr.ensureMarks(i);
  }
}
const C6 = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: i, editor: r }) => {
  const { selection: o, doc: s } = e, { $from: a, $to: l } = o, c = r.extensionManager.attributes, u = uo(c, a.node().type.name, a.node().attrs);
  if (o instanceof F && o.node.isBlock)
    return !a.parentOffset || !on(s, a.pos) ? !1 : (i && (n && Mu(t, r.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, h = a.depth === 0 ? void 0 : s6(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let f = d && h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0, p = on(e.doc, e.mapping.map(a.pos), 1, f);
  if (!f && !p && on(e.doc, e.mapping.map(a.pos), 1, h ? [{ type: h }] : void 0) && (p = !0, f = h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0), i) {
    if (p && (o instanceof Y && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, f), h && !d && !a.parentOffset && a.parent.type !== h)) {
      const m = e.mapping.map(a.before()), g = e.doc.resolve(m);
      a.node(-1).canReplaceWith(g.index(), g.index() + 1, h) && e.setNodeMarkup(e.mapping.map(a.before()), h);
    }
    n && Mu(t, r.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, T6 = (n, e = {}) => ({ tr: t, state: i, dispatch: r, editor: o }) => {
  var s;
  const a = Ie(n, i.schema), { $from: l, $to: c } = i.selection, u = i.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== a)
    return !1;
  const h = o.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (r) {
      let k = O.empty;
      const v = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let $ = l.depth - v; $ >= l.depth - 3; $ -= 1)
        k = O.from(l.node($).copy(k));
      const S = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, _ = {
        ...uo(h, l.node().type.name, l.node().attrs),
        ...e
      }, x = ((s = a.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(_)) || void 0;
      k = k.append(O.from(a.createAndFill(null, x) || void 0));
      const y = l.before(l.depth - (v - 1));
      t.replace(y, l.after(-S), new N(k, 4 - v, 0));
      let w = -1;
      t.doc.nodesBetween(y, t.doc.content.size, ($, A) => {
        if (w > -1)
          return !1;
        $.isTextblock && $.content.size === 0 && (w = A + 1);
      }), w > -1 && t.setSelection(Y.near(t.doc.resolve(w))), t.scrollIntoView();
    }
    return !0;
  }
  const f = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ...uo(h, d.type.name, d.attrs),
    ...e
  }, m = {
    ...uo(h, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, c.pos);
  const g = f ? [
    { type: a, attrs: p },
    { type: f, attrs: m }
  ] : [{ type: a, attrs: p }];
  if (!on(t.doc, l.pos, 2))
    return !1;
  if (r) {
    const { selection: k, storedMarks: v } = i, { splittableMarks: S } = o.extensionManager, _ = v || k.$to.parentOffset && k.$from.marks();
    if (t.split(l.pos, 2, g).scrollIntoView(), !_ || !r)
      return !0;
    const x = _.filter((y) => S.includes(y.type.name));
    t.ensureMarks(x);
  }
  return !0;
}, aa = (n, e) => {
  const t = Gl((s) => s.type === e)(n.selection);
  if (!t)
    return !0;
  const i = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (i === void 0)
    return !0;
  const r = n.doc.nodeAt(i);
  return t.node.type === (r == null ? void 0 : r.type) && Dn(n.doc, t.pos) && n.join(t.pos), !0;
}, la = (n, e) => {
  const t = Gl((s) => s.type === e)(n.selection);
  if (!t)
    return !0;
  const i = n.doc.resolve(t.start).after(t.depth);
  if (i === void 0)
    return !0;
  const r = n.doc.nodeAt(i);
  return t.node.type === (r == null ? void 0 : r.type) && Dn(n.doc, i) && n.join(i), !0;
}, O6 = (n, e, t, i = {}) => ({ editor: r, tr: o, state: s, dispatch: a, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: h } = r.extensionManager, f = Ie(n, s.schema), p = Ie(e, s.schema), { selection: m, storedMarks: g } = s, { $from: k, $to: v } = m, S = k.blockRange(v), _ = g || m.$to.parentOffset && m.$from.marks();
  if (!S)
    return !1;
  const x = Gl((y) => Eu(y.type.name, d))(m);
  if (S.depth >= 1 && x && S.depth - x.depth <= 1) {
    if (x.node.type === f)
      return c.liftListItem(p);
    if (Eu(x.node.type.name, d) && f.validContent(x.node.content) && a)
      return l().command(() => (o.setNodeMarkup(x.pos, f), !0)).command(() => aa(o, f)).command(() => la(o, f)).run();
  }
  return !t || !_ || !a ? l().command(() => u().wrapInList(f, i) ? !0 : c.clearNodes()).wrapInList(f, i).command(() => aa(o, f)).command(() => la(o, f)).run() : l().command(() => {
    const y = u().wrapInList(f, i), w = _.filter(($) => h.includes($.type.name));
    return o.ensureMarks(w), y ? !0 : c.clearNodes();
  }).wrapInList(f, i).command(() => aa(o, f)).command(() => la(o, f)).run();
}, E6 = (n, e = {}, t = {}) => ({ state: i, commands: r }) => {
  const { extendEmptyMarkRange: o = !1 } = t, s = In(n, i.schema);
  return Xa(i, s, e) ? r.unsetMark(s, { extendEmptyMarkRange: o }) : r.setMark(s, e);
}, M6 = (n, e, t = {}) => ({ state: i, commands: r }) => {
  const o = Ie(n, i.schema), s = Ie(e, i.schema), a = yr(i, o, t);
  let l;
  return i.selection.$anchor.sameParent(i.selection.$head) && (l = i.selection.$anchor.parent.attrs), a ? r.setNode(s, l) : r.setNode(o, { ...l, ...t });
}, $6 = (n, e = {}) => ({ state: t, commands: i }) => {
  const r = Ie(n, t.schema);
  return yr(t, r, e) ? i.lift(r) : i.wrapIn(r, e);
}, z6 = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let i = 0; i < t.length; i += 1) {
    const r = t[i];
    let o;
    if (r.spec.isInputRules && (o = r.getState(n))) {
      if (e) {
        const s = n.tr, a = o.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          s.step(a.steps[l].invert(a.docs[l]));
        if (o.text) {
          const l = s.doc.resolve(o.from).marks();
          s.replaceWith(o.from, o.to, n.schema.text(o.text, l));
        } else
          s.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, A6 = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: i, ranges: r } = t;
  return i || e && r.forEach((o) => {
    n.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, L6 = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  var o;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: a } = t, l = In(n, i.schema), { $from: c, empty: u, ranges: d } = a;
  if (!r)
    return !0;
  if (u && s) {
    let { from: h, to: f } = a;
    const p = (o = c.marks().find((g) => g.type === l)) === null || o === void 0 ? void 0 : o.attrs, m = Kl(c, l, p);
    m && (h = m.from, f = m.to), t.removeMark(h, f, l);
  } else
    d.forEach((h) => {
      t.removeMark(h.$from.pos, h.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, N6 = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  let o = null, s = null;
  const a = Ls(typeof n == "string" ? n : n.name, i.schema);
  return a ? (a === "node" && (o = Ie(n, i.schema)), a === "mark" && (s = In(n, i.schema)), r && t.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, h, f, p;
    t.selection.empty ? i.doc.nodesBetween(c, u, (m, g) => {
      o && o === m.type && (f = Math.max(g, c), p = Math.min(g + m.nodeSize, u), d = g, h = m);
    }) : i.doc.nodesBetween(c, u, (m, g) => {
      g < c && o && o === m.type && (f = Math.max(g, c), p = Math.min(g + m.nodeSize, u), d = g, h = m), g >= c && g <= u && (o && o === m.type && t.setNodeMarkup(g, void 0, {
        ...m.attrs,
        ...e
      }), s && m.marks.length && m.marks.forEach((k) => {
        if (s === k.type) {
          const v = Math.max(g, c), S = Math.min(g + m.nodeSize, u);
          t.addMark(v, S, s.create({
            ...k.attrs,
            ...e
          }));
        }
      }));
    }), h && (d !== void 0 && t.setNodeMarkup(d, void 0, {
      ...h.attrs,
      ...e
    }), s && h.marks.length && h.marks.forEach((m) => {
      s === m.type && t.addMark(f, p, s.create({
        ...m.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, D6 = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Ie(n, t.schema);
  return KN(r, e)(t, i);
}, R6 = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Ie(n, t.schema);
  return ZN(r, e)(t, i);
};
var I6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: gD,
  clearContent: _D,
  clearNodes: bD,
  command: kD,
  createParagraphNear: yD,
  cut: vD,
  deleteCurrentNode: xD,
  deleteNode: SD,
  deleteRange: wD,
  deleteSelection: CD,
  enter: TD,
  exitCode: OD,
  extendMarkRange: ED,
  first: MD,
  focus: $D,
  forEach: zD,
  insertContent: AD,
  insertContentAt: DD,
  joinBackward: PD,
  joinDown: ID,
  joinForward: jD,
  joinItemBackward: BD,
  joinItemForward: FD,
  joinTextblockBackward: qD,
  joinTextblockForward: HD,
  joinUp: RD,
  keyboardShortcut: UD,
  lift: WD,
  liftEmptyBlock: KD,
  liftListItem: ZD,
  newlineInCode: GD,
  resetAttributes: JD,
  scrollIntoView: YD,
  selectAll: XD,
  selectNodeBackward: QD,
  selectNodeForward: e6,
  selectParentNode: t6,
  selectTextblockEnd: n6,
  selectTextblockStart: i6,
  setContent: r6,
  setMark: k6,
  setMeta: y6,
  setNode: v6,
  setNodeSelection: x6,
  setTextSelection: S6,
  sinkListItem: w6,
  splitBlock: C6,
  splitListItem: T6,
  toggleList: O6,
  toggleMark: E6,
  toggleNode: M6,
  toggleWrap: $6,
  undoInputRule: z6,
  unsetAllMarks: A6,
  unsetMark: L6,
  updateAttributes: N6,
  wrapIn: D6,
  wrapInList: R6
});
const P6 = Ce.create({
  name: "commands",
  addCommands() {
    return {
      ...I6
    };
  }
}), j6 = Ce.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new $e({
        key: new Ve("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, i) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: i
            });
          }
        }
      })
    ];
  }
}), B6 = Ce.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new $e({
        key: new Ve("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), F6 = new Ve("focusEvents"), q6 = Ce.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new $e({
        key: F6,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const i = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const i = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            }
          }
        }
      })
    ];
  }
}), H6 = Ce.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: a }) => {
        const { selection: l, doc: c } = a, { empty: u, $anchor: d } = l, { pos: h, parent: f } = d, p = d.parent.isTextblock && h > 0 ? a.doc.resolve(h - 1) : d, m = p.parent.type.spec.isolating, g = d.pos - d.parentOffset, k = m && p.parent.childCount === 1 ? g === d.pos : ie.atStart(c).from === h;
        return !u || !f.type.isTextblock || f.textContent.length || !k || k && d.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), i = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, r = {
      ...i
    }, o = {
      ...i,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return As() || rp() ? o : r;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new $e({
        key: new Ve("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((m) => m.getMeta("composition")))
            return;
          const i = n.some((m) => m.docChanged) && !e.doc.eq(t.doc), r = n.some((m) => m.getMeta("preventClearDocument"));
          if (!i || r)
            return;
          const { empty: o, from: s, to: a } = e.selection, l = ie.atStart(e.doc).from, c = ie.atEnd(e.doc).to;
          if (o || !(s === l && a === c) || !Yl(t.doc))
            return;
          const h = t.tr, f = Os({
            state: t,
            transaction: h
          }), { commands: p } = new Es({
            editor: this.editor,
            state: f
          });
          if (p.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), V6 = Ce.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new $e({
        key: new Ve("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), U6 = Ce.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new $e({
        key: new Ve("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Gn {
  get name() {
    return this.node.type.name;
  }
  constructor(e, t, i = !1, r = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = i, this.resolvedPos = e, this.editor = t, this.currentNode = r;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, i = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, i = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: i }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new Gn(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Gn(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Gn(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, i) => {
      const r = t.isBlock && !t.isTextblock, o = t.isAtom && !t.isText, s = this.pos + i + (o ? 0 : 1);
      if (s < 0 || s > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(s);
      if (!r && a.depth <= this.depth)
        return;
      const l = new Gn(a, this.editor, r, r ? t : null);
      r && (l.actualDepth = this.depth + 1), e.push(new Gn(a, this.editor, r, r ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let i = null, r = this.parent;
    for (; r && !i; ) {
      if (r.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const o = r.node.attrs, s = Object.keys(t);
          for (let a = 0; a < s.length; a += 1) {
            const l = s[a];
            if (o[l] !== t[l])
              break;
          }
        } else
          i = r;
      r = r.parent;
    }
    return i;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, i = !1) {
    let r = [];
    if (!this.children || this.children.length === 0)
      return r;
    const o = Object.keys(t);
    return this.children.forEach((s) => {
      i && r.length > 0 || (s.node.type.name === e && o.every((l) => t[l] === s.node.attrs[l]) && r.push(s), !(i && r.length > 0) && (r = r.concat(s.querySelectorAll(e, t, i))));
    }), r;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}
const W6 = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function K6(n, e, t) {
  const i = document.querySelector("style[data-tiptap-style]");
  if (i !== null)
    return i;
  const r = document.createElement("style");
  return e && r.setAttribute("nonce", e), r.setAttribute("data-tiptap-style", ""), r.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(r), r;
}
class Z6 extends tD {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: t }) => {
        throw t;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: t, slice: i, moved: r }) => this.options.onDrop(t, i, r)), this.on("paste", ({ event: t, slice: i }) => this.options.onPaste(t, i)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = K6(W6, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const i = Jf(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], r = this.state.reconfigure({ plugins: i });
    return this.view.updateState(r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let i = t;
    if ([].concat(e).forEach((o) => {
      const s = typeof o == "string" ? `${o}$` : o.key;
      i = i.filter((a) => !a.key.startsWith(s));
    }), t.length === i.length)
      return;
    const r = this.state.reconfigure({
      plugins: i
    });
    return this.view.updateState(r), r;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const r = [...this.options.enableCoreExtensions ? [
      B6,
      mD.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      P6,
      q6,
      H6,
      U6,
      j6,
      V6
    ].filter((o) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[o.name] !== !1 : !0) : [], ...this.options.extensions].filter((o) => ["extension", "node", "mark"].includes(o == null ? void 0 : o.type));
    this.extensionManager = new Xn(r, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Es({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let t;
    try {
      t = Ya(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (s) {
      if (!(s instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(s.message))
        throw s;
      this.emit("contentError", {
        editor: this,
        error: s,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = Ya(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const i = tp(t, this.options.autofocus);
    this.view = new Rf(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Ti.create({
        doc: t,
        selection: i || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const o = this.view.dom;
    o.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((s) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(s);
      });
      return;
    }
    const t = this.state.apply(e), i = !this.state.selection.eq(t.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), i && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const r = e.getMeta("focus"), o = e.getMeta("blur");
    r && this.emit("focus", {
      editor: this,
      event: r.event,
      transaction: e
    }), o && this.emit("blur", {
      editor: this,
      event: o.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return ap(this.state, e);
  }
  isActive(e, t) {
    const i = typeof e == "string" ? e : null, r = typeof e == "string" ? t : e;
    return m6(this.state, i, r);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return $s(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: i = {} } = e || {};
    return u6(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...Qf(this.schema),
        ...i
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Yl(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, t) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new Gn(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function vr(n) {
  return new Wl({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      const r = ee(n.getAttributes, void 0, i);
      if (r === !1 || r === null)
        return null;
      const { tr: o } = e, s = i[i.length - 1], a = i[0];
      if (s) {
        const l = a.search(/\S/), c = t.from + a.indexOf(s), u = c + s.length;
        if (Jl(t.from, t.to, e.doc).filter((f) => f.mark.type.excluded.find((m) => m === n.type && m !== f.mark.type)).filter((f) => f.to > c).length)
          return null;
        u < t.to && o.delete(u, t.to), c > t.from && o.delete(t.from + l, c);
        const h = t.from + l + s.length;
        o.addMark(t.from + l, h, n.type.create(r || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
function G6(n) {
  return new Wl({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      const r = e.doc.resolve(t.from), o = ee(n.getAttributes, void 0, i) || {};
      if (!r.node(-1).canReplaceWith(r.index(-1), r.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, o);
    }
  });
}
function Lo(n) {
  return new Wl({
    find: n.find,
    handler: ({ state: e, range: t, match: i, chain: r }) => {
      const o = ee(n.getAttributes, void 0, i) || {}, s = e.tr.delete(t.from, t.to), l = s.doc.resolve(t.from).blockRange(), c = l && Ml(l, n.type, o);
      if (!c)
        return null;
      if (s.wrap(l, c), n.keepMarks && n.editor) {
        const { selection: d, storedMarks: h } = e, { splittableMarks: f } = n.editor.extensionManager, p = h || d.$to.parentOffset && d.$from.marks();
        if (p) {
          const m = p.filter((g) => f.includes(g.type.name));
          s.ensureMarks(m);
        }
      }
      if (n.keepAttributes) {
        const d = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        r().updateAttributes(d, o).run();
      }
      const u = s.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === n.type && Dn(s.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(i, u)) && s.join(t.from - 1);
    }
  });
}
class xt {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ee(D(this, "addOptions", {
      name: this.name
    }))), this.storage = ee(D(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new xt(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => zs(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new xt(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = ee(D(t, "addOptions", {
      name: t.name
    })), t.storage = ee(D(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
class J6 {
  constructor(e, t, i) {
    this.isDragging = !1, this.component = e, this.editor = t.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...i
    }, this.extension = t.extension, this.node = t.node, this.decorations = t.decorations, this.innerDecorations = t.innerDecorations, this.view = t.view, this.HTMLAttributes = t.HTMLAttributes, this.getPos = t.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(e) {
    var t, i, r, o, s, a, l;
    const { view: c } = this.editor, u = e.target, d = u.nodeType === 3 ? (t = u.parentElement) === null || t === void 0 ? void 0 : t.closest("[data-drag-handle]") : u.closest("[data-drag-handle]");
    if (!this.dom || !((i = this.contentDOM) === null || i === void 0) && i.contains(u) || !d)
      return;
    let h = 0, f = 0;
    if (this.dom !== d) {
      const v = this.dom.getBoundingClientRect(), S = d.getBoundingClientRect(), _ = (r = e.offsetX) !== null && r !== void 0 ? r : (o = e.nativeEvent) === null || o === void 0 ? void 0 : o.offsetX, x = (s = e.offsetY) !== null && s !== void 0 ? s : (a = e.nativeEvent) === null || a === void 0 ? void 0 : a.offsetY;
      h = S.x - v.x + _, f = S.y - v.y + x;
    }
    const p = this.dom.cloneNode(!0);
    (l = e.dataTransfer) === null || l === void 0 || l.setDragImage(p, h, f);
    const m = this.getPos();
    if (typeof m != "number")
      return;
    const g = F.create(c.state.doc, m), k = c.state.tr.setSelection(g);
    c.dispatch(k);
  }
  stopEvent(e) {
    var t;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: e });
    const i = e.target;
    if (!(this.dom.contains(i) && !(!((t = this.contentDOM) === null || t === void 0) && t.contains(i))))
      return !1;
    const o = e.type.startsWith("drag"), s = e.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(i.tagName) || i.isContentEditable) && !s && !o)
      return !0;
    const { isEditable: l } = this.editor, { isDragging: c } = this, u = !!this.node.type.spec.draggable, d = F.isSelectable(this.node), h = e.type === "copy", f = e.type === "paste", p = e.type === "cut", m = e.type === "mousedown";
    if (!u && d && o && e.target === this.dom && e.preventDefault(), u && o && !c && e.target === this.dom)
      return e.preventDefault(), !1;
    if (u && l && !c && m) {
      const g = i.closest("[data-drag-handle]");
      g && (this.dom === g || this.dom.contains(g)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(c || s || h || f || p || m && d);
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(e) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: e }) : this.node.isLeaf || this.node.isAtom ? !0 : e.type === "selection" || this.dom.contains(e.target) && e.type === "childList" && (As() || np()) && this.editor.isFocused && [
      ...Array.from(e.addedNodes),
      ...Array.from(e.removedNodes)
    ].every((i) => i.isContentEditable) ? !1 : this.contentDOM === e.target && e.type === "attributes" ? !0 : !this.contentDOM.contains(e.target);
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(e) {
    this.editor.commands.command(({ tr: t }) => {
      const i = this.getPos();
      return typeof i != "number" ? !1 : (t.setNodeMarkup(i, void 0, {
        ...this.node.attrs,
        ...e
      }), !0);
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const e = this.getPos();
    if (typeof e != "number")
      return;
    const t = e + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: e, to: t });
  }
}
function Ni(n) {
  return new cD({
    find: n.find,
    handler: ({ state: e, range: t, match: i, pasteEvent: r }) => {
      const o = ee(n.getAttributes, void 0, i, r);
      if (o === !1 || o === null)
        return null;
      const { tr: s } = e, a = i[i.length - 1], l = i[0];
      let c = t.to;
      if (a) {
        const u = l.search(/\S/), d = t.from + l.indexOf(a), h = d + a.length;
        if (Jl(t.from, t.to, e.doc).filter((p) => p.mark.type.excluded.find((g) => g === n.type && g !== p.mark.type)).filter((p) => p.to > d).length)
          return null;
        h < t.to && s.delete(h, t.to), d > t.from && s.delete(t.from + u, d), c = t.from + u + a.length, s.addMark(t.from + u, c, n.type.create(o || {})), s.removeStoredMark(n.type);
      }
    }
  });
}
class Y6 {
  constructor(e) {
    this.transaction = e, this.currentStep = this.transaction.steps.length;
  }
  map(e) {
    let t = !1;
    return {
      position: this.transaction.steps.slice(this.currentStep).reduce((r, o) => {
        const s = o.getMap().mapResult(r);
        return s.deleted && (t = !0), s.pos;
      }, e),
      deleted: t
    };
  }
}
var at = "top", St = "bottom", wt = "right", lt = "left", Xl = "auto", Nr = [at, St, wt, lt], Di = "start", xr = "end", X6 = "clippingParents", lp = "viewport", qi = "popper", Q6 = "reference", $u = /* @__PURE__ */ Nr.reduce(function(n, e) {
  return n.concat([e + "-" + Di, e + "-" + xr]);
}, []), cp = /* @__PURE__ */ [].concat(Nr, [Xl]).reduce(function(n, e) {
  return n.concat([e, e + "-" + Di, e + "-" + xr]);
}, []), e9 = "beforeRead", t9 = "read", n9 = "afterRead", i9 = "beforeMain", r9 = "main", o9 = "afterMain", s9 = "beforeWrite", a9 = "write", l9 = "afterWrite", c9 = [e9, t9, n9, i9, r9, o9, s9, a9, l9];
function Ut(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function ht(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function ui(n) {
  var e = ht(n).Element;
  return n instanceof e || n instanceof Element;
}
function vt(n) {
  var e = ht(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function Ql(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ht(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
function u9(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var i = e.styles[t] || {}, r = e.attributes[t] || {}, o = e.elements[t];
    !vt(o) || !Ut(o) || (Object.assign(o.style, i), Object.keys(r).forEach(function(s) {
      var a = r[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function d9(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(i) {
      var r = e.elements[i], o = e.attributes[i] || {}, s = Object.keys(e.styles.hasOwnProperty(i) ? e.styles[i] : t[i]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !vt(r) || !Ut(r) || (Object.assign(r.style, a), Object.keys(o).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const up = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: u9,
  effect: d9,
  requires: ["computeStyles"]
};
function Bt(n) {
  return n.split("-")[0];
}
var ri = Math.max, No = Math.min, Ri = Math.round;
function Qa() {
  var n = navigator.userAgentData;
  return n != null && n.brands && Array.isArray(n.brands) ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function dp() {
  return !/^((?!chrome|android).)*safari/i.test(Qa());
}
function Ii(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var i = n.getBoundingClientRect(), r = 1, o = 1;
  e && vt(n) && (r = n.offsetWidth > 0 && Ri(i.width) / n.offsetWidth || 1, o = n.offsetHeight > 0 && Ri(i.height) / n.offsetHeight || 1);
  var s = ui(n) ? ht(n) : window, a = s.visualViewport, l = !dp() && t, c = (i.left + (l && a ? a.offsetLeft : 0)) / r, u = (i.top + (l && a ? a.offsetTop : 0)) / o, d = i.width / r, h = i.height / o;
  return {
    width: d,
    height: h,
    top: u,
    right: c + d,
    bottom: u + h,
    left: c,
    x: c,
    y: u
  };
}
function ec(n) {
  var e = Ii(n), t = n.offsetWidth, i = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - i) <= 1 && (i = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: i
  };
}
function hp(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && Ql(t)) {
    var i = e;
    do {
      if (i && n.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function cn(n) {
  return ht(n).getComputedStyle(n);
}
function h9(n) {
  return ["table", "td", "th"].indexOf(Ut(n)) >= 0;
}
function Pn(n) {
  return ((ui(n) ? n.ownerDocument : (
    // $FlowFixMe[prop-missing]
    n.document
  )) || window.document).documentElement;
}
function Ns(n) {
  return Ut(n) === "html" ? n : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    n.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    n.parentNode || // DOM Element detected
    (Ql(n) ? n.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Pn(n)
  );
}
function zu(n) {
  return !vt(n) || // https://github.com/popperjs/popper-core/issues/837
  cn(n).position === "fixed" ? null : n.offsetParent;
}
function f9(n) {
  var e = /firefox/i.test(Qa()), t = /Trident/i.test(Qa());
  if (t && vt(n)) {
    var i = cn(n);
    if (i.position === "fixed")
      return null;
  }
  var r = Ns(n);
  for (Ql(r) && (r = r.host); vt(r) && ["html", "body"].indexOf(Ut(r)) < 0; ) {
    var o = cn(r);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Dr(n) {
  for (var e = ht(n), t = zu(n); t && h9(t) && cn(t).position === "static"; )
    t = zu(t);
  return t && (Ut(t) === "html" || Ut(t) === "body" && cn(t).position === "static") ? e : t || f9(n) || e;
}
function tc(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function er(n, e, t) {
  return ri(n, No(e, t));
}
function p9(n, e, t) {
  var i = er(n, e, t);
  return i > t ? t : i;
}
function fp() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function pp(n) {
  return Object.assign({}, fp(), n);
}
function mp(n, e) {
  return e.reduce(function(t, i) {
    return t[i] = n, t;
  }, {});
}
var m9 = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, pp(typeof e != "number" ? e : mp(e, Nr));
};
function g9(n) {
  var e, t = n.state, i = n.name, r = n.options, o = t.elements.arrow, s = t.modifiersData.popperOffsets, a = Bt(t.placement), l = tc(a), c = [lt, wt].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!o || !s)) {
    var d = m9(r.padding, t), h = ec(o), f = l === "y" ? at : lt, p = l === "y" ? St : wt, m = t.rects.reference[u] + t.rects.reference[l] - s[l] - t.rects.popper[u], g = s[l] - t.rects.reference[l], k = Dr(o), v = k ? l === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, S = m / 2 - g / 2, _ = d[f], x = v - h[u] - d[p], y = v / 2 - h[u] / 2 + S, w = er(_, y, x), $ = l;
    t.modifiersData[i] = (e = {}, e[$] = w, e.centerOffset = w - y, e);
  }
}
function _9(n) {
  var e = n.state, t = n.options, i = t.element, r = i === void 0 ? "[data-popper-arrow]" : i;
  r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || hp(e.elements.popper, r) && (e.elements.arrow = r));
}
const b9 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: g9,
  effect: _9,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Pi(n) {
  return n.split("-")[1];
}
var k9 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function y9(n, e) {
  var t = n.x, i = n.y, r = e.devicePixelRatio || 1;
  return {
    x: Ri(t * r) / r || 0,
    y: Ri(i * r) / r || 0
  };
}
function Au(n) {
  var e, t = n.popper, i = n.popperRect, r = n.placement, o = n.variation, s = n.offsets, a = n.position, l = n.gpuAcceleration, c = n.adaptive, u = n.roundOffsets, d = n.isFixed, h = s.x, f = h === void 0 ? 0 : h, p = s.y, m = p === void 0 ? 0 : p, g = typeof u == "function" ? u({
    x: f,
    y: m
  }) : {
    x: f,
    y: m
  };
  f = g.x, m = g.y;
  var k = s.hasOwnProperty("x"), v = s.hasOwnProperty("y"), S = lt, _ = at, x = window;
  if (c) {
    var y = Dr(t), w = "clientHeight", $ = "clientWidth";
    if (y === ht(t) && (y = Pn(t), cn(y).position !== "static" && a === "absolute" && (w = "scrollHeight", $ = "scrollWidth")), y = y, r === at || (r === lt || r === wt) && o === xr) {
      _ = St;
      var A = d && y === x && x.visualViewport ? x.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[w]
      );
      m -= A - i.height, m *= l ? 1 : -1;
    }
    if (r === lt || (r === at || r === St) && o === xr) {
      S = wt;
      var z = d && y === x && x.visualViewport ? x.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[$]
      );
      f -= z - i.width, f *= l ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: a
  }, c && k9), L = u === !0 ? y9({
    x: f,
    y: m
  }, ht(t)) : {
    x: f,
    y: m
  };
  if (f = L.x, m = L.y, l) {
    var P;
    return Object.assign({}, I, (P = {}, P[_] = v ? "0" : "", P[S] = k ? "0" : "", P.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + m + "px)" : "translate3d(" + f + "px, " + m + "px, 0)", P));
  }
  return Object.assign({}, I, (e = {}, e[_] = v ? m + "px" : "", e[S] = k ? f + "px" : "", e.transform = "", e));
}
function v9(n) {
  var e = n.state, t = n.options, i = t.gpuAcceleration, r = i === void 0 ? !0 : i, o = t.adaptive, s = o === void 0 ? !0 : o, a = t.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: Bt(e.placement),
    variation: Pi(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: r,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Au(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Au(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const x9 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: v9,
  data: {}
};
var Kr = {
  passive: !0
};
function S9(n) {
  var e = n.state, t = n.instance, i = n.options, r = i.scroll, o = r === void 0 ? !0 : r, s = i.resize, a = s === void 0 ? !0 : s, l = ht(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", t.update, Kr);
  }), a && l.addEventListener("resize", t.update, Kr), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", t.update, Kr);
    }), a && l.removeEventListener("resize", t.update, Kr);
  };
}
const w9 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: S9,
  data: {}
};
var C9 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ho(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return C9[e];
  });
}
var T9 = {
  start: "end",
  end: "start"
};
function Lu(n) {
  return n.replace(/start|end/g, function(e) {
    return T9[e];
  });
}
function nc(n) {
  var e = ht(n), t = e.pageXOffset, i = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: i
  };
}
function ic(n) {
  return Ii(Pn(n)).left + nc(n).scrollLeft;
}
function O9(n, e) {
  var t = ht(n), i = Pn(n), r = t.visualViewport, o = i.clientWidth, s = i.clientHeight, a = 0, l = 0;
  if (r) {
    o = r.width, s = r.height;
    var c = dp();
    (c || !c && e === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + ic(n),
    y: l
  };
}
function E9(n) {
  var e, t = Pn(n), i = nc(n), r = (e = n.ownerDocument) == null ? void 0 : e.body, o = ri(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), s = ri(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -i.scrollLeft + ic(n), l = -i.scrollTop;
  return cn(r || t).direction === "rtl" && (a += ri(t.clientWidth, r ? r.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function rc(n) {
  var e = cn(n), t = e.overflow, i = e.overflowX, r = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + r + i);
}
function gp(n) {
  return ["html", "body", "#document"].indexOf(Ut(n)) >= 0 ? n.ownerDocument.body : vt(n) && rc(n) ? n : gp(Ns(n));
}
function tr(n, e) {
  var t;
  e === void 0 && (e = []);
  var i = gp(n), r = i === ((t = n.ownerDocument) == null ? void 0 : t.body), o = ht(i), s = r ? [o].concat(o.visualViewport || [], rc(i) ? i : []) : i, a = e.concat(s);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(tr(Ns(s)))
  );
}
function el(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function M9(n, e) {
  var t = Ii(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Nu(n, e, t) {
  return e === lp ? el(O9(n, t)) : ui(e) ? M9(e, t) : el(E9(Pn(n)));
}
function $9(n) {
  var e = tr(Ns(n)), t = ["absolute", "fixed"].indexOf(cn(n).position) >= 0, i = t && vt(n) ? Dr(n) : n;
  return ui(i) ? e.filter(function(r) {
    return ui(r) && hp(r, i) && Ut(r) !== "body";
  }) : [];
}
function z9(n, e, t, i) {
  var r = e === "clippingParents" ? $9(n) : [].concat(e), o = [].concat(r, [t]), s = o[0], a = o.reduce(function(l, c) {
    var u = Nu(n, c, i);
    return l.top = ri(u.top, l.top), l.right = No(u.right, l.right), l.bottom = No(u.bottom, l.bottom), l.left = ri(u.left, l.left), l;
  }, Nu(n, s, i));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function _p(n) {
  var e = n.reference, t = n.element, i = n.placement, r = i ? Bt(i) : null, o = i ? Pi(i) : null, s = e.x + e.width / 2 - t.width / 2, a = e.y + e.height / 2 - t.height / 2, l;
  switch (r) {
    case at:
      l = {
        x: s,
        y: e.y - t.height
      };
      break;
    case St:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case wt:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case lt:
      l = {
        x: e.x - t.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = r ? tc(r) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case Di:
        l[c] = l[c] - (e[u] / 2 - t[u] / 2);
        break;
      case xr:
        l[c] = l[c] + (e[u] / 2 - t[u] / 2);
        break;
    }
  }
  return l;
}
function Sr(n, e) {
  e === void 0 && (e = {});
  var t = e, i = t.placement, r = i === void 0 ? n.placement : i, o = t.strategy, s = o === void 0 ? n.strategy : o, a = t.boundary, l = a === void 0 ? X6 : a, c = t.rootBoundary, u = c === void 0 ? lp : c, d = t.elementContext, h = d === void 0 ? qi : d, f = t.altBoundary, p = f === void 0 ? !1 : f, m = t.padding, g = m === void 0 ? 0 : m, k = pp(typeof g != "number" ? g : mp(g, Nr)), v = h === qi ? Q6 : qi, S = n.rects.popper, _ = n.elements[p ? v : h], x = z9(ui(_) ? _ : _.contextElement || Pn(n.elements.popper), l, u, s), y = Ii(n.elements.reference), w = _p({
    reference: y,
    element: S,
    placement: r
  }), $ = el(Object.assign({}, S, w)), A = h === qi ? $ : y, z = {
    top: x.top - A.top + k.top,
    bottom: A.bottom - x.bottom + k.bottom,
    left: x.left - A.left + k.left,
    right: A.right - x.right + k.right
  }, I = n.modifiersData.offset;
  if (h === qi && I) {
    var L = I[r];
    Object.keys(z).forEach(function(P) {
      var q = [wt, St].indexOf(P) >= 0 ? 1 : -1, W = [at, St].indexOf(P) >= 0 ? "y" : "x";
      z[P] += L[W] * q;
    });
  }
  return z;
}
function A9(n, e) {
  e === void 0 && (e = {});
  var t = e, i = t.placement, r = t.boundary, o = t.rootBoundary, s = t.padding, a = t.flipVariations, l = t.allowedAutoPlacements, c = l === void 0 ? cp : l, u = Pi(i), d = u ? a ? $u : $u.filter(function(p) {
    return Pi(p) === u;
  }) : Nr, h = d.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  h.length === 0 && (h = d);
  var f = h.reduce(function(p, m) {
    return p[m] = Sr(n, {
      placement: m,
      boundary: r,
      rootBoundary: o,
      padding: s
    })[Bt(m)], p;
  }, {});
  return Object.keys(f).sort(function(p, m) {
    return f[p] - f[m];
  });
}
function L9(n) {
  if (Bt(n) === Xl)
    return [];
  var e = ho(n);
  return [Lu(n), e, Lu(e)];
}
function N9(n) {
  var e = n.state, t = n.options, i = n.name;
  if (!e.modifiersData[i]._skip) {
    for (var r = t.mainAxis, o = r === void 0 ? !0 : r, s = t.altAxis, a = s === void 0 ? !0 : s, l = t.fallbackPlacements, c = t.padding, u = t.boundary, d = t.rootBoundary, h = t.altBoundary, f = t.flipVariations, p = f === void 0 ? !0 : f, m = t.allowedAutoPlacements, g = e.options.placement, k = Bt(g), v = k === g, S = l || (v || !p ? [ho(g)] : L9(g)), _ = [g].concat(S).reduce(function(ze, Te) {
      return ze.concat(Bt(Te) === Xl ? A9(e, {
        placement: Te,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : Te);
    }, []), x = e.rects.reference, y = e.rects.popper, w = /* @__PURE__ */ new Map(), $ = !0, A = _[0], z = 0; z < _.length; z++) {
      var I = _[z], L = Bt(I), P = Pi(I) === Di, q = [at, St].indexOf(L) >= 0, W = q ? "width" : "height", B = Sr(e, {
        placement: I,
        boundary: u,
        rootBoundary: d,
        altBoundary: h,
        padding: c
      }), Z = q ? P ? wt : lt : P ? St : at;
      x[W] > y[W] && (Z = ho(Z));
      var V = ho(Z), pe = [];
      if (o && pe.push(B[L] <= 0), a && pe.push(B[Z] <= 0, B[V] <= 0), pe.every(function(ze) {
        return ze;
      })) {
        A = I, $ = !1;
        break;
      }
      w.set(I, pe);
    }
    if ($)
      for (var me = p ? 3 : 1, G = function(Te) {
        var Ae = _.find(function(oe) {
          var be = w.get(oe);
          if (be)
            return be.slice(0, Te).every(function(Pe) {
              return Pe;
            });
        });
        if (Ae)
          return A = Ae, "break";
      }, Q = me; Q > 0; Q--) {
        var X = G(Q);
        if (X === "break") break;
      }
    e.placement !== A && (e.modifiersData[i]._skip = !0, e.placement = A, e.reset = !0);
  }
}
const D9 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: N9,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Du(n, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: n.top - e.height - t.y,
    right: n.right - e.width + t.x,
    bottom: n.bottom - e.height + t.y,
    left: n.left - e.width - t.x
  };
}
function Ru(n) {
  return [at, wt, St, lt].some(function(e) {
    return n[e] >= 0;
  });
}
function R9(n) {
  var e = n.state, t = n.name, i = e.rects.reference, r = e.rects.popper, o = e.modifiersData.preventOverflow, s = Sr(e, {
    elementContext: "reference"
  }), a = Sr(e, {
    altBoundary: !0
  }), l = Du(s, i), c = Du(a, r, o), u = Ru(l), d = Ru(c);
  e.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const I9 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: R9
};
function P9(n, e, t) {
  var i = Bt(n), r = [lt, at].indexOf(i) >= 0 ? -1 : 1, o = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * r, [lt, wt].indexOf(i) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function j9(n) {
  var e = n.state, t = n.options, i = n.name, r = t.offset, o = r === void 0 ? [0, 0] : r, s = cp.reduce(function(u, d) {
    return u[d] = P9(d, e.rects, o), u;
  }, {}), a = s[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[i] = s;
}
const B9 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: j9
};
function F9(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = _p({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const q9 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: F9,
  data: {}
};
function H9(n) {
  return n === "x" ? "y" : "x";
}
function V9(n) {
  var e = n.state, t = n.options, i = n.name, r = t.mainAxis, o = r === void 0 ? !0 : r, s = t.altAxis, a = s === void 0 ? !1 : s, l = t.boundary, c = t.rootBoundary, u = t.altBoundary, d = t.padding, h = t.tether, f = h === void 0 ? !0 : h, p = t.tetherOffset, m = p === void 0 ? 0 : p, g = Sr(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), k = Bt(e.placement), v = Pi(e.placement), S = !v, _ = tc(k), x = H9(_), y = e.modifiersData.popperOffsets, w = e.rects.reference, $ = e.rects.popper, A = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, z = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), I = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (y) {
    if (o) {
      var P, q = _ === "y" ? at : lt, W = _ === "y" ? St : wt, B = _ === "y" ? "height" : "width", Z = y[_], V = Z + g[q], pe = Z - g[W], me = f ? -$[B] / 2 : 0, G = v === Di ? w[B] : $[B], Q = v === Di ? -$[B] : -w[B], X = e.elements.arrow, ze = f && X ? ec(X) : {
        width: 0,
        height: 0
      }, Te = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : fp(), Ae = Te[q], oe = Te[W], be = er(0, w[B], ze[B]), Pe = S ? w[B] / 2 - me - be - Ae - z.mainAxis : G - be - Ae - z.mainAxis, tt = S ? -w[B] / 2 + me + be + oe + z.mainAxis : Q + be + oe + z.mainAxis, Kt = e.elements.arrow && Dr(e.elements.arrow), jn = Kt ? _ === "y" ? Kt.clientTop || 0 : Kt.clientLeft || 0 : 0, dn = (P = I == null ? void 0 : I[_]) != null ? P : 0, Bn = Z + Pe - dn - jn, Fn = Z + tt - dn, hn = er(f ? No(V, Bn) : V, Z, f ? ri(pe, Fn) : pe);
      y[_] = hn, L[_] = hn - Z;
    }
    if (a) {
      var fn, nt = _ === "x" ? at : lt, qn = _ === "x" ? St : wt, Tt = y[x], Ot = x === "y" ? "height" : "width", ye = Tt + g[nt], te = Tt - g[qn], it = [at, lt].indexOf(k) !== -1, Et = (fn = I == null ? void 0 : I[x]) != null ? fn : 0, ct = it ? ye : Tt - w[Ot] - $[Ot] - Et + z.altAxis, pn = it ? Tt + w[Ot] + $[Ot] - Et - z.altAxis : te, mn = f && it ? p9(ct, Tt, pn) : er(f ? ct : ye, Tt, f ? pn : te);
      y[x] = mn, L[x] = mn - Tt;
    }
    e.modifiersData[i] = L;
  }
}
const U9 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: V9,
  requiresIfExists: ["offset"]
};
function W9(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function K9(n) {
  return n === ht(n) || !vt(n) ? nc(n) : W9(n);
}
function Z9(n) {
  var e = n.getBoundingClientRect(), t = Ri(e.width) / n.offsetWidth || 1, i = Ri(e.height) / n.offsetHeight || 1;
  return t !== 1 || i !== 1;
}
function G9(n, e, t) {
  t === void 0 && (t = !1);
  var i = vt(e), r = vt(e) && Z9(e), o = Pn(e), s = Ii(n, r, t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (i || !i && !t) && ((Ut(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  rc(o)) && (a = K9(e)), vt(e) ? (l = Ii(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : o && (l.x = ic(o))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function J9(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), i = [];
  n.forEach(function(o) {
    e.set(o.name, o);
  });
  function r(o) {
    t.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!t.has(a)) {
        var l = e.get(a);
        l && r(l);
      }
    }), i.push(o);
  }
  return n.forEach(function(o) {
    t.has(o.name) || r(o);
  }), i;
}
function Y9(n) {
  var e = J9(n);
  return c9.reduce(function(t, i) {
    return t.concat(e.filter(function(r) {
      return r.phase === i;
    }));
  }, []);
}
function X9(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function Q9(n) {
  var e = n.reduce(function(t, i) {
    var r = t[i.name];
    return t[i.name] = r ? Object.assign({}, r, i, {
      options: Object.assign({}, r.options, i.options),
      data: Object.assign({}, r.data, i.data)
    }) : i, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var Iu = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Pu() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function e4(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, i = t === void 0 ? [] : t, r = e.defaultOptions, o = r === void 0 ? Iu : r;
  return function(a, l, c) {
    c === void 0 && (c = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Iu, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], h = !1, f = {
      state: u,
      setOptions: function(k) {
        var v = typeof k == "function" ? k(u.options) : k;
        m(), u.options = Object.assign({}, o, u.options, v), u.scrollParents = {
          reference: ui(a) ? tr(a) : a.contextElement ? tr(a.contextElement) : [],
          popper: tr(l)
        };
        var S = Y9(Q9([].concat(i, u.options.modifiers)));
        return u.orderedModifiers = S.filter(function(_) {
          return _.enabled;
        }), p(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var k = u.elements, v = k.reference, S = k.popper;
          if (Pu(v, S)) {
            u.rects = {
              reference: G9(v, Dr(S), u.options.strategy === "fixed"),
              popper: ec(S)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(z) {
              return u.modifiersData[z.name] = Object.assign({}, z.data);
            });
            for (var _ = 0; _ < u.orderedModifiers.length; _++) {
              if (u.reset === !0) {
                u.reset = !1, _ = -1;
                continue;
              }
              var x = u.orderedModifiers[_], y = x.fn, w = x.options, $ = w === void 0 ? {} : w, A = x.name;
              typeof y == "function" && (u = y({
                state: u,
                options: $,
                name: A,
                instance: f
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: X9(function() {
        return new Promise(function(g) {
          f.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        m(), h = !0;
      }
    };
    if (!Pu(a, l))
      return f;
    f.setOptions(c).then(function(g) {
      !h && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function p() {
      u.orderedModifiers.forEach(function(g) {
        var k = g.name, v = g.options, S = v === void 0 ? {} : v, _ = g.effect;
        if (typeof _ == "function") {
          var x = _({
            state: u,
            name: k,
            instance: f,
            options: S
          }), y = function() {
          };
          d.push(x || y);
        }
      });
    }
    function m() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return f;
  };
}
var t4 = [w9, q9, x9, up, B9, D9, U9, b9, I9], n4 = /* @__PURE__ */ e4({
  defaultModifiers: t4
}), i4 = "tippy-box", bp = "tippy-content", r4 = "tippy-backdrop", kp = "tippy-arrow", yp = "tippy-svg-arrow", Wn = {
  passive: !0,
  capture: !0
}, vp = function() {
  return document.body;
};
function o4(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function ca(n, e, t) {
  if (Array.isArray(n)) {
    var i = n[e];
    return i ?? (Array.isArray(t) ? t[e] : t);
  }
  return n;
}
function oc(n, e) {
  var t = {}.toString.call(n);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function xp(n, e) {
  return typeof n == "function" ? n.apply(void 0, e) : n;
}
function ju(n, e) {
  if (e === 0)
    return n;
  var t;
  return function(i) {
    clearTimeout(t), t = setTimeout(function() {
      n(i);
    }, e);
  };
}
function s4(n, e) {
  var t = Object.assign({}, n);
  return e.forEach(function(i) {
    delete t[i];
  }), t;
}
function a4(n) {
  return n.split(/\s+/).filter(Boolean);
}
function wi(n) {
  return [].concat(n);
}
function Bu(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function l4(n) {
  return n.filter(function(e, t) {
    return n.indexOf(e) === t;
  });
}
function c4(n) {
  return n.split("-")[0];
}
function Do(n) {
  return [].slice.call(n);
}
function Fu(n) {
  return Object.keys(n).reduce(function(e, t) {
    return n[t] !== void 0 && (e[t] = n[t]), e;
  }, {});
}
function nr() {
  return document.createElement("div");
}
function wr(n) {
  return ["Element", "Fragment"].some(function(e) {
    return oc(n, e);
  });
}
function u4(n) {
  return oc(n, "NodeList");
}
function d4(n) {
  return oc(n, "MouseEvent");
}
function h4(n) {
  return !!(n && n._tippy && n._tippy.reference === n);
}
function f4(n) {
  return wr(n) ? [n] : u4(n) ? Do(n) : Array.isArray(n) ? n : Do(document.querySelectorAll(n));
}
function ua(n, e) {
  n.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function qu(n, e) {
  n.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function p4(n) {
  var e, t = wi(n), i = t[0];
  return i != null && (e = i.ownerDocument) != null && e.body ? i.ownerDocument : document;
}
function m4(n, e) {
  var t = e.clientX, i = e.clientY;
  return n.every(function(r) {
    var o = r.popperRect, s = r.popperState, a = r.props, l = a.interactiveBorder, c = c4(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, h = c === "top" ? u.bottom.y : 0, f = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, m = o.top - i + d > l, g = i - o.bottom - h > l, k = o.left - t + f > l, v = t - o.right - p > l;
    return m || g || k || v;
  });
}
function da(n, e, t) {
  var i = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    n[i](r, t);
  });
}
function Hu(n, e) {
  for (var t = e; t; ) {
    var i;
    if (n.contains(t))
      return !0;
    t = t.getRootNode == null || (i = t.getRootNode()) == null ? void 0 : i.host;
  }
  return !1;
}
var It = {
  isTouch: !1
}, Vu = 0;
function g4() {
  It.isTouch || (It.isTouch = !0, window.performance && document.addEventListener("mousemove", Sp));
}
function Sp() {
  var n = performance.now();
  n - Vu < 20 && (It.isTouch = !1, document.removeEventListener("mousemove", Sp)), Vu = n;
}
function _4() {
  var n = document.activeElement;
  if (h4(n)) {
    var e = n._tippy;
    n.blur && !e.state.isVisible && n.blur();
  }
}
function b4() {
  document.addEventListener("touchstart", g4, Wn), window.addEventListener("blur", _4);
}
var k4 = typeof window < "u" && typeof document < "u", y4 = k4 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function gi(n) {
  var e = n === "destroy" ? "n already-" : " ";
  return [n + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Uu(n) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return n.replace(e, " ").replace(t, "").trim();
}
function v4(n) {
  return Uu(`
  %ctippy.js

  %c` + Uu(n) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function wp(n) {
  return [
    v4(n),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Cr;
process.env.NODE_ENV !== "production" && x4();
function x4() {
  Cr = /* @__PURE__ */ new Set();
}
function en(n, e) {
  if (n && !Cr.has(e)) {
    var t;
    Cr.add(e), (t = console).warn.apply(t, wp(e));
  }
}
function tl(n, e) {
  if (n && !Cr.has(e)) {
    var t;
    Cr.add(e), (t = console).error.apply(t, wp(e));
  }
}
function S4(n) {
  var e = !n, t = Object.prototype.toString.call(n) === "[object Object]" && !n.addEventListener;
  tl(e, ["tippy() was passed", "`" + String(n) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), tl(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var Cp = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, w4 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, dt = Object.assign({
  appendTo: vp,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Cp, w4), C4 = Object.keys(dt), T4 = function(e) {
  process.env.NODE_ENV !== "production" && Op(e, []);
  var t = Object.keys(e);
  t.forEach(function(i) {
    dt[i] = e[i];
  });
};
function Tp(n) {
  var e = n.plugins || [], t = e.reduce(function(i, r) {
    var o = r.name, s = r.defaultValue;
    if (o) {
      var a;
      i[o] = n[o] !== void 0 ? n[o] : (a = dt[o]) != null ? a : s;
    }
    return i;
  }, {});
  return Object.assign({}, n, t);
}
function O4(n, e) {
  var t = e ? Object.keys(Tp(Object.assign({}, dt, {
    plugins: e
  }))) : C4, i = t.reduce(function(r, o) {
    var s = (n.getAttribute("data-tippy-" + o) || "").trim();
    if (!s)
      return r;
    if (o === "content")
      r[o] = s;
    else
      try {
        r[o] = JSON.parse(s);
      } catch {
        r[o] = s;
      }
    return r;
  }, {});
  return i;
}
function Wu(n, e) {
  var t = Object.assign({}, e, {
    content: xp(e.content, [n])
  }, e.ignoreAttributes ? {} : O4(n, e.plugins));
  return t.aria = Object.assign({}, dt.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function Op(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = []);
  var t = Object.keys(n);
  t.forEach(function(i) {
    var r = s4(dt, Object.keys(Cp)), o = !o4(r, i);
    o && (o = e.filter(function(s) {
      return s.name === i;
    }).length === 0), en(o, ["`" + i + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var E4 = function() {
  return "innerHTML";
};
function nl(n, e) {
  n[E4()] = e;
}
function Ku(n) {
  var e = nr();
  return n === !0 ? e.className = kp : (e.className = yp, wr(n) ? e.appendChild(n) : nl(e, n)), e;
}
function Zu(n, e) {
  wr(e.content) ? (nl(n, ""), n.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? nl(n, e.content) : n.textContent = e.content);
}
function il(n) {
  var e = n.firstElementChild, t = Do(e.children);
  return {
    box: e,
    content: t.find(function(i) {
      return i.classList.contains(bp);
    }),
    arrow: t.find(function(i) {
      return i.classList.contains(kp) || i.classList.contains(yp);
    }),
    backdrop: t.find(function(i) {
      return i.classList.contains(r4);
    })
  };
}
function Ep(n) {
  var e = nr(), t = nr();
  t.className = i4, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var i = nr();
  i.className = bp, i.setAttribute("data-state", "hidden"), Zu(i, n.props), e.appendChild(t), t.appendChild(i), r(n.props, n.props);
  function r(o, s) {
    var a = il(e), l = a.box, c = a.content, u = a.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (o.content !== s.content || o.allowHTML !== s.allowHTML) && Zu(c, n.props), s.arrow ? u ? o.arrow !== s.arrow && (l.removeChild(u), l.appendChild(Ku(s.arrow))) : l.appendChild(Ku(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: r
  };
}
Ep.$$tippy = !0;
var M4 = 1, Zr = [], ha = [];
function $4(n, e) {
  var t = Wu(n, Object.assign({}, dt, Tp(Fu(e)))), i, r, o, s = !1, a = !1, l = !1, c = !1, u, d, h, f = [], p = ju(Bn, t.interactiveDebounce), m, g = M4++, k = null, v = l4(t.plugins), S = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, _ = {
    // properties
    id: g,
    reference: n,
    popper: nr(),
    popperInstance: k,
    props: t,
    state: S,
    plugins: v,
    // methods
    clearDelayTimeouts: ct,
    setProps: pn,
    setContent: mn,
    show: qs,
    hide: Ir,
    hideWithInteractivity: At,
    enable: it,
    disable: Et,
    unmount: gn,
    destroy: Hn
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && tl(!0, "render() function has not been supplied."), _;
  var x = t.render(_), y = x.popper, w = x.onUpdate;
  y.setAttribute("data-tippy-root", ""), y.id = "tippy-" + _.id, _.popper = y, n._tippy = _, y._tippy = _;
  var $ = v.map(function(C) {
    return C.fn(_);
  }), A = n.hasAttribute("aria-expanded");
  return Kt(), me(), Z(), V("onCreate", [_]), t.showOnCreate && ye(), y.addEventListener("mouseenter", function() {
    _.props.interactive && _.state.isVisible && _.clearDelayTimeouts();
  }), y.addEventListener("mouseleave", function() {
    _.props.interactive && _.props.trigger.indexOf("mouseenter") >= 0 && q().addEventListener("mousemove", p);
  }), _;
  function z() {
    var C = _.props.touch;
    return Array.isArray(C) ? C : [C, 0];
  }
  function I() {
    return z()[0] === "hold";
  }
  function L() {
    var C;
    return !!((C = _.props.render) != null && C.$$tippy);
  }
  function P() {
    return m || n;
  }
  function q() {
    var C = P().parentNode;
    return C ? p4(C) : document;
  }
  function W() {
    return il(y);
  }
  function B(C) {
    return _.state.isMounted && !_.state.isVisible || It.isTouch || u && u.type === "focus" ? 0 : ca(_.props.delay, C ? 0 : 1, dt.delay);
  }
  function Z(C) {
    C === void 0 && (C = !1), y.style.pointerEvents = _.props.interactive && !C ? "" : "none", y.style.zIndex = "" + _.props.zIndex;
  }
  function V(C, R, H) {
    if (H === void 0 && (H = !0), $.forEach(function(se) {
      se[C] && se[C].apply(se, R);
    }), H) {
      var ue;
      (ue = _.props)[C].apply(ue, R);
    }
  }
  function pe() {
    var C = _.props.aria;
    if (C.content) {
      var R = "aria-" + C.content, H = y.id, ue = wi(_.props.triggerTarget || n);
      ue.forEach(function(se) {
        var Ye = se.getAttribute(R);
        if (_.state.isVisible)
          se.setAttribute(R, Ye ? Ye + " " + H : H);
        else {
          var pt = Ye && Ye.replace(H, "").trim();
          pt ? se.setAttribute(R, pt) : se.removeAttribute(R);
        }
      });
    }
  }
  function me() {
    if (!(A || !_.props.aria.expanded)) {
      var C = wi(_.props.triggerTarget || n);
      C.forEach(function(R) {
        _.props.interactive ? R.setAttribute("aria-expanded", _.state.isVisible && R === P() ? "true" : "false") : R.removeAttribute("aria-expanded");
      });
    }
  }
  function G() {
    q().removeEventListener("mousemove", p), Zr = Zr.filter(function(C) {
      return C !== p;
    });
  }
  function Q(C) {
    if (!(It.isTouch && (l || C.type === "mousedown"))) {
      var R = C.composedPath && C.composedPath()[0] || C.target;
      if (!(_.props.interactive && Hu(y, R))) {
        if (wi(_.props.triggerTarget || n).some(function(H) {
          return Hu(H, R);
        })) {
          if (It.isTouch || _.state.isVisible && _.props.trigger.indexOf("click") >= 0)
            return;
        } else
          V("onClickOutside", [_, C]);
        _.props.hideOnClick === !0 && (_.clearDelayTimeouts(), _.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), _.state.isMounted || Ae());
      }
    }
  }
  function X() {
    l = !0;
  }
  function ze() {
    l = !1;
  }
  function Te() {
    var C = q();
    C.addEventListener("mousedown", Q, !0), C.addEventListener("touchend", Q, Wn), C.addEventListener("touchstart", ze, Wn), C.addEventListener("touchmove", X, Wn);
  }
  function Ae() {
    var C = q();
    C.removeEventListener("mousedown", Q, !0), C.removeEventListener("touchend", Q, Wn), C.removeEventListener("touchstart", ze, Wn), C.removeEventListener("touchmove", X, Wn);
  }
  function oe(C, R) {
    Pe(C, function() {
      !_.state.isVisible && y.parentNode && y.parentNode.contains(y) && R();
    });
  }
  function be(C, R) {
    Pe(C, R);
  }
  function Pe(C, R) {
    var H = W().box;
    function ue(se) {
      se.target === H && (da(H, "remove", ue), R());
    }
    if (C === 0)
      return R();
    da(H, "remove", d), da(H, "add", ue), d = ue;
  }
  function tt(C, R, H) {
    H === void 0 && (H = !1);
    var ue = wi(_.props.triggerTarget || n);
    ue.forEach(function(se) {
      se.addEventListener(C, R, H), f.push({
        node: se,
        eventType: C,
        handler: R,
        options: H
      });
    });
  }
  function Kt() {
    I() && (tt("touchstart", dn, {
      passive: !0
    }), tt("touchend", Fn, {
      passive: !0
    })), a4(_.props.trigger).forEach(function(C) {
      if (C !== "manual")
        switch (tt(C, dn), C) {
          case "mouseenter":
            tt("mouseleave", Fn);
            break;
          case "focus":
            tt(y4 ? "focusout" : "blur", hn);
            break;
          case "focusin":
            tt("focusout", hn);
            break;
        }
    });
  }
  function jn() {
    f.forEach(function(C) {
      var R = C.node, H = C.eventType, ue = C.handler, se = C.options;
      R.removeEventListener(H, ue, se);
    }), f = [];
  }
  function dn(C) {
    var R, H = !1;
    if (!(!_.state.isEnabled || fn(C) || a)) {
      var ue = ((R = u) == null ? void 0 : R.type) === "focus";
      u = C, m = C.currentTarget, me(), !_.state.isVisible && d4(C) && Zr.forEach(function(se) {
        return se(C);
      }), C.type === "click" && (_.props.trigger.indexOf("mouseenter") < 0 || s) && _.props.hideOnClick !== !1 && _.state.isVisible ? H = !0 : ye(C), C.type === "click" && (s = !H), H && !ue && te(C);
    }
  }
  function Bn(C) {
    var R = C.target, H = P().contains(R) || y.contains(R);
    if (!(C.type === "mousemove" && H)) {
      var ue = Ot().concat(y).map(function(se) {
        var Ye, pt = se._tippy, hi = (Ye = pt.popperInstance) == null ? void 0 : Ye.state;
        return hi ? {
          popperRect: se.getBoundingClientRect(),
          popperState: hi,
          props: t
        } : null;
      }).filter(Boolean);
      m4(ue, C) && (G(), te(C));
    }
  }
  function Fn(C) {
    var R = fn(C) || _.props.trigger.indexOf("click") >= 0 && s;
    if (!R) {
      if (_.props.interactive) {
        _.hideWithInteractivity(C);
        return;
      }
      te(C);
    }
  }
  function hn(C) {
    _.props.trigger.indexOf("focusin") < 0 && C.target !== P() || _.props.interactive && C.relatedTarget && y.contains(C.relatedTarget) || te(C);
  }
  function fn(C) {
    return It.isTouch ? I() !== C.type.indexOf("touch") >= 0 : !1;
  }
  function nt() {
    qn();
    var C = _.props, R = C.popperOptions, H = C.placement, ue = C.offset, se = C.getReferenceClientRect, Ye = C.moveTransition, pt = L() ? il(y).arrow : null, hi = se ? {
      getBoundingClientRect: se,
      contextElement: se.contextElement || P()
    } : n, kc = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Pr) {
        var fi = Pr.state;
        if (L()) {
          var Dz = W(), Vs = Dz.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(jr) {
            jr === "placement" ? Vs.setAttribute("data-placement", fi.placement) : fi.attributes.popper["data-popper-" + jr] ? Vs.setAttribute("data-" + jr, "") : Vs.removeAttribute("data-" + jr);
          }), fi.attributes.popper = {};
        }
      }
    }, Vn = [{
      name: "offset",
      options: {
        offset: ue
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ye
      }
    }, kc];
    L() && pt && Vn.push({
      name: "arrow",
      options: {
        element: pt,
        padding: 3
      }
    }), Vn.push.apply(Vn, (R == null ? void 0 : R.modifiers) || []), _.popperInstance = n4(hi, y, Object.assign({}, R, {
      placement: H,
      onFirstUpdate: h,
      modifiers: Vn
    }));
  }
  function qn() {
    _.popperInstance && (_.popperInstance.destroy(), _.popperInstance = null);
  }
  function Tt() {
    var C = _.props.appendTo, R, H = P();
    _.props.interactive && C === vp || C === "parent" ? R = H.parentNode : R = xp(C, [H]), R.contains(y) || R.appendChild(y), _.state.isMounted = !0, nt(), process.env.NODE_ENV !== "production" && en(_.props.interactive && C === dt.appendTo && H.nextElementSibling !== y, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Ot() {
    return Do(y.querySelectorAll("[data-tippy-root]"));
  }
  function ye(C) {
    _.clearDelayTimeouts(), C && V("onTrigger", [_, C]), Te();
    var R = B(!0), H = z(), ue = H[0], se = H[1];
    It.isTouch && ue === "hold" && se && (R = se), R ? i = setTimeout(function() {
      _.show();
    }, R) : _.show();
  }
  function te(C) {
    if (_.clearDelayTimeouts(), V("onUntrigger", [_, C]), !_.state.isVisible) {
      Ae();
      return;
    }
    if (!(_.props.trigger.indexOf("mouseenter") >= 0 && _.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(C.type) >= 0 && s)) {
      var R = B(!1);
      R ? r = setTimeout(function() {
        _.state.isVisible && _.hide();
      }, R) : o = requestAnimationFrame(function() {
        _.hide();
      });
    }
  }
  function it() {
    _.state.isEnabled = !0;
  }
  function Et() {
    _.hide(), _.state.isEnabled = !1;
  }
  function ct() {
    clearTimeout(i), clearTimeout(r), cancelAnimationFrame(o);
  }
  function pn(C) {
    if (process.env.NODE_ENV !== "production" && en(_.state.isDestroyed, gi("setProps")), !_.state.isDestroyed) {
      V("onBeforeUpdate", [_, C]), jn();
      var R = _.props, H = Wu(n, Object.assign({}, R, Fu(C), {
        ignoreAttributes: !0
      }));
      _.props = H, Kt(), R.interactiveDebounce !== H.interactiveDebounce && (G(), p = ju(Bn, H.interactiveDebounce)), R.triggerTarget && !H.triggerTarget ? wi(R.triggerTarget).forEach(function(ue) {
        ue.removeAttribute("aria-expanded");
      }) : H.triggerTarget && n.removeAttribute("aria-expanded"), me(), Z(), w && w(R, H), _.popperInstance && (nt(), Ot().forEach(function(ue) {
        requestAnimationFrame(ue._tippy.popperInstance.forceUpdate);
      })), V("onAfterUpdate", [_, C]);
    }
  }
  function mn(C) {
    _.setProps({
      content: C
    });
  }
  function qs() {
    process.env.NODE_ENV !== "production" && en(_.state.isDestroyed, gi("show"));
    var C = _.state.isVisible, R = _.state.isDestroyed, H = !_.state.isEnabled, ue = It.isTouch && !_.props.touch, se = ca(_.props.duration, 0, dt.duration);
    if (!(C || R || H || ue) && !P().hasAttribute("disabled") && (V("onShow", [_], !1), _.props.onShow(_) !== !1)) {
      if (_.state.isVisible = !0, L() && (y.style.visibility = "visible"), Z(), Te(), _.state.isMounted || (y.style.transition = "none"), L()) {
        var Ye = W(), pt = Ye.box, hi = Ye.content;
        ua([pt, hi], 0);
      }
      h = function() {
        var Vn;
        if (!(!_.state.isVisible || c)) {
          if (c = !0, y.offsetHeight, y.style.transition = _.props.moveTransition, L() && _.props.animation) {
            var Hs = W(), Pr = Hs.box, fi = Hs.content;
            ua([Pr, fi], se), qu([Pr, fi], "visible");
          }
          pe(), me(), Bu(ha, _), (Vn = _.popperInstance) == null || Vn.forceUpdate(), V("onMount", [_]), _.props.animation && L() && be(se, function() {
            _.state.isShown = !0, V("onShown", [_]);
          });
        }
      }, Tt();
    }
  }
  function Ir() {
    process.env.NODE_ENV !== "production" && en(_.state.isDestroyed, gi("hide"));
    var C = !_.state.isVisible, R = _.state.isDestroyed, H = !_.state.isEnabled, ue = ca(_.props.duration, 1, dt.duration);
    if (!(C || R || H) && (V("onHide", [_], !1), _.props.onHide(_) !== !1)) {
      if (_.state.isVisible = !1, _.state.isShown = !1, c = !1, s = !1, L() && (y.style.visibility = "hidden"), G(), Ae(), Z(!0), L()) {
        var se = W(), Ye = se.box, pt = se.content;
        _.props.animation && (ua([Ye, pt], ue), qu([Ye, pt], "hidden"));
      }
      pe(), me(), _.props.animation ? L() && oe(ue, _.unmount) : _.unmount();
    }
  }
  function At(C) {
    process.env.NODE_ENV !== "production" && en(_.state.isDestroyed, gi("hideWithInteractivity")), q().addEventListener("mousemove", p), Bu(Zr, p), p(C);
  }
  function gn() {
    process.env.NODE_ENV !== "production" && en(_.state.isDestroyed, gi("unmount")), _.state.isVisible && _.hide(), _.state.isMounted && (qn(), Ot().forEach(function(C) {
      C._tippy.unmount();
    }), y.parentNode && y.parentNode.removeChild(y), ha = ha.filter(function(C) {
      return C !== _;
    }), _.state.isMounted = !1, V("onHidden", [_]));
  }
  function Hn() {
    process.env.NODE_ENV !== "production" && en(_.state.isDestroyed, gi("destroy")), !_.state.isDestroyed && (_.clearDelayTimeouts(), _.unmount(), jn(), delete n._tippy, _.state.isDestroyed = !0, V("onDestroy", [_]));
  }
}
function Rr(n, e) {
  e === void 0 && (e = {});
  var t = dt.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (S4(n), Op(e, t)), b4();
  var i = Object.assign({}, e, {
    plugins: t
  }), r = f4(n);
  if (process.env.NODE_ENV !== "production") {
    var o = wr(i.content), s = r.length > 1;
    en(o && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = r.reduce(function(l, c) {
    var u = c && $4(c, i);
    return u && l.push(u), l;
  }, []);
  return wr(n) ? a[0] : a;
}
Rr.defaultProps = dt;
Rr.setDefaultProps = T4;
Rr.currentInput = It;
Object.assign({}, up, {
  effect: function(e) {
    var t = e.state, i = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow);
  }
});
Rr.setDefaultProps({
  render: Ep
});
class z4 {
  constructor({ editor: e, element: t, view: i, tippyOptions: r = {}, updateDelay: o = 250, shouldShow: s }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: l, from: c, to: u }) => {
      const { doc: d, selection: h } = l, { empty: f } = h, p = !d.textBetween(c, u).length && Zl(l.selection), m = this.element.contains(document.activeElement);
      return !(!(a.hasFocus() || m) || f || p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(a.relatedTarget)) || (a == null ? void 0 : a.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.handleDebouncedUpdate = (a, l) => {
      const c = !(l != null && l.selection.eq(a.state.selection)), u = !(l != null && l.doc.eq(a.state.doc));
      !c && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(a, c, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (a, l, c, u) => {
      var d, h, f;
      const { state: p, composing: m } = a, { selection: g } = p;
      if (m || !l && !c)
        return;
      this.createTooltip();
      const { ranges: v } = g, S = Math.min(...v.map((y) => y.$from.pos)), _ = Math.max(...v.map((y) => y.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        element: this.element,
        view: a,
        state: p,
        oldState: u,
        from: S,
        to: _
      }))) {
        this.hide();
        return;
      }
      (h = this.tippy) === null || h === void 0 || h.setProps({
        getReferenceClientRect: ((f = this.tippyOptions) === null || f === void 0 ? void 0 : f.getReferenceClientRect) || (() => {
          if (g6(p.selection)) {
            let y = a.nodeDOM(S);
            if (y) {
              const w = y.dataset.nodeViewWrapper ? y : y.querySelector("[data-node-view-wrapper]");
              if (w && (y = w.firstChild), y)
                return y.getBoundingClientRect();
            }
          }
          return _6(a, S, _);
        })
      }), this.show();
    }, this.editor = e, this.element = t, this.view = i, this.updateDelay = o, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = r, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = Rr(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    const { state: i } = e, r = i.selection.from !== i.selection.to;
    if (this.updateDelay > 0 && r) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const o = !(t != null && t.selection.eq(e.state.selection)), s = !(t != null && t.doc.eq(e.state.doc));
    this.updateHandler(e, o, s, t);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const Mp = (n) => new $e({
  key: typeof n.pluginKey == "string" ? new Ve(n.pluginKey) : n.pluginKey,
  view: (e) => new z4({ view: e, ...n })
});
Ce.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Mp({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
function A4(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var rl = { exports: {} }, fa = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gu;
function L4() {
  if (Gu) return fa;
  Gu = 1;
  var n = _e;
  function e(d, h) {
    return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
  }
  var t = typeof Object.is == "function" ? Object.is : e, i = n.useState, r = n.useEffect, o = n.useLayoutEffect, s = n.useDebugValue;
  function a(d, h) {
    var f = h(), p = i({ inst: { value: f, getSnapshot: h } }), m = p[0].inst, g = p[1];
    return o(function() {
      m.value = f, m.getSnapshot = h, l(m) && g({ inst: m });
    }, [d, f, h]), r(function() {
      return l(m) && g({ inst: m }), d(function() {
        l(m) && g({ inst: m });
      });
    }, [d]), s(f), f;
  }
  function l(d) {
    var h = d.getSnapshot;
    d = d.value;
    try {
      var f = h();
      return !t(d, f);
    } catch {
      return !0;
    }
  }
  function c(d, h) {
    return h();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return fa.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : u, fa;
}
var pa = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ju;
function N4() {
  return Ju || (Ju = 1, process.env.NODE_ENV !== "production" && (function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = _e, e = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(S) {
      {
        for (var _ = arguments.length, x = new Array(_ > 1 ? _ - 1 : 0), y = 1; y < _; y++)
          x[y - 1] = arguments[y];
        i("error", S, x);
      }
    }
    function i(S, _, x) {
      {
        var y = e.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (_ += "%s", x = x.concat([w]));
        var $ = x.map(function(A) {
          return String(A);
        });
        $.unshift("Warning: " + _), Function.prototype.apply.call(console[S], console, $);
      }
    }
    function r(S, _) {
      return S === _ && (S !== 0 || 1 / S === 1 / _) || S !== S && _ !== _;
    }
    var o = typeof Object.is == "function" ? Object.is : r, s = n.useState, a = n.useEffect, l = n.useLayoutEffect, c = n.useDebugValue, u = !1, d = !1;
    function h(S, _, x) {
      u || n.startTransition !== void 0 && (u = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var y = _();
      if (!d) {
        var w = _();
        o(y, w) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var $ = s({
        inst: {
          value: y,
          getSnapshot: _
        }
      }), A = $[0].inst, z = $[1];
      return l(function() {
        A.value = y, A.getSnapshot = _, f(A) && z({
          inst: A
        });
      }, [S, y, _]), a(function() {
        f(A) && z({
          inst: A
        });
        var I = function() {
          f(A) && z({
            inst: A
          });
        };
        return S(I);
      }, [S]), c(y), y;
    }
    function f(S) {
      var _ = S.getSnapshot, x = S.value;
      try {
        var y = _();
        return !o(x, y);
      } catch {
        return !0;
      }
    }
    function p(S, _, x) {
      return _();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", g = !m, k = g ? p : h, v = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : k;
    pa.useSyncExternalStore = v, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  })()), pa;
}
process.env.NODE_ENV === "production" ? rl.exports = L4() : rl.exports = N4();
var Ds = rl.exports;
const D4 = (...n) => (e) => {
  n.forEach((t) => {
    typeof t == "function" ? t(e) : t && (t.current = e);
  });
}, R4 = ({ contentComponent: n }) => {
  const e = Ds.useSyncExternalStore(n.subscribe, n.getSnapshot, n.getServerSnapshot);
  return _e.createElement(_e.Fragment, null, Object.values(e));
};
function I4() {
  const n = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(t) {
      return n.add(t), () => {
        n.delete(t);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(t, i) {
      e = {
        ...e,
        [t]: Wz.createPortal(i.reactElement, i.element, t)
      }, n.forEach((r) => r());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(t) {
      const i = { ...e };
      delete i[t], e = i, n.forEach((r) => r());
    }
  };
}
class P4 extends _e.Component {
  constructor(e) {
    var t;
    super(e), this.editorContentRef = _e.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((t = e.editor) === null || t === void 0) && t.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const t = this.editorContentRef.current;
      t.append(...e.options.element.childNodes), e.setOptions({
        element: t
      }), e.contentComponent = I4(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((i) => i.hasContentComponentInitialized ? i : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const t = document.createElement("div");
    t.append(...e.options.element.childNodes), e.setOptions({
      element: t
    });
  }
  render() {
    const { editor: e, innerRef: t, ...i } = this.props;
    return _e.createElement(
      _e.Fragment,
      null,
      _e.createElement("div", { ref: D4(t, this.editorContentRef), ...i }),
      (e == null ? void 0 : e.contentComponent) && _e.createElement(R4, { contentComponent: e.contentComponent })
    );
  }
}
const j4 = Fz((n, e) => {
  const t = _e.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [n.editor]);
  return _e.createElement(P4, {
    key: t,
    innerRef: e,
    ...n
  });
}), B4 = _e.memo(j4);
var F4 = function n(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var i, r, o;
    if (Array.isArray(e)) {
      if (i = e.length, i != t.length) return !1;
      for (r = i; r-- !== 0; )
        if (!n(e[r], t[r])) return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (r of e.entries())
        if (!t.has(r[0])) return !1;
      for (r of e.entries())
        if (!n(r[1], t.get(r[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (r of e.entries())
        if (!t.has(r[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (i = e.length, i != t.length) return !1;
      for (r = i; r-- !== 0; )
        if (e[r] !== t[r]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (o = Object.keys(e), i = o.length, i !== Object.keys(t).length) return !1;
    for (r = i; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r])) return !1;
    for (r = i; r-- !== 0; ) {
      var s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !n(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}, q4 = /* @__PURE__ */ A4(F4), ol = { exports: {} }, ma = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yu;
function H4() {
  if (Yu) return ma;
  Yu = 1;
  var n = _e, e = Ds;
  function t(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var i = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, o = n.useRef, s = n.useEffect, a = n.useMemo, l = n.useDebugValue;
  return ma.useSyncExternalStoreWithSelector = function(c, u, d, h, f) {
    var p = o(null);
    if (p.current === null) {
      var m = { hasValue: !1, value: null };
      p.current = m;
    } else m = p.current;
    p = a(function() {
      function k(y) {
        if (!v) {
          if (v = !0, S = y, y = h(y), f !== void 0 && m.hasValue) {
            var w = m.value;
            if (f(w, y)) return _ = w;
          }
          return _ = y;
        }
        if (w = _, i(S, y)) return w;
        var $ = h(y);
        return f !== void 0 && f(w, $) ? w : (S = y, _ = $);
      }
      var v = !1, S, _, x = d === void 0 ? null : d;
      return [function() {
        return k(u());
      }, x === null ? void 0 : function() {
        return k(x());
      }];
    }, [u, d, h, f]);
    var g = r(c, p[0], p[1]);
    return s(function() {
      m.hasValue = !0, m.value = g;
    }, [g]), l(g), g;
  }, ma;
}
var ga = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xu;
function V4() {
  return Xu || (Xu = 1, process.env.NODE_ENV !== "production" && (function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = _e, e = Ds;
    function t(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var i = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, o = n.useRef, s = n.useEffect, a = n.useMemo, l = n.useDebugValue;
    function c(u, d, h, f, p) {
      var m = o(null), g;
      m.current === null ? (g = {
        hasValue: !1,
        value: null
      }, m.current = g) : g = m.current;
      var k = a(function() {
        var x = !1, y, w, $ = function(L) {
          if (!x) {
            x = !0, y = L;
            var P = f(L);
            if (p !== void 0 && g.hasValue) {
              var q = g.value;
              if (p(q, P))
                return w = q, q;
            }
            return w = P, P;
          }
          var W = y, B = w;
          if (i(W, L))
            return B;
          var Z = f(L);
          return p !== void 0 && p(B, Z) ? B : (y = L, w = Z, Z);
        }, A = h === void 0 ? null : h, z = function() {
          return $(d());
        }, I = A === null ? void 0 : function() {
          return $(A());
        };
        return [z, I];
      }, [d, h, f, p]), v = k[0], S = k[1], _ = r(u, v, S);
      return s(function() {
        g.hasValue = !0, g.value = _;
      }, [_]), l(_), _;
    }
    ga.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  })()), ga;
}
process.env.NODE_ENV === "production" ? ol.exports = H4() : ol.exports = V4();
var U4 = ol.exports;
const W4 = typeof window < "u" ? qz : Ge;
class K4 {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const t = () => {
        this.transactionNumber += 1, this.subscribers.forEach((r) => r());
      }, i = this.editor;
      return i.on("transaction", t), () => {
        i.off("transaction", t);
      };
    }
  }
}
function Z4(n) {
  var e;
  const [t] = xe(() => new K4(n.editor)), i = U4.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getServerSnapshot, n.selector, (e = n.equalityFn) !== null && e !== void 0 ? e : q4);
  return W4(() => t.watch(n.editor), [n.editor, t]), hh(i), i;
}
const Qu = process.env.NODE_ENV !== "production", sl = typeof window > "u", G4 = sl || !!(typeof window < "u" && window.next);
class sc {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((t) => t());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return sl || G4 ? (Qu && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && sl && Qu)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onBeforeCreate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onBlur: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onBlur) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onCreate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onCreate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onDestroy: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onDestroy) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onFocus: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onFocus) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onSelectionUpdate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onSelectionUpdate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onTransaction: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onTransaction) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onUpdate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onUpdate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onContentError: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onContentError) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onDrop: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onDrop) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onPaste: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onPaste) === null || o === void 0 ? void 0 : o.call(r, ...i);
      }
    };
    return new Z6(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, t) {
    return Object.keys(e).every((i) => ["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(i) ? !0 : i === "extensions" && e.extensions && t.extensions ? e.extensions.length !== t.extensions.length ? !1 : e.extensions.every((r, o) => {
      var s;
      return r === ((s = t.extensions) === null || s === void 0 ? void 0 : s[o]);
    }) : e[i] === t[i]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? sc.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((i, r) => i === e[r]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, t = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        t && t.setOptions(this.options.current);
        return;
      }
      t && !t.isDestroyed && (t.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function J4(n = {}, e = []) {
  const t = Oi(n);
  t.current = n;
  const [i] = xe(() => new sc(t)), r = Ds.useSyncExternalStore(i.subscribe, i.getEditor, i.getServerSnapshot);
  return hh(r), Ge(i.onRender(e)), Z4({
    editor: r,
    selector: ({ transactionNumber: o }) => n.shouldRerenderOnTransaction === !1 ? null : n.immediatelyRender && o === 0 ? 0 : o + 1
  }), r;
}
const $p = Sl({
  editor: null
});
$p.Consumer;
const Y4 = () => fh($p), X4 = (n) => {
  const [e, t] = xe(null), { editor: i } = Y4();
  return Ge(() => {
    var r;
    if (!e || !((r = n.editor) === null || r === void 0) && r.isDestroyed || i != null && i.isDestroyed)
      return;
    const { pluginKey: o = "bubbleMenu", editor: s, tippyOptions: a = {}, updateDelay: l, shouldShow: c = null } = n, u = s || i;
    if (!u) {
      console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
      return;
    }
    const d = Mp({
      updateDelay: l,
      editor: u,
      element: e,
      pluginKey: o,
      shouldShow: c,
      tippyOptions: a
    });
    return u.registerPlugin(d), () => {
      u.unregisterPlugin(o);
    };
  }, [n.editor, i, e]), _e.createElement("div", { ref: t, className: n.className, style: { visibility: "hidden" } }, n.children);
}, zp = Sl({
  onDragStart: void 0
}), ac = () => fh(zp), Rs = (n) => {
  const e = n.as || "div", { nodeViewContentRef: t } = ac();
  return (
    // @ts-ignore
    _e.createElement(e, { ...n, ref: t, "data-node-view-content": "", style: {
      whiteSpace: "pre-wrap",
      ...n.style
    } })
  );
}, lc = _e.forwardRef((n, e) => {
  const { onDragStart: t } = ac(), i = n.as || "div";
  return (
    // @ts-ignore
    _e.createElement(i, { ...n, ref: e, "data-node-view-wrapper": "", onDragStart: t, style: {
      whiteSpace: "normal",
      ...n.style
    } })
  );
});
function Q4(n) {
  return !!(typeof n == "function" && n.prototype && n.prototype.isReactComponent);
}
function e5(n) {
  var e;
  return typeof n == "object" && ((e = n.$$typeof) === null || e === void 0 ? void 0 : e.toString()) === "Symbol(react.forward_ref)";
}
class t5 {
  /**
   * Immediately creates element and renders the provided React component.
   */
  constructor(e, { editor: t, props: i = {}, as: r = "div", className: o = "" }) {
    this.ref = null, this.id = Math.floor(Math.random() * 4294967295).toString(), this.component = e, this.editor = t, this.props = i, this.element = document.createElement(r), this.element.classList.add("react-renderer"), o && this.element.classList.add(...o.split(" ")), this.editor.isInitialized ? ph(() => {
      this.render();
    }) : this.render();
  }
  /**
   * Render the React component.
   */
  render() {
    var e;
    const t = this.component, i = this.props, r = this.editor;
    (Q4(t) || e5(t)) && (i.ref = (o) => {
      this.ref = o;
    }), this.reactElement = _e.createElement(t, { ...i }), (e = r == null ? void 0 : r.contentComponent) === null || e === void 0 || e.setRenderer(this.id, this);
  }
  /**
   * Re-renders the React component with new props.
   */
  updateProps(e = {}) {
    this.props = {
      ...this.props,
      ...e
    }, this.render();
  }
  /**
   * Destroy the React component.
   */
  destroy() {
    var e;
    const t = this.editor;
    (e = t == null ? void 0 : t.contentComponent) === null || e === void 0 || e.removeRenderer(this.id);
  }
  /**
   * Update the attributes of the element that holds the React component.
   */
  updateAttributes(e) {
    Object.keys(e).forEach((t) => {
      this.element.setAttribute(t, e[t]);
    });
  }
}
class n5 extends J6 {
  /**
   * Setup the React component.
   * Called on initialization.
   */
  mount() {
    const e = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      innerDecorations: this.innerDecorations,
      view: this.view,
      selected: !1,
      extension: this.extension,
      HTMLAttributes: this.HTMLAttributes,
      getPos: () => this.getPos(),
      updateAttributes: (c = {}) => this.updateAttributes(c),
      deleteNode: () => this.deleteNode()
    };
    if (!this.component.displayName) {
      const c = (u) => u.charAt(0).toUpperCase() + u.substring(1);
      this.component.displayName = c(this.extension.name);
    }
    const r = { onDragStart: this.onDragStart.bind(this), nodeViewContentRef: (c) => {
      c && this.contentDOMElement && c.firstChild !== this.contentDOMElement && c.appendChild(this.contentDOMElement);
    } }, o = this.component, s = _e.memo((c) => _e.createElement(zp.Provider, { value: r }, _e.createElement(o, c)));
    s.displayName = "ReactNodeView", this.node.isLeaf ? this.contentDOMElement = null : this.options.contentDOMElementTag ? this.contentDOMElement = document.createElement(this.options.contentDOMElementTag) : this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div"), this.contentDOMElement && (this.contentDOMElement.dataset.nodeViewContentReact = "", this.contentDOMElement.style.whiteSpace = "inherit");
    let a = this.node.isInline ? "span" : "div";
    this.options.as && (a = this.options.as);
    const { className: l = "" } = this.options;
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this), this.renderer = new t5(s, {
      editor: this.editor,
      props: e,
      as: a,
      className: `node-${this.node.type.name} ${l}`.trim()
    }), this.editor.on("selectionUpdate", this.handleSelectionUpdate), this.updateElementAttributes();
  }
  /**
   * Return the DOM element.
   * This is the element that will be used to display the node view.
   */
  get dom() {
    var e;
    if (this.renderer.element.firstElementChild && !(!((e = this.renderer.element.firstElementChild) === null || e === void 0) && e.hasAttribute("data-node-view-wrapper")))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  /**
   * Return the content DOM element.
   * This is the element that will be used to display the rich-text content of the node.
   */
  get contentDOM() {
    return this.node.isLeaf ? null : this.contentDOMElement;
  }
  /**
   * On editor selection update, check if the node is selected.
   * If it is, call `selectNode`, otherwise call `deselectNode`.
   */
  handleSelectionUpdate() {
    const { from: e, to: t } = this.editor.state.selection, i = this.getPos();
    if (typeof i == "number")
      if (e <= i && t >= i + this.node.nodeSize) {
        if (this.renderer.props.selected)
          return;
        this.selectNode();
      } else {
        if (!this.renderer.props.selected)
          return;
        this.deselectNode();
      }
  }
  /**
   * On update, update the React component.
   * To prevent unnecessary updates, the `update` option can be used.
   */
  update(e, t, i) {
    const r = (o) => {
      this.renderer.updateProps(o), typeof this.options.attrs == "function" && this.updateElementAttributes();
    };
    if (e.type !== this.node.type)
      return !1;
    if (typeof this.options.update == "function") {
      const o = this.node, s = this.decorations, a = this.innerDecorations;
      return this.node = e, this.decorations = t, this.innerDecorations = i, this.options.update({
        oldNode: o,
        oldDecorations: s,
        newNode: e,
        newDecorations: t,
        oldInnerDecorations: a,
        innerDecorations: i,
        updateProps: () => r({ node: e, decorations: t, innerDecorations: i })
      });
    }
    return e === this.node && this.decorations === t && this.innerDecorations === i || (this.node = e, this.decorations = t, this.innerDecorations = i, r({ node: e, decorations: t, innerDecorations: i })), !0;
  }
  /**
   * Select the node.
   * Add the `selected` prop and the `ProseMirror-selectednode` class.
   */
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  /**
   * Deselect the node.
   * Remove the `selected` prop and the `ProseMirror-selectednode` class.
   */
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  /**
   * Destroy the React component instance.
   */
  destroy() {
    this.renderer.destroy(), this.editor.off("selectionUpdate", this.handleSelectionUpdate), this.contentDOMElement = null;
  }
  /**
   * Update the attributes of the top-level element that holds the React component.
   * Applying the attributes defined in the `attrs` option.
   */
  updateElementAttributes() {
    if (this.options.attrs) {
      let e = {};
      if (typeof this.options.attrs == "function") {
        const t = this.editor.extensionManager.attributes, i = zo(this.node, t);
        e = this.options.attrs({ node: this.node, HTMLAttributes: i });
      } else
        e = this.options.attrs;
      this.renderer.updateAttributes(e);
    }
  }
}
function ji(n, e) {
  return (t) => t.editor.contentComponent ? new n5(n, t, e) : {};
}
var Gr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function i5(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var _a, ed;
function r5() {
  if (ed) return _a;
  ed = 1;
  var n = "Expected a function", e = NaN, t = "[object Symbol]", i = /^\s+|\s+$/g, r = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, l = typeof Gr == "object" && Gr && Gr.Object === Object && Gr, c = typeof self == "object" && self && self.Object === Object && self, u = l || c || Function("return this")(), d = Object.prototype, h = d.toString, f = Math.max, p = Math.min, m = function() {
    return u.Date.now();
  };
  function g(x, y, w) {
    var $, A, z, I, L, P, q = 0, W = !1, B = !1, Z = !0;
    if (typeof x != "function")
      throw new TypeError(n);
    y = _(y) || 0, k(w) && (W = !!w.leading, B = "maxWait" in w, z = B ? f(_(w.maxWait) || 0, y) : z, Z = "trailing" in w ? !!w.trailing : Z);
    function V(oe) {
      var be = $, Pe = A;
      return $ = A = void 0, q = oe, I = x.apply(Pe, be), I;
    }
    function pe(oe) {
      return q = oe, L = setTimeout(Q, y), W ? V(oe) : I;
    }
    function me(oe) {
      var be = oe - P, Pe = oe - q, tt = y - be;
      return B ? p(tt, z - Pe) : tt;
    }
    function G(oe) {
      var be = oe - P, Pe = oe - q;
      return P === void 0 || be >= y || be < 0 || B && Pe >= z;
    }
    function Q() {
      var oe = m();
      if (G(oe))
        return X(oe);
      L = setTimeout(Q, me(oe));
    }
    function X(oe) {
      return L = void 0, Z && $ ? V(oe) : ($ = A = void 0, I);
    }
    function ze() {
      L !== void 0 && clearTimeout(L), q = 0, $ = P = A = L = void 0;
    }
    function Te() {
      return L === void 0 ? I : X(m());
    }
    function Ae() {
      var oe = m(), be = G(oe);
      if ($ = arguments, A = this, P = oe, be) {
        if (L === void 0)
          return pe(P);
        if (B)
          return L = setTimeout(Q, y), V(P);
      }
      return L === void 0 && (L = setTimeout(Q, y)), I;
    }
    return Ae.cancel = ze, Ae.flush = Te, Ae;
  }
  function k(x) {
    var y = typeof x;
    return !!x && (y == "object" || y == "function");
  }
  function v(x) {
    return !!x && typeof x == "object";
  }
  function S(x) {
    return typeof x == "symbol" || v(x) && h.call(x) == t;
  }
  function _(x) {
    if (typeof x == "number")
      return x;
    if (S(x))
      return e;
    if (k(x)) {
      var y = typeof x.valueOf == "function" ? x.valueOf() : x;
      x = k(y) ? y + "" : y;
    }
    if (typeof x != "string")
      return x === 0 ? x : +x;
    x = x.replace(i, "");
    var w = o.test(x);
    return w || s.test(x) ? a(x.slice(2), w ? 2 : 8) : r.test(x) ? e : +x;
  }
  return _a = g, _a;
}
var o5 = r5();
const s5 = /* @__PURE__ */ i5(o5);
function a5({
  hint: n,
  editor: e,
  className: t
}) {
  if (!e) return null;
  const i = e.storage.characterCount.characters() || "";
  return i ? /* @__PURE__ */ b(wl, { label: n ?? "", showHint: !!n, className: K(t, "h-5"), children: /* @__PURE__ */ b("span", { className: "mt-[2px]", children: i }) }) : /* @__PURE__ */ b("div", { className: K(t, "h-5") });
}
function Tr(n) {
  "@babel/helpers - typeof";
  return Tr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Tr(n);
}
function l5(n, e) {
  if (Tr(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(n, e);
    if (Tr(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function c5(n) {
  var e = l5(n, "string");
  return Tr(e) == "symbol" ? e : e + "";
}
function u5(n, e, t) {
  return (e = c5(e)) in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
var d5 = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, h5 = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, f5 = function(e) {
  return h5[e];
}, p5 = function(e) {
  return e.replace(d5, f5);
};
function td(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function nd(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? td(Object(t), !0).forEach(function(i) {
      u5(n, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : td(Object(t)).forEach(function(i) {
      Object.defineProperty(n, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return n;
}
var id = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: p5
};
function m5() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  id = nd(nd({}, id), n);
}
var g5 = {
  type: "3rdParty",
  init: function(e) {
    m5(e.options.react);
  }
};
const U = (n) => typeof n == "string", Hi = () => {
  let n, e;
  const t = new Promise((i, r) => {
    n = i, e = r;
  });
  return t.resolve = n, t.reject = e, t;
}, rd = (n) => n == null ? "" : "" + n, _5 = (n, e, t) => {
  n.forEach((i) => {
    e[i] && (t[i] = e[i]);
  });
}, b5 = /###/g, od = (n) => n && n.indexOf("###") > -1 ? n.replace(b5, ".") : n, sd = (n) => !n || U(n), ir = (n, e, t) => {
  const i = U(e) ? e.split(".") : e;
  let r = 0;
  for (; r < i.length - 1; ) {
    if (sd(n)) return {};
    const o = od(i[r]);
    !n[o] && t && (n[o] = new t()), Object.prototype.hasOwnProperty.call(n, o) ? n = n[o] : n = {}, ++r;
  }
  return sd(n) ? {} : {
    obj: n,
    k: od(i[r])
  };
}, ad = (n, e, t) => {
  const {
    obj: i,
    k: r
  } = ir(n, e, Object);
  if (i !== void 0 || e.length === 1) {
    i[r] = t;
    return;
  }
  let o = e[e.length - 1], s = e.slice(0, e.length - 1), a = ir(n, s, Object);
  for (; a.obj === void 0 && s.length; )
    o = `${s[s.length - 1]}.${o}`, s = s.slice(0, s.length - 1), a = ir(n, s, Object), a && a.obj && typeof a.obj[`${a.k}.${o}`] < "u" && (a.obj = void 0);
  a.obj[`${a.k}.${o}`] = t;
}, k5 = (n, e, t, i) => {
  const {
    obj: r,
    k: o
  } = ir(n, e, Object);
  r[o] = r[o] || [], r[o].push(t);
}, Ro = (n, e) => {
  const {
    obj: t,
    k: i
  } = ir(n, e);
  if (t)
    return t[i];
}, y5 = (n, e, t) => {
  const i = Ro(n, t);
  return i !== void 0 ? i : Ro(e, t);
}, Ap = (n, e, t) => {
  for (const i in e)
    i !== "__proto__" && i !== "constructor" && (i in n ? U(n[i]) || n[i] instanceof String || U(e[i]) || e[i] instanceof String ? t && (n[i] = e[i]) : Ap(n[i], e[i], t) : n[i] = e[i]);
  return n;
}, _i = (n) => n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var v5 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const x5 = (n) => U(n) ? n.replace(/[&<>"'\/]/g, (e) => v5[e]) : n;
class S5 {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const i = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, i), this.regExpQueue.push(e), i;
  }
}
const w5 = [" ", ",", "?", "!", ";"], C5 = new S5(20), T5 = (n, e, t) => {
  e = e || "", t = t || "";
  const i = w5.filter((s) => e.indexOf(s) < 0 && t.indexOf(s) < 0);
  if (i.length === 0) return !0;
  const r = C5.getRegExp(`(${i.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let o = !r.test(n);
  if (!o) {
    const s = n.indexOf(t);
    s > 0 && !r.test(n.substring(0, s)) && (o = !0);
  }
  return o;
}, al = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n) return;
  if (n[e]) return n[e];
  const i = e.split(t);
  let r = n;
  for (let o = 0; o < i.length; ) {
    if (!r || typeof r != "object")
      return;
    let s, a = "";
    for (let l = o; l < i.length; ++l)
      if (l !== o && (a += t), a += i[l], s = r[a], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && l < i.length - 1)
          continue;
        o += l - o + 1;
        break;
      }
    r = s;
  }
  return r;
}, Io = (n) => n && n.replace("_", "-"), O5 = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    console && console[n] && console[n].apply(console, e);
  }
};
class Po {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || O5, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, i, r) {
    return r && !this.debug ? null : (U(e[0]) && (e[0] = `${i}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new Po(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Po(this.logger, e);
  }
}
var jt = new Po();
class Is {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((i) => {
      this.observers[i] || (this.observers[i] = /* @__PURE__ */ new Map());
      const r = this.observers[i].get(t) || 0;
      this.observers[i].set(t, r + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      i[r - 1] = arguments[r];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((s) => {
      let [a, l] = s;
      for (let c = 0; c < l; c++)
        a(...i);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((s) => {
      let [a, l] = s;
      for (let c = 0; c < l; c++)
        a.apply(a, [e, ...i]);
    });
  }
}
class ld extends Is {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, s = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let a;
    e.indexOf(".") > -1 ? a = e.split(".") : (a = [e, t], i && (Array.isArray(i) ? a.push(...i) : U(i) && o ? a.push(...i.split(o)) : a.push(i)));
    const l = Ro(this.data, a);
    return !l && !t && !i && e.indexOf(".") > -1 && (e = a[0], t = a[1], i = a.slice(2).join(".")), l || !s || !U(i) ? l : al(this.data && this.data[e] && this.data[e][t], i, o);
  }
  addResource(e, t, i, r) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let a = [e, t];
    i && (a = a.concat(s ? i.split(s) : i)), e.indexOf(".") > -1 && (a = e.split("."), r = t, t = a[1]), this.addNamespaces(t), ad(this.data, a, r), o.silent || this.emit("added", e, t, i, r);
  }
  addResources(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in i)
      (U(i[o]) || Array.isArray(i[o])) && this.addResource(e, t, o, i[o], {
        silent: !0
      });
    r.silent || this.emit("added", e, t, i);
  }
  addResourceBundle(e, t, i, r, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, a = [e, t];
    e.indexOf(".") > -1 && (a = e.split("."), r = i, i = t, t = a[1]), this.addNamespaces(t);
    let l = Ro(this.data, a) || {};
    s.skipCopy || (i = JSON.parse(JSON.stringify(i))), r ? Ap(l, i, o) : l = {
      ...l,
      ...i
    }, ad(this.data, a, l), s.silent || this.emit("added", e, t, i);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((r) => t[r] && Object.keys(t[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Lp = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, i, r) {
    return n.forEach((o) => {
      this.processors[o] && (e = this.processors[o].process(e, t, i, r));
    }), e;
  }
};
const cd = {};
class jo extends Is {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), _5(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = jt.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const i = this.resolve(e, t);
    return i && i.res !== void 0;
  }
  extractFromKey(e, t) {
    let i = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    i === void 0 && (i = ":");
    const r = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let o = t.ns || this.options.defaultNS || [];
    const s = i && e.indexOf(i) > -1, a = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !T5(e, i, r);
    if (s && !a) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: U(o) ? [o] : o
        };
      const c = e.split(i);
      (i !== r || i === r && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), e = c.join(r);
    }
    return {
      key: e,
      namespaces: U(o) ? [o] : o
    };
  }
  translate(e, t, i) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const r = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, o = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: a
    } = this.extractFromKey(e[e.length - 1], t), l = a[a.length - 1], c = t.lng || this.language, u = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const _ = t.nsSeparator || this.options.nsSeparator;
        return r ? {
          res: `${l}${_}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${_}${s}`;
      }
      return r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : s;
    }
    const d = this.resolve(e, t);
    let h = d && d.res;
    const f = d && d.usedKey || s, p = d && d.exactUsedKey || s, m = Object.prototype.toString.apply(h), g = ["[object Number]", "[object Function]", "[object RegExp]"], k = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, S = !U(h) && typeof h != "boolean" && typeof h != "number";
    if (v && h && S && g.indexOf(m) < 0 && !(U(k) && Array.isArray(h))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const _ = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, h, {
          ...t,
          ns: a
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (d.res = _, d.usedParams = this.getUsedParamsDetails(t), d) : _;
      }
      if (o) {
        const _ = Array.isArray(h), x = _ ? [] : {}, y = _ ? p : f;
        for (const w in h)
          if (Object.prototype.hasOwnProperty.call(h, w)) {
            const $ = `${y}${o}${w}`;
            x[w] = this.translate($, {
              ...t,
              joinArrays: !1,
              ns: a
            }), x[w] === $ && (x[w] = h[w]);
          }
        h = x;
      }
    } else if (v && U(k) && Array.isArray(h))
      h = h.join(k), h && (h = this.extendTranslation(h, e, t, i));
    else {
      let _ = !1, x = !1;
      const y = t.count !== void 0 && !U(t.count), w = jo.hasDefaultValue(t), $ = y ? this.pluralResolver.getSuffix(c, t.count, t) : "", A = t.ordinal && y ? this.pluralResolver.getSuffix(c, t.count, {
        ordinal: !1
      }) : "", z = y && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = z && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${$}`] || t[`defaultValue${A}`] || t.defaultValue;
      !this.isValidLookup(h) && w && (_ = !0, h = I), this.isValidLookup(h) || (x = !0, h = s);
      const P = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && x ? void 0 : h, q = w && I !== h && this.options.updateMissing;
      if (x || _ || q) {
        if (this.logger.log(q ? "updateKey" : "missingKey", c, l, s, q ? I : h), o) {
          const V = this.resolve(s, {
            ...t,
            keySeparator: !1
          });
          V && V.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let W = [];
        const B = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && B && B[0])
          for (let V = 0; V < B.length; V++)
            W.push(B[V]);
        else this.options.saveMissingTo === "all" ? W = this.languageUtils.toResolveHierarchy(t.lng || this.language) : W.push(t.lng || this.language);
        const Z = (V, pe, me) => {
          const G = w && me !== h ? me : P;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(V, l, pe, G, q, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(V, l, pe, G, q, t), this.emit("missingKey", V, l, pe, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && y ? W.forEach((V) => {
          const pe = this.pluralResolver.getSuffixes(V, t);
          z && t[`defaultValue${this.options.pluralSeparator}zero`] && pe.indexOf(`${this.options.pluralSeparator}zero`) < 0 && pe.push(`${this.options.pluralSeparator}zero`), pe.forEach((me) => {
            Z([V], s + me, t[`defaultValue${me}`] || I);
          });
        }) : Z(W, s, I));
      }
      h = this.extendTranslation(h, e, t, d, i), x && h === s && this.options.appendNamespaceToMissingKey && (h = `${l}:${s}`), (x || _) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${s}` : s, _ ? h : void 0) : h = this.options.parseMissingKeyHandler(h));
    }
    return r ? (d.res = h, d.usedParams = this.getUsedParamsDetails(t), d) : h;
  }
  extendTranslation(e, t, i, r, o) {
    var s = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...i
      }, i.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!i.skipInterpolation) {
      i.interpolation && this.interpolator.init({
        ...i,
        interpolation: {
          ...this.options.interpolation,
          ...i.interpolation
        }
      });
      const c = U(e) && (i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const h = e.match(this.interpolator.nestingRegexp);
        u = h && h.length;
      }
      let d = i.replace && !U(i.replace) ? i.replace : i;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, i.lng || this.language || r.usedLng, i), c) {
        const h = e.match(this.interpolator.nestingRegexp), f = h && h.length;
        u < f && (i.nest = !1);
      }
      !i.lng && this.options.compatibilityAPI !== "v1" && r && r.res && (i.lng = this.language || r.usedLng), i.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var h = arguments.length, f = new Array(h), p = 0; p < h; p++)
          f[p] = arguments[p];
        return o && o[0] === f[0] && !i.context ? (s.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${t[0]}`), null) : s.translate(...f, t);
      }, i)), i.interpolation && this.interpolator.reset();
    }
    const a = i.postProcess || this.options.postProcess, l = U(a) ? [a] : a;
    return e != null && l && l.length && i.applyPostProcessor !== !1 && (e = Lp.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(i)
      },
      ...i
    } : i, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i, r, o, s, a;
    return U(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(i)) return;
      const c = this.extractFromKey(l, t), u = c.key;
      r = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = t.count !== void 0 && !U(t.count), f = h && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = t.context !== void 0 && (U(t.context) || typeof t.context == "number") && t.context !== "", m = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((g) => {
        this.isValidLookup(i) || (a = g, !cd[`${m[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(a) && (cd[`${m[0]}-${g}`] = !0, this.logger.warn(`key "${r}" for languages "${m.join(", ")}" won't get resolved as namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((k) => {
          if (this.isValidLookup(i)) return;
          s = k;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, k, g, t);
          else {
            let _;
            h && (_ = this.pluralResolver.getSuffix(k, t.count, t));
            const x = `${this.options.pluralSeparator}zero`, y = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (v.push(u + _), t.ordinal && _.indexOf(y) === 0 && v.push(u + _.replace(y, this.options.pluralSeparator)), f && v.push(u + x)), p) {
              const w = `${u}${this.options.contextSeparator}${t.context}`;
              v.push(w), h && (v.push(w + _), t.ordinal && _.indexOf(y) === 0 && v.push(w + _.replace(y, this.options.pluralSeparator)), f && v.push(w + x));
            }
          }
          let S;
          for (; S = v.pop(); )
            this.isValidLookup(i) || (o = S, i = this.getResource(k, g, S, t));
        }));
      });
    }), {
      res: i,
      usedKey: r,
      exactUsedKey: o,
      usedLng: s,
      usedNS: a
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, i, r) : this.resourceStore.getResource(e, t, i, r);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], i = e.replace && !U(e.replace);
    let r = i ? e.replace : e;
    if (i && typeof e.count < "u" && (r.count = e.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !i) {
      r = {
        ...r
      };
      for (const o of t)
        delete r[o];
    }
    return r;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const i in e)
      if (Object.prototype.hasOwnProperty.call(e, i) && t === i.substring(0, t.length) && e[i] !== void 0)
        return !0;
    return !1;
  }
}
const ba = (n) => n.charAt(0).toUpperCase() + n.slice(1);
class ud {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = jt.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Io(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Io(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (U(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let r = Intl.getCanonicalLocales(e)[0];
          if (r && this.options.lowerCaseLng && (r = r.toLowerCase()), r) return r;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let i = e.split("-");
      return this.options.lowerCaseLng ? i = i.map((r) => r.toLowerCase()) : i.length === 2 ? (i[0] = i[0].toLowerCase(), i[1] = i[1].toUpperCase(), t.indexOf(i[1].toLowerCase()) > -1 && (i[1] = ba(i[1].toLowerCase()))) : i.length === 3 && (i[0] = i[0].toLowerCase(), i[1].length === 2 && (i[1] = i[1].toUpperCase()), i[0] !== "sgn" && i[2].length === 2 && (i[2] = i[2].toUpperCase()), t.indexOf(i[1].toLowerCase()) > -1 && (i[1] = ba(i[1].toLowerCase())), t.indexOf(i[2].toLowerCase()) > -1 && (i[2] = ba(i[2].toLowerCase()))), i.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((i) => {
      if (t) return;
      const r = this.formatLanguageCode(i);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (t = r);
    }), !t && this.options.supportedLngs && e.forEach((i) => {
      if (t) return;
      const r = this.getLanguagePartFromCode(i);
      if (this.isSupportedCode(r)) return t = r;
      t = this.options.supportedLngs.find((o) => {
        if (o === r) return o;
        if (!(o.indexOf("-") < 0 && r.indexOf("-") < 0) && (o.indexOf("-") > 0 && r.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === r || o.indexOf(r) === 0 && r.length > 1))
          return o;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), U(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let i = e[t];
    return i || (i = e[this.getScriptPartFromCode(t)]), i || (i = e[this.formatLanguageCode(t)]), i || (i = e[this.getLanguagePartFromCode(t)]), i || (i = e.default), i || [];
  }
  toResolveHierarchy(e, t) {
    const i = this.getFallbackCodes(t || this.options.fallbackLng || [], e), r = [], o = (s) => {
      s && (this.isSupportedCode(s) ? r.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return U(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(e))) : U(e) && o(this.formatLanguageCode(e)), i.forEach((s) => {
      r.indexOf(s) < 0 && o(this.formatLanguageCode(s));
    }), r;
  }
}
let E5 = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], M5 = {
  1: (n) => +(n > 1),
  2: (n) => +(n != 1),
  3: (n) => 0,
  4: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  5: (n) => n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5,
  6: (n) => n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2,
  7: (n) => n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  8: (n) => n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3,
  9: (n) => +(n >= 2),
  10: (n) => n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4,
  11: (n) => n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3,
  12: (n) => +(n % 10 != 1 || n % 100 == 11),
  13: (n) => +(n !== 0),
  14: (n) => n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3,
  15: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  16: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2,
  17: (n) => n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1,
  18: (n) => n == 0 ? 0 : n == 1 ? 1 : 2,
  19: (n) => n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3,
  20: (n) => n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2,
  21: (n) => n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0,
  22: (n) => n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3
};
const $5 = ["v1", "v2", "v3"], z5 = ["v4"], dd = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, A5 = () => {
  const n = {};
  return E5.forEach((e) => {
    e.lngs.forEach((t) => {
      n[t] = {
        numbers: e.nr,
        plurals: M5[e.fc]
      };
    });
  }), n;
};
class L5 {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = jt.create("pluralResolver"), (!this.options.compatibilityJSON || z5.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = A5(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const i = Io(e === "dev" ? "en" : e), r = t.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
        cleanedCode: i,
        type: r
      });
      if (o in this.pluralRulesCache)
        return this.pluralRulesCache[o];
      let s;
      try {
        s = new Intl.PluralRules(i, {
          type: r
        });
      } catch {
        if (!e.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        s = this.getRule(l, t);
      }
      return this.pluralRulesCache[o] = s, s;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = this.getRule(e, t);
    return this.shouldUseIntlApi() ? i && i.resolvedOptions().pluralCategories.length > 1 : i && i.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, i).map((r) => `${t}${r}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = this.getRule(e, t);
    return i ? this.shouldUseIntlApi() ? i.resolvedOptions().pluralCategories.sort((r, o) => dd[r] - dd[o]).map((r) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : i.numbers.map((r) => this.getSuffix(e, r, t)) : [];
  }
  getSuffix(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const r = this.getRule(e, i);
    return r ? this.shouldUseIntlApi() ? `${this.options.prepend}${i.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(t)}` : this.getSuffixRetroCompatible(r, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const i = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let r = e.numbers[i];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (r === 2 ? r = "plural" : r === 1 && (r = ""));
    const o = () => this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
    return this.options.compatibilityJSON === "v1" ? r === 1 ? "" : typeof r == "number" ? `_plural_${r.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? o() : this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
  }
  shouldUseIntlApi() {
    return !$5.includes(this.options.compatibilityJSON);
  }
}
const hd = function(n, e, t) {
  let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = y5(n, e, t);
  return !o && r && U(t) && (o = al(n, t, i), o === void 0 && (o = al(e, t, i))), o;
}, ka = (n) => n.replace(/\$/g, "$$$$");
class N5 {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = jt.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: i,
      useRawValueToEscape: r,
      prefix: o,
      prefixEscaped: s,
      suffix: a,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: f,
      nestingSuffix: p,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: g,
      maxReplaces: k,
      alwaysFormat: v
    } = e.interpolation;
    this.escape = t !== void 0 ? t : x5, this.escapeValue = i !== void 0 ? i : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = o ? _i(o) : s || "{{", this.suffix = a ? _i(a) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? _i(h) : f || _i("$t("), this.nestingSuffix = p ? _i(p) : m || _i(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = k || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, i) => t && t.source === i ? (t.lastIndex = 0, t) : new RegExp(i, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, i, r) {
    let o, s, a;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const k = hd(t, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(k, void 0, i, {
          ...r,
          ...t,
          interpolationkey: f
        }) : k;
      }
      const p = f.split(this.formatSeparator), m = p.shift().trim(), g = p.join(this.formatSeparator).trim();
      return this.format(hd(t, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), g, i, {
        ...r,
        ...t,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler, d = r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => ka(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? ka(this.escape(f)) : ka(f)
    }].forEach((f) => {
      for (a = 0; o = f.regex.exec(e); ) {
        const p = o[1].trim();
        if (s = c(p), s === void 0)
          if (typeof u == "function") {
            const g = u(e, o, r);
            s = U(g) ? g : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, p))
            s = "";
          else if (d) {
            s = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), s = "";
        else !U(s) && !this.useRawValueToEscape && (s = rd(s));
        const m = f.safeValue(s);
        if (e = e.replace(o[0], m), d ? (f.regex.lastIndex += s.length, f.regex.lastIndex -= o[0].length) : f.regex.lastIndex = 0, a++, a >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, o, s;
    const a = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, s);
      const f = h.match(/'/g), p = h.match(/"/g);
      (f && f.length % 2 === 0 && !p || p.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        s = JSON.parse(h), c && (s = {
          ...c,
          ...s
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${u}${h}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, l;
    };
    for (; r = this.nestingRegexp.exec(e); ) {
      let l = [];
      s = {
        ...i
      }, s = s.replace && !U(s.replace) ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let c = !1;
      if (r[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(r[1])) {
        const u = r[1].split(this.formatSeparator).map((d) => d.trim());
        r[1] = u.shift(), l = u, c = !0;
      }
      if (o = t(a.call(this, r[1].trim(), s), s), o && r[0] === e && !U(o)) return o;
      U(o) || (o = rd(o)), o || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${e}`), o = ""), c && (o = l.reduce((u, d) => this.format(u, d, i.lng, {
        ...i,
        interpolationkey: r[1].trim()
      }), o.trim())), e = e.replace(r[0], o), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const D5 = (n) => {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const i = n.split("(");
    e = i[0].toLowerCase().trim();
    const r = i[1].substring(0, i[1].length - 1);
    e === "currency" && r.indexOf(":") < 0 ? t.currency || (t.currency = r.trim()) : e === "relativetime" && r.indexOf(":") < 0 ? t.range || (t.range = r.trim()) : r.split(";").forEach((s) => {
      if (s) {
        const [a, ...l] = s.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = a.trim();
        t[u] || (t[u] = c), c === "false" && (t[u] = !1), c === "true" && (t[u] = !0), isNaN(c) || (t[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, bi = (n) => {
  const e = {};
  return (t, i, r) => {
    let o = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (o = {
      ...o,
      [r.interpolationkey]: void 0
    });
    const s = i + JSON.stringify(o);
    let a = e[s];
    return a || (a = n(Io(i), r), e[s] = a), a(t);
  };
};
class R5 {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = jt.create("formatter"), this.options = e, this.formats = {
      number: bi((t, i) => {
        const r = new Intl.NumberFormat(t, {
          ...i
        });
        return (o) => r.format(o);
      }),
      currency: bi((t, i) => {
        const r = new Intl.NumberFormat(t, {
          ...i,
          style: "currency"
        });
        return (o) => r.format(o);
      }),
      datetime: bi((t, i) => {
        const r = new Intl.DateTimeFormat(t, {
          ...i
        });
        return (o) => r.format(o);
      }),
      relativetime: bi((t, i) => {
        const r = new Intl.RelativeTimeFormat(t, {
          ...i
        });
        return (o) => r.format(o, i.range || "day");
      }),
      list: bi((t, i) => {
        const r = new Intl.ListFormat(t, {
          ...i
        });
        return (o) => r.format(o);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = bi(t);
  }
  format(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = t.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((a) => a.indexOf(")") > -1)) {
      const a = o.findIndex((l) => l.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, a)].join(this.formatSeparator);
    }
    return o.reduce((a, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = D5(l);
      if (this.formats[c]) {
        let d = a;
        try {
          const h = r && r.formatParams && r.formatParams[r.interpolationkey] || {}, f = h.locale || h.lng || r.locale || r.lng || i;
          d = this.formats[c](a, f, {
            ...u,
            ...r,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return a;
    }, e);
  }
}
const I5 = (n, e) => {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
};
class P5 extends Is {
  constructor(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = i, this.languageUtils = i.languageUtils, this.options = r, this.logger = jt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(i, r.backend, r);
  }
  queueLoad(e, t, i, r) {
    const o = {}, s = {}, a = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      t.forEach((d) => {
        const h = `${c}|${d}`;
        !i.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? s[h] === void 0 && (s[h] = !0) : (this.state[h] = 1, u = !1, s[h] === void 0 && (s[h] = !0), o[h] === void 0 && (o[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (a[c] = !0);
    }), (Object.keys(o).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(a),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, i) {
    const r = e.split("|"), o = r[0], s = r[1];
    t && this.emit("failedLoading", o, s, t), !t && i && this.store.addResourceBundle(o, s, i, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && i && (this.state[e] = 0);
    const a = {};
    this.queue.forEach((l) => {
      k5(l.loaded, [o], s), I5(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        a[c] || (a[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          a[c][d] === void 0 && (a[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", a), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: i,
        tried: r,
        wait: o,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const a = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, i, r + 1, o * 2, s);
        }, o);
        return;
      }
      s(c, u);
    }, l = this.backend[i].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((u) => a(null, u)).catch(a) : a(null, c);
      } catch (c) {
        a(c);
      }
      return;
    }
    return l(e, t, a);
  }
  prepareLoading(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    U(e) && (e = this.languageUtils.toResolveHierarchy(e)), U(t) && (t = [t]);
    const o = this.queueLoad(e, t, i, r);
    if (!o.toLoad.length)
      return o.pending.length || r(), null;
    o.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(e, t, i) {
    this.prepareLoading(e, t, {}, i);
  }
  reload(e, t, i) {
    this.prepareLoading(e, t, {
      reload: !0
    }, i);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const i = e.split("|"), r = i[0], o = i[1];
    this.read(r, o, "read", void 0, void 0, (s, a) => {
      s && this.logger.warn(`${t}loading namespace ${o} for language ${r} failed`, s), !s && a && this.logger.log(`${t}loaded namespace ${o} for language ${r}`, a), this.loaded(e, s, a);
    });
  }
  saveMissing(e, t, i, r, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${i}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(i == null || i === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...s,
          isUpdate: o
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, t, i, r, l) : u = c(e, t, i, r), u && typeof u.then == "function" ? u.then((d) => a(null, d)).catch(a) : a(null, u);
          } catch (u) {
            a(u);
          }
        else
          c(e, t, i, r, a, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, i, r);
    }
  }
}
const fd = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (n) => {
    let e = {};
    if (typeof n[1] == "object" && (e = n[1]), U(n[1]) && (e.defaultValue = n[1]), U(n[2]) && (e.tDescription = n[2]), typeof n[2] == "object" || typeof n[3] == "object") {
      const t = n[3] || n[2];
      Object.keys(t).forEach((i) => {
        e[i] = t[i];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (n) => n,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), pd = (n) => (U(n.ns) && (n.ns = [n.ns]), U(n.fallbackLng) && (n.fallbackLng = [n.fallbackLng]), U(n.fallbackNS) && (n.fallbackNS = [n.fallbackNS]), n.supportedLngs && n.supportedLngs.indexOf("cimode") < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), n), Jr = () => {
}, j5 = (n) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
};
class Or extends Is {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = pd(e), this.services = {}, this.logger = jt, this.modules = {
      external: []
    }, j5(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (i = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (U(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const r = fd();
    this.options = {
      ...r,
      ...this.options,
      ...pd(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...r.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const o = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? jt.init(o(this.modules.logger), this.options) : jt.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = R5);
      const d = new ud(this.options);
      this.store = new ld(this.options.resources, this.options);
      const h = this.services;
      h.logger = jt, h.resourceStore = this.store, h.languageUtils = d, h.pluralResolver = new L5(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === r.interpolation.format) && (h.formatter = o(u), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new N5(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new P5(o(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(f) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
          m[g - 1] = arguments[g];
        e.emit(f, ...m);
      }), this.modules.languageDetector && (h.languageDetector = o(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = o(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new jo(this.services, this.options), this.translator.on("*", function(f) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
          m[g - 1] = arguments[g];
        e.emit(f, ...m);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, i || (i = Jr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = Hi(), c = () => {
      const u = (d, h) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(h), i(d, h);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Jr;
    const r = U(e) ? e : this.language;
    if (typeof e == "function" && (i = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return i();
      const o = [], s = (a) => {
        if (!a || a === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(a).forEach((c) => {
          c !== "cimode" && o.indexOf(c) < 0 && o.push(c);
        });
      };
      r ? s(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => s(l)), this.options.preload && this.options.preload.forEach((a) => s(a)), this.services.backendConnector.load(o, this.options.ns, (a) => {
        !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), i(a);
      });
    } else
      i(null);
  }
  reloadResources(e, t, i) {
    const r = Hi();
    return typeof e == "function" && (i = e, e = void 0), typeof t == "function" && (i = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), i || (i = Jr), this.services.backendConnector.reload(e, t, (o) => {
      r.resolve(), i(o);
    }), r;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Lp.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const i = this.languages[t];
        if (!(["cimode", "dev"].indexOf(i) > -1) && this.store.hasLanguageSomeTranslations(i)) {
          this.resolvedLanguage = i;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var i = this;
    this.isLanguageChangingTo = e;
    const r = Hi();
    this.emit("languageChanging", e);
    const o = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, s = (l, c) => {
      c ? (o(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, r.resolve(function() {
        return i.t(...arguments);
      }), t && t(l, function() {
        return i.t(...arguments);
      });
    }, a = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = U(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        s(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? a(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(a) : this.services.languageDetector.detect(a) : a(e), r;
  }
  getFixedT(e, t, i) {
    var r = this;
    const o = function(s, a) {
      let l;
      if (typeof a != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = r.options.overloadTranslationOptionHandler([s, a].concat(u));
      } else
        l = {
          ...a
        };
      l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || i || o.keyPrefix);
      const h = r.options.keySeparator || ".";
      let f;
      return l.keyPrefix && Array.isArray(s) ? f = s.map((p) => `${l.keyPrefix}${h}${p}`) : f = l.keyPrefix ? `${l.keyPrefix}${h}${s}` : s, r.t(f, l);
    };
    return U(e) ? o.lng = e : o.lngs = e, o.ns = t, o.keyPrefix = i, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const i = t.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (i.toLowerCase() === "cimode") return !0;
    const s = (a, l) => {
      const c = this.services.backendConnector.state[`${a}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (t.precheck) {
      const a = t.precheck(this, s);
      if (a !== void 0) return a;
    }
    return !!(this.hasResourceBundle(i, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(i, e) && (!r || s(o, e)));
  }
  loadNamespaces(e, t) {
    const i = Hi();
    return this.options.ns ? (U(e) && (e = [e]), e.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      i.resolve(), t && t(r);
    }), i) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const i = Hi();
    U(e) && (e = [e]);
    const r = this.options.preload || [], o = e.filter((s) => r.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return o.length ? (this.options.preload = r.concat(o), this.loadResources((s) => {
      i.resolve(), t && t(s);
    }), i) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], i = this.services && this.services.languageUtils || new ud(fd());
    return t.indexOf(i.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Or(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Jr;
    const i = e.forkResourceStore;
    i && delete e.forkResourceStore;
    const r = {
      ...this.options,
      ...e,
      isClone: !0
    }, o = new Or(r);
    return (e.debug !== void 0 || e.prefix !== void 0) && (o.logger = o.logger.clone(e)), ["store", "services", "language"].forEach((a) => {
      o[a] = this[a];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, i && (o.store = new ld(this.store.data, r), o.services.resourceStore = o.store), o.translator = new jo(o.services, r), o.translator.on("*", function(a) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      o.emit(a, ...c);
    }), o.init(r, t), o.translator.options = r, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const M = Or.createInstance();
M.createInstance = Or.createInstance;
M.createInstance;
M.dir;
M.init;
M.loadResources;
M.reloadResources;
M.use;
M.changeLanguage;
M.getFixedT;
M.t;
M.exists;
M.setDefaultNamespace;
M.hasLoadedNamespace;
M.loadNamespaces;
M.loadLanguages;
const Np = "نص بديل", Dp = "لون خلفية الخط", Rp = "خط عريض", Ip = "قائمة نقطية", Pp = "تعليق توضيحي", jp = "تقليل مسافة البداية", Bp = "افتراضي", Fp = "تباعد الفقرات", qp = "لون الخط", Hp = { default: "افتراضي", default_hint: "يستخدم الخط المحدد في مكان استخدامه", hint: "الخط الافتراضي يعتمد على الخطوط المستخدمة في منصة المراسلة للعميل", mailbox_default: "صندوق البريد الافتراضي", mailbox_default_hint: "يستخدم الخط الافتراضي لصندوق البريد الخاص بالمستلم (مثل Gmail، Outlook، أو Yahoo) لقراءة مثالية", title: "مجموعة الخطوط" }, Vp = "حجم الخط", Up = { apply: "تطبيق", clear: "حذف", error: "خطأ" }, Wp = "صورة", Kp = "محاذاة الصورة للوسط", Zp = "تغيير النص البديل للصورة", Gp = "تغيير التعليق التوضيحي للصورة", Jp = "تغيير رابط الصورة", Yp = "ضبط عرض الصورة ليكون بعرض الجهاز المحمول بالكامل", Xp = "فشل في معالجة الصورة", Qp = "محاذاة", em = "إدراج صورة عبر رابط", tm = "محاذاة الصورة لليسار", nm = "إدراج صورة عبر رابط", im = "زيادة مسافة البداية", rm = "خط مائل", om = "ارتفاع السطر", sm = "رابط", am = "قائمة مرقّمة", lm = "إعادة", cm = { austral: "رمز الأوسترا", bitcoin: "رمز البيتكوين", cedi: "رمز السيدي", cent: "رمز السنت", colon: "رمز الكولون", copyright_sign: "رمز حقوق الطبع والنشر", cruzeiro: "رمز الكروزيرو", currency: "رمز العملة", dollar: "رمز الدولار", dong: "رمز الدونغ", double_dagger: "رمز الخنجر المزدوج", double_exclamation_mark: "علامة تعجب مزدوجة", double_low_quotation_mark: "علاماتا تنصيص سفليتان", double_question_mark: "رمز استفهام مزدوج", drachma: "رمز الدراخما", euro: "رمز الأورو", euro_currency: "رمز عملة الأورو", exclamation_question_mark: "رمز استفهام و تعجب", french_franc: "رمز الفرنك الفرنسي", german_penny: "رمز الفينين الألماني", guarani: "رمز الغواراني", horizontal_ellipsis: "رمز الحذف الأفقي", hryvnia: "رمز الهريفنيا", indian_rupee: "رمز الروبية الهندية", inverted_exclamation_mark: "علامة تعجّب مقلوبة", inverted_question_mark: "علامة استفهام مقلوبة", kip: "رمز الكيب", left_double_quotation_mark: 'علاماتا تنصيص "يسار"', left_pointing_angle_quotation_mark: 'علامة تنصيص "زاوية منفردة لليسار"', left_pointing_double_angle_quotation_mark: 'علامة تنصيص "زاوية مزدوجة لليسار"', left_single_quotation_mark: 'علامة تنصيص منفردة "يسار"', lira: "رمز الليرة", livre_tournois: "رمز الليفر تورنوا", manat: "رمز عملة المانات", mill: "رمز الميل", new_sheqel: "رمز الشيكل الجديد", nordic_mark: "رمز العلامة النوردية", paragraph_sign: "رمز الفقرة", per_mille_sign: 'رمز "لكل ميل"', per_ten_thousand_sign: 'رمز "لكل 10 آلاف"', peseta: "رمز البيزيتا", peso: "رمز البيزو", pound: "رمز الجنيه", question_exclamation_mark: "رمز تعجب و استفهام", registered_sign: "رمز مسجّل", reversed_paragraph_sign: "رمز الفقرة المعكوس", right_double_quotation_mark: 'علاماتا تنصيص "يمين"', right_pointing_angle_quotation_mark: 'علامة تنصيص "زاوية منفردة لليمين"', right_pointing_double_angle_quotation_mark: 'علامة تنصيص "زاوية مزدوجة لليمين"', right_single_quotation_mark: 'علامة تنصيص منفردة "يمين"', ruble: "رمز عملة الروبل", rupee: "رمز الروبية", section_sign: "رمز القسم", select_all: "الكل", select_currency: "العملة", select_text: "نص", single_low_quotation_mark: "علامة تنصيص سفلية منفردة", spesmilo: "رمز سبسميلو", tenge: "رمز التينغي", title: "أحرف مميزة", trade_mark_sign: "رمز العلامة التجارية", tugrik: "رمز التوغريك", turkish_lira: "رمز الليرة التركية", two_dot_leader: "رمز الفاصل بنقطتين", won: "رمز الوون", yen: "رمز الين" }, um = "شطب الخط", dm = "المتغيرات البديلة", hm = "البدائل", fm = "ضبط النص", pm = { header_one: "العنوان 1", header_three: "العنوان 3", header_two: "العنوان 2", paragraph: "الفقرة", title: "عنوان" }, mm = "تسطير", gm = "إلغاء", _m = "غير مضبوط", bm = {
  alt_text: Np,
  background_color: Dp,
  bold: Rp,
  bulletList: Ip,
  caption: Pp,
  decrease_intent: jp,
  default_font_size: Bp,
  extra_spacing: Fp,
  font_color: qp,
  font_family: Hp,
  font_size: Vp,
  global: Up,
  image: Wp,
  image_center: Kp,
  image_change_alt_text: Zp,
  image_change_caption: Gp,
  image_change_link: Jp,
  image_change_mobile_full_width: Yp,
  image_error: Xp,
  image_in_line: Qp,
  image_insert_via_link: em,
  image_side: tm,
  image_via_link: nm,
  increase_intent: im,
  italic: rm,
  line_height: om,
  link: sm,
  orderedList: am,
  redo: lm,
  special_characters: cm,
  strike: um,
  substitute_variables: dm,
  substitutions: hm,
  text_align: fm,
  text_level: pm,
  underline: mm,
  undo: gm,
  unset: _m
}, B5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Np,
  background_color: Dp,
  bold: Rp,
  bulletList: Ip,
  caption: Pp,
  decrease_intent: jp,
  default: bm,
  default_font_size: Bp,
  extra_spacing: Fp,
  font_color: qp,
  font_family: Hp,
  font_size: Vp,
  global: Up,
  image: Wp,
  image_center: Kp,
  image_change_alt_text: Zp,
  image_change_caption: Gp,
  image_change_link: Jp,
  image_change_mobile_full_width: Yp,
  image_error: Xp,
  image_in_line: Qp,
  image_insert_via_link: em,
  image_side: tm,
  image_via_link: nm,
  increase_intent: im,
  italic: rm,
  line_height: om,
  link: sm,
  orderedList: am,
  redo: lm,
  special_characters: cm,
  strike: um,
  substitute_variables: dm,
  substitutions: hm,
  text_align: fm,
  text_level: pm,
  underline: mm,
  undo: gm,
  unset: _m
}, Symbol.toStringTag, { value: "Module" })), km = "Textová alternativa", ym = "Barva pozadí písma", vm = "Tučně", xm = "Odrážkový seznam", Sm = "Titulek", wm = "Zmenšit odsazení", Cm = "Výchozí", Tm = "Mezera mezi odstavci", Om = "Barva písma", Em = { default: "Výchozí", default_hint: "Používá písmo nastavené na místě použití", hint: "Standardní písmo používá písma e-mailového klienta", mailbox_default: "Výchozí", mailbox_default_hint: "Používá výchozí písmo příjemcovy e-mailové schránky (například Gmail, Outlook nebo Yahoo) pro optimální čitelnost", title: "Rodina písma" }, Mm = "Velikost písma", $m = { apply: "Aplikovat", clear: "Průhledná", error: "Chyba" }, zm = "Obrázek", Am = "Zarovnat obrázek na střed", Lm = "Změnit alternativní text obrázku", Nm = "Změnit popis obrázku", Dm = "Změnit odkaz obrázku", Rm = "Nastavit šířku obrázku na plnou šířku mobilního zařízení", Im = "Nepodařilo se zpracovat obrázek", Pm = "Zarovnat obrázek vpravo", jm = "Vložit obrázek přes odkaz", Bm = "Zarovnat obrázek vlevo", Fm = "Obrázek přes odkaz", qm = "Zvětšit odsazení", Hm = "Kurzíva", Vm = "Výška řádku", Um = "Odkaz", Wm = "Číslovaný seznam", Km = "Znovu", Zm = { austral: "Symbol australu", bitcoin: "Symbol bitcoinu", cedi: "Symbol cedi", cent: "Cent znak", colon: "Znak dvojtečky", copyright_sign: "Znak autorského práva", cruzeiro: "Znak cruzeiro", currency: "Symbol měny", dollar: "Dolarový znak", dong: "Symbol dongu", double_dagger: "Dvojitá dýka", double_exclamation_mark: "Dvojitý vykřičník", double_low_quotation_mark: "Dvojitá nízká 9 uvozovka", double_question_mark: "Dvojitý otazník", drachma: "Symbol drachmy", euro: "Euro znak", euro_currency: "Znak euro-měny", exclamation_question_mark: "Vykřičník otazník", french_franc: "Znak francouzského franku", german_penny: "Symbol německé pfenigu", guarani: "Symbol guaraní", horizontal_ellipsis: "Horizontální elipsa", hryvnia: "Symbol hřivny", indian_rupee: "Symbol indické rupie", inverted_exclamation_mark: "Inverzní vykřičník", inverted_question_mark: "Inverzní otazník", kip: "Symbol kipy", left_double_quotation_mark: "Levé dvojité uvozovky", left_pointing_angle_quotation_mark: "Jednoduchá levá úhlová uvozovka", left_pointing_double_angle_quotation_mark: "Levé dvojité úhlové uvozovka", left_single_quotation_mark: "Levé jednoduché uvozovky", lira: "Znak liry", livre_tournois: "Symbol livre tournois", manat: "Znak manat", mill: "Symbol millu", new_sheqel: "Symbol nového šekelu", nordic_mark: "Symbol nordické marky", paragraph_sign: "Znak odstavce", per_mille_sign: "Per mille znak", per_ten_thousand_sign: "Per deset tisíc znak", peseta: "Symbol pesety", peso: "Symbol pesa", pound: "Libra znak", question_exclamation_mark: "Otazník vykřičník", registered_sign: "Registrovaný znak", reversed_paragraph_sign: "Obrácený znak odstavce", right_double_quotation_mark: "Pravé dvojité uvozovky", right_pointing_angle_quotation_mark: "Jednoduchá pravá úhlová uvozovka", right_pointing_double_angle_quotation_mark: "Pravá dvojitá úhlová uvozovka", right_single_quotation_mark: "Pravé jednoduché uvozovky", ruble: "Symbol rublu", rupee: "Symbol rupie", section_sign: "Znak paragrafu", select_all: "Vše", select_currency: "Měna", select_text: "Text", single_low_quotation_mark: "Jednoduchá nízká 9 uvozovka", spesmilo: "Symbol spesmila", tenge: "Symbol tenge", title: "Speciální znaky", trade_mark_sign: "Znak ochranné známky", tugrik: "Symbol tugriku", turkish_lira: "Symbol turecké liry", two_dot_leader: "Dvojtečkový vodítko", won: "Symbol wonu", yen: "Japonský jen znak" }, Gm = "Přeškrtnuté", Jm = "Náhradní proměnné", Ym = "Náhrady", Xm = "Zarovnání textu", Qm = { header_one: "Nadpis 1", header_three: "Nadpis 3", header_two: "Nadpis 2", paragraph: "Odstavec", title: "Nadpis" }, eg = "Podtržené", tg = "Zpět", ng = "Neurčeno", ig = {
  alt_text: km,
  background_color: ym,
  bold: vm,
  bulletList: xm,
  caption: Sm,
  decrease_intent: wm,
  default_font_size: Cm,
  extra_spacing: Tm,
  font_color: Om,
  font_family: Em,
  font_size: Mm,
  global: $m,
  image: zm,
  image_center: Am,
  image_change_alt_text: Lm,
  image_change_caption: Nm,
  image_change_link: Dm,
  image_change_mobile_full_width: Rm,
  image_error: Im,
  image_in_line: Pm,
  image_insert_via_link: jm,
  image_side: Bm,
  image_via_link: Fm,
  increase_intent: qm,
  italic: Hm,
  line_height: Vm,
  link: Um,
  orderedList: Wm,
  redo: Km,
  special_characters: Zm,
  strike: Gm,
  substitute_variables: Jm,
  substitutions: Ym,
  text_align: Xm,
  text_level: Qm,
  underline: eg,
  undo: tg,
  unset: ng
}, F5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: km,
  background_color: ym,
  bold: vm,
  bulletList: xm,
  caption: Sm,
  decrease_intent: wm,
  default: ig,
  default_font_size: Cm,
  extra_spacing: Tm,
  font_color: Om,
  font_family: Em,
  font_size: Mm,
  global: $m,
  image: zm,
  image_center: Am,
  image_change_alt_text: Lm,
  image_change_caption: Nm,
  image_change_link: Dm,
  image_change_mobile_full_width: Rm,
  image_error: Im,
  image_in_line: Pm,
  image_insert_via_link: jm,
  image_side: Bm,
  image_via_link: Fm,
  increase_intent: qm,
  italic: Hm,
  line_height: Vm,
  link: Um,
  orderedList: Wm,
  redo: Km,
  special_characters: Zm,
  strike: Gm,
  substitute_variables: Jm,
  substitutions: Ym,
  text_align: Xm,
  text_level: Qm,
  underline: eg,
  undo: tg,
  unset: ng
}, Symbol.toStringTag, { value: "Module" })), rg = "Tekstalternativ", og = "Font baggrundsfarve", sg = "fed tryk", ag = "Punktliste", lg = "Billedtekst", cg = "Reducer hensigten", ug = "Misligholdelse", dg = "Afsnitsafstand", hg = "Skriftfarve", fg = { default: "Misligholdelse", default_hint: "Bruger den skrifttype, der er angivet på anvendelsesstedet", hint: "Standardskrifttype bruger e-mailklientskrifttyper", mailbox_default: "Postkasse-standard", mailbox_default_hint: "Bruger modtagerens postkasses standardskrifttype (f.eks. Gmail, Outlook eller Yahoo) for optimal læsbarhed", title: "Fontfamilie" }, pg = "Skriftstørrelse", mg = { apply: "Ansøge", clear: "Klar", error: "Fejl" }, gg = "Billede", _g = "Billedjustering i midten", bg = "Skift billedtekstalternativ", kg = "Skift billedtekst", yg = "Skift billedlink", vg = "Indstil billedbredden til mobilens fulde bredde", xg = "Billedet kunne ikke behandles", Sg = "Billedjustering til højre", wg = "Indsæt billede via link", Cg = "Billedjustering til venstre", Tg = "Billede via link", Og = "Øg hensigten", Eg = "Kursiv", Mg = "Linjehøjde", $g = "Forbindelse", zg = "Nummereret liste", Ag = "Gentag", Lg = { austral: "Australske tegn", bitcoin: "Bitcoin tegn", cedi: "Cedi tegn", cent: "Cent tegn", colon: "Kolon tegn", copyright_sign: "Copyright tegn", cruzeiro: "Cruzeiro tegn", currency: "Valuta tegn", dollar: "Dollar tegn", dong: "Dong tegn", double_dagger: "Dobbelt dolk", double_exclamation_mark: "Dobbelt udråbstegn", double_low_quotation_mark: "Dobbelt lav-9 anførselstegn", double_question_mark: "Dobbelt spørgsmålstegn", drachma: "Drakme tegn", euro: "Euro tegn", euro_currency: "Euro-valuta tegn", exclamation_question_mark: "Udråbstegn spørgsmålstegn", french_franc: "Fransk franc tegn", german_penny: "Tysk penny tegn", guarani: "Guarani tegn", horizontal_ellipsis: "Vandret ellipse", hryvnia: "Hryvnia tegn", indian_rupee: "Indiske rupee tegn", inverted_exclamation_mark: "Omvendt udråbstegn", inverted_question_mark: "Omvendt spørgsmålstegn", kip: "Kip tegn", left_double_quotation_mark: "Venstre dobbelte anførselstegn", left_pointing_angle_quotation_mark: "Enkelt venstre-pegende vinkel anførselstegn", left_pointing_double_angle_quotation_mark: "Venstre-pegende dobbelt vinkel anførselstegn", left_single_quotation_mark: "Venstre enkelt anførselstegn", lira: "Lira tegn", livre_tournois: "Livre tournois tegn", manat: "Manat tegn", mill: "Mill. tegn", new_sheqel: "Nyt shekel tegn", nordic_mark: "Nordisk mærke tegn", paragraph_sign: "Paragraf-tegn", per_mille_sign: "Promille tegn", per_ten_thousand_sign: "Per ti tusind tegn", peseta: "Peseta tegn", peso: "Peso tegn", pound: "Pund tegn", question_exclamation_mark: "Spørgsmål udråbstegn", registered_sign: "Registreret tegn", reversed_paragraph_sign: "Omvendt paragraftegn", right_double_quotation_mark: "Højre dobbelt anførselstegn", right_pointing_angle_quotation_mark: "Enkelt ret-pegende vinkel anførselstegn", right_pointing_double_angle_quotation_mark: "Højre-pegende dobbelt vinkel anførselstegn", right_single_quotation_mark: "Højre enkelt anførselstegn", ruble: "Rubel tegn", rupee: "Rupee tegn", section_sign: "Sektionsskilt", select_all: "Alle", select_currency: "Valuta", select_text: "Tekst", single_low_quotation_mark: "Enkelt lav-9 anførselstegn", spesmilo: "Spesmilo tegn", tenge: "Tenge tegn", title: "Specialtegn", trade_mark_sign: "Varemærke tegn", tugrik: "Tugrik tegn", turkish_lira: "Tyrkisk lira tegn", two_dot_leader: "To prikker leder", won: "Won tegn", yen: "Yen tegn" }, Ng = "Gennemstregning", Dg = "Erstatningsvariable", Rg = "Udskiftninger", Ig = "Tekstjustering", Pg = { header_one: "Overskrift 1", header_three: "Overskrift 3", header_two: "Overskrift 2", paragraph: "Paragraf", title: "Overskrift" }, jg = "Understrege", Bg = "Fortryd", Fg = "Afbryd", qg = {
  alt_text: rg,
  background_color: og,
  bold: sg,
  bulletList: ag,
  caption: lg,
  decrease_intent: cg,
  default_font_size: ug,
  extra_spacing: dg,
  font_color: hg,
  font_family: fg,
  font_size: pg,
  global: mg,
  image: gg,
  image_center: _g,
  image_change_alt_text: bg,
  image_change_caption: kg,
  image_change_link: yg,
  image_change_mobile_full_width: vg,
  image_error: xg,
  image_in_line: Sg,
  image_insert_via_link: wg,
  image_side: Cg,
  image_via_link: Tg,
  increase_intent: Og,
  italic: Eg,
  line_height: Mg,
  link: $g,
  orderedList: zg,
  redo: Ag,
  special_characters: Lg,
  strike: Ng,
  substitute_variables: Dg,
  substitutions: Rg,
  text_align: Ig,
  text_level: Pg,
  underline: jg,
  undo: Bg,
  unset: Fg
}, q5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: rg,
  background_color: og,
  bold: sg,
  bulletList: ag,
  caption: lg,
  decrease_intent: cg,
  default: qg,
  default_font_size: ug,
  extra_spacing: dg,
  font_color: hg,
  font_family: fg,
  font_size: pg,
  global: mg,
  image: gg,
  image_center: _g,
  image_change_alt_text: bg,
  image_change_caption: kg,
  image_change_link: yg,
  image_change_mobile_full_width: vg,
  image_error: xg,
  image_in_line: Sg,
  image_insert_via_link: wg,
  image_side: Cg,
  image_via_link: Tg,
  increase_intent: Og,
  italic: Eg,
  line_height: Mg,
  link: $g,
  orderedList: zg,
  redo: Ag,
  special_characters: Lg,
  strike: Ng,
  substitute_variables: Dg,
  substitutions: Rg,
  text_align: Ig,
  text_level: Pg,
  underline: jg,
  undo: Bg,
  unset: Fg
}, Symbol.toStringTag, { value: "Module" })), Hg = "Textalternative", Vg = "Hintergrundfarbe der Schrift", Ug = "Fettdruck", Wg = "Aufzählungsliste", Kg = "Bildunterschrift", Zg = "Einrückung verkleinern", Gg = "Standard", Jg = "Absatzabstand", Yg = "Schriftfarbe", Xg = { default: "Standard", default_hint: "Verwendet die an der Stelle der Verwendung eingestellte Schriftart", hint: "Standardschriftart verwendet E-Mail-Client-Schriftarten", mailbox_default: "Postfach-Standard", mailbox_default_hint: "Verwendet die Standardschriftart des Postfachs des Empfängers (z. B. Gmail, Outlook oder Yahoo) für optimale Lesbarkeit", title: "Schriftfamilie" }, Qg = "Schriftgröße", e_ = { apply: "Anwenden", clear: "Löschen", error: "Fehler" }, t_ = "Bild", n_ = "Bild zentriert ausrichten", i_ = "Bildtextalternative ändern", r_ = "Bildunterschrift ändern", o_ = "Bildlink ändern", s_ = "Stellen Sie die Bildbreite auf die volle Breite des Mobilgeräts ein", a_ = "Das Bild konnte nicht verarbeitet werden", l_ = "Bild rechtsbündig ausrichten", c_ = "Bild per Link einfügen", u_ = "Bild linksbündig ausrichten", d_ = "Bild über Link", h_ = "Einrückung vergrößern", f_ = "Kursiv", p_ = "Zeilenhöhe", m_ = "Link", g_ = "Nummerierte Liste", __ = "Wiederholen", b_ = { austral: "Australisches Währungszeichen", bitcoin: "Bitcoin-Zeichen", cedi: "Cedi-Zeichen", cent: "Cent-Zeichen", colon: "Doppelpunkt-Zeichen", copyright_sign: "Copyright-Zeichen", cruzeiro: "Cruzeiro-Zeichen", currency: "Währungszeichen", dollar: "Dollar Zeichen", dong: "Dong-Zeichen", double_dagger: "Doppeldolch", double_exclamation_mark: "Doppeltes Ausrufezeichen", double_low_quotation_mark: "Doppeltes Anführungszeichen (9)", double_question_mark: "Doppeltes Fragezeichen", drachma: "Drachme-Zeichen", euro: "Euro-Zeichen", euro_currency: "Euro-Währungszeichen", exclamation_question_mark: "Ausrufezeichen Fragezeichen", french_franc: "Französisches Franc-Zeichen", german_penny: "Deutsches Pfennigzeichen", guarani: "Guarani-Zeichen", horizontal_ellipsis: "Horizontale Auslassungspunkte", hryvnia: "Griwna-Zeichen", indian_rupee: "Indisches Rupie Zeichen", inverted_exclamation_mark: "Umgekehrtes Ausrufezeichen", inverted_question_mark: "Umgekehrtes Fragezeichen", kip: "Kip-Zeichen", left_double_quotation_mark: "Linkes doppeltes Anführungszeichen", left_pointing_angle_quotation_mark: "Einfaches, nach links weisendes Anführungszeichen", left_pointing_double_angle_quotation_mark: "Nach links zeigendes doppeltes Anführungszeichen", left_single_quotation_mark: "Linkes einfaches Anführungszeichen", lira: "Lira-Zeichen", livre_tournois: "Livre Tournois-Zeichen", manat: "Manat-Zeichen", mill: "Mill. Zeichen", new_sheqel: "Neues Schekel-Zeichen", nordic_mark: "Zeichen der Nordischen Mark", paragraph_sign: "Absatzzeichen", per_mille_sign: "Promille-Zeichen", per_ten_thousand_sign: "Pro-Zehntausend-Zeichen", peseta: "Peseta-Zeichen", peso: "Peso-Zeichen", pound: "Pfund-Zeichen", question_exclamation_mark: "Fragezeichen Ausrufezeichen", registered_sign: "Registriertes Zeichen", reversed_paragraph_sign: "Umgekehrtes Absatzzeichen", right_double_quotation_mark: "Rechtes doppeltes Anführungszeichen", right_pointing_angle_quotation_mark: "Einfaches, nach rechts zeigendes Anführungszeichen", right_pointing_double_angle_quotation_mark: "Nach rechts zeigendes doppeltes spitzes Anführungszeichen", right_single_quotation_mark: "Rechtes einfaches Anführungszeichen", ruble: "Rubel-Zeichen", rupee: "Rupie-Zeichen", section_sign: "Abschnittszeichen", select_all: "Alle", select_currency: "Währung", select_text: "Text", single_low_quotation_mark: "Einzelnes Anführungszeichen (9)", spesmilo: "Spesmilo-Zeichen", tenge: "Tenge-Zeichen", title: "Sonderzeichen", trade_mark_sign: "Markenzeichen", tugrik: "Tugrik-Zeichen", turkish_lira: "Türkisches Lira-Zeichen", two_dot_leader: "Zwei Punktführer", won: "Won-Zeichen", yen: "Yen-Zeichen" }, k_ = "Durchgestrichen", y_ = "Platzhalter", v_ = "Auswechslungen", x_ = "Textausrichtung", S_ = { header_one: "Kopfzeile 1", header_three: "Kopfzeile 3", header_two: "Kopfzeile 2", paragraph: "Absatz", title: "Überschrift" }, w_ = "Unterstreichen", C_ = "Rückgängig machen", T_ = "Zurücksetzen", O_ = {
  alt_text: Hg,
  background_color: Vg,
  bold: Ug,
  bulletList: Wg,
  caption: Kg,
  decrease_intent: Zg,
  default_font_size: Gg,
  extra_spacing: Jg,
  font_color: Yg,
  font_family: Xg,
  font_size: Qg,
  global: e_,
  image: t_,
  image_center: n_,
  image_change_alt_text: i_,
  image_change_caption: r_,
  image_change_link: o_,
  image_change_mobile_full_width: s_,
  image_error: a_,
  image_in_line: l_,
  image_insert_via_link: c_,
  image_side: u_,
  image_via_link: d_,
  increase_intent: h_,
  italic: f_,
  line_height: p_,
  link: m_,
  orderedList: g_,
  redo: __,
  special_characters: b_,
  strike: k_,
  substitute_variables: y_,
  substitutions: v_,
  text_align: x_,
  text_level: S_,
  underline: w_,
  undo: C_,
  unset: T_
}, H5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Hg,
  background_color: Vg,
  bold: Ug,
  bulletList: Wg,
  caption: Kg,
  decrease_intent: Zg,
  default: O_,
  default_font_size: Gg,
  extra_spacing: Jg,
  font_color: Yg,
  font_family: Xg,
  font_size: Qg,
  global: e_,
  image: t_,
  image_center: n_,
  image_change_alt_text: i_,
  image_change_caption: r_,
  image_change_link: o_,
  image_change_mobile_full_width: s_,
  image_error: a_,
  image_in_line: l_,
  image_insert_via_link: c_,
  image_side: u_,
  image_via_link: d_,
  increase_intent: h_,
  italic: f_,
  line_height: p_,
  link: m_,
  orderedList: g_,
  redo: __,
  special_characters: b_,
  strike: k_,
  substitute_variables: y_,
  substitutions: v_,
  text_align: x_,
  text_level: S_,
  underline: w_,
  undo: C_,
  unset: T_
}, Symbol.toStringTag, { value: "Module" })), E_ = "Εναλλακτικό κείμενο", M_ = "Χρώμα φόντου κειμένου", $_ = "Έντονη γραφή", z_ = "Λίστα με κουκίδες", A_ = "Λεζάντα", L_ = "Μείωση εσοχής", N_ = "Προεπιλογή", D_ = "Απόσταση μεταξύ παραγράφων", R_ = "Χρώμα κειμένου", I_ = { default: "Προεπιλογή", default_hint: "Χρησιμοποιεί τη γραμματοσειρά που έχει οριστεί στον χώρο χρήσης", hint: "Η τυπική γραμματοσειρά χρησιμοποιεί τις γραμματοσειρές του email client", mailbox_default: "Προεπιλογή γραμματοκιβωτίου", mailbox_default_hint: "Χρησιμοποιεί την προεπιλεγμένη γραμματοσειρά του γραμματοκιβωτίου του παραλήπτη (π.χ., Gmail, Outlook, ή Yahoo) για βέλτιστη αναγνωσιμότητα", title: "Οικογένεια γραμματοσειράς" }, P_ = "Μέγεθος κειμένου", j_ = { apply: "Εφαρμογή", clear: "Εκκαθάριση", error: "Σφάλμα" }, B_ = "Εικόνα", F_ = "Εικόνα στο κέντρο", q_ = "Αλλαγή εναλλακτικού κειμένου εικόνας", H_ = "Αλλαγή λεζάντας εικόνας", V_ = "Αλλαγή συνδέσμου εικόνας", U_ = "Ορίστε το πλάτος της εικόνας στο μέγιστο πλάτος της κινητής συσκευής", W_ = "Αποτυχία επεξεργασίας εικόνας", K_ = "Εικόνα μέσα στο κείμενο", Z_ = "Εισαγωγή εικόνας μέσω συνδέσμου", G_ = "Εικόνα στο πλάι", J_ = "Εικόνα μέσω συνδέσμου", Y_ = "Αύξηση εσοχής", X_ = "Πλάγια γραφή", Q_ = "Διάστιχο", eb = "Σύνδεσμος", tb = "Αριθμημένη λίστα", nb = "Επαναφορά", ib = { austral: "Σύμβολο αυστράλ", bitcoin: "Σύμβολο Bitcoin", cedi: "Σύμβολο σέντι", cent: "Σύμβολο σεντ", colon: "Σύμβολο άνω κάτω τελείας", copyright_sign: "Σύμβολο πνευματικών δικαιωμάτων", cruzeiro: "Σύμβολο κρουζέιρο", currency: "Σύμβολο νομίσματος", dollar: "Σύμβολο δολαρίου", dong: "Σύμβολο ντονγκ", double_dagger: "Διπλός σταυρός (‡)", double_exclamation_mark: "Διπλό θαυμαστικό", double_low_quotation_mark: "Διπλό κάτω εισαγωγικό („)", double_question_mark: "Διπλό ερωτηματικό", drachma: "Σύμβολο δραχμής", euro: "Σύμβολο ευρώ", euro_currency: "Σύμβολο νομίσματος ευρώ", exclamation_question_mark: "Θαυμαστικό-ερωτηματικό (⁉)", french_franc: "Σύμβολο γαλλικού φράγκου", german_penny: "Σύμβολο φένιχ", guarani: "Σύμβολο γκουαρανί", horizontal_ellipsis: "Αποσιωπητικά", hryvnia: "Σύμβολο χρίβνια", indian_rupee: "Σύμβολο ινδικής ρουπίας", inverted_exclamation_mark: "Αντεστραμμένο θαυμαστικό", inverted_question_mark: "Αντεστραμμένο ερωτηματικό", kip: "Σύμβολο κιπ", left_double_quotation_mark: "Αριστερό διπλό εισαγωγικό (“)", left_pointing_angle_quotation_mark: "Αριστερό μονό γωνιακό εισαγωγικό", left_pointing_double_angle_quotation_mark: "Αριστερό διπλό γωνιακό εισαγωγικό", left_single_quotation_mark: "Αριστερό μονό εισαγωγικό (‘)", lira: "Σύμβολο λίρας", livre_tournois: "Σύμβολο λίβρας τουρνουά", manat: "Σύμβολο μανάτ (₼)", mill: "Σύμβολο mill (₥)", new_sheqel: "Σύμβολο νέου σεκέλ", nordic_mark: "Σύμβολο σκανδιναβικής μάρκας", paragraph_sign: "Σύμβολο ¶ (σήμα παραγράφου)", per_mille_sign: "Σύμβολο τοις χιλίοις (‰)", per_ten_thousand_sign: "Σύμβολο τοις μυρίοις (‱)", peseta: "Σύμβολο πεσέτας", peso: "Σύμβολο πέσο", pound: "Σύμβολο στερλίνας", question_exclamation_mark: "Ερωτηματικό-θαυμαστικό (⁈)", registered_sign: "Σύμβολο καταχωρημένου εμπορικού σήματος", reversed_paragraph_sign: "Ανεστραμμένο σύμβολο ¶", right_double_quotation_mark: "Δεξί διπλό εισαγωγικό (”)", right_pointing_angle_quotation_mark: "Δεξί μονό γωνιακό εισαγωγικό", right_pointing_double_angle_quotation_mark: "Δεξί διπλό γωνιακό εισαγωγικό", right_single_quotation_mark: "Δεξί μονό εισαγωγικό (’)", ruble: "Σύμβολο ρουβλίου", rupee: "Σύμβολο ρουπίας", section_sign: "Σύμβολο § (παράγραφος)", select_all: "Όλα", select_currency: "Νόμισμα", select_text: "Κείμενο", single_low_quotation_mark: "Μονό κάτω εισαγωγικό (‚)", spesmilo: "Σύμβολο spesmilo", tenge: "Σύμβολο τενγκέ", title: "Ειδικοί χαρακτήρες", trade_mark_sign: "Σύμβολο εμπορικού σήματος", tugrik: "Σύμβολο τουγκρίκ", turkish_lira: "Σύμβολο τουρκικής λίρας", two_dot_leader: "Διπλή τελεία", won: "Σύμβολο γουόν", yen: "Σύμβολο γιεν" }, rb = "Διαγράμμιση", ob = "Μεταβλητές αντικατάστασης", sb = "Αντικαταστάσεις", ab = "Στοίχιση κειμένου", lb = { header_one: "Επικεφαλίδα 1", header_three: "Επικεφαλίδα 3", header_two: "Επικεφαλίδα 2", paragraph: "Παράγραφος", title: "Επικεφαλίδα" }, cb = "Υπογράμμιση", ub = "Αναίρεση", db = "Κατάργηση", hb = {
  alt_text: E_,
  background_color: M_,
  bold: $_,
  bulletList: z_,
  caption: A_,
  decrease_intent: L_,
  default_font_size: N_,
  extra_spacing: D_,
  font_color: R_,
  font_family: I_,
  font_size: P_,
  global: j_,
  image: B_,
  image_center: F_,
  image_change_alt_text: q_,
  image_change_caption: H_,
  image_change_link: V_,
  image_change_mobile_full_width: U_,
  image_error: W_,
  image_in_line: K_,
  image_insert_via_link: Z_,
  image_side: G_,
  image_via_link: J_,
  increase_intent: Y_,
  italic: X_,
  line_height: Q_,
  link: eb,
  orderedList: tb,
  redo: nb,
  special_characters: ib,
  strike: rb,
  substitute_variables: ob,
  substitutions: sb,
  text_align: ab,
  text_level: lb,
  underline: cb,
  undo: ub,
  unset: db
}, V5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: E_,
  background_color: M_,
  bold: $_,
  bulletList: z_,
  caption: A_,
  decrease_intent: L_,
  default: hb,
  default_font_size: N_,
  extra_spacing: D_,
  font_color: R_,
  font_family: I_,
  font_size: P_,
  global: j_,
  image: B_,
  image_center: F_,
  image_change_alt_text: q_,
  image_change_caption: H_,
  image_change_link: V_,
  image_change_mobile_full_width: U_,
  image_error: W_,
  image_in_line: K_,
  image_insert_via_link: Z_,
  image_side: G_,
  image_via_link: J_,
  increase_intent: Y_,
  italic: X_,
  line_height: Q_,
  link: eb,
  orderedList: tb,
  redo: nb,
  special_characters: ib,
  strike: rb,
  substitute_variables: ob,
  substitutions: sb,
  text_align: ab,
  text_level: lb,
  underline: cb,
  undo: ub,
  unset: db
}, Symbol.toStringTag, { value: "Module" })), fb = "Text alternative", pb = "Font background color", mb = "Bold", gb = "Bulleted list", _b = "Caption", bb = "Decrease indent", kb = "Default", yb = "Paragraph spacing", vb = "Font color", xb = { default: "Default", default_hint: "Uses the font set at the place of usage", hint: "Standard font uses email client fonts", mailbox_default: "Mailbox Default", mailbox_default_hint: "Uses the default font of the recipient's mailbox (e.g., Gmail, Outlook, or Yahoo) for optimal readability", title: "Font family" }, Sb = "Font size", wb = { apply: "Apply", clear: "Clear", error: "Error" }, Cb = "Image", Tb = "Centered image", Ob = "Change image text alternative", Eb = "Change image caption", Mb = "Change image link", $b = "Set the image width to the full width of the mobile device", zb = "Failed to process the image", Ab = "In line", Lb = "Insert image via link", Nb = "Side image", Db = "Image via link", Rb = "Increase indent", Ib = "Italic", Pb = "Line hight", jb = "Link", Bb = "Numbered list", Fb = "Redo", qb = { austral: "Austral sign", bitcoin: "Bitcoin sign", cedi: "Cedi sign", cent: "Cent sign", colon: "Colon sign", copyright_sign: "Copyright sign", cruzeiro: "Cruzeiro sign", currency: "Currency sign", dollar: "Dollar sign", dong: "Dong sign", double_dagger: "Double dagger", double_exclamation_mark: "Double exclamation mark", double_low_quotation_mark: "Double low-9 quotation mark", double_question_mark: "Double question mark", drachma: "Drachma sign", euro: "Euro sign", euro_currency: "Euro-currency sign", exclamation_question_mark: "Exclamation question mark", french_franc: "French franc sign", german_penny: "German penny sign", guarani: "Guarani sign", horizontal_ellipsis: "Horizontal ellipsis", hryvnia: "Hryvnia sign", indian_rupee: "Indian rupee sign", inverted_exclamation_mark: "Inverted exclamation mark", inverted_question_mark: "Inverted question mark", kip: "Kip sign", left_double_quotation_mark: "Left double quotation mark", left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark", left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark", left_single_quotation_mark: "Left single quotation mark", lira: "Lira sign", livre_tournois: "Livre tournois sign", manat: "Manat sign", mill: "Mill sign", new_sheqel: "New sheqel sign", nordic_mark: "Nordic mark sign", paragraph_sign: "Paragraph sign", per_mille_sign: "Per mille sign", per_ten_thousand_sign: "Per ten thousand sign", peseta: "Peseta sign", peso: "Peso sign", pound: "Pound sign", question_exclamation_mark: "Question exclamation mark", registered_sign: "Registered sign", reversed_paragraph_sign: "Reversed paragraph sign", right_double_quotation_mark: "Right double quotation mark", right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark", right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark", right_single_quotation_mark: "Right single quotation mark", ruble: "Ruble sign", rupee: "Rupee sign", section_sign: "Section sign", select_all: "All", select_currency: "Currency", select_text: "Text", single_low_quotation_mark: "Single low-9 quotation mark", spesmilo: "Spesmilo sign", tenge: "Tenge sign", title: "Special characters", trade_mark_sign: "Trade mark sign", tugrik: "Tugrik sign", turkish_lira: "Turkish lira sign", two_dot_leader: "Two dot leader", won: "Won sign", yen: "Yen sign" }, Hb = "Strikethrough", Vb = "Substitute variables", Ub = "Substitutions", Wb = "Text alignment", Kb = { header_one: "Header 1", header_three: "Header 3", header_two: "Header 2", paragraph: "Paragraph", title: "Heading" }, Zb = "Underline", Gb = "Undo", Jb = "Unset", Yb = {
  alt_text: fb,
  background_color: pb,
  bold: mb,
  bulletList: gb,
  caption: _b,
  decrease_intent: bb,
  default_font_size: kb,
  extra_spacing: yb,
  font_color: vb,
  font_family: xb,
  font_size: Sb,
  global: wb,
  image: Cb,
  image_center: Tb,
  image_change_alt_text: Ob,
  image_change_caption: Eb,
  image_change_link: Mb,
  image_change_mobile_full_width: $b,
  image_error: zb,
  image_in_line: Ab,
  image_insert_via_link: Lb,
  image_side: Nb,
  image_via_link: Db,
  increase_intent: Rb,
  italic: Ib,
  line_height: Pb,
  link: jb,
  orderedList: Bb,
  redo: Fb,
  special_characters: qb,
  strike: Hb,
  substitute_variables: Vb,
  substitutions: Ub,
  text_align: Wb,
  text_level: Kb,
  underline: Zb,
  undo: Gb,
  unset: Jb
}, U5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: fb,
  background_color: pb,
  bold: mb,
  bulletList: gb,
  caption: _b,
  decrease_intent: bb,
  default: Yb,
  default_font_size: kb,
  extra_spacing: yb,
  font_color: vb,
  font_family: xb,
  font_size: Sb,
  global: wb,
  image: Cb,
  image_center: Tb,
  image_change_alt_text: Ob,
  image_change_caption: Eb,
  image_change_link: Mb,
  image_change_mobile_full_width: $b,
  image_error: zb,
  image_in_line: Ab,
  image_insert_via_link: Lb,
  image_side: Nb,
  image_via_link: Db,
  increase_intent: Rb,
  italic: Ib,
  line_height: Pb,
  link: jb,
  orderedList: Bb,
  redo: Fb,
  special_characters: qb,
  strike: Hb,
  substitute_variables: Vb,
  substitutions: Ub,
  text_align: Wb,
  text_level: Kb,
  underline: Zb,
  undo: Gb,
  unset: Jb
}, Symbol.toStringTag, { value: "Module" })), Xb = "Texto alternativo", Qb = "Color de fondo para la fuente", ek = "Negrilla", tk = "Lista de viñetas", nk = "Texto", ik = "Disminuir sangría", rk = "Estándar", ok = "Espacio entre párrafos", sk = "Color de la fuente", ak = { default: "Estándar", default_hint: "Utiliza la fuente definida en el lugar de uso", hint: "La fuente estándar implementa las fuentes de utiliza el cliente en sus correos", mailbox_default: "Buzón predeterminado", mailbox_default_hint: "Usa la fuente predeterminada del buzón del destinatario (ej, Gmail, Outlook o Yahoo) para una legibilidad óptima", title: "Familia de la fuente" }, lk = "Tamaño de la fuente", ck = { apply: "Aplicar", clear: "Limpiar", error: "Error" }, uk = "Imagen", dk = "Alinear imagen al centro", hk = "Cambiar el texto alternativo de la imagen", fk = "Cambiar el texto de la imagen", pk = "Cambiar el enlace de la imagen", mk = "Establece el ancho de la imagen al ancho completo del dispositivo móvil", gk = "Error al insertar la imagen", _k = "Alinear imagen a la derecha", bk = "Insertar imagen a través de enlace", kk = "Alinear imagen a la izquierda", yk = "Imagen a través de enlace", vk = "Aumentar sangría", xk = "Cursiva", Sk = "Altura de línea", wk = "Enlace", Ck = "Lista numerada", Tk = "Rehacer", Ok = { austral: "Austral", bitcoin: "Bitcoin", cedi: "Cedi", cent: "Centavo", colon: "Colon", copyright_sign: "Derechos reservados", cruzeiro: "Cruzeiro", currency: "Signo monetario", dollar: "Dólar", dong: "Dong", double_dagger: "Daga doble", double_exclamation_mark: "Doble exclamación", double_low_quotation_mark: "comillas dobles", double_question_mark: "Doble interrogante", drachma: "Drachma", euro: "Euro", euro_currency: "Eurodivisa", exclamation_question_mark: "Interrogación exclamativa", french_franc: "Franco francés", german_penny: "Centavo alemán", guarani: "Guarani", horizontal_ellipsis: "puntos suspensivos", hryvnia: "Grivna", indian_rupee: "India rupia", inverted_exclamation_mark: "Exclamación invertida", inverted_question_mark: "Interrogación invertida", kip: "Kip", left_double_quotation_mark: "Doble interrogación izquierda", left_pointing_angle_quotation_mark: "Comilla angular simple izquierda", left_pointing_double_angle_quotation_mark: "Comilla angular doble izquierda", left_single_quotation_mark: "Interrogación izquierda", lira: "Lira turca", livre_tournois: "Librta de tours", manat: "Manat", mill: "Milésima", new_sheqel: "Nuevo séquel", nordic_mark: "Signo nórdico", paragraph_sign: "Párrafo", per_mille_sign: "Por mil", per_ten_thousand_sign: "Por diez mil", peseta: "Mill", peso: "Peso", pound: "Libra esterlina", question_exclamation_mark: "Interrogación exclamativa", registered_sign: "Marca registrada", reversed_paragraph_sign: "Párrafo invertido", right_double_quotation_mark: "Doble interrogación derecha", right_pointing_angle_quotation_mark: "Comilla angular simple derecha", right_pointing_double_angle_quotation_mark: "Comilla angular doble derecha", right_single_quotation_mark: "Interrogación derecha", ruble: "Rublo", rupee: "Rupia", section_sign: "Sección", select_all: "Todo", select_currency: "Monedas", select_text: "Texto", single_low_quotation_mark: "Comillas", spesmilo: "Spesmilo", tenge: "Tenge", title: "Caracteres especiales", trade_mark_sign: "Marca comercial", tugrik: "Tugrik mongól", turkish_lira: "Lira turca", two_dot_leader: "dos puntos", won: "Won", yen: "Yen" }, Ek = "Tachado", Mk = "Variables de sustitución", $k = "Sustituciones", zk = "Alineación del texto", Ak = { header_one: "Encabezado 1", header_three: "Encabezado 3", header_two: "Encabezado 2", paragraph: "Parágrafo", title: "Encabezado" }, Lk = "Subrayado", Nk = "Deshacer", Dk = "Por defecto", Rk = {
  alt_text: Xb,
  background_color: Qb,
  bold: ek,
  bulletList: tk,
  caption: nk,
  decrease_intent: ik,
  default_font_size: rk,
  extra_spacing: ok,
  font_color: sk,
  font_family: ak,
  font_size: lk,
  global: ck,
  image: uk,
  image_center: dk,
  image_change_alt_text: hk,
  image_change_caption: fk,
  image_change_link: pk,
  image_change_mobile_full_width: mk,
  image_error: gk,
  image_in_line: _k,
  image_insert_via_link: bk,
  image_side: kk,
  image_via_link: yk,
  increase_intent: vk,
  italic: xk,
  line_height: Sk,
  link: wk,
  orderedList: Ck,
  redo: Tk,
  special_characters: Ok,
  strike: Ek,
  substitute_variables: Mk,
  substitutions: $k,
  text_align: zk,
  text_level: Ak,
  underline: Lk,
  undo: Nk,
  unset: Dk
}, W5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Xb,
  background_color: Qb,
  bold: ek,
  bulletList: tk,
  caption: nk,
  decrease_intent: ik,
  default: Rk,
  default_font_size: rk,
  extra_spacing: ok,
  font_color: sk,
  font_family: ak,
  font_size: lk,
  global: ck,
  image: uk,
  image_center: dk,
  image_change_alt_text: hk,
  image_change_caption: fk,
  image_change_link: pk,
  image_change_mobile_full_width: mk,
  image_error: gk,
  image_in_line: _k,
  image_insert_via_link: bk,
  image_side: kk,
  image_via_link: yk,
  increase_intent: vk,
  italic: xk,
  line_height: Sk,
  link: wk,
  orderedList: Ck,
  redo: Tk,
  special_characters: Ok,
  strike: Ek,
  substitute_variables: Mk,
  substitutions: $k,
  text_align: zk,
  text_level: Ak,
  underline: Lk,
  undo: Nk,
  unset: Dk
}, Symbol.toStringTag, { value: "Module" })), Ik = "Texte alternatif", Pk = "Couleur de fond de la police", jk = "Gras", Bk = "Liste à puces", Fk = "Légende", qk = "Diminuer le retrait", Hk = "Par défaut", Vk = "Espacement des paragraphes", Uk = "Couleur de la police", Wk = { default: "Par défaut", default_hint: "Utilise la police définie à son emplacement d'utilisation", hint: "La police standard utilise les polices de la plateforme de messagerie du client", mailbox_default: "Boîte de réception par défaut", mailbox_default_hint: "Utilise la police par défaut de la boîte de reception du destinataire (par exemple, Gmail, Outlook ou Yahoo) pour une meilleure lisibilité", title: "Type de police" }, Kk = "Taille de la police", Zk = { apply: "Appliquer", clear: "Effacer", error: "Erreur" }, Gk = "Image", Jk = "Centrer l'image", Yk = "Changer le texte alternatif de l'image", Xk = "Changer la légende de l'image", Qk = "Changer le lien de l'image", ey = "Définissez la largeur de l'image à la largeur complète de l'appareil mobile", ty = "Échec du traitement de l'image", ny = "Aligner l'image à droite", iy = "Insérer une image via un lien", ry = "Aligner l'image à gauche", oy = "Image via un lien", sy = "Augmenter le retrait", ay = "Italique", ly = "Hauteur de ligne", cy = "Lien", uy = "Liste numérotée", dy = "Refaire", hy = { austral: "symbole austral", bitcoin: "Symbole du bitcoin", cedi: "Symbole du Cedi", cent: "Symbole des cents", colon: "Deux-points", copyright_sign: "Symbole de copyright", cruzeiro: "Symbole du Cruzeiro", currency: "Symbole de la monnaie", dollar: "Symbole du dollar", dong: "Symbole du Dong", double_dagger: "Double dagger", double_exclamation_mark: "Double point d'exclamation", double_low_quotation_mark: "Double guillemet bas-9", double_question_mark: "Double point d'interrogation", drachma: "Symbole du drachme", euro: "Symbole de l'euro", euro_currency: "Symbole de la monnaie européenne", exclamation_question_mark: "Point d'interrogation", french_franc: "Symbole du franc français", german_penny: "Symbole du penny allemand", guarani: "Symbole de Guarani", horizontal_ellipsis: "Ellipse horizontale", hryvnia: "Symbole de la Hryvnia", indian_rupee: "Symbole de la roupie indienne", inverted_exclamation_mark: "Point d'exclamation inversé", inverted_question_mark: "Point d'interrogation inversé", kip: "Symbole du Kip", left_double_quotation_mark: "Left double quotation mark", left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark", left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark", left_single_quotation_mark: "Left single quotation mark", lira: "Symbole de la livre", livre_tournois: "Symbole du livre tournois", manat: "Symbole manat", mill: "Symbole du Mill", new_sheqel: "Nouveau symbole du Sheqel", nordic_mark: "Symbole de la marque nordique", paragraph_sign: "Symbole du paragraphe", per_mille_sign: "Symbole pour mille", per_ten_thousand_sign: "Symbole pour dix mille", peseta: "Symbole de la peseta", peso: "Symbole du peso", pound: "Symbole de la livre", question_exclamation_mark: "Question point d'exclamation", registered_sign: "Symbole de marque déposée", reversed_paragraph_sign: "Symbole du paragraphe inversé", right_double_quotation_mark: "Right double quotation mark", right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark", right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark", right_single_quotation_mark: "Right single quotation mark", ruble: "Symbole du rouble", rupee: "Symbole de la roupie", section_sign: "Symbole de section", select_all: "Tous", select_currency: "Monnaie", select_text: "Texte", single_low_quotation_mark: "Single low-9 quotation mark", spesmilo: "Symbole du Spesmilo", tenge: "Symbole du Tenge", title: "Caractères spéciaux", trade_mark_sign: "Symbole de marque commerciale", tugrik: "Symbole de Tugrik", turkish_lira: "Symbole de la livre turque", two_dot_leader: "Two dot leader", won: "Symbole du won", yen: "Symbole du Yen" }, fy = "Barré", py = "Variables de substitution", my = "Substitutions", gy = "Alignement du texte", _y = { header_one: "Titre 1", header_three: "Titre 3", header_two: "Titre 2", paragraph: "Paragraphe", title: "Intitulé" }, by = "Souligné", ky = "Annuler", yy = "Non défini", vy = {
  alt_text: Ik,
  background_color: Pk,
  bold: jk,
  bulletList: Bk,
  caption: Fk,
  decrease_intent: qk,
  default_font_size: Hk,
  extra_spacing: Vk,
  font_color: Uk,
  font_family: Wk,
  font_size: Kk,
  global: Zk,
  image: Gk,
  image_center: Jk,
  image_change_alt_text: Yk,
  image_change_caption: Xk,
  image_change_link: Qk,
  image_change_mobile_full_width: ey,
  image_error: ty,
  image_in_line: ny,
  image_insert_via_link: iy,
  image_side: ry,
  image_via_link: oy,
  increase_intent: sy,
  italic: ay,
  line_height: ly,
  link: cy,
  orderedList: uy,
  redo: dy,
  special_characters: hy,
  strike: fy,
  substitute_variables: py,
  substitutions: my,
  text_align: gy,
  text_level: _y,
  underline: by,
  undo: ky,
  unset: yy
}, K5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Ik,
  background_color: Pk,
  bold: jk,
  bulletList: Bk,
  caption: Fk,
  decrease_intent: qk,
  default: vy,
  default_font_size: Hk,
  extra_spacing: Vk,
  font_color: Uk,
  font_family: Wk,
  font_size: Kk,
  global: Zk,
  image: Gk,
  image_center: Jk,
  image_change_alt_text: Yk,
  image_change_caption: Xk,
  image_change_link: Qk,
  image_change_mobile_full_width: ey,
  image_error: ty,
  image_in_line: ny,
  image_insert_via_link: iy,
  image_side: ry,
  image_via_link: oy,
  increase_intent: sy,
  italic: ay,
  line_height: ly,
  link: cy,
  orderedList: uy,
  redo: dy,
  special_characters: hy,
  strike: fy,
  substitute_variables: py,
  substitutions: my,
  text_align: gy,
  text_level: _y,
  underline: by,
  undo: ky,
  unset: yy
}, Symbol.toStringTag, { value: "Module" })), xy = "टेक्स्ट विकल्प", Sy = "फॉण्ट बैकग्राउंड कलर", wy = "बोल्ड", Cy = "बुलेटेड लिस्ट", Ty = "कैप्शन", Oy = "इंटेंट को घटायें", Ey = "पुनर्निश्चित", My = "पैराग्राफ स्पेसिंग", $y = "फॉण्ट कलर", zy = { default: "पुनर्निश्चित", default_hint: "उपयोग के स्थान पर सेट फ़ॉन्ट का उपयोग करता है", hint: "स्टैण्डर्ड फॉण्ट ईमेल क्लाइंट फॉण्ट का इस्तेमाल करता है", mailbox_default: "मेलबॉक्स डिफ़ॉल्ट", mailbox_default_hint: "प्राप्तकर्ता के मेलबॉक्स (जैसे, जीमेल, आउटलुक या याहू) के डिफॉल्ट फ़ॉन्ट का उपयोग सर्वोत्तम पठनीयता के लिए किया जाता है।", title: "फॉण्ट फॅमिली" }, Ay = "फॉण्ट साइज़", Ly = { apply: "अप्लाई करें", clear: "साफ़ करें", error: "त्रुटि" }, Ny = "इमेज", Dy = "केंद्रित इमेज ", Ry = "इमेज के लिए वैकल्पिक टेक्स्ट बदलें", Iy = "इमेज कैप्शन बदलें", Py = "छवि लिंक बदलें", jy = "मोबाइल डिवाइस की पूरी चौड़ाई पर छवि की चौड़ाई सेट करें।", By = "इमेज को प्रोसेस करने में फेल", Fy = "लाइन में", qy = "लिंक के माध्यम से इमेज डालें", Hy = "साइड इमेज", Vy = "लिंक के माध्यम से छवि", Uy = "इंटेंट को बढ़ाएं", Wy = "इटैलिक", Ky = "रेखा ऊंचाई", Zy = "लिंक", Gy = "नंबर की गयी लिस्ट", Jy = "रीडू", Yy = { austral: "ऑस्ट्रेल चिन्ह", bitcoin: "बिटकॉइन चिन्ह", cedi: "सेडी चिन्ह", cent: "सेंट चिन्ह", colon: "कोलोन चिन्ह", copyright_sign: "कॉपीराइट चिन्ह", cruzeiro: "क्रूज़ेरो चिन्ह", currency: "करेंसी चिन्ह", dollar: "डॉलर चिन्ह", dong: "डाँग चिन्ह", double_dagger: "डबल डैगर", double_exclamation_mark: "डबल एक्सक्लेमेशन मार्क", double_low_quotation_mark: "डबल लो-9 उद्धरण चिन्ह", double_question_mark: "डबल प्रश्नवाचक चिन्ह", drachma: "द्राखमा चिन्ह", euro: "यूरो चिन्ह", euro_currency: "यूरो-करेंसी चिन्ह", exclamation_question_mark: "विस्मयादिबोधक-प्रश्नवाचक चिन्ह", french_franc: "फ्रेंच फ्रैंक चिन्ह", german_penny: "जर्मन पेनी चिन्ह", guarani: "गुआरानी चिन्ह", horizontal_ellipsis: "क्षैतिज एलिप्सिस", hryvnia: "ह्रिव्निया चिन्ह", indian_rupee: "भारतीय रुपया चिन्ह", inverted_exclamation_mark: "उल्टा विस्मयादिबोधक चिन्ह", inverted_question_mark: "उल्टा प्रश्नवाचक चिन्ह", kip: "किप चिन्ह", left_double_quotation_mark: "बाएँ डबल उद्धरण चिन्ह", left_pointing_angle_quotation_mark: "सिंगल बाएँ इंगित करने वाला कोणीय उद्धरण चिन्ह", left_pointing_double_angle_quotation_mark: "बाएँ इंगित करने वाला डबल कोणीय उद्धरण चिन्ह", left_single_quotation_mark: "बाएँ सिंगल उद्धरण चिन्ह", lira: "लीरा चिन्ह", livre_tournois: "लिवर टूरनोइस चिन्ह", manat: "मनत चिन्ह", mill: "मिल चिन्ह", new_sheqel: "नया शेकेल चिन्ह", nordic_mark: "नॉर्डिक मार्क चिन्ह", paragraph_sign: "पैराग्राफ चिन्ह", per_mille_sign: "प्रति हज़ार चिन्ह", per_ten_thousand_sign: "प्रति दस हजार चिन्ह", peseta: "पसेटा चिन्ह", peso: "पेसो चिन्ह", pound: "पाउंड चिन्ह", question_exclamation_mark: "प्रश्नवाचक-विस्मयादिबोधक चिन्ह", registered_sign: "रजिस्टर्ड चिन्ह", reversed_paragraph_sign: "रिवर्स पैराग्राफ चिन्ह", right_double_quotation_mark: "दाएँ डबल उद्धरण चिन्ह", right_pointing_angle_quotation_mark: "सिंगल दाएँ इंगित करने वाला कोणीय उद्धरण चिन्ह", right_pointing_double_angle_quotation_mark: "दाएँ इंगित करने वाला डबल कोणीय उद्धरण चिन्ह", right_single_quotation_mark: "दाएँ सिंगल उद्धरण चिन्ह", ruble: "रूबल चिन्ह", rupee: "रुपया चिन्ह", section_sign: "सेक्शन चिन्ह", select_all: "सभी", select_currency: "करेंसी", select_text: "टेक्स्ट", single_low_quotation_mark: "सिंगल लो-9 उद्धरण चिन्ह", spesmilo: "स्पेस्मिलो चिन्ह", tenge: "तेंगे चिन्ह", title: "विशेष अक्षर", trade_mark_sign: "ट्रेडमार्क चिन्ह", tugrik: "तुगरिक चिन्ह", turkish_lira: "तुर्की लीरा चिन्ह", two_dot_leader: "दो बिंदु लीडर", won: "वॉन चिन्ह", yen: "येन चिन्ह" }, Xy = "स्ट्राइकथ्रू", Qy = "सब्स्टिटूट वेरिएबल्स", e1 = "स्थानापन्न", t1 = "टेक्स्ट एलाइनमेंट", n1 = { header_one: "हेडर १", header_three: "हेडर ३", header_two: "हेडर २", paragraph: "पैराग्राफ", title: "हेडिंग" }, i1 = "अंडरलाइन", r1 = "अनडू", o1 = "असंबद्ध", s1 = {
  alt_text: xy,
  background_color: Sy,
  bold: wy,
  bulletList: Cy,
  caption: Ty,
  decrease_intent: Oy,
  default_font_size: Ey,
  extra_spacing: My,
  font_color: $y,
  font_family: zy,
  font_size: Ay,
  global: Ly,
  image: Ny,
  image_center: Dy,
  image_change_alt_text: Ry,
  image_change_caption: Iy,
  image_change_link: Py,
  image_change_mobile_full_width: jy,
  image_error: By,
  image_in_line: Fy,
  image_insert_via_link: qy,
  image_side: Hy,
  image_via_link: Vy,
  increase_intent: Uy,
  italic: Wy,
  line_height: Ky,
  link: Zy,
  orderedList: Gy,
  redo: Jy,
  special_characters: Yy,
  strike: Xy,
  substitute_variables: Qy,
  substitutions: e1,
  text_align: t1,
  text_level: n1,
  underline: i1,
  undo: r1,
  unset: o1
}, Z5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: xy,
  background_color: Sy,
  bold: wy,
  bulletList: Cy,
  caption: Ty,
  decrease_intent: Oy,
  default: s1,
  default_font_size: Ey,
  extra_spacing: My,
  font_color: $y,
  font_family: zy,
  font_size: Ay,
  global: Ly,
  image: Ny,
  image_center: Dy,
  image_change_alt_text: Ry,
  image_change_caption: Iy,
  image_change_link: Py,
  image_change_mobile_full_width: jy,
  image_error: By,
  image_in_line: Fy,
  image_insert_via_link: qy,
  image_side: Hy,
  image_via_link: Vy,
  increase_intent: Uy,
  italic: Wy,
  line_height: Ky,
  link: Zy,
  orderedList: Gy,
  redo: Jy,
  special_characters: Yy,
  strike: Xy,
  substitute_variables: Qy,
  substitutions: e1,
  text_align: t1,
  text_level: n1,
  underline: i1,
  undo: r1,
  unset: o1
}, Symbol.toStringTag, { value: "Module" })), a1 = "Szöveges alternatíva", l1 = "Betűtípus háttérszíne", c1 = "Félkövér", u1 = "Felsorolás lista", d1 = "Felirat", h1 = "Behúzás csökkentése", f1 = "Alapértelmezett", p1 = "Extra térköz", m1 = "Betűszín", g1 = { default: "Alapértelmezett", default_hint: "A használat helyén beállított betűtípust használja", hint: "A standard betűtípus az e-mail kliens betűtípusait használja", mailbox_default: "Postafiók Alapértelmezett", mailbox_default_hint: "A címzett postafiókjának alapértelmezett betűtípusát használja (pl. Gmail, Outlook vagy Yahoo) a legjobb olvashatóság érdekében", title: "Betűtípus család" }, _1 = "Betűméret", b1 = { apply: "Alkalmaz", clear: "Egyértelmű", error: "Hiba" }, k1 = "Kép", y1 = "Kép középre igazítása", v1 = "Kép alternatív szövegének megváltoztatása", x1 = "Kép feliratának megváltoztatása", S1 = "Kép hivatkozásának megváltoztatása", w1 = "Állítsa be a kép szélességét a mobil eszköz teljes szélességére", C1 = "A kép feldolgozása nem sikerült.", T1 = "Kép jobbra igazítása", O1 = "Kép beillesztése link alapján", E1 = "Kép balra igazítása", M1 = "Kép link alapján", $1 = "Behúzás növelése", z1 = "Dőlt", A1 = "Sor magassága", L1 = "Hivatkozás", N1 = "Számozott lista", D1 = "Újra", R1 = { austral: "Austral jel", bitcoin: "Bitcoin jel", cedi: "Cedi jel", cent: "Cent jel", colon: "Kettőspont jel", copyright_sign: "szerzői jog jel", cruzeiro: "Cruzeiro jel", currency: "Valuta jel", dollar: "Dollár jel", dong: "Dong jel", double_dagger: "dupla kereszt", double_exclamation_mark: "Kettős felkiáltójel", double_low_quotation_mark: "dupla alacsony 9-es idézőjel", double_question_mark: "dupla kérdőjel", drachma: "Drachma jel", euro: "Euró jel", euro_currency: "Euró valuta jel", exclamation_question_mark: "felkiáltó kérdőjel", french_franc: "Francia frank jel", german_penny: "Német penny jel", guarani: "Guarani jel", horizontal_ellipsis: "horizontális ellipszis", hryvnia: "Hrivnya jel", indian_rupee: "indiai rúpiás jel", inverted_exclamation_mark: "fordított felkiáltójel", inverted_question_mark: "fordított kérdőjel", kip: "Kip jel", left_double_quotation_mark: "baloldali dupla idézőjel", left_pointing_angle_quotation_mark: "balra mutató egyes idézőjel", left_pointing_double_angle_quotation_mark: "balra mutató dupla idézőjel", left_single_quotation_mark: "baloldali egyes idézőjel", lira: "Lira jel", livre_tournois: "Livre tournois jel", manat: "Manat jel", mill: "Mill jel", new_sheqel: "Új sékel jel", nordic_mark: "északi márka jel", paragraph_sign: "bekezdés jel", per_mille_sign: "ezrelék jel", per_ten_thousand_sign: "tízezer jel", peseta: "Peseta jel", peso: "Peso jel", pound: "Font jel", question_exclamation_mark: "kérdő felkiáltójel", registered_sign: "bejegyzett jel", reversed_paragraph_sign: "fordított bekezdés jel", right_double_quotation_mark: "jobboldali dupla idézőjel", right_pointing_angle_quotation_mark: "jobbra mutató egyes idézőjel", right_pointing_double_angle_quotation_mark: "jobbra mutató dupla idézőjel", right_single_quotation_mark: "jobboldali egyes idézőjel", ruble: "rubel jel", rupee: "Rúpia jel", section_sign: "szakasz jel", select_all: "Minden", select_currency: "Pénznem", select_text: "Szöveg", single_low_quotation_mark: "alacsony 9-es idézőjel", spesmilo: "Spesmilo jel", tenge: "Tenge jel", title: "Speciális karakterek", trade_mark_sign: "védjegy jel", tugrik: "Tugrik jel", turkish_lira: "török líra jel", two_dot_leader: "két pont vezető", won: "Won jel", yen: "Jen jel" }, I1 = "Áthúzott", P1 = "Helyettesítő változók", j1 = "Helyettesítések", B1 = "Szöveg igazítása", F1 = { header_one: "Fejléc 1", header_three: "Fejléc 3", header_two: "Fejléc 2", paragraph: "Bekezdés", title: "Cím" }, q1 = "Aláhúzott", H1 = "Visszavonás", V1 = "Alaphelyzetbe állítva", U1 = {
  alt_text: a1,
  background_color: l1,
  bold: c1,
  bulletList: u1,
  caption: d1,
  decrease_intent: h1,
  default_font_size: f1,
  extra_spacing: p1,
  font_color: m1,
  font_family: g1,
  font_size: _1,
  global: b1,
  image: k1,
  image_center: y1,
  image_change_alt_text: v1,
  image_change_caption: x1,
  image_change_link: S1,
  image_change_mobile_full_width: w1,
  image_error: C1,
  image_in_line: T1,
  image_insert_via_link: O1,
  image_side: E1,
  image_via_link: M1,
  increase_intent: $1,
  italic: z1,
  line_height: A1,
  link: L1,
  orderedList: N1,
  redo: D1,
  special_characters: R1,
  strike: I1,
  substitute_variables: P1,
  substitutions: j1,
  text_align: B1,
  text_level: F1,
  underline: q1,
  undo: H1,
  unset: V1
}, G5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: a1,
  background_color: l1,
  bold: c1,
  bulletList: u1,
  caption: d1,
  decrease_intent: h1,
  default: U1,
  default_font_size: f1,
  extra_spacing: p1,
  font_color: m1,
  font_family: g1,
  font_size: _1,
  global: b1,
  image: k1,
  image_center: y1,
  image_change_alt_text: v1,
  image_change_caption: x1,
  image_change_link: S1,
  image_change_mobile_full_width: w1,
  image_error: C1,
  image_in_line: T1,
  image_insert_via_link: O1,
  image_side: E1,
  image_via_link: M1,
  increase_intent: $1,
  italic: z1,
  line_height: A1,
  link: L1,
  orderedList: N1,
  redo: D1,
  special_characters: R1,
  strike: I1,
  substitute_variables: P1,
  substitutions: j1,
  text_align: B1,
  text_level: F1,
  underline: q1,
  undo: H1,
  unset: V1
}, Symbol.toStringTag, { value: "Module" })), W1 = "Alternatif teks", K1 = "Warna latar belakang font", Z1 = "Tebal", G1 = "Daftar berpoin", J1 = "Keterangan", Y1 = "Kurangi indentasi", X1 = "Default", Q1 = "Jarak ekstra", e0 = "Warna font", t0 = { default: "Default", default_hint: "Menggunakan font yang diatur di tempat penggunaannya", hint: "Font standar menggunakan font klien email", mailbox_default: "Kotak surat Bawaan", mailbox_default_hint: "Menggunakan font default dari kotak surat penerima (misalnya, Gmail, Outlook, atau Yahoo) untuk keterbacaan optimal", title: "Keluarga font" }, n0 = "Ukuran font", i0 = { apply: "Menerapkan", clear: "Jernih", error: "Kesalahan" }, r0 = "Gambar", o0 = "Gambar rata tengah", s0 = "Ubah teks alternatif gambar", a0 = "Ubah keterangan gambar", l0 = "Ubah tautan gambar", c0 = "Atur lebar gambar agar sesuai dengan lebar penuh perangkat seluler", u0 = "Gagal memproses gambar", d0 = "Gambar rata kanan", h0 = "Sisipkan gambar melalui tautan", f0 = "Gambar rata kiri", p0 = "Gambar melalui tautan", m0 = "Tingkatkan indentasi", g0 = "Miring", _0 = "Tinggi garis", b0 = "Tautan", k0 = "Daftar bernomor", y0 = "Ulangi", v0 = { austral: "Tanda austral", bitcoin: "Tanda Bitcoin", cedi: "Tanda cedi", cent: "Tanda sen", colon: "Tanda titik dua", copyright_sign: "Tanda hak cipta", cruzeiro: "Tanda cruzeiro", currency: "Tanda mata uang", dollar: "Tanda dolar", dong: "Tanda dong", double_dagger: "Dagger ganda", double_exclamation_mark: "Tanda seru ganda", double_low_quotation_mark: "Tanda kutip rendah ganda 9", double_question_mark: "Tanda tanya ganda", drachma: "Tanda drachma", euro: "Tanda euro", euro_currency: "Tanda mata uang euro", exclamation_question_mark: "Tanda seru tanya", french_franc: "Tanda franc Prancis", german_penny: "Tanda penny Jerman", guarani: "Tanda guarani", horizontal_ellipsis: "Elipsis horizontal", hryvnia: "Tanda hryvnia", indian_rupee: "Tanda rupee India", inverted_exclamation_mark: "Tanda seru terbalik", inverted_question_mark: "Tanda tanya terbalik", kip: "Tanda kip", left_double_quotation_mark: "Tanda kutip ganda kiri", left_pointing_angle_quotation_mark: "Tanda kutip sudut kiri tunggal", left_pointing_double_angle_quotation_mark: "Tanda kutip sudut ganda kiri", left_single_quotation_mark: "Tanda kutip tunggal kiri", lira: "Tanda lira", livre_tournois: "Tanda livre tournois", manat: "Tanda manat", mill: "Tanda mil", new_sheqel: "Tanda shekel baru", nordic_mark: "Tanda mark Nordik", paragraph_sign: "Tanda paragraf", per_mille_sign: "Tanda per mille", per_ten_thousand_sign: "Tanda per sepuluh ribu", peseta: "Tanda peseta", peso: "Tanda peso", pound: "Tanda pound", question_exclamation_mark: "Tanda tanya seru", registered_sign: "Tanda terdaftar", reversed_paragraph_sign: "Tanda paragraf terbalik", right_double_quotation_mark: "Tanda kutip ganda kanan", right_pointing_angle_quotation_mark: "Tanda kutip sudut kanan tunggal", right_pointing_double_angle_quotation_mark: "Tanda kutip sudut ganda kanan", right_single_quotation_mark: "Tanda kutip tunggal kanan", ruble: "Tanda rubel", rupee: "Tanda rupee", section_sign: "Tanda bagian", select_all: "Semua", select_currency: "Mata uang", select_text: "Teks", single_low_quotation_mark: "Tanda kutip rendah tunggal 9", spesmilo: "Tanda spesmilo", tenge: "Tanda tenge", title: "Karakter khusus", trade_mark_sign: "Tanda merek dagang", tugrik: "Tanda tugrik", turkish_lira: "Tanda lira Turki", two_dot_leader: "Pemimpin dua titik", won: "Tanda won", yen: "Tanda yen" }, x0 = "Garis tengah", S0 = "Variabel pengganti", w0 = "Substitusi", C0 = "Penyelarasan teks", T0 = { header_one: "Header 1", header_three: "Header 3", header_two: "Header 2", paragraph: "Paragraf", title: "Judul" }, O0 = "Garis bawah", E0 = "Batalkan", M0 = "Tidak diatur", $0 = {
  alt_text: W1,
  background_color: K1,
  bold: Z1,
  bulletList: G1,
  caption: J1,
  decrease_intent: Y1,
  default_font_size: X1,
  extra_spacing: Q1,
  font_color: e0,
  font_family: t0,
  font_size: n0,
  global: i0,
  image: r0,
  image_center: o0,
  image_change_alt_text: s0,
  image_change_caption: a0,
  image_change_link: l0,
  image_change_mobile_full_width: c0,
  image_error: u0,
  image_in_line: d0,
  image_insert_via_link: h0,
  image_side: f0,
  image_via_link: p0,
  increase_intent: m0,
  italic: g0,
  line_height: _0,
  link: b0,
  orderedList: k0,
  redo: y0,
  special_characters: v0,
  strike: x0,
  substitute_variables: S0,
  substitutions: w0,
  text_align: C0,
  text_level: T0,
  underline: O0,
  undo: E0,
  unset: M0
}, J5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: W1,
  background_color: K1,
  bold: Z1,
  bulletList: G1,
  caption: J1,
  decrease_intent: Y1,
  default: $0,
  default_font_size: X1,
  extra_spacing: Q1,
  font_color: e0,
  font_family: t0,
  font_size: n0,
  global: i0,
  image: r0,
  image_center: o0,
  image_change_alt_text: s0,
  image_change_caption: a0,
  image_change_link: l0,
  image_change_mobile_full_width: c0,
  image_error: u0,
  image_in_line: d0,
  image_insert_via_link: h0,
  image_side: f0,
  image_via_link: p0,
  increase_intent: m0,
  italic: g0,
  line_height: _0,
  link: b0,
  orderedList: k0,
  redo: y0,
  special_characters: v0,
  strike: x0,
  substitute_variables: S0,
  substitutions: w0,
  text_align: C0,
  text_level: T0,
  underline: O0,
  undo: E0,
  unset: M0
}, Symbol.toStringTag, { value: "Module" })), z0 = "Alternativa di testo", A0 = "Colore di sfondo del carattere", L0 = "Grassetto", N0 = "Elenco puntato", D0 = "Didascalia", R0 = "Diminuire l'intento", I0 = "predefinito", P0 = "Spaziatura tra paragrafi", j0 = "Colori dei font", B0 = { default: "predefinito", default_hint: "Utilizza il carattere che è stato impostato nel luogo di utilizzo", hint: "Il font predefinito utilizza i font per il client di posta elettronica", mailbox_default: "Casella di posta predefinita", mailbox_default_hint: "Viene utilizzato il carattere predefinito della casella di posta del destinatario (ad esempio Gmail, Outlook o Yahoo) per una leggibilità ottimale", title: "Famiglia caratteri" }, F0 = "Dimensione carattere", q0 = { apply: "Applica", clear: "Cancella", error: "Errore" }, H0 = "Immagine", V0 = "Allineamento dell'immagine al centro", U0 = "Cambia il testo alternativo dell'immagine", W0 = "Cambia la didascalia dell'immagine", K0 = "Cambia il link dell'immagine", Z0 = "Imposta la larghezza dell'immagine alla larghezza completa del dispositivo mobile", G0 = "Impossibile elaborare l'immagine", J0 = "Allineamento dell'immagine a destra", Y0 = "Inserisci immagine tramite link", X0 = "Allineamento dell'immagine a sinistra", Q0 = "Immagine tramite link", ev = "Aumentare l'intento", tv = "Corsivo", nv = "Altezza della linea", iv = "Collegamento", rv = "Elenco numerato", ov = "Ripetere", sv = { austral: "Simbolo dell'austral", bitcoin: "Simbolo del bitcoin", cedi: "Simbolo del Cedi", cent: "Simbolo del centesimo", colon: "Simbolo del colòn", copyright_sign: "Segno di copyright", cruzeiro: "Simbolo del cruzeiro", currency: "Simbolo della valuta", dollar: "Simbolo del dollaro", dong: "Simbolo del dong", double_dagger: "Doppio pugnale", double_exclamation_mark: "Doppio punto esclamativo", double_low_quotation_mark: "Doppie virgolette basse 9", double_question_mark: "Doppio punto interrogativo", drachma: "Simbolo della dracma", euro: "Simbolo dell'euro", euro_currency: "Simbolo della valuta in euro", exclamation_question_mark: "Punto interrogativo esclamativo", french_franc: "Simbolo del franco francese", german_penny: "Simbolo del centesimo tedesco", guarani: "Simbolo del Guarani", horizontal_ellipsis: "Ellissi orizzontale", hryvnia: "Simbolo della hryvnia", indian_rupee: "Simbolo della rupia indiana", inverted_exclamation_mark: "Punto esclamativo rovesciato", inverted_question_mark: "Punto interrogativo rovesciato", kip: "Simbolo del kip", left_double_quotation_mark: "Virgolette doppie a sinistra", left_pointing_angle_quotation_mark: "Virgolette angolari singole a sinistra", left_pointing_double_angle_quotation_mark: "Virgolette doppie angolari a sinistra", left_single_quotation_mark: "Virgolette singole a sinistra", lira: "Simbolo della lira", livre_tournois: "Simbolo del livre tournois", manat: "Segno Manat", mill: "Simbolo del mill", new_sheqel: "Nuovo Simbolo sheqel", nordic_mark: "Simbolo del marco nordico", paragraph_sign: "Segno del paragrafo", per_mille_sign: "Segno per mille", per_ten_thousand_sign: "Per ogni diecimila segni", peseta: "Simbolo della peseta", peso: "Simbolo del peso", pound: "Simbolo della sterlina", question_exclamation_mark: "Domanda punto esclamativo", registered_sign: "Segno registrato", reversed_paragraph_sign: "Segno di paragrafo invertito", right_double_quotation_mark: "Virgolette doppie a destra", right_pointing_angle_quotation_mark: "Virgoletta angolare singola rivolta a destra", right_pointing_double_angle_quotation_mark: "Virgolette doppie angolari con punta a destra", right_single_quotation_mark: "Virgolette singole a destra", ruble: "Simbolo del rublo", rupee: "Simbolo della rupia", section_sign: "Segno della sezione", select_all: "Tutto", select_currency: "Valuta", select_text: "Testo", single_low_quotation_mark: "Singola virgoletta bassa-9", spesmilo: "Simbolo dello spesmilo", tenge: "Simbolo del tenge", title: "Caratteri speciali", trade_mark_sign: "Segno del marchio", tugrik: "Simbolo del tugrik", turkish_lira: "Simbolo della lira turca", two_dot_leader: "Leader a due punti", won: "Simbolo del won", yen: "Simbolo dello yen" }, av = "Barrato", lv = "Variabili", cv = "Sostituzioni", uv = "Allineamento del testo", dv = { header_one: "Intestazione 1", header_three: "Intestazione 3", header_two: "Intestazione 2", paragraph: "Paragrafo", title: "Intestazione" }, hv = "Sottolineato", fv = "Annullare", pv = "Non impostato", mv = {
  alt_text: z0,
  background_color: A0,
  bold: L0,
  bulletList: N0,
  caption: D0,
  decrease_intent: R0,
  default_font_size: I0,
  extra_spacing: P0,
  font_color: j0,
  font_family: B0,
  font_size: F0,
  global: q0,
  image: H0,
  image_center: V0,
  image_change_alt_text: U0,
  image_change_caption: W0,
  image_change_link: K0,
  image_change_mobile_full_width: Z0,
  image_error: G0,
  image_in_line: J0,
  image_insert_via_link: Y0,
  image_side: X0,
  image_via_link: Q0,
  increase_intent: ev,
  italic: tv,
  line_height: nv,
  link: iv,
  orderedList: rv,
  redo: ov,
  special_characters: sv,
  strike: av,
  substitute_variables: lv,
  substitutions: cv,
  text_align: uv,
  text_level: dv,
  underline: hv,
  undo: fv,
  unset: pv
}, Y5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: z0,
  background_color: A0,
  bold: L0,
  bulletList: N0,
  caption: D0,
  decrease_intent: R0,
  default: mv,
  default_font_size: I0,
  extra_spacing: P0,
  font_color: j0,
  font_family: B0,
  font_size: F0,
  global: q0,
  image: H0,
  image_center: V0,
  image_change_alt_text: U0,
  image_change_caption: W0,
  image_change_link: K0,
  image_change_mobile_full_width: Z0,
  image_error: G0,
  image_in_line: J0,
  image_insert_via_link: Y0,
  image_side: X0,
  image_via_link: Q0,
  increase_intent: ev,
  italic: tv,
  line_height: nv,
  link: iv,
  orderedList: rv,
  redo: ov,
  special_characters: sv,
  strike: av,
  substitute_variables: lv,
  substitutions: cv,
  text_align: uv,
  text_level: dv,
  underline: hv,
  undo: fv,
  unset: pv
}, Symbol.toStringTag, { value: "Module" })), gv = "テキストの代替", _v = "フォント背景色", bv = "太字", kv = "箇条書き", yv = "キャプション", vv = "字下げ", xv = "デフォルト", Sv = "段落の余白", wv = "フォントの色", Cv = { default: "デフォルト", default_hint: "使用箇所で設定されているフォントを使用します", hint: "標準フォントはメールクライアントのフォントを使用しています。", mailbox_default: "メールボックスのデフォルトフォント", mailbox_default_hint: "受信者のメールボックスのデフォルトフォント（例：Gmail、Outlook、Yahoo）を使用して最適な読みやすさを実現します", title: "フォントファミリー" }, Tv = "フォントサイズ", Ov = { apply: "適用する", clear: "クリア", error: "エラー" }, Ev = "画像", Mv = "画像を中央に配置", $v = "画像の代替テキストを変更", zv = "画像のキャプションを変更", Av = "画像のリンクを変更", Lv = "画像の幅をモバイルデバイスの全幅に設定します", Nv = "画像の処理に失敗しました", Dv = "画像を右に配置", Rv = "リンクから画像を挿入", Iv = "画像を左に配置", Pv = "外部リンク画像", jv = "字上げ", Bv = "斜体", Fv = "行の高さ", qv = "リンク", Hv = "番号付きリスト", Vv = "やり直す", Uv = { austral: "南半球記号", bitcoin: "ビットコイン記号", cedi: "セディ記号", cent: "セント記号", colon: "コロン記号", copyright_sign: "著作権記号", cruzeiro: "クルゼイロ記号", currency: "通貨記号", dollar: "ドル記号", dong: "ドン記号", double_dagger: "二重ダガー", double_exclamation_mark: "二重ビックリマーク", double_low_quotation_mark: "二重低9引用符", double_question_mark: "二重クエスチョンマーク", drachma: "ドラクマ記号", euro: "ユーロ記号", euro_currency: "ユーロ通貨記号", exclamation_question_mark: "ビックリクエスチョンマーク", french_franc: "フランスフラン記号", german_penny: "ドイツペニー記号", guarani: "グアラニ記号", horizontal_ellipsis: "水平省略記号", hryvnia: "グリブナ記号", indian_rupee: "インドルピー記号", inverted_exclamation_mark: "逆向きビックリマーク", inverted_question_mark: "反転クエスチョンマーク", kip: "キップ記号", left_double_quotation_mark: "左二重引用符", left_pointing_angle_quotation_mark: "左向きシングル引用符", left_pointing_double_angle_quotation_mark: "左向き二重引用符", left_single_quotation_mark: "左シングル引用符", lira: "リラ記号", livre_tournois: "リブレトゥルノワ記号", manat: "マネーのサイン", mill: "ミル記号", new_sheqel: "新シェケル記号", nordic_mark: "北欧マーク記号", paragraph_sign: "段落記号", per_mille_sign: "1000分記号", per_ten_thousand_sign: "1万ごと記号", peseta: "ペセタ記号", peso: "ペソ記号", pound: "ポンド記号", question_exclamation_mark: "クエスチョンビックリマーク", registered_sign: "登録記号", reversed_paragraph_sign: "段落記号の反転", right_double_quotation_mark: "右二重引用符", right_pointing_angle_quotation_mark: "右向きシングル引用符", right_pointing_double_angle_quotation_mark: "右向き二重引用符", right_single_quotation_mark: "右シングル引用符", ruble: "ルーブル記号", rupee: "ルピー記号", section_sign: "区切り記号", select_all: "全て", select_currency: "通過", select_text: "テキスト", single_low_quotation_mark: "シングル低9引用符", spesmilo: "スペすミーロ記号", tenge: "テンゲ記号", title: "特殊文字", trade_mark_sign: "商標記号", tugrik: "トゥグリク記号", turkish_lira: "トルコリラ記号", two_dot_leader: "2ドットリーダー", won: "元記号", yen: "円記号" }, Wv = "取消線", Kv = "代用変数", Zv = "差し込み項目", Gv = "テキストの配置", Jv = { header_one: "見出し１", header_three: "見出し３", header_two: "見出し２", paragraph: "段落", title: "見出し" }, Yv = "下線", Xv = "元に戻す", Qv = "未設定", ex = {
  alt_text: gv,
  background_color: _v,
  bold: bv,
  bulletList: kv,
  caption: yv,
  decrease_intent: vv,
  default_font_size: xv,
  extra_spacing: Sv,
  font_color: wv,
  font_family: Cv,
  font_size: Tv,
  global: Ov,
  image: Ev,
  image_center: Mv,
  image_change_alt_text: $v,
  image_change_caption: zv,
  image_change_link: Av,
  image_change_mobile_full_width: Lv,
  image_error: Nv,
  image_in_line: Dv,
  image_insert_via_link: Rv,
  image_side: Iv,
  image_via_link: Pv,
  increase_intent: jv,
  italic: Bv,
  line_height: Fv,
  link: qv,
  orderedList: Hv,
  redo: Vv,
  special_characters: Uv,
  strike: Wv,
  substitute_variables: Kv,
  substitutions: Zv,
  text_align: Gv,
  text_level: Jv,
  underline: Yv,
  undo: Xv,
  unset: Qv
}, X5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: gv,
  background_color: _v,
  bold: bv,
  bulletList: kv,
  caption: yv,
  decrease_intent: vv,
  default: ex,
  default_font_size: xv,
  extra_spacing: Sv,
  font_color: wv,
  font_family: Cv,
  font_size: Tv,
  global: Ov,
  image: Ev,
  image_center: Mv,
  image_change_alt_text: $v,
  image_change_caption: zv,
  image_change_link: Av,
  image_change_mobile_full_width: Lv,
  image_error: Nv,
  image_in_line: Dv,
  image_insert_via_link: Rv,
  image_side: Iv,
  image_via_link: Pv,
  increase_intent: jv,
  italic: Bv,
  line_height: Fv,
  link: qv,
  orderedList: Hv,
  redo: Vv,
  special_characters: Uv,
  strike: Wv,
  substitute_variables: Kv,
  substitutions: Zv,
  text_align: Gv,
  text_level: Jv,
  underline: Yv,
  undo: Xv,
  unset: Qv
}, Symbol.toStringTag, { value: "Module" })), tx = "Alternatieve tekst", nx = "Achtergrondkleur tekst", ix = "Vet", rx = "Opsomminglijst", ox = "Bijschrift", sx = "Invoering verkleinen", ax = "Standaard", lx = "Alinea-afstand", cx = "Letterkleur", ux = { default: "Standaard", default_hint: "Gebruikt het lettertype dat op de gebruiksplek is ingesteld", hint: "Standaardlettertype gebruikt de lettertypes van de e-mailclient", mailbox_default: "Standaard mailbox", mailbox_default_hint: "Gebruikt het standaardlettertype van de mailbox van de ontvanger (bijvoorbeeld Gmail, Outlook of Yahoo) voor optimale leesbaarheid", title: "Lettertype" }, dx = "Lettergrootte", hx = { apply: "Toepassen", clear: "Wissen", error: "Fout" }, fx = "Afbeelding", px = "Afbeelding centreren", mx = "Wijzig alternatieve tekst voor afbeelding", gx = "Wijzig bijschrift van afbeelding", _x = "Wijzig afbeeldingslink", bx = "Stel de breedte van de afbeelding in op de volledige breedte van het mobiele apparaat", kx = "Afbeelding kon niet worden verwerkt", yx = "Afbeelding rechts uitlijnen", vx = "Afbeelding invoegen via link", xx = "Afbeelding links uitlijnen", Sx = "Afbeelding via link", wx = "Invoering vergroten", Cx = "Cursief", Tx = "Lijnhoogte", Ox = "Link", Ex = "Genummerde lijst", Mx = "Opnieuw uitvoeren", $x = { austral: "Austral-teken", bitcoin: "Bitcoin-teken", cedi: "Cedi-teken", cent: "Cent-teken", colon: "Colón-teken", copyright_sign: "Auteursrecht-teken", cruzeiro: "Cruzeiro-teken", currency: "Valutateken", dollar: "Dollar-teken", dong: "Dong-teken", double_dagger: "Dubbele kruis", double_exclamation_mark: "Alinea-teken", double_low_quotation_mark: "Dubbele lage-9 aanhalingstekens", double_question_mark: "Dubbele vraagteken", drachma: "Drachme-teken", euro: "Euro-teken", euro_currency: "Euro-teken", exclamation_question_mark: "Uitroepvraagteken", french_franc: "Frank-teken", german_penny: "Duitse cent-teken", guarani: "Guarani-teken", horizontal_ellipsis: "Horizontale ellips", hryvnia: "Hryvnia-teken", indian_rupee: "Indiase roepie-teken", inverted_exclamation_mark: "Omgekeerd uitroepteken", inverted_question_mark: "Omgekeerd vraagteken", kip: "Kip-teken", left_double_quotation_mark: "Linkermatig dubbel aanhalingsteken", left_pointing_angle_quotation_mark: "Enkele linkswijzende hoekaanhalingsteken", left_pointing_double_angle_quotation_mark: "Linksdraaiend dubbel hoek-aanhalingsteken", left_single_quotation_mark: "Linkermatig enkel aanhalingsteken", lira: "Lira-teken", livre_tournois: "Livre tournois-teken", manat: "Alinea-teken", mill: "Mill-teken", new_sheqel: "Nieuwe sjekel-teken", nordic_mark: "Noordse markteken", paragraph_sign: "Alinea-teken", per_mille_sign: "Per duizend", per_ten_thousand_sign: "Per tienduizend-teken", peseta: "Peseta-teken", peso: "Peso-teken", pound: "Pond-teken", question_exclamation_mark: "Uitroepvraagteken", registered_sign: "Geregistreerd merk-teken", reversed_paragraph_sign: "Omgekeerd alinea-teken", right_double_quotation_mark: "Rechtermatig dubbel aanhalingsteken", right_pointing_angle_quotation_mark: "Enkel rechtsdraaiend hoek-aanhalingsteken", right_pointing_double_angle_quotation_mark: "Rechtdraaiend dubbel hoek-aanhalingsteken", right_single_quotation_mark: "Rechtermatig enkele aanhalingsteken", ruble: "Roebel-teken", rupee: "Roepie-teken", section_sign: "Sectie-teken", select_all: "Alles", select_currency: "Valuta", select_text: "Tekst", single_low_quotation_mark: "Enkele lage-9 aanhalingsteken", spesmilo: "Spesmilo-teken", tenge: "Tenge-teken", title: "Speciale tekens", trade_mark_sign: "Merkteken", tugrik: "Tugrik-teken", turkish_lira: "Turkse lira-teken", two_dot_leader: "twee-punt-leider", won: "Zuid-Koreaanse won-teken", yen: "Yen-teken" }, zx = "Doorstrepen", Ax = "Vervangende variabelen", Lx = "Vervangingen", Nx = "Tekstuitlijning", Dx = { header_one: "Kop 1", header_three: "Kop 3", header_two: "Kop 2", paragraph: "Paragraaf", title: "Koptekst" }, Rx = "Onderstrepen", Ix = "Ongedaan maken", Px = "Niet ingesteld", jx = {
  alt_text: tx,
  background_color: nx,
  bold: ix,
  bulletList: rx,
  caption: ox,
  decrease_intent: sx,
  default_font_size: ax,
  extra_spacing: lx,
  font_color: cx,
  font_family: ux,
  font_size: dx,
  global: hx,
  image: fx,
  image_center: px,
  image_change_alt_text: mx,
  image_change_caption: gx,
  image_change_link: _x,
  image_change_mobile_full_width: bx,
  image_error: kx,
  image_in_line: yx,
  image_insert_via_link: vx,
  image_side: xx,
  image_via_link: Sx,
  increase_intent: wx,
  italic: Cx,
  line_height: Tx,
  link: Ox,
  orderedList: Ex,
  redo: Mx,
  special_characters: $x,
  strike: zx,
  substitute_variables: Ax,
  substitutions: Lx,
  text_align: Nx,
  text_level: Dx,
  underline: Rx,
  undo: Ix,
  unset: Px
}, Q5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: tx,
  background_color: nx,
  bold: ix,
  bulletList: rx,
  caption: ox,
  decrease_intent: sx,
  default: jx,
  default_font_size: ax,
  extra_spacing: lx,
  font_color: cx,
  font_family: ux,
  font_size: dx,
  global: hx,
  image: fx,
  image_center: px,
  image_change_alt_text: mx,
  image_change_caption: gx,
  image_change_link: _x,
  image_change_mobile_full_width: bx,
  image_error: kx,
  image_in_line: yx,
  image_insert_via_link: vx,
  image_side: xx,
  image_via_link: Sx,
  increase_intent: wx,
  italic: Cx,
  line_height: Tx,
  link: Ox,
  orderedList: Ex,
  redo: Mx,
  special_characters: $x,
  strike: zx,
  substitute_variables: Ax,
  substitutions: Lx,
  text_align: Nx,
  text_level: Dx,
  underline: Rx,
  undo: Ix,
  unset: Px
}, Symbol.toStringTag, { value: "Module" })), Bx = "Tekstalternativ", Fx = "Bakgrunnsfarge på skrifttype", qx = "Fet", Hx = "Punktliste", Vx = "Bildetekst", Ux = "Reduser innrykk", Wx = "Standard", Kx = "Ekstra mellomrom", Zx = "Skriftfarge", Gx = { default: "Standard", default_hint: "Bruker fonten som er satt på stedet for bruk", hint: "Standard skrifttype bruker e-postklientens skrifttyper", mailbox_default: "Standard postkasse", mailbox_default_hint: "Bruker standardfonten til mottakerens postkasse (f.eks. Gmail, Outlook eller Yahoo) for best lesbarhet", title: "Skrifttypefamilie" }, Jx = "Skriftstørrelse", Yx = { apply: "Søke om", clear: "Klar", error: "Feil" }, Xx = "Bilde", Qx = "Bilde juster senter", eS = "Endre bilde tekstalternativ", tS = "Endre bilde bildetekst", nS = "Endre bilde lenke", iS = "Still inn bildets bredde til full bredde på mobilenheten", rS = "Kunne ikke behandle bildet", oS = "Bilde juster høyre", sS = "Sett inn bilde via lenke", aS = "Bilde juster venstre", lS = "Bilde via lenke", cS = "Øk innrykk", uS = "Kursiv", dS = "Linjehøyde", hS = "Lenke", fS = "Nummerert liste", pS = "Gjør om", mS = { austral: "Australsymbol", bitcoin: "Bitcoin-symbol", cedi: "Cedisymbol", cent: "Cent tegn", colon: "Kolon tegn", copyright_sign: "Opphavsrett-tegn", cruzeiro: "Cruzeiro tegn", currency: "Valutasymbol", dollar: "Dollar tegn", dong: "Dong-symbol", double_dagger: "Dobbel dolk", double_exclamation_mark: "Dobbelt utropstegn", double_low_quotation_mark: "Dobbel lav-9 anførselstegn", double_question_mark: "Dobbel spørsmålstegn", drachma: "Drachmasymbol", euro: "Euro tegn", euro_currency: "Euro-valuta tegn", exclamation_question_mark: "Utrop spørsmålstegn", french_franc: "Fransk franc tegn", german_penny: "Tysk penny-symbol", guarani: "Guaranisymbol", horizontal_ellipsis: "Horisonalt ellipsis", hryvnia: "Hryvnia-symbol", indian_rupee: "Indisk rupiesymbol", inverted_exclamation_mark: "Invertert utropstegn", inverted_question_mark: "Invertert spørsmålstegn", kip: "Kipsymbol", left_double_quotation_mark: "Venstre dobbel anførselstegn", left_pointing_angle_quotation_mark: "Enkel venstre-pil vinkelsitattegn", left_pointing_double_angle_quotation_mark: "Venstre dobbeltvinkel sitattegn", left_single_quotation_mark: "Venstre enkel sitattegn", lira: "Lira tegn", livre_tournois: "Livre tournois-symbol", manat: "Manat-tegn", mill: "Millsymbol", new_sheqel: "Ny shekel-symbol", nordic_mark: "Nordisk mark-symbol", paragraph_sign: "Avsnitt-tegn", per_mille_sign: "Per mille-tegn", per_ten_thousand_sign: "Per ti tusen-tegn", peseta: "Pesetasymbol", peso: "Pesosymbol", pound: "Pund tegn", question_exclamation_mark: "Spørsmål utropstegn", registered_sign: "Registrert tegn", reversed_paragraph_sign: "Reversert avsnitt-tegn", right_double_quotation_mark: "Høyre dobbel anførselstegn", right_pointing_angle_quotation_mark: "Enkel høyre-pil vinkelsitattegn", right_pointing_double_angle_quotation_mark: "Høyre dobbeltvinkel sitattegn", right_single_quotation_mark: "Høyre enkel sitattegn", ruble: "Rublen-symbol", rupee: "Rupiesymbol", section_sign: "Paragraf-tegn", select_all: "Alle", select_currency: "Valuta", select_text: "Tekst", single_low_quotation_mark: "Enkelt lav-9 anførselstegn", spesmilo: "Spesmilo-symbol", tenge: "Tengesymbol", title: "Spesialtegn", trade_mark_sign: "Varemerke-tegn", tugrik: "Tugrik-symbol", turkish_lira: "Tyrkisk lira-symbol", two_dot_leader: "To punkters leder", won: "Wonsymbol", yen: "Yen tegn" }, gS = "Gjennomstreket", _S = "Erstatningsvariabler", bS = "Substitusjoner", kS = "Tekstjustering", yS = { header_one: "Overskrift 1", header_three: "Overskrift 3", header_two: "Overskrift 2", paragraph: "Avsnitt", title: "Overskrift" }, vS = "Understreket", xS = "Angre", SS = "Tilbakestill", wS = {
  alt_text: Bx,
  background_color: Fx,
  bold: qx,
  bulletList: Hx,
  caption: Vx,
  decrease_intent: Ux,
  default_font_size: Wx,
  extra_spacing: Kx,
  font_color: Zx,
  font_family: Gx,
  font_size: Jx,
  global: Yx,
  image: Xx,
  image_center: Qx,
  image_change_alt_text: eS,
  image_change_caption: tS,
  image_change_link: nS,
  image_change_mobile_full_width: iS,
  image_error: rS,
  image_in_line: oS,
  image_insert_via_link: sS,
  image_side: aS,
  image_via_link: lS,
  increase_intent: cS,
  italic: uS,
  line_height: dS,
  link: hS,
  orderedList: fS,
  redo: pS,
  special_characters: mS,
  strike: gS,
  substitute_variables: _S,
  substitutions: bS,
  text_align: kS,
  text_level: yS,
  underline: vS,
  undo: xS,
  unset: SS
}, eR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Bx,
  background_color: Fx,
  bold: qx,
  bulletList: Hx,
  caption: Vx,
  decrease_intent: Ux,
  default: wS,
  default_font_size: Wx,
  extra_spacing: Kx,
  font_color: Zx,
  font_family: Gx,
  font_size: Jx,
  global: Yx,
  image: Xx,
  image_center: Qx,
  image_change_alt_text: eS,
  image_change_caption: tS,
  image_change_link: nS,
  image_change_mobile_full_width: iS,
  image_error: rS,
  image_in_line: oS,
  image_insert_via_link: sS,
  image_side: aS,
  image_via_link: lS,
  increase_intent: cS,
  italic: uS,
  line_height: dS,
  link: hS,
  orderedList: fS,
  redo: pS,
  special_characters: mS,
  strike: gS,
  substitute_variables: _S,
  substitutions: bS,
  text_align: kS,
  text_level: yS,
  underline: vS,
  undo: xS,
  unset: SS
}, Symbol.toStringTag, { value: "Module" })), CS = "Alternatywny tekst", TS = "Kolor tła czcionki", OS = "Pogrubienie", ES = "Lista punktowana", MS = "Podpis", $S = "Zmniejsz wcięcie", zS = "Domyślny", AS = "Dodatkowa przerwa", LS = "Kolor czcionki", NS = { default: "Domyślny", default_hint: "Używa czcionki ustawionej w miejscu użycia", hint: "Standardowa czcionka używa czcionki klienta pocztowego", mailbox_default: "Domyślna skrzynka pocztowa", mailbox_default_hint: "Używa domyślnej czcionki skrzynki odbiorcy (np. Gmail, Outlook lub Yahoo) dla optymalnej czytelności", title: "Rodzina czcionek" }, DS = "Rozmiar czcionki", RS = { apply: "Zastosuj", clear: "Wyczyść", error: "Błąd" }, IS = "Obraz", PS = "Wyrównaj obrazek do środka", jS = "Zmień tekst alternatywny obrazka", BS = "Zmień podpis obrazka", FS = "Zmień link obrazka", qS = "Ustaw szerokość obrazu na pełną szerokość urządzenia mobilnego", HS = "Nie udało się przetworzyć obrazu", VS = "Wyrównanie", US = "Wstaw obraz za pomocą linku", WS = "Wyrównaj obrazek do boku", KS = "Obraz za pomocą linku", ZS = "Zwiększ wcięcie", GS = "Kursywa", JS = "Wysokość linii", YS = "Link", XS = "Lista numerowana", QS = "Ponów", ew = { austral: "Znak austral", bitcoin: "Znak Bitcoina", cedi: "Znak cedi", cent: "Znak centa", colon: "Dwukropek", copyright_sign: "Znak praw autorskich", cruzeiro: "Znak cruzeiro", currency: "Znak waluty", dollar: "Znak dolara", dong: "Znak dong", double_dagger: "Podwójny krzyżyk", double_exclamation_mark: "Podwójny wykrzyknik", double_low_quotation_mark: "Podwójny niski cudzysłów 9", double_question_mark: "Podwójny znak zapytania", drachma: "Znak drachmy", euro: "Znak euro", euro_currency: "Znak waluty euro", exclamation_question_mark: "wykrzyknik i znak zapytania", french_franc: "Znak franka francuskiego", german_penny: "Znak niemieckiego feniga", guarani: "Znak guarani", horizontal_ellipsis: "Pozioma elipsa", hryvnia: "Znak hrywna", indian_rupee: "Znak rupii indyjskiej", inverted_exclamation_mark: "Odwrócony wykrzyknik", inverted_question_mark: "Odwrócony znak zapytania", kip: "Znak kip", left_double_quotation_mark: "Lewy podwójny cudzysłów", left_pointing_angle_quotation_mark: "Pojedynczy lewy szewron", left_pointing_double_angle_quotation_mark: "Podwójny lewy szewron", left_single_quotation_mark: "Lewy pojedynczy cudzysłów", lira: "Znak liry", livre_tournois: "Znak livre tournois", manat: "Znak manat", mill: "Znak mill", new_sheqel: "Znak nowego szekla", nordic_mark: "Znak marki nordyckiej", paragraph_sign: "Znak paragrafu", per_mille_sign: "Znak promila", per_ten_thousand_sign: "Znak na dziesięć tysięcy", peseta: "Znak pesety", peso: "Znak peso", pound: "Znak funta", question_exclamation_mark: "Znak zapytania i wykrzyknik", registered_sign: "Znak zarejestrowany", reversed_paragraph_sign: "Odwrócony znak paragrafu", right_double_quotation_mark: "Prawy podwójny cudzysłów", right_pointing_angle_quotation_mark: "Pojedynczy prawy szewron", right_pointing_double_angle_quotation_mark: "Podwójny prawy szewron", right_single_quotation_mark: "Prawy pojedynczy cudzysłów", ruble: "Znak rubla", rupee: "Znak rupii", section_sign: "Znak sekcji", select_all: "Wszystko", select_currency: "Waluta", select_text: "Tekst", single_low_quotation_mark: "Pojedynczy niski cudzysłów 9", spesmilo: "Znak spesmilo", tenge: "Znak Tenge", title: "Znaki specjalne", trade_mark_sign: "Znak towarowy", tugrik: "Znak tugrik", turkish_lira: "Znak liry tureckiej", two_dot_leader: "Dwupunktowy lider", won: "Znak wona", yen: "Znak jena" }, tw = "Przekreślenie", nw = "Zmienne zastępcze", iw = "Zamienniki", rw = "Wyrównanie tekstu", ow = { header_one: "Nagłówek 1", header_three: "Nagłówek 3", header_two: "Nagłówek 2", paragraph: "Akapit", title: "Nagłówek" }, sw = "Podkreślenie", aw = "Cofnij", lw = "Nieustawione", cw = {
  alt_text: CS,
  background_color: TS,
  bold: OS,
  bulletList: ES,
  caption: MS,
  decrease_intent: $S,
  default_font_size: zS,
  extra_spacing: AS,
  font_color: LS,
  font_family: NS,
  font_size: DS,
  global: RS,
  image: IS,
  image_center: PS,
  image_change_alt_text: jS,
  image_change_caption: BS,
  image_change_link: FS,
  image_change_mobile_full_width: qS,
  image_error: HS,
  image_in_line: VS,
  image_insert_via_link: US,
  image_side: WS,
  image_via_link: KS,
  increase_intent: ZS,
  italic: GS,
  line_height: JS,
  link: YS,
  orderedList: XS,
  redo: QS,
  special_characters: ew,
  strike: tw,
  substitute_variables: nw,
  substitutions: iw,
  text_align: rw,
  text_level: ow,
  underline: sw,
  undo: aw,
  unset: lw
}, tR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: CS,
  background_color: TS,
  bold: OS,
  bulletList: ES,
  caption: MS,
  decrease_intent: $S,
  default: cw,
  default_font_size: zS,
  extra_spacing: AS,
  font_color: LS,
  font_family: NS,
  font_size: DS,
  global: RS,
  image: IS,
  image_center: PS,
  image_change_alt_text: jS,
  image_change_caption: BS,
  image_change_link: FS,
  image_change_mobile_full_width: qS,
  image_error: HS,
  image_in_line: VS,
  image_insert_via_link: US,
  image_side: WS,
  image_via_link: KS,
  increase_intent: ZS,
  italic: GS,
  line_height: JS,
  link: YS,
  orderedList: XS,
  redo: QS,
  special_characters: ew,
  strike: tw,
  substitute_variables: nw,
  substitutions: iw,
  text_align: rw,
  text_level: ow,
  underline: sw,
  undo: aw,
  unset: lw
}, Symbol.toStringTag, { value: "Module" })), uw = "Texto alternativo", dw = "Cor de fundo da fonte", hw = "Negrito", fw = "Lista com marcadores", pw = "Legenda", mw = "Diminuir recuo", gw = "Padrão", _w = "Espaçamento entre parágrafos", bw = "Cor da fonte", kw = { default: "Padrão", default_hint: "Usa a fonte definida no elemento onde está inserido", hint: "A fonte padrão usa as fontes da plataforma de emails do cliente", mailbox_default: "Padrão da caixa de entrada", mailbox_default_hint: "Usa a fonte padrão da caixa de entrada do destinatário (ex: Gmail, Outlook ou Yahoo) para facilitar a leitura", title: "Família da fonte" }, yw = "Tamanho da fonte", vw = { apply: "Aplicar", clear: "Limpar", error: "Erro" }, xw = "Imagem", Sw = "Centralizar a imagem", ww = "Alterar o texto alternativo da imagem", Cw = "Alterar a legenda da imagem", Tw = "Alterar o link da imagem", Ow = "Defina a largura da imagem para a largura total do dispositivo móvel", Ew = "Falha ao processar a imagem", Mw = "Alinhar imagem à direita", $w = "Inserir imagem através de link", zw = "Alinhar imagem à esquerda", Aw = "Imagem através de link", Lw = "Aumentar recuo", Nw = "Itálico", Dw = "Altura da linha", Rw = "Link", Iw = "Lista numerada", Pw = "Refazer", jw = { austral: "Austral sign", bitcoin: "Bitcoin sign", cedi: "Cedi sign", cent: "Cent sign", colon: "Colon sign", copyright_sign: "Copyright sign", cruzeiro: "Cruzeiro sign", currency: "Currency sign", dollar: "Dollar sign", dong: "Dong sign", double_dagger: "Double dagger", double_exclamation_mark: "Double exclamation mark", double_low_quotation_mark: "Double low-9 quotation mark", double_question_mark: "Double question mark", drachma: "Drachma sign", euro: "Euro sign", euro_currency: "Euro-currency sign", exclamation_question_mark: "Exclamation question mark", french_franc: "French franc sign", german_penny: "German penny sign", guarani: "Guarani sign", horizontal_ellipsis: "Horizontal ellipsis", hryvnia: "Hryvnia sign", indian_rupee: "Indian rupee sign", inverted_exclamation_mark: "Inverted exclamation mark", inverted_question_mark: "Ponto de interrogação invertido", kip: "Kip sign", left_double_quotation_mark: "Left double quotation mark", left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark", left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark", left_single_quotation_mark: "Left single quotation mark", lira: "Lira sign", livre_tournois: "Livre tournois sign", manat: "Manat sign", mill: "Mill sign", new_sheqel: "New sheqel sign", nordic_mark: "Nordic mark sign", paragraph_sign: "Paragraph sign", per_mille_sign: "Per mille sign", per_ten_thousand_sign: "Per ten thousand sign", peseta: "Peseta sign", peso: "Peso sign", pound: "Pound sign", question_exclamation_mark: "Question exclamation mark", registered_sign: "Registered sign", reversed_paragraph_sign: "Reversed paragraph sign", right_double_quotation_mark: "Right double quotation mark", right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark", right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark", right_single_quotation_mark: "Right single quotation mark", ruble: "Ruble sign", rupee: "Rupee sign", section_sign: "Section sign", select_all: "Todos", select_currency: "Moeda", select_text: "Texto", single_low_quotation_mark: "Single low-9 quotation mark", spesmilo: "Spesmilo sign", tenge: "Tenge sign", title: "Caracteres especiais", trade_mark_sign: "Trade mark sign", tugrik: "Tugrik sign", turkish_lira: "Turkish lira sign", two_dot_leader: "Dois pontos", won: "Won sign", yen: "Yen sign" }, Bw = "Riscado", Fw = "Variáveis de substituição", qw = "Substituições", Hw = "Alinhamento do texto", Vw = { header_one: "Título 1", header_three: "Título 3", header_two: "Título 2", paragraph: "Parágrafo", title: "Título" }, Uw = "Sublinhado", Ww = "Desfazer", Kw = "Desmarcar", Zw = {
  alt_text: uw,
  background_color: dw,
  bold: hw,
  bulletList: fw,
  caption: pw,
  decrease_intent: mw,
  default_font_size: gw,
  extra_spacing: _w,
  font_color: bw,
  font_family: kw,
  font_size: yw,
  global: vw,
  image: xw,
  image_center: Sw,
  image_change_alt_text: ww,
  image_change_caption: Cw,
  image_change_link: Tw,
  image_change_mobile_full_width: Ow,
  image_error: Ew,
  image_in_line: Mw,
  image_insert_via_link: $w,
  image_side: zw,
  image_via_link: Aw,
  increase_intent: Lw,
  italic: Nw,
  line_height: Dw,
  link: Rw,
  orderedList: Iw,
  redo: Pw,
  special_characters: jw,
  strike: Bw,
  substitute_variables: Fw,
  substitutions: qw,
  text_align: Hw,
  text_level: Vw,
  underline: Uw,
  undo: Ww,
  unset: Kw
}, nR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: uw,
  background_color: dw,
  bold: hw,
  bulletList: fw,
  caption: pw,
  decrease_intent: mw,
  default: Zw,
  default_font_size: gw,
  extra_spacing: _w,
  font_color: bw,
  font_family: kw,
  font_size: yw,
  global: vw,
  image: xw,
  image_center: Sw,
  image_change_alt_text: ww,
  image_change_caption: Cw,
  image_change_link: Tw,
  image_change_mobile_full_width: Ow,
  image_error: Ew,
  image_in_line: Mw,
  image_insert_via_link: $w,
  image_side: zw,
  image_via_link: Aw,
  increase_intent: Lw,
  italic: Nw,
  line_height: Dw,
  link: Rw,
  orderedList: Iw,
  redo: Pw,
  special_characters: jw,
  strike: Bw,
  substitute_variables: Fw,
  substitutions: qw,
  text_align: Hw,
  text_level: Vw,
  underline: Uw,
  undo: Ww,
  unset: Kw
}, Symbol.toStringTag, { value: "Module" })), Gw = "Text alternativ", Jw = "Culoarea de fundal a fontului", Yw = "Îngroșat", Xw = "Listă cu puncte", Qw = "Subtitlu", eC = "Scade indentarea", tC = "Implicit", nC = "Spațiere suplimentară", iC = "Culoarea fontului", rC = { default: "Implicit", default_hint: "Utilizează fontul setat în locul de utilizare", hint: "Fontul standard folosește fonturile clientului de email", mailbox_default: "Cutia poștală implicită", mailbox_default_hint: " Utilizează fontul implicit al căsuței poștale a destinatarului (de exemplu, Gmail, Outlook sau Yahoo) pentru o lizibilitate optimă", title: "Familia de fonturi" }, oC = "Dimensiunea fontului", sC = { apply: "Aplica", clear: "Clar", error: "Eroare" }, aC = "Imagine", lC = "Aliniere imagine la centru", cC = "Schimbare text alternativ pentru imagine", uC = "Schimbare legendă pentru imagine", dC = "Schimbare link pentru imagine", hC = "Setează lățimea imaginii la lățimea completă a dispozitivului mobil", fC = "Procesarea imaginii a eșuat", pC = "Aliniere imagine la dreapta", mC = "Inserare imagine prin link", gC = "Aliniere imagine la stânga", _C = "Imagine prin link", bC = "Crește indentarea", kC = "Italic", yC = "Înălțimea liniei", vC = "Link", xC = "Listă numerotată", SC = "Refă", wC = { austral: "Semn de austral", bitcoin: "Semn Bitcoin", cedi: "Semn de cedi", cent: "Semnul cenților", colon: "Semnul două puncte", copyright_sign: "Semn de copyright", cruzeiro: "Semnul cruzeiro", currency: "Semn de valută", dollar: "Semnul dolarului", dong: "Semn de dong", double_dagger: "Dagger dublu", double_exclamation_mark: "Semn de exclamare dublu", double_low_quotation_mark: "Semn de întrebare dublu jos-9", double_question_mark: "Semn de întrebare dublu", drachma: "Semn de drahmă", euro: "Semnul euro", euro_currency: "Semnul monedei euro", exclamation_question_mark: "Semn de exclamare întrebare", french_franc: "Semnul francului francez", german_penny: "Semn de penny german", guarani: "Semn de guarani", horizontal_ellipsis: "Eliipsă orizontală", hryvnia: "Semn de hrivnă", indian_rupee: "Semn de rupie indiană", inverted_exclamation_mark: "Semn de exclamare inversat", inverted_question_mark: "Semn de întrebare inversat", kip: "Semn de kip", left_double_quotation_mark: "Semn de întrebare dublu stânga", left_pointing_angle_quotation_mark: "Semn de citare unghiulară stângă simplă", left_pointing_double_angle_quotation_mark: "Semn de citare unghiulară dublă stângă", left_single_quotation_mark: "Semn de citare simplă stângă", lira: "Semnul lirei italiene", livre_tournois: "Semn de livre tournois", manat: "Semn de manat", mill: "Semn de milă", new_sheqel: "Semn de nouă shekel", nordic_mark: "Semn de marcă nordică", paragraph_sign: "Semn de paragraf", per_mille_sign: "Semn de per mille", per_ten_thousand_sign: "Semn de per zece mii", peseta: "Semn de pesetă", peso: "Semn de peso", pound: "Semnul lirei", question_exclamation_mark: "Semn de întrebare exclamare", registered_sign: "Semn înregistrat", reversed_paragraph_sign: "Semn de paragraf inversat", right_double_quotation_mark: "Semn de întrebare dublu dreapta", right_pointing_angle_quotation_mark: "Semn de citare unghiulară dreaptă simplă", right_pointing_double_angle_quotation_mark: "Semn de citare unghiulară dublă dreaptă", right_single_quotation_mark: "Semn de citare simplă dreaptă", ruble: "Semn de ruble", rupee: "Semn de rupie", section_sign: "Semn de secțiune", select_all: "Toate", select_currency: "Monedă", select_text: "Text", single_low_quotation_mark: "Semn de întrebare simplu jos-9", spesmilo: "Semn de spesmilo", tenge: "Semn de tenge", title: "Caractere speciale", trade_mark_sign: "Semn de marcă comercială", tugrik: "Semn de tugrik", turkish_lira: "Semn de liră turcească", two_dot_leader: "Lider cu două puncte", won: "Semn de won", yen: "Semnul yenului" }, CC = "Tăiat", TC = "Variabile de substituție", OC = "Substituții", EC = "Alinierea textului", MC = { header_one: "Antet 1", header_three: "Antet 3", header_two: "Antet 2", paragraph: "Paragraf", title: "Titlu" }, $C = "Subliniat", zC = "Anulează", AC = "Anulat", LC = {
  alt_text: Gw,
  background_color: Jw,
  bold: Yw,
  bulletList: Xw,
  caption: Qw,
  decrease_intent: eC,
  default_font_size: tC,
  extra_spacing: nC,
  font_color: iC,
  font_family: rC,
  font_size: oC,
  global: sC,
  image: aC,
  image_center: lC,
  image_change_alt_text: cC,
  image_change_caption: uC,
  image_change_link: dC,
  image_change_mobile_full_width: hC,
  image_error: fC,
  image_in_line: pC,
  image_insert_via_link: mC,
  image_side: gC,
  image_via_link: _C,
  increase_intent: bC,
  italic: kC,
  line_height: yC,
  link: vC,
  orderedList: xC,
  redo: SC,
  special_characters: wC,
  strike: CC,
  substitute_variables: TC,
  substitutions: OC,
  text_align: EC,
  text_level: MC,
  underline: $C,
  undo: zC,
  unset: AC
}, iR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Gw,
  background_color: Jw,
  bold: Yw,
  bulletList: Xw,
  caption: Qw,
  decrease_intent: eC,
  default: LC,
  default_font_size: tC,
  extra_spacing: nC,
  font_color: iC,
  font_family: rC,
  font_size: oC,
  global: sC,
  image: aC,
  image_center: lC,
  image_change_alt_text: cC,
  image_change_caption: uC,
  image_change_link: dC,
  image_change_mobile_full_width: hC,
  image_error: fC,
  image_in_line: pC,
  image_insert_via_link: mC,
  image_side: gC,
  image_via_link: _C,
  increase_intent: bC,
  italic: kC,
  line_height: yC,
  link: vC,
  orderedList: xC,
  redo: SC,
  special_characters: wC,
  strike: CC,
  substitute_variables: TC,
  substitutions: OC,
  text_align: EC,
  text_level: MC,
  underline: $C,
  undo: zC,
  unset: AC
}, Symbol.toStringTag, { value: "Module" })), NC = "Текстовая альтернатива", DC = "Цвет фона шрифта", RC = "Жирный", IC = "Пунктирный список", PC = "Подпись", jC = "Уменьшить отступ", BC = "По умолчанию", FC = "Интервал между абзацами", qC = "Цвет шрифта", HC = { default: "По умолчанию", default_hint: "Использует шрифт, установленный в месте использования", hint: "Стандартный шрифт использует шрифты почтового клиента", mailbox_default: "Почтовый ящик по умолчанию", mailbox_default_hint: "Использует шрифт по умолчанию почтового ящика получателя (например, Gmail, Outlook или Yahoo) для оптимальной читаемости", title: "Семейство шрифтов" }, VC = "Размер шрифта", UC = { apply: "Применить", clear: "Очистить", error: "Ошибка" }, WC = "Изображение", KC = "Изображение выровнено по центру", ZC = "Изменить альтернативный текст изображения", GC = "Изменить подпись изображения", JC = "Изменить ссылку на изображение", YC = "Установите ширину изображения на полную ширину мобильного устройства", XC = "Не удалось обработать изображение", QC = "Изображение выровнено вправо", e3 = "Вставить изображение по ссылке", t3 = "Изображение выровнено влево", n3 = "Изображение по ссылке", i3 = "Увеличить отступ", r3 = "Курсив", o3 = "Высота строки", s3 = "Ссылка", a3 = "Нумерованный список", l3 = "Повторить", c3 = { austral: "Австралийский знак", bitcoin: "Знак биткоина", cedi: "Знак цеди", cent: "Знак цента", colon: "Знак колона", copyright_sign: "Знак копирайта", cruzeiro: "Круизный знак", currency: "Знак валюты", dollar: "Знак доллара", dong: "Знак Донга", double_dagger: "Двойной кинжал", double_exclamation_mark: "Двойной восклицательный знак", double_low_quotation_mark: "Двойная кавычка со знаком минус 9", double_question_mark: "Двойной вопросительный знак", drachma: "Знак драхмы", euro: "Знак евро", euro_currency: "Знак евровалюты", exclamation_question_mark: "Восклицательный знак вопроса", french_franc: "Знак французского франка", german_penny: "Знак немецкого пенни", guarani: "Знак гуарани", horizontal_ellipsis: "Горизонтальное многоточие", hryvnia: "Знак гривны", indian_rupee: "Знак индийской рупии", inverted_exclamation_mark: "Перевернутый восклицательный знак", inverted_question_mark: "Перевернутый вопросительный знак", kip: "Знак Кипа", left_double_quotation_mark: "Левая двойная кавычка", left_pointing_angle_quotation_mark: "Одиночная угловая кавычка, направленная влево", left_pointing_double_angle_quotation_mark: "Кавычки с двойным углом наклона влево", left_single_quotation_mark: "Левая одинарная кавычка", lira: "Знак лиры", livre_tournois: "Знак турнирной книги", manat: "Знак Маната", mill: "Знак мельницы", new_sheqel: "Новый знак шекеля", nordic_mark: "Знак северной марки", paragraph_sign: "Знак параграфа", per_mille_sign: "За миллион знаков", per_ten_thousand_sign: "За десять тысяч знаков", peseta: "Знак песеты", peso: "Знак песо", pound: "Знак фунта", question_exclamation_mark: "Вопросительный восклицательный знак", registered_sign: "Зарегистрированный знак", reversed_paragraph_sign: "Знак перевернутого параграфа", right_double_quotation_mark: "Правая двойная кавычка", right_pointing_angle_quotation_mark: "Одиночная угловая кавычка, направленная вправо", right_pointing_double_angle_quotation_mark: "Кавычки под прямым углом", right_single_quotation_mark: "Правая одинарная кавычка", ruble: "Рублевый знак", rupee: "Знак рупии", section_sign: "Знак секции", select_all: "Все", select_currency: "Валюта", select_text: "Текст", single_low_quotation_mark: "Одиночная кавычка со знаком минус 9", spesmilo: "Знак Спесмило", tenge: "Знак тенге", title: "Специальные символы", trade_mark_sign: "Знак торговой марки", tugrik: "Знак Тугрика", turkish_lira: "Знак турецкой лиры", two_dot_leader: "Лидер с двумя точками", won: "Знак победы", yen: "Знак иены" }, u3 = "Зачеркивание", d3 = "Замещающие переменные", h3 = "Заменители", f3 = "Выравнивание текста", p3 = { header_one: "Заголовок 1", header_three: "Заголовок 3", header_two: "Заголовок 2", paragraph: "Параграф", title: "Заголовок" }, m3 = "Подчеркивание", g3 = "Отменить", _3 = "Сброшено", b3 = {
  alt_text: NC,
  background_color: DC,
  bold: RC,
  bulletList: IC,
  caption: PC,
  decrease_intent: jC,
  default_font_size: BC,
  extra_spacing: FC,
  font_color: qC,
  font_family: HC,
  font_size: VC,
  global: UC,
  image: WC,
  image_center: KC,
  image_change_alt_text: ZC,
  image_change_caption: GC,
  image_change_link: JC,
  image_change_mobile_full_width: YC,
  image_error: XC,
  image_in_line: QC,
  image_insert_via_link: e3,
  image_side: t3,
  image_via_link: n3,
  increase_intent: i3,
  italic: r3,
  line_height: o3,
  link: s3,
  orderedList: a3,
  redo: l3,
  special_characters: c3,
  strike: u3,
  substitute_variables: d3,
  substitutions: h3,
  text_align: f3,
  text_level: p3,
  underline: m3,
  undo: g3,
  unset: _3
}, rR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: NC,
  background_color: DC,
  bold: RC,
  bulletList: IC,
  caption: PC,
  decrease_intent: jC,
  default: b3,
  default_font_size: BC,
  extra_spacing: FC,
  font_color: qC,
  font_family: HC,
  font_size: VC,
  global: UC,
  image: WC,
  image_center: KC,
  image_change_alt_text: ZC,
  image_change_caption: GC,
  image_change_link: JC,
  image_change_mobile_full_width: YC,
  image_error: XC,
  image_in_line: QC,
  image_insert_via_link: e3,
  image_side: t3,
  image_via_link: n3,
  increase_intent: i3,
  italic: r3,
  line_height: o3,
  link: s3,
  orderedList: a3,
  redo: l3,
  special_characters: c3,
  strike: u3,
  substitute_variables: d3,
  substitutions: h3,
  text_align: f3,
  text_level: p3,
  underline: m3,
  undo: g3,
  unset: _3
}, Symbol.toStringTag, { value: "Module" })), k3 = "Alternatívny text", y3 = "Farba pozadia písma", v3 = "Tučné", x3 = "Zoznam s odrážkami", S3 = "Popis", w3 = "Znížiť odsadenie", C3 = "Predvolené", T3 = "Extra medzery", O3 = "Farba písma", E3 = { default: "Predvolené", default_hint: "Používa nastavené písmo na mieste použitia", hint: "Štandardné písmo používa písma emailového klienta", mailbox_default: "Predvolená poštová schránka", mailbox_default_hint: "Používa predvolené písmo príjemcovho poštového schránky (napríklad Gmail, Outlook alebo Yahoo) pre optimálnu čitateľnosť", title: "Rodina písma" }, M3 = "Veľkosť písma", $3 = { apply: "Použiť", clear: "Jasný", error: "Chyba" }, z3 = "Obrázok", A3 = "Obrázok zarovnať na stred", L3 = "Zmeniť alternatívny text obrázka", N3 = "Zmeniť popis obrázka", D3 = "Zmeniť odkaz obrázka", R3 = "Nastavte šírku obrázka na celú šírku mobilného zariadenia", I3 = "Nepodarilo sa spracovať obrázok", P3 = "Obrázok zarovnať doprava", j3 = "Vložte obrázok cez odkaz", B3 = "Obrázok zarovnať doľava", F3 = "Obrázok cez odkaz", q3 = "Zvýšiť odsadenie", H3 = "Kurzíva", V3 = "Výška riadku", U3 = "Odkaz", W3 = "Číslovaný zoznam", K3 = "Znova", Z3 = { austral: "Austral znak", bitcoin: "Znak bitcoinu", cedi: "Cedi znak", cent: "Centový znak", colon: "Znak dvojbodky", copyright_sign: "Znak autorského práva", cruzeiro: "Znak cruzeiro", currency: "Znak meny", dollar: "Dolarový znak", dong: "Dong znak", double_dagger: "Dvojitý kríž", double_exclamation_mark: "Dvojitý výkričník", double_low_quotation_mark: "Dvojité nízke 9 úvodzovky", double_question_mark: "Dvojitý otáznik", drachma: "Drachma znak", euro: "Euro znak", euro_currency: "Znak euro-meny", exclamation_question_mark: "Výkričník otáznik", french_franc: "Znak francúzskeho franku", german_penny: "Nemecký penny znak", guarani: "Guarani znak", horizontal_ellipsis: "Horizontálne elipsy", hryvnia: "Hryvnia znak", indian_rupee: "Indická rupia znak", inverted_exclamation_mark: "Invertný výkričník", inverted_question_mark: "Invertná otázka", kip: "Kip znak", left_double_quotation_mark: "Ľavé dvojité úvodzovky", left_pointing_angle_quotation_mark: "Jednoduché ľavé úvodzovky", left_pointing_double_angle_quotation_mark: "Ľavé dvojité úvodzovky", left_single_quotation_mark: "Ľavé jednoduché úvodzovky", lira: "Znak líry", livre_tournois: "Livre tournois znak", manat: "Znak manátu", mill: "Znak milu", new_sheqel: "Znak nového šekelu", nordic_mark: "Nordická marka znak", paragraph_sign: "Znak odseku", per_mille_sign: "Per mille znak", per_ten_thousand_sign: "Per desaťtisíc znak", peseta: "Znak pesety", peso: "Peso znak", pound: "Librový znak", question_exclamation_mark: "Otázkový výkričník", registered_sign: "Zaregistrovaný znak", reversed_paragraph_sign: "Obrátený znak odseku", right_double_quotation_mark: "Pravé dvojité úvodzovky", right_pointing_angle_quotation_mark: "Jednoduché pravé úvodzovky", right_pointing_double_angle_quotation_mark: "Pravé dvojité úvodzovky", right_single_quotation_mark: "Pravé jednoduché úvodzovky", ruble: "Rubeľ znak", rupee: "Znak rupie", section_sign: "Znak sekcie", select_all: "Všetko", select_currency: "Mena", select_text: "Text", single_low_quotation_mark: "Jednoduché nízke 9 úvodzovky", spesmilo: "Spesmilo znak", tenge: "Tenge znak", title: "Špeciálne znaky", trade_mark_sign: "Znak ochranné známky", tugrik: "Tugrik znak", turkish_lira: "Turecká líra znak", two_dot_leader: "Dvojbodový vodítko", won: "Znak wonu", yen: "Jenový znak" }, G3 = "Prečiarknuť", J3 = "Náhradné premenné", Y3 = "Náhrady", X3 = "Zarovnanie textu", Q3 = { header_one: "Nadpis 1", header_three: "Nadpis 3", header_two: "Nadpis 2", paragraph: "Odstavec", title: "Nadpis" }, eT = "Podčiarknuť", tT = "Zrušiť", nT = "Zrušiť", iT = {
  alt_text: k3,
  background_color: y3,
  bold: v3,
  bulletList: x3,
  caption: S3,
  decrease_intent: w3,
  default_font_size: C3,
  extra_spacing: T3,
  font_color: O3,
  font_family: E3,
  font_size: M3,
  global: $3,
  image: z3,
  image_center: A3,
  image_change_alt_text: L3,
  image_change_caption: N3,
  image_change_link: D3,
  image_change_mobile_full_width: R3,
  image_error: I3,
  image_in_line: P3,
  image_insert_via_link: j3,
  image_side: B3,
  image_via_link: F3,
  increase_intent: q3,
  italic: H3,
  line_height: V3,
  link: U3,
  orderedList: W3,
  redo: K3,
  special_characters: Z3,
  strike: G3,
  substitute_variables: J3,
  substitutions: Y3,
  text_align: X3,
  text_level: Q3,
  underline: eT,
  undo: tT,
  unset: nT
}, oR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: k3,
  background_color: y3,
  bold: v3,
  bulletList: x3,
  caption: S3,
  decrease_intent: w3,
  default: iT,
  default_font_size: C3,
  extra_spacing: T3,
  font_color: O3,
  font_family: E3,
  font_size: M3,
  global: $3,
  image: z3,
  image_center: A3,
  image_change_alt_text: L3,
  image_change_caption: N3,
  image_change_link: D3,
  image_change_mobile_full_width: R3,
  image_error: I3,
  image_in_line: P3,
  image_insert_via_link: j3,
  image_side: B3,
  image_via_link: F3,
  increase_intent: q3,
  italic: H3,
  line_height: V3,
  link: U3,
  orderedList: W3,
  redo: K3,
  special_characters: Z3,
  strike: G3,
  substitute_variables: J3,
  substitutions: Y3,
  text_align: X3,
  text_level: Q3,
  underline: eT,
  undo: tT,
  unset: nT
}, Symbol.toStringTag, { value: "Module" })), rT = "Besedilna alternativa", oT = "Barva ozadja pisave", sT = "Krepko", aT = "Seznam z oznakami", lT = "Podnapis", cT = "Zmanjšaj zamik", uT = "Privzeto", dT = "Dodatni razmik", hT = "Barva pisave", fT = { default: "Privzeto", default_hint: "Uporablja nastavitev pisave na mestu uporabe", hint: "Standardna pisava uporablja pisave odjemalca e-pošte", mailbox_default: "Privzeta poštna škatla", mailbox_default_hint: "Uporablja privzeto pisavo prejemnikove poštne škatle (npr. Gmail, Outlook ali Yahoo) za optimalno berljivost", title: "Družina pisave" }, pT = "Velikost pisave", mT = { apply: "Prijavite se", clear: "Jasno", error: "Napaka" }, gT = "Slika", _T = "Slika poravnana na sredino", bT = "Spremeni alternativno besedilo slike", kT = "Spremeni napis slike", yT = "Spremeni povezavo slike", vT = "Nastavi širino slike na celotno širino mobilne naprave", xT = "Obdelava slike ni uspela", ST = "Slika poravnana desno", wT = "Vstavite sliko prek povezave", CT = "Slika poravnana levo", TT = "Slika prek povezave", OT = "Povečaj zamik", ET = "Ležeče", MT = "Višina črte", $T = "Povezava", zT = "Oštevilčen seznam", AT = "Ponovi", LT = { austral: "Simbol australa", bitcoin: "Simbol bitcoina", cedi: "Simbol cedi", cent: "Znak centa", colon: "Znak dvopičje", copyright_sign: "Znak avtorskih pravic", cruzeiro: "Znak cruzeira", currency: "Simbol valute", dollar: "Znak dolarja", dong: "Simbol donga", double_dagger: "Dvojni meč", double_exclamation_mark: "Dvojni klicaj", double_low_quotation_mark: "Dvojni nizki 9 narekovaj", double_question_mark: "Dvojni vprašaj", drachma: "Simbol drahme", euro: "Znak evra", euro_currency: "Znak evrovalute", exclamation_question_mark: "Vzklik vprašaj", french_franc: "Znak francoskega franka", german_penny: "Simbol nemške penije", guarani: "Simbol guaranija", horizontal_ellipsis: "Horizontalne elipse", hryvnia: "Simbol grivna", indian_rupee: "Simbol indijske rupije", inverted_exclamation_mark: "Obrnjen vzklik", inverted_question_mark: "Obrnjen vprašaj", kip: "Simbol kipa", left_double_quotation_mark: "Leva dvojna narekovaja", left_pointing_angle_quotation_mark: "Enojni levo usmerjen kotni narekovaj", left_pointing_double_angle_quotation_mark: "Levo usmerjen dvojni kotni narekovaj", left_single_quotation_mark: "Levi enojni narekovaj", lira: "Znak lire", livre_tournois: "Simbol livre tournois", manat: "Znak manat", mill: "Simbol mila", new_sheqel: "Simbol novega šekela", nordic_mark: "Simbol nordijske marke", paragraph_sign: "Znak odstavka", per_mille_sign: "Znak za promil", per_ten_thousand_sign: "Znak za deset tisoč", peseta: "Simbol pesete", peso: "Simbol pesosa", pound: "Znak funta", question_exclamation_mark: "Vprašalni vzklik", registered_sign: "Znak registracije", reversed_paragraph_sign: "Obrnjen znak odstavka", right_double_quotation_mark: "Desna dvojna narekovaja", right_pointing_angle_quotation_mark: "Enojni desno usmerjen kotni narekovaj", right_pointing_double_angle_quotation_mark: "Desno usmerjen dvojni kotni narekovaj", right_single_quotation_mark: "Desni enojni narekovaj", ruble: "Simbol rublja", rupee: "Simbol rupije", section_sign: "Znak odseka", select_all: "Vse", select_currency: "Valuta", select_text: "Besedilo", single_low_quotation_mark: "Enojni nizki 9 narekovaj", spesmilo: "Simbol spesmila", tenge: "Simbol tenge", title: "Posebni znaki", trade_mark_sign: "Znak blagovne znamke", tugrik: "Simbol tugrika", turkish_lira: "Simbol turške lire", two_dot_leader: "Dva pika vodilo", won: "Simbol wona", yen: "Znak jena" }, NT = "Prečrtano", DT = "Nadomestne spremenljivke", RT = "Nadomestila", IT = "Poravnava besedila", PT = { header_one: "Glava 1", header_three: "Glava 3", header_two: "Glava 2", paragraph: "Odlomek", title: "Naslov" }, jT = "Podčrtano", BT = "Razveljavi", FT = "Nastavi", qT = {
  alt_text: rT,
  background_color: oT,
  bold: sT,
  bulletList: aT,
  caption: lT,
  decrease_intent: cT,
  default_font_size: uT,
  extra_spacing: dT,
  font_color: hT,
  font_family: fT,
  font_size: pT,
  global: mT,
  image: gT,
  image_center: _T,
  image_change_alt_text: bT,
  image_change_caption: kT,
  image_change_link: yT,
  image_change_mobile_full_width: vT,
  image_error: xT,
  image_in_line: ST,
  image_insert_via_link: wT,
  image_side: CT,
  image_via_link: TT,
  increase_intent: OT,
  italic: ET,
  line_height: MT,
  link: $T,
  orderedList: zT,
  redo: AT,
  special_characters: LT,
  strike: NT,
  substitute_variables: DT,
  substitutions: RT,
  text_align: IT,
  text_level: PT,
  underline: jT,
  undo: BT,
  unset: FT
}, sR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: rT,
  background_color: oT,
  bold: sT,
  bulletList: aT,
  caption: lT,
  decrease_intent: cT,
  default: qT,
  default_font_size: uT,
  extra_spacing: dT,
  font_color: hT,
  font_family: fT,
  font_size: pT,
  global: mT,
  image: gT,
  image_center: _T,
  image_change_alt_text: bT,
  image_change_caption: kT,
  image_change_link: yT,
  image_change_mobile_full_width: vT,
  image_error: xT,
  image_in_line: ST,
  image_insert_via_link: wT,
  image_side: CT,
  image_via_link: TT,
  increase_intent: OT,
  italic: ET,
  line_height: MT,
  link: $T,
  orderedList: zT,
  redo: AT,
  special_characters: LT,
  strike: NT,
  substitute_variables: DT,
  substitutions: RT,
  text_align: IT,
  text_level: PT,
  underline: jT,
  undo: BT,
  unset: FT
}, Symbol.toStringTag, { value: "Module" })), HT = "Alternativa e tekstit", VT = "Ngjyra e sfondit të shkronjave", UT = "Të theksuara", WT = "Lista me bullets", KT = "Titulli", ZT = "Pako indentimin", GT = "Parazgjedhje", JT = "Hapësirë shtesë", YT = "Ngjyra e shkronjave", XT = { default: "Parazgjedhje", default_hint: "Përdor fontin e vendosur në vendin e përdorimit", hint: "Fonti standard përdor fontet e klientit të emailit", mailbox_default: "Posta e parazgjedhur", mailbox_default_hint: "Përdor fontin e parazgjedhur të kutisë postare të marrësit (p.sh., Gmail, Outlook, ose Yahoo) për lexim më të mirë", title: "Familja e shkronjave" }, QT = "Madhësia e shkronjave", e2 = { apply: "Aplikoni", clear: "Qartë", error: "Gabim" }, t2 = "Imazhi", n2 = "Imazhi në qendër", i2 = "Ndrysho tekstin alternativ të imazhit", r2 = "Ndrysho titullin e imazhit", o2 = "Ndrysho lidhjen e imazhit", s2 = "Cakto gjatësinë e imazhit në gjatësinë e plotë të pajisjes mobile", a2 = "Dështoi për të procesuar imazhin", l2 = "Imazhi në anën e djathtë", c2 = "Shtoni imazhin përmes lidhjes", u2 = "Imazhi në anën e majtë", d2 = "Imazhi përmes lidhjes", h2 = "Rrit indentimin", f2 = "Të italizuara", p2 = "Lartësia e linjës", m2 = "Lidhje", g2 = "Lista e numrave", _2 = "Rifillo", b2 = { austral: "Shenja e Austral", bitcoin: "Shenja e Bitcoin", cedi: "Shenja e Cedi", cent: "Shenja e centit", colon: "Shenja e kolonës", copyright_sign: "Shenja e të drejtat e autorit", cruzeiro: "Shenja e cruzeiro", currency: "Shenja e monedhës", dollar: "Shenja e dollarit", dong: "Shenja e Dong", double_dagger: "Daga dyfish", double_exclamation_mark: "Shenjë dyfishi e exclamacionit", double_low_quotation_mark: "Shenja e cituar e ulët-9 dyfish", double_question_mark: "Shenja e pyetjes dyfish", drachma: "Shenja e Drachma", euro: "Shenja e euros", euro_currency: "Shenja e monedhës euro", exclamation_question_mark: "Shenja e thirrjes dhe pyetjes", french_franc: "Shenja e frangës franceze", german_penny: "Shenja e centit gjerman", guarani: "Shenja e Guarani", horizontal_ellipsis: "Ellips horizontal", hryvnia: "Shenja e Hryvnia", indian_rupee: "Shenja e rupees indiane", inverted_exclamation_mark: "Shenja e përmbysur e thirrjes", inverted_question_mark: "Shenja e përmbysur e pyetjes", kip: "Shenja e Kip", left_double_quotation_mark: "Shenja e cituar e majtë", left_pointing_angle_quotation_mark: "Shenja e cituar me kënd të majtë", left_pointing_double_angle_quotation_mark: "Shenja e cituar me dy kënde të majtë", left_single_quotation_mark: "Shenja e cituar e majtë", lira: "Shenja e lirës", livre_tournois: "Shenja e livre tournois", manat: "Shenja e manatit", mill: "Shenja e Mill", new_sheqel: "Shenja e shekellit të ri", nordic_mark: "Shenja e markës nordike", paragraph_sign: "Shenja e paragrafit", per_mille_sign: "Shenja per mille", per_ten_thousand_sign: "Shenja per dhjetë mijë", peseta: "Shenja e Peseta", peso: "Shenja e Peso", pound: "Shenja e poundit", question_exclamation_mark: "Shenja e pyetjes dhe thirrjes", registered_sign: "Shenja e regjistruar", reversed_paragraph_sign: "Shenja e paragrafit të përmbysur", right_double_quotation_mark: "Shenja e cituar e djathtë", right_pointing_angle_quotation_mark: "Shenja e cituar me kënd të djathtë", right_pointing_double_angle_quotation_mark: "Shenja e cituar me dy kënde të djathtë", right_single_quotation_mark: "Shenja e cituar e djathtë", ruble: "Shenja e Ruble", rupee: "Shenja e Rupee", section_sign: "Shenja e seksionit", select_all: "Të gjitha", select_currency: "Monedha", select_text: "Teksti", single_low_quotation_mark: "Shenja e cituar e ulët-9", spesmilo: "Shenja e Spesmilo", tenge: "Shenja e Tenge", title: "Karaktere speciale", trade_mark_sign: "Shenja e markës tregtare", tugrik: "Shenja e Tugrik", turkish_lira: "Shenja e lira turke", two_dot_leader: "Lideri me dy pika", won: "Shenja e Won", yen: "Shenja e yenit" }, k2 = "Të goditura", y2 = "Ndryshoret zëvendësuese", v2 = "Zëvendësimet", x2 = "Rreshtimi i tekstit", S2 = { header_one: "Titulli 1", header_three: "Titulli 3", header_two: "Titulli 2", paragraph: "Paragrafi", title: "Titulli" }, w2 = "Të nënvizuara", C2 = "Anulo", T2 = "Ç'aktivizuar", O2 = {
  alt_text: HT,
  background_color: VT,
  bold: UT,
  bulletList: WT,
  caption: KT,
  decrease_intent: ZT,
  default_font_size: GT,
  extra_spacing: JT,
  font_color: YT,
  font_family: XT,
  font_size: QT,
  global: e2,
  image: t2,
  image_center: n2,
  image_change_alt_text: i2,
  image_change_caption: r2,
  image_change_link: o2,
  image_change_mobile_full_width: s2,
  image_error: a2,
  image_in_line: l2,
  image_insert_via_link: c2,
  image_side: u2,
  image_via_link: d2,
  increase_intent: h2,
  italic: f2,
  line_height: p2,
  link: m2,
  orderedList: g2,
  redo: _2,
  special_characters: b2,
  strike: k2,
  substitute_variables: y2,
  substitutions: v2,
  text_align: x2,
  text_level: S2,
  underline: w2,
  undo: C2,
  unset: T2
}, aR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: HT,
  background_color: VT,
  bold: UT,
  bulletList: WT,
  caption: KT,
  decrease_intent: ZT,
  default: O2,
  default_font_size: GT,
  extra_spacing: JT,
  font_color: YT,
  font_family: XT,
  font_size: QT,
  global: e2,
  image: t2,
  image_center: n2,
  image_change_alt_text: i2,
  image_change_caption: r2,
  image_change_link: o2,
  image_change_mobile_full_width: s2,
  image_error: a2,
  image_in_line: l2,
  image_insert_via_link: c2,
  image_side: u2,
  image_via_link: d2,
  increase_intent: h2,
  italic: f2,
  line_height: p2,
  link: m2,
  orderedList: g2,
  redo: _2,
  special_characters: b2,
  strike: k2,
  substitute_variables: y2,
  substitutions: v2,
  text_align: x2,
  text_level: S2,
  underline: w2,
  undo: C2,
  unset: T2
}, Symbol.toStringTag, { value: "Module" })), E2 = "Alternativa za tekst", M2 = "Boja pozadine fonta", $2 = "Podebljano", z2 = "Lista sa oznakama", A2 = "Natpis", L2 = "Smanji uvlačenje", N2 = "Podrazumevano", D2 = "Dodatni razmak", R2 = "Boja fonta", I2 = { default: "Podrazumevano", default_hint: "Koristi font koji je postavljen na mestu korišćenja", hint: "Standardni font koristi fontove klijenta za e-poštu", mailbox_default: "Podrazumevana pošta", mailbox_default_hint: "Koristi podrazumevani font primaoca pošte (npr. Gmail, Outlook ili Yahoo) za optimalnu čitljivost", title: "Porodica fonta" }, P2 = "Veličina fonta", j2 = { apply: "Primeni", clear: "Obriši", error: "Greška" }, B2 = "Slika", F2 = "Središnja slika", q2 = "Promeni alternativni tekst slike", H2 = "Promeni opis slike", V2 = "Promeni link slike", U2 = "Podesi širinu slike na punu širinu mobilnog uređaja", W2 = "Nije uspelo da se obradi slika", K2 = "U redu", Z2 = "Umetnite sliku putem linka", G2 = "Bočna slika", J2 = "Slika putem linka", Y2 = "Povećaj uvlačenje", X2 = "Kurziv", Q2 = "Visina linije", eO = "Link", tO = "Numerisana lista", nO = "Ponovi", iO = { austral: "Znak austral", bitcoin: "Znak bitcoina", cedi: "Znak cedi", cent: "Znak centa", colon: "Znak dvotačka", copyright_sign: "Znak autorskih prava", cruzeiro: "Znak kruzeira", currency: "Znak valute", dollar: "Znak dolara", dong: "Znak donga", double_dagger: "Dupli dagger", double_exclamation_mark: "Dupli znak uzvika", double_low_quotation_mark: "Dvostruki nisko-9 navodnik", double_question_mark: "Dupli znak pitanja", drachma: "Znak drahme", euro: "Znak evra", euro_currency: "Znak evro-valute", exclamation_question_mark: "Znak uzvika i pitanja", french_franc: "Znak francuskog franka", german_penny: "Znak nemačke penije", guarani: "Znak guarane", horizontal_ellipsis: "Horizontalna elipsa", hryvnia: "Znak grivnje", indian_rupee: "Znak indijske rupije", inverted_exclamation_mark: "Obrnuti uzvičnik", inverted_question_mark: "Obrnuto pitanje", kip: "Znak kipa", left_double_quotation_mark: "Levi dvostruki navodnik", left_pointing_angle_quotation_mark: "Levi jednostruki uglasti navodnik", left_pointing_double_angle_quotation_mark: "Levi dvostruki uglasti navodnik", left_single_quotation_mark: "Levi jednostruki navodnik", lira: "Znak lire", livre_tournois: "Znak livre turnoisa", manat: "Znak manat", mill: "Znak mila", new_sheqel: "Znak novog šekela", nordic_mark: "Znak nordijske marke", paragraph_sign: "Znak paragrafa", per_mille_sign: "Per mille znak", per_ten_thousand_sign: "Per deset hiljada znak", peseta: "Znak pesete", peso: "Znak pesosa", pound: "Znak funte", question_exclamation_mark: "Znak pitanja i uzvika", registered_sign: "Registrovani znak", reversed_paragraph_sign: "Obrnuti znak paragrafa", right_double_quotation_mark: "Desni dvostruki navodnik", right_pointing_angle_quotation_mark: "Desni jednostruki uglasti navodnik", right_pointing_double_angle_quotation_mark: "Desni dvostruki uglasti navodnik", right_single_quotation_mark: "Desni jednostruki navodnik", ruble: "Znak ruble", rupee: "Znak rupije", section_sign: "Znak odeljka", select_all: "Sve", select_currency: "Valuta", select_text: "Tekst", single_low_quotation_mark: "Jednostruki nisko-9 navodnik", spesmilo: "Znak spesmila", tenge: "Znak tenge", title: "Specijalni karakteri", trade_mark_sign: "Znak trgovinske marke", tugrik: "Znak tugrika", turkish_lira: "Znak turske lire", two_dot_leader: "Dvo-tačka vođa", won: "Znak wona", yen: "Znak jena" }, rO = "Precrtano", oO = "Zamenski varijable", sO = "Zamene", aO = "Poravnanje teksta", lO = { header_one: "Naslov 1", header_three: "Naslov 3", header_two: "Naslov 2", paragraph: "Paragraf", title: "Naslov" }, cO = "Podvučeno", uO = "Poništi", dO = "Poništi", hO = {
  alt_text: E2,
  background_color: M2,
  bold: $2,
  bulletList: z2,
  caption: A2,
  decrease_intent: L2,
  default_font_size: N2,
  extra_spacing: D2,
  font_color: R2,
  font_family: I2,
  font_size: P2,
  global: j2,
  image: B2,
  image_center: F2,
  image_change_alt_text: q2,
  image_change_caption: H2,
  image_change_link: V2,
  image_change_mobile_full_width: U2,
  image_error: W2,
  image_in_line: K2,
  image_insert_via_link: Z2,
  image_side: G2,
  image_via_link: J2,
  increase_intent: Y2,
  italic: X2,
  line_height: Q2,
  link: eO,
  orderedList: tO,
  redo: nO,
  special_characters: iO,
  strike: rO,
  substitute_variables: oO,
  substitutions: sO,
  text_align: aO,
  text_level: lO,
  underline: cO,
  undo: uO,
  unset: dO
}, lR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: E2,
  background_color: M2,
  bold: $2,
  bulletList: z2,
  caption: A2,
  decrease_intent: L2,
  default: hO,
  default_font_size: N2,
  extra_spacing: D2,
  font_color: R2,
  font_family: I2,
  font_size: P2,
  global: j2,
  image: B2,
  image_center: F2,
  image_change_alt_text: q2,
  image_change_caption: H2,
  image_change_link: V2,
  image_change_mobile_full_width: U2,
  image_error: W2,
  image_in_line: K2,
  image_insert_via_link: Z2,
  image_side: G2,
  image_via_link: J2,
  increase_intent: Y2,
  italic: X2,
  line_height: Q2,
  link: eO,
  orderedList: tO,
  redo: nO,
  special_characters: iO,
  strike: rO,
  substitute_variables: oO,
  substitutions: sO,
  text_align: aO,
  text_level: lO,
  underline: cO,
  undo: uO,
  unset: dO
}, Symbol.toStringTag, { value: "Module" })), fO = "Textalternativ", pO = "Teckensnittets bakgrundsfärg", mO = "Fet", gO = "Punktlista", _O = "Bildtext", bO = "Minska indrag", kO = "Standard", yO = "Extra mellanrum", vO = "Teckensnittsfärg", xO = { default: "Standard", default_hint: "Använder teckensnittet som är inställt på platsen för användning", hint: "Standardteckensnitt använder e-postklientens teckensnitt", mailbox_default: "Standard brevlåda", mailbox_default_hint: "Använder mottagarens brevlådas standardteckensnitt (t.ex. Gmail, Outlook eller Yahoo) för optimal läsbarhet", title: "Teckensnittsfamilj" }, SO = "Teckensnittsstorlek", wO = { apply: "Tillämpa", clear: "Klar", error: "Fel" }, CO = "Bild", TO = "Bildjustering center", OO = "Ändra bildens alternativa text", EO = "Ändra bildtext", MO = "Ändra bildlänk", $O = "Ställ in bildens bredd till hela bredden på mobilen", zO = "Misslyckades med att bearbeta bilden", AO = "Bildjustering höger", LO = "Infoga bild via länk", NO = "Bildjustering vänster", DO = "Bild via länk", RO = "Öka indrag", IO = "Kursiv", PO = "Radavstånd", jO = "Länk", BO = "Numrerad lista", FO = "Gör om", qO = { austral: "Australsymbol", bitcoin: "Bitcoinsymbol", cedi: "Cedi-symbol", cent: "Cent-tecken", colon: "Kolontecken", copyright_sign: "Upphovsrättstecken", cruzeiro: "Cruzeiro-tecken", currency: "Valutasymbol", dollar: "Dollar-tecken", dong: "Dong-symbol", double_dagger: "Dubbelt kors", double_exclamation_mark: "Dubbel utropstecken", double_low_quotation_mark: "Dubbelt låg-9 fnutt", double_question_mark: "Dubbelt frågetecken", drachma: "Drachmasymbol", euro: "Euro-tecken", euro_currency: "Euro-valuta-tecken", exclamation_question_mark: "Utropfrågetecken", french_franc: "Fransk franc-tecken", german_penny: "Tysk penny-symbol", guarani: "Guaranísymbol", horizontal_ellipsis: "Horisontell ellips", hryvnia: "Hryvnia-symbol", indian_rupee: "Indisk rupiesymbol", inverted_exclamation_mark: "Omvänt utropstecken", inverted_question_mark: "Omvänt frågetecken", kip: "Kip-symbol", left_double_quotation_mark: "Vänster dubbelfnutt", left_pointing_angle_quotation_mark: "Enkel vänsterpekande vinkelcitattecken", left_pointing_double_angle_quotation_mark: "Vänsterpekande dubbla vinkelcitattecken", left_single_quotation_mark: "Vänster enkel citattecken", lira: "Lira-tecken", livre_tournois: "Livre tournois-symbol", manat: "Manat-tecken", mill: "Mill-symbol", new_sheqel: "Ny shekel-symbol", nordic_mark: "Nordisk mark-symbol", paragraph_sign: "Stycke-tecken", per_mille_sign: "Per mille-tecken", per_ten_thousand_sign: "Per tiotusen-tecken", peseta: "Pesetasymbol", peso: "Pesosymbol", pound: "Pund-tecken", question_exclamation_mark: "Frågeutropstecken", registered_sign: "Registrerat tecken", reversed_paragraph_sign: "Omvänt stycke-tecken", right_double_quotation_mark: "Höger dubbelfnutt", right_pointing_angle_quotation_mark: "Enkel högerpekande vinkelcitattecken", right_pointing_double_angle_quotation_mark: "Högerpekande dubbla vinkelcitattecken", right_single_quotation_mark: "Höger enkel citattecken", ruble: "Rublésymbol", rupee: "Rupiesymbol", section_sign: "Paragraftecken", select_all: "Alla", select_currency: "Valuta", select_text: "Text", single_low_quotation_mark: "Enkel låg-9 fnutt", spesmilo: "Spesmilo-symbol", tenge: "Tenge-symbol", title: "Specialtecken", trade_mark_sign: "Varumärkestecken", tugrik: "Tugrik-symbol", turkish_lira: "Turkisk lira-symbol", two_dot_leader: "Två punkters ledare", won: "Won-symbol", yen: "Yen-tecken" }, HO = "Genomstruken", VO = "Ersättande variabler", UO = "Substitutioner", WO = "Textjustering", KO = { header_one: "Rubrik 1", header_three: "Rubrik 3", header_two: "Rubrik 2", paragraph: "Stycke", title: "Rubrik" }, ZO = "Understruken", GO = "Ångra", JO = "Åtkomst avstängd", YO = {
  alt_text: fO,
  background_color: pO,
  bold: mO,
  bulletList: gO,
  caption: _O,
  decrease_intent: bO,
  default_font_size: kO,
  extra_spacing: yO,
  font_color: vO,
  font_family: xO,
  font_size: SO,
  global: wO,
  image: CO,
  image_center: TO,
  image_change_alt_text: OO,
  image_change_caption: EO,
  image_change_link: MO,
  image_change_mobile_full_width: $O,
  image_error: zO,
  image_in_line: AO,
  image_insert_via_link: LO,
  image_side: NO,
  image_via_link: DO,
  increase_intent: RO,
  italic: IO,
  line_height: PO,
  link: jO,
  orderedList: BO,
  redo: FO,
  special_characters: qO,
  strike: HO,
  substitute_variables: VO,
  substitutions: UO,
  text_align: WO,
  text_level: KO,
  underline: ZO,
  undo: GO,
  unset: JO
}, cR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: fO,
  background_color: pO,
  bold: mO,
  bulletList: gO,
  caption: _O,
  decrease_intent: bO,
  default: YO,
  default_font_size: kO,
  extra_spacing: yO,
  font_color: vO,
  font_family: xO,
  font_size: SO,
  global: wO,
  image: CO,
  image_center: TO,
  image_change_alt_text: OO,
  image_change_caption: EO,
  image_change_link: MO,
  image_change_mobile_full_width: $O,
  image_error: zO,
  image_in_line: AO,
  image_insert_via_link: LO,
  image_side: NO,
  image_via_link: DO,
  increase_intent: RO,
  italic: IO,
  line_height: PO,
  link: jO,
  orderedList: BO,
  redo: FO,
  special_characters: qO,
  strike: HO,
  substitute_variables: VO,
  substitutions: UO,
  text_align: WO,
  text_level: KO,
  underline: ZO,
  undo: GO,
  unset: JO
}, Symbol.toStringTag, { value: "Module" })), XO = "ข้อความทางเลือก", QO = "สีพื้นหลังฟอนต์", eE = "ตัวหนา", tE = "รายการที่มีสัญลักษณ์จุด", nE = "คำบรรยาย", iE = "ลดการเยื้อง", rE = "ค่าเริ่มต้น", oE = "ช่องว่างเพิ่มเติม", sE = "สีฟอนต์", aE = { default: "ค่าเริ่มต้น", default_hint: "ใช้ชุดฟอนต์ที่ตั้งไว้ในสถานที่ใช้งาน", hint: "ฟอนต์มาตรฐานใช้ฟอนต์ของโปรแกรมอีเมล", mailbox_default: "กล่องจดหมายเริ่มต้น", mailbox_default_hint: "ใช้ฟอนต์เริ่มต้นของกล่องจดหมายของผู้รับ (เช่น Gmail, Outlook หรือ Yahoo) เพื่อความอ่านง่ายสูงสุด", title: "ตระกูลฟอนต์" }, lE = "ขนาดฟอนต์", cE = { apply: "นำมาใช้", clear: "ชัดเจน", error: "ข้อผิดพลาด" }, uE = "ภาพ", dE = "จัดภาพไปกลาง", hE = "เปลี่ยนข้อความทางเลือกของภาพ", fE = "เปลี่ยนคำบรรยายภาพ", pE = "เปลี่ยนลิงก์ของภาพ", mE = "ตั้งค่าความกว้างของภาพให้เต็มความกว้างของอุปกรณ์มือถือ", gE = "ไม่สามารถประมวลผลภาพได้", _E = "จัดภาพไปทางขวา", bE = "แทรกรูปภาพผ่านลิงก์", kE = "จัดภาพไปทางซ้าย", yE = "ภาพผ่านลิงก์", vE = "เพิ่มการเยื้อง", xE = "ตัวเอียง", SE = "ความสูงของบรรทัด", wE = "ลิงก์", CE = "รายการที่มีหมายเลข", TE = "ทำซ้ำ", OE = { austral: "สัญลักษณ์ออสตรัล", bitcoin: "สัญลักษณ์บิตคอยน์", cedi: "สัญลักษณ์เซดี", cent: "สัญลักษณ์เซนต์", colon: "สัญลักษณ์โคลอน", copyright_sign: "เครื่องหมายลิขสิทธิ์", cruzeiro: "สัญลักษณ์ครูเซโร", currency: "สัญลักษณ์สกุลเงิน", dollar: "สัญลักษณ์ดอลลาร์", dong: "สัญลักษณ์ดง", double_dagger: "เครื่องหมายดาบคู่", double_exclamation_mark: "เครื่องหมายตกใจสองตัว", double_low_quotation_mark: "เครื่องหมายคำพูดต่ำแบบคู่ 9", double_question_mark: "เครื่องหมายคำถามคู่", drachma: "สัญลักษณ์ดรัคมา", euro: "สัญลักษณ์ยูโร", euro_currency: "สัญลักษณ์สกุลเงินยูโร", exclamation_question_mark: "เครื่องหมายอัศเจรีย์คำถาม", french_franc: "สัญลักษณ์ฟรังก์ฝรั่งเศส", german_penny: "สัญลักษณ์เพนนีเยอรมัน", guarani: "สัญลักษณ์กัวรานี", horizontal_ellipsis: "จุดไข่ปลาแนวนอน", hryvnia: "สัญลักษณ์ฮรีฟเนีย", indian_rupee: "สัญลักษณ์รูปีอินเดีย", inverted_exclamation_mark: "เครื่องหมายอัศเจรีย์กลับด้าน", inverted_question_mark: "เครื่องหมายคำถามกลับด้าน", kip: "สัญลักษณ์คิป", left_double_quotation_mark: "เครื่องหมายคำพูดเปิดแบบคู่", left_pointing_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมซ้ายเดี่ยว", left_pointing_double_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมซ้ายคู่", left_single_quotation_mark: "เครื่องหมายคำพูดเดี่ยวแบบซ้าย", lira: "สัญลักษณ์ลิรา", livre_tournois: "สัญลักษณ์ลิฟร์ตูร์นัว", manat: "เครื่องหมายมานัต", mill: "สัญลักษณ์มิลล์", new_sheqel: "สัญลักษณ์เชเคลใหม่", nordic_mark: "สัญลักษณ์มาร์คเหนือ", paragraph_sign: "เครื่องหมายย่อหน้า", per_mille_sign: "เครื่องหมายเปอร์มิลล์", per_ten_thousand_sign: "เครื่องหมายเปอร์สิบพัน", peseta: "สัญลักษณ์เปเซตา", peso: "สัญลักษณ์เปโซ", pound: "สัญลักษณ์ปอนด์", question_exclamation_mark: "เครื่องหมายคำถามอัศเจรีย์", registered_sign: "เครื่องหมายจดทะเบียน", reversed_paragraph_sign: "เครื่องหมายย่อหน้ากลับด้าน", right_double_quotation_mark: "เครื่องหมายคำพูดปิดแบบคู่", right_pointing_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมขวาเดี่ยว", right_pointing_double_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมขวาคู่", right_single_quotation_mark: "เครื่องหมายคำพูดเดี่ยวแบบขวา", ruble: "สัญลักษณ์รูเบิล", rupee: "สัญลักษณ์รูปี", section_sign: "เครื่องหมายหมวดหมู่", select_all: "ทั้งหมด", select_currency: "สกุลเงิน", select_text: "ข้อความ", single_low_quotation_mark: "เครื่องหมายคำพูดต่ำแบบเดี่ยว 9", spesmilo: "สัญลักษณ์สเปสมีโล", tenge: "สัญลักษณ์เทนเก", title: "อักขระพิเศษ", trade_mark_sign: "เครื่องหมายการค้า", tugrik: "สัญลักษณ์ทูกริก", turkish_lira: "สัญลักษณ์ลีราตุรกี", two_dot_leader: "จุดนำสองจุด", won: "สัญลักษณ์วอน", yen: "สัญลักษณ์เยน" }, EE = "ขีดทับ", ME = "ตัวแปรทดแทน", $E = "การแทนที่", zE = "การจัดแนวข้อความ", AE = { header_one: "หัวเรื่อง 1", header_three: "หัวเรื่อง 3", header_two: "หัวเรื่อง 2", paragraph: "ย่อหน้า", title: "หัวเรื่อง" }, LE = "ขีดเส้นใต้", NE = "ย้อนกลับ", DE = "ไม่กำหนด", RE = {
  alt_text: XO,
  background_color: QO,
  bold: eE,
  bulletList: tE,
  caption: nE,
  decrease_intent: iE,
  default_font_size: rE,
  extra_spacing: oE,
  font_color: sE,
  font_family: aE,
  font_size: lE,
  global: cE,
  image: uE,
  image_center: dE,
  image_change_alt_text: hE,
  image_change_caption: fE,
  image_change_link: pE,
  image_change_mobile_full_width: mE,
  image_error: gE,
  image_in_line: _E,
  image_insert_via_link: bE,
  image_side: kE,
  image_via_link: yE,
  increase_intent: vE,
  italic: xE,
  line_height: SE,
  link: wE,
  orderedList: CE,
  redo: TE,
  special_characters: OE,
  strike: EE,
  substitute_variables: ME,
  substitutions: $E,
  text_align: zE,
  text_level: AE,
  underline: LE,
  undo: NE,
  unset: DE
}, uR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: XO,
  background_color: QO,
  bold: eE,
  bulletList: tE,
  caption: nE,
  decrease_intent: iE,
  default: RE,
  default_font_size: rE,
  extra_spacing: oE,
  font_color: sE,
  font_family: aE,
  font_size: lE,
  global: cE,
  image: uE,
  image_center: dE,
  image_change_alt_text: hE,
  image_change_caption: fE,
  image_change_link: pE,
  image_change_mobile_full_width: mE,
  image_error: gE,
  image_in_line: _E,
  image_insert_via_link: bE,
  image_side: kE,
  image_via_link: yE,
  increase_intent: vE,
  italic: xE,
  line_height: SE,
  link: wE,
  orderedList: CE,
  redo: TE,
  special_characters: OE,
  strike: EE,
  substitute_variables: ME,
  substitutions: $E,
  text_align: zE,
  text_level: AE,
  underline: LE,
  undo: NE,
  unset: DE
}, Symbol.toStringTag, { value: "Module" })), IE = "Metin alternatifi", PE = "Yazı tipi arka plan rengi", jE = "Kalın", BE = "Madde işaretli liste", FE = "Resim yazısı", qE = "Girintiyi azalt", HE = "Varsayılan", VE = "Ekstra boşluk", UE = "Yazı tipi rengi", WE = { default: "Varsayılan", default_hint: "Kullanım yerinde ayarlanan yazı tipini kullanır", hint: "Standart yazı tipi e-posta istemcisi yazı tiplerini kullanır", mailbox_default: "Posta Kutusu Varsayılanı", mailbox_default_hint: "Alıcının posta kutusunun varsayılan yazı tipini kullanır (örneğin, Gmail, Outlook veya Yahoo) en iyi okunabilirlik için", title: "Yazı tipi ailesi" }, KE = "Yazı tipi boyutu", ZE = { apply: "Uygula", clear: "Temizlemek", error: "Hata" }, GE = "Resim", JE = "Resmi ortaya hizala", YE = "Resim metin alternatifini değiştir", XE = "Resim yazısını değiştir", QE = "Resim bağlantısını değiştir", eM = "Görüntü genişliğini mobil cihazın tam genişliğine ayarla", tM = "Görüntü işleme başarısız oldu", nM = "Resmi sağa hizala", iM = "Bağlantı aracılığıyla görüntü ekle", rM = "Resmi sola hizala", oM = "Bağlantı yoluyla görüntü", sM = "Girintiyi artır", aM = "İtalik", lM = "Satır yüksekliği", cM = "Bağlantı", uM = "Numaralandırılmış liste", dM = "Yinele", hM = { austral: "Avustral işareti", bitcoin: "Bitcoin işareti", cedi: "Cedi işareti", cent: "Sent işareti", colon: "Colon işareti", copyright_sign: "Telif hakkı işareti", cruzeiro: "Cruzeiro işareti", currency: "Para birimi işareti", dollar: "Dolar işareti", dong: "Dong işareti", double_dagger: "Çift hançer işareti", double_exclamation_mark: "Çift ünlem işareti", double_low_quotation_mark: "Çift düşük-9 tırnak işareti", double_question_mark: "Çift soru işareti", drachma: "Drahmi işareti", euro: "Euro işareti", euro_currency: "Euro para birimi işareti", exclamation_question_mark: "Ünlem soru işareti", french_franc: "Fransız frankı işareti", german_penny: "Alman kuruşu işareti", guarani: "Guarani işareti", horizontal_ellipsis: "Yatay üç nokta", hryvnia: "Hırvat kunası işareti", indian_rupee: "Hindistan rupisi işareti", inverted_exclamation_mark: "Ters ünlem işareti", inverted_question_mark: "Ters soru işareti", kip: "Kip işareti", left_double_quotation_mark: "Sol çift tırnak işareti", left_pointing_angle_quotation_mark: "Sola bakan tek açı tırnak işareti", left_pointing_double_angle_quotation_mark: "Sola bakan çift açı tırnak işareti", left_single_quotation_mark: "Sol tek tırnak işareti", lira: "Lira işareti", livre_tournois: "Livre tournois işareti", manat: "Manat işareti", mill: "Mill işareti", new_sheqel: "Yeni şekel işareti", nordic_mark: "Nordik işareti", paragraph_sign: "Paragraf işareti", per_mille_sign: "Binde işareti", per_ten_thousand_sign: "On binde işareti", peseta: "Peseta işareti", peso: "Peso işareti", pound: "Pound işareti", question_exclamation_mark: "Soru ünlem işareti", registered_sign: "Tescilli işareti", reversed_paragraph_sign: "Ters paragraf işareti", right_double_quotation_mark: "Sağ çift tırnak işareti", right_pointing_angle_quotation_mark: "Sağa bakan tek açı tırnak işareti", right_pointing_double_angle_quotation_mark: "Sağa bakan çift açı tırnak işareti", right_single_quotation_mark: "Sağ tek tırnak işareti", ruble: "Ruble işareti", rupee: "Rupi işareti", section_sign: "Bölüm işareti", select_all: "Hepsi", select_currency: "Para birimi", select_text: "Metin", single_low_quotation_mark: "Tek düşük-9 tırnak işareti", spesmilo: "Spesmilo işareti", tenge: "Tenge işareti", title: "Özel karakterler", trade_mark_sign: "Ticari marka işareti", tugrik: "Tugrik işareti", turkish_lira: "Türk lirası işareti", two_dot_leader: "İki nokta lideri", won: "Won işareti", yen: "Yen işareti" }, fM = "Üstü çizili", pM = "Yedek değişkenler", mM = "Yedekler", gM = "Metin hizalama", _M = { header_one: "Başlık 1", header_three: "Başlık 3", header_two: "Başlık 2", paragraph: "Paragraf", title: "Başlık" }, bM = "Altı çizili", kM = "Geri al", yM = "Sıfırla", vM = {
  alt_text: IE,
  background_color: PE,
  bold: jE,
  bulletList: BE,
  caption: FE,
  decrease_intent: qE,
  default_font_size: HE,
  extra_spacing: VE,
  font_color: UE,
  font_family: WE,
  font_size: KE,
  global: ZE,
  image: GE,
  image_center: JE,
  image_change_alt_text: YE,
  image_change_caption: XE,
  image_change_link: QE,
  image_change_mobile_full_width: eM,
  image_error: tM,
  image_in_line: nM,
  image_insert_via_link: iM,
  image_side: rM,
  image_via_link: oM,
  increase_intent: sM,
  italic: aM,
  line_height: lM,
  link: cM,
  orderedList: uM,
  redo: dM,
  special_characters: hM,
  strike: fM,
  substitute_variables: pM,
  substitutions: mM,
  text_align: gM,
  text_level: _M,
  underline: bM,
  undo: kM,
  unset: yM
}, dR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: IE,
  background_color: PE,
  bold: jE,
  bulletList: BE,
  caption: FE,
  decrease_intent: qE,
  default: vM,
  default_font_size: HE,
  extra_spacing: VE,
  font_color: UE,
  font_family: WE,
  font_size: KE,
  global: ZE,
  image: GE,
  image_center: JE,
  image_change_alt_text: YE,
  image_change_caption: XE,
  image_change_link: QE,
  image_change_mobile_full_width: eM,
  image_error: tM,
  image_in_line: nM,
  image_insert_via_link: iM,
  image_side: rM,
  image_via_link: oM,
  increase_intent: sM,
  italic: aM,
  line_height: lM,
  link: cM,
  orderedList: uM,
  redo: dM,
  special_characters: hM,
  strike: fM,
  substitute_variables: pM,
  substitutions: mM,
  text_align: gM,
  text_level: _M,
  underline: bM,
  undo: kM,
  unset: yM
}, Symbol.toStringTag, { value: "Module" })), xM = "Текстова альтернатива", SM = "Колір фону шрифту", wM = "Жирний", CM = "Маркерований список", TM = "Підпис", OM = "Зменшити відступ", EM = "За замовчуванням", MM = "Додатковий інтервал", $M = "Колір шрифту", zM = { default: "За замовчуванням", default_hint: "Використовує набір шрифтів, встановлений у місці використання", hint: "Стандартний шрифт використовує шрифти поштового клієнта", mailbox_default: "За замовчуванням поштової скриньки", mailbox_default_hint: "Використовує стандартний шрифт поштової скриньки отримувача (наприклад, Gmail, Outlook або Yahoo) для оптимальної читабельності", title: "Сімейство шрифтів" }, AM = "Розмір шрифту", LM = { apply: "Застосувати", clear: "ясно", error: "Помилка" }, NM = "Зображення", DM = "Вирівняти зображення по центру", RM = "Змінити альтернативний текст зображення", IM = "Змінити підпис зображення", PM = "Змінити посилання на зображення", jM = "Встановіть ширину зображення на повну ширину мобільного пристрою", BM = "Не вдалося обробити зображення", FM = "Вирівняти зображення праворуч", qM = "Вставити зображення за посиланням", HM = "Вирівняти зображення ліворуч", VM = "Зображення за посиланням", UM = "Збільшити відступ", WM = "Курсив", KM = "Висота рядка", ZM = "Посилання", GM = "Нумерований список", JM = "Повторити", YM = { austral: "Знак австрала", bitcoin: "Знак біткоїна", cedi: "Знак седі", cent: "Знак центу", colon: "Знак двокрапки", copyright_sign: "Знак авторського права", cruzeiro: "Знак крузейро", currency: "Знак валюти", dollar: "Знак долара", dong: "Знак донга", double_dagger: "Подвійний хрестик", double_exclamation_mark: "Подвійний знак оклику", double_low_quotation_mark: "Подвійна низька лапка-9", double_question_mark: "Подвійний знак питання", drachma: "Знак драхми", euro: "Знак євро", euro_currency: "Знак євро-валюти", exclamation_question_mark: "Знак оклику-питання", french_franc: "Знак французького франка", german_penny: "Знак німецької пенні", guarani: "Знак гуарані", horizontal_ellipsis: "Горизонтальні три крапки", hryvnia: "Знак гривні", indian_rupee: "Знак індійської рупії", inverted_exclamation_mark: "Перевернутий знак оклику", inverted_question_mark: "Перевернуте питання", kip: "Знак кипа", left_double_quotation_mark: "Ліва подвійна лапка", left_pointing_angle_quotation_mark: "Одинична лівостороння кутова лапка", left_pointing_double_angle_quotation_mark: "Подвійна лівостороння кутова лапка", left_single_quotation_mark: "Лівостороння одинична лапка", lira: "Знак ліри", livre_tournois: "Знак ліври турно", manat: "Знак маната", mill: "Знак мілі", new_sheqel: "Знак нового шекеля", nordic_mark: "Знак нордичної марки", paragraph_sign: "Знак абзацу", per_mille_sign: "Знак пер mille", per_ten_thousand_sign: "Знак пер десять тисяч", peseta: "Знак песети", peso: "Знак песо", pound: "Знак фунта", question_exclamation_mark: "Знак питання-оклик", registered_sign: "Знак зареєстрованої торгової марки", reversed_paragraph_sign: "Перевернутий знак абзацу", right_double_quotation_mark: "Права подвійна лапка", right_pointing_angle_quotation_mark: "Одинична правостороння кутова лапка", right_pointing_double_angle_quotation_mark: "Подвійна правостороння кутова лапка", right_single_quotation_mark: "Правостороння одинична лапка", ruble: "Знак рубля", rupee: "Знак рупії", section_sign: "Знак розділу", select_all: "Усе", select_currency: "Валюта", select_text: "Текст", single_low_quotation_mark: "Одиночна низька лапка-9", spesmilo: "Знак спесміло", tenge: "Знак тенге", title: "Спеціальні символи", trade_mark_sign: "Знак торгової марки", tugrik: "Знак тугрика", turkish_lira: "Знак турецької ліри", two_dot_leader: "Двокрапка-лідер", won: "Знак вона", yen: "Знак єни" }, XM = "Перекреслений", QM = "Замінні змінні", e$ = "Зам substitutions", t$ = "Вирівнювання тексту", n$ = { header_one: "Заголовок 1", header_three: "Заголовок 3", header_two: "Заголовок 2", paragraph: "Абзац", title: "Заголовок" }, i$ = "Підкреслений", r$ = "Скасувати", o$ = "Скинути", s$ = {
  alt_text: xM,
  background_color: SM,
  bold: wM,
  bulletList: CM,
  caption: TM,
  decrease_intent: OM,
  default_font_size: EM,
  extra_spacing: MM,
  font_color: $M,
  font_family: zM,
  font_size: AM,
  global: LM,
  image: NM,
  image_center: DM,
  image_change_alt_text: RM,
  image_change_caption: IM,
  image_change_link: PM,
  image_change_mobile_full_width: jM,
  image_error: BM,
  image_in_line: FM,
  image_insert_via_link: qM,
  image_side: HM,
  image_via_link: VM,
  increase_intent: UM,
  italic: WM,
  line_height: KM,
  link: ZM,
  orderedList: GM,
  redo: JM,
  special_characters: YM,
  strike: XM,
  substitute_variables: QM,
  substitutions: e$,
  text_align: t$,
  text_level: n$,
  underline: i$,
  undo: r$,
  unset: o$
}, hR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: xM,
  background_color: SM,
  bold: wM,
  bulletList: CM,
  caption: TM,
  decrease_intent: OM,
  default: s$,
  default_font_size: EM,
  extra_spacing: MM,
  font_color: $M,
  font_family: zM,
  font_size: AM,
  global: LM,
  image: NM,
  image_center: DM,
  image_change_alt_text: RM,
  image_change_caption: IM,
  image_change_link: PM,
  image_change_mobile_full_width: jM,
  image_error: BM,
  image_in_line: FM,
  image_insert_via_link: qM,
  image_side: HM,
  image_via_link: VM,
  increase_intent: UM,
  italic: WM,
  line_height: KM,
  link: ZM,
  orderedList: GM,
  redo: JM,
  special_characters: YM,
  strike: XM,
  substitute_variables: QM,
  substitutions: e$,
  text_align: t$,
  text_level: n$,
  underline: i$,
  undo: r$,
  unset: o$
}, Symbol.toStringTag, { value: "Module" })), a$ = "文本替代", l$ = "字体背景颜色", c$ = "粗体", u$ = "项目符号列表", d$ = "标题", h$ = "减少意图", f$ = "默认", p$ = "段落间距", m$ = "字体颜色", g$ = { default: "默认", default_hint: "采用使用位置所设置的字体", hint: "标准字体使用电子邮件客户端字体", mailbox_default: "邮箱默认", mailbox_default_hint: "使用收件人邮箱的默认字体（例如，Gmail、Outlook或Yahoo）以获得最佳可读性", title: "字体" }, _$ = "字体大小", b$ = { apply: "申请", clear: "清空", error: "错误" }, k$ = "图像", y$ = "图片居中对齐", v$ = "更改图片替代文本", x$ = "更改图片标题", S$ = "更改图片链接", w$ = "将图像宽度设置为移动设备的全宽", C$ = "处理图像失败", T$ = "图片右对齐", O$ = "通过链接插入图像", E$ = "图片左对齐", M$ = "通过链接插入的图像", $$ = "增加意图", z$ = "斜体", A$ = "行高", L$ = "链接", N$ = "编号列表", D$ = "重做", R$ = { austral: "澳大利亚标志", bitcoin: "比特币标志", cedi: "塞地标志", cent: "美分标志", colon: "Colon标志", copyright_sign: "版权标记", cruzeiro: "克鲁塞罗标志", currency: "货币标志", dollar: "美元标志", dong: "侗族标志", double_dagger: "双匕", double_exclamation_mark: "双感叹号", double_low_quotation_mark: "双低引号", double_question_mark: "双问号", drachma: "德拉克马标志", euro: "欧元标志", euro_currency: "欧洲货币标志", exclamation_question_mark: "感叹问号", french_franc: "法国法郎标志", german_penny: "德国便士标志", guarani: "瓜拉尼标志", horizontal_ellipsis: "水平省略号", hryvnia: "格里夫纳标志", indian_rupee: "印度卢比标志", inverted_exclamation_mark: "倒置感叹号", inverted_question_mark: "倒置问号", kip: "基普标志", left_double_quotation_mark: "左双引号", left_pointing_angle_quotation_mark: "单个左角引号", left_pointing_double_angle_quotation_mark: "左侧双角引号", left_single_quotation_mark: "左单引号", lira: "里拉标志", livre_tournois: "巡回赛标志", manat: "马纳特标志", mill: "Mill标志", new_sheqel: "新 Sheqel 标志", nordic_mark: "北欧标志", paragraph_sign: "段落标记", per_mille_sign: "每米标志", per_ten_thousand_sign: "每万个标志", peseta: "比塞塔标志", peso: "比索标志", pound: "英镑标志", question_exclamation_mark: "问号感叹号", registered_sign: "已注册标记", reversed_paragraph_sign: "反向段落标记", right_double_quotation_mark: "右双引号", right_pointing_angle_quotation_mark: "单个右角引号", right_pointing_double_angle_quotation_mark: "直角双角引号", right_single_quotation_mark: "右单引号", ruble: "卢布标志", rupee: "卢比标志", section_sign: "部分标记", select_all: "所有", select_currency: "货币", select_text: "文本", single_low_quotation_mark: "单引号", spesmilo: "Spesmilo 标志", tenge: "坚戈标志", title: "特殊字符", trade_mark_sign: "商标标记", tugrik: "图格里克标志", turkish_lira: "土耳其里拉标志", two_dot_leader: "两点领航", won: "Won标志", yen: "日元标志" }, I$ = "划线", P$ = "替代变量", j$ = "替代品", B$ = "文本对齐", F$ = { header_one: "标题1", header_three: "标题 3", header_two: "标题 2", paragraph: "段落", title: "标题" }, q$ = "下划线", H$ = "撤销", V$ = "未设置", U$ = {
  alt_text: a$,
  background_color: l$,
  bold: c$,
  bulletList: u$,
  caption: d$,
  decrease_intent: h$,
  default_font_size: f$,
  extra_spacing: p$,
  font_color: m$,
  font_family: g$,
  font_size: _$,
  global: b$,
  image: k$,
  image_center: y$,
  image_change_alt_text: v$,
  image_change_caption: x$,
  image_change_link: S$,
  image_change_mobile_full_width: w$,
  image_error: C$,
  image_in_line: T$,
  image_insert_via_link: O$,
  image_side: E$,
  image_via_link: M$,
  increase_intent: $$,
  italic: z$,
  line_height: A$,
  link: L$,
  orderedList: N$,
  redo: D$,
  special_characters: R$,
  strike: I$,
  substitute_variables: P$,
  substitutions: j$,
  text_align: B$,
  text_level: F$,
  underline: q$,
  undo: H$,
  unset: V$
}, fR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: a$,
  background_color: l$,
  bold: c$,
  bulletList: u$,
  caption: d$,
  decrease_intent: h$,
  default: U$,
  default_font_size: f$,
  extra_spacing: p$,
  font_color: m$,
  font_family: g$,
  font_size: _$,
  global: b$,
  image: k$,
  image_center: y$,
  image_change_alt_text: v$,
  image_change_caption: x$,
  image_change_link: S$,
  image_change_mobile_full_width: w$,
  image_error: C$,
  image_in_line: T$,
  image_insert_via_link: O$,
  image_side: E$,
  image_via_link: M$,
  increase_intent: $$,
  italic: z$,
  line_height: A$,
  link: L$,
  orderedList: N$,
  redo: D$,
  special_characters: R$,
  strike: I$,
  substitute_variables: P$,
  substitutions: j$,
  text_align: B$,
  text_level: F$,
  underline: q$,
  undo: H$,
  unset: V$
}, Symbol.toStringTag, { value: "Module" })), W$ = ["common"], pR = W$[0], mR = Object.values(Na), gR = {
  ar: { common: bm },
  cs: { common: ig },
  da: { common: qg },
  de: { common: O_ },
  el: { common: hb },
  en: { common: Yb },
  es: { common: Rk },
  fr: { common: vy },
  hi: { common: s1 },
  hu: { common: U1 },
  id: { common: $0 },
  it: { common: mv },
  ja: { common: ex },
  nl: { common: jx },
  no: { common: wS },
  pl: { common: cw },
  pt: { common: Zw },
  ro: { common: LC },
  ru: { common: b3 },
  sk: { common: iT },
  sl: { common: qT },
  sq: { common: O2 },
  sr: { common: hO },
  sv: { common: YO },
  th: { common: RE },
  tr: { common: vM },
  uk: { common: s$ },
  zh: { common: U$ }
}, _R = {
  supportedLngs: mR,
  load: "languageOnly",
  debug: !1,
  defaultNS: pR,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: W$,
  compatibilityJSON: "v3",
  fallbackLng: Na.ENGLISH,
  lng: Na.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: gR
};
M.use(g5).init(_R);
function K$(n) {
  return /* @__PURE__ */ j("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b("path", { d: "M13.2656 1.6875H6.73438C5.75172 1.6875 4.95312 2.48609 4.95312 3.46875V16.5312C4.95312 17.5139 5.75172 18.3125 6.73438 18.3125H13.2656C14.2483 18.3125 15.0469 17.5139 15.0469 16.5312V3.46875C15.0469 2.48609 14.2483 1.6875 13.2656 1.6875ZM13.8594 16.5312C13.8594 16.8578 13.5922 17.125 13.2656 17.125H6.73438C6.40781 17.125 6.14062 16.8578 6.14062 16.5312V3.46875C6.14062 3.14219 6.40781 2.875 6.73438 2.875H7.32812C7.32812 3.36484 7.72891 3.76562 8.21875 3.76562H11.7812C12.2711 3.76562 12.6719 3.36484 12.6719 2.875H13.2656C13.5922 2.875 13.8594 3.14219 13.8594 3.46875V16.5312Z" }),
    /* @__PURE__ */ b(
      "path",
      {
        d: "M7.5 13L12.5 8M7.5 13H9.16667M7.5 13L7.5 11.3333M12.5 8H10.8333M12.5 8V9.66667",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] });
}
const Nn = "group flex items-center justify-center focus-visible:outline-brand-primary rounded-lg h-3 px-[9px] py-4 [&>svg]:h-3.5 [&>svg]:w-3.5 cursor-pointer", he = (n) => K(
  "main-transition-colors",
  n ? "stroke-text-secondary" : "stroke-text-primary group-hover:stroke-brand-primary"
), md = (n) => K(
  "main-transition-colors",
  n ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
), Z$ = (n) => K(
  "main-transition-colors",
  n ? "text-text-secondary" : "text-text-primary hover:text-brand-primary"
), bR = "#000000", kR = "15px", yR = "#ffffff", ll = "1rem", gd = "8px", vR = {
  marginTop: 0,
  marginBottom: 0
}, fo = {
  2: {
    marginTop: "0.83em",
    marginBottom: "0.83em",
    fontSize: "1.5em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  3: {
    marginTop: "1em",
    marginBottom: "1em",
    fontSize: "1.17em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  4: {
    marginTop: "1.33em",
    marginBottom: "1.33em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold",
    fontSize: "1em"
  }
}, Bo = {
  marginTop: ll,
  marginBottom: ll,
  paddingLeft: "40px"
}, re = {
  hoverOpenDelay: 900,
  popoverClassName: "px-2 py-1 shadow-md [--anchor-gap:5px] z-[9999]"
}, G$ = {
  display: "table",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: ".9em auto"
}, xR = "@media (max-width: 600px) { .is-mobile-full-width figure { width: 100% !important; } }", SR = "@media (max-width: 600px) { .is-mobile-full-width img { width: 100% !important; max-width: 100% !important; } }", J$ = (n) => ({
  display: "table",
  float: "right",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: n ? `${ll} 0 .9em 1.5em` : "0 0 .9em 1.5em"
}), wR = {
  display: "block",
  margin: "0 auto",
  minWidth: "100%",
  maxWidth: "100%"
}, Y$ = {
  display: "table-caption",
  captionSide: "bottom",
  wordBreak: "break-word",
  textAlign: "center",
  color: "rgb(var(--text-primary))",
  backgroundColor: "rgb(var(--background-primary))",
  padding: ".6em",
  fontSize: ".75em",
  outlineOffset: "-1px"
};
var We = /* @__PURE__ */ ((n) => (n.Inline = "inline-image", n.Block = "block-image", n))(We || {}), ce = /* @__PURE__ */ ((n) => (n.Inline = "inline", n.BlockCenter = "blockCenter", n.BlockRight = "blockRight", n))(ce || {}), Zi = /* @__PURE__ */ ((n) => (n.Before = "before", n.After = "after", n))(Zi || {}), le = /* @__PURE__ */ ((n) => (n[n.InitialMode = 0] = "InitialMode", n[n.ViewLinkMode = 1] = "ViewLinkMode", n.EditCaptionMode = "caption", n.EditAltMode = "alt", n.EditLinkMode = "href", n))(le || {});
function ae({ className: n, children: e, ...t }) {
  return /* @__PURE__ */ b(
    "button",
    {
      type: "button",
      className: K(
        Nn,
        "main-transition-colors",
        t.disabled ? "text-text-secondary" : "text-text-primary hover:text-brand-primary",
        n
      ),
      ...t,
      children: e
    }
  );
}
function CR(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M19 13V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V13M15 8L10 13M10 13L5 8M10 13V1",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function TR(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M21 20.9998H13M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function OR(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0858L20.5 20.5M12 17.6569L9.87868 19.7782C8.31658 21.3403 5.78392 21.3403 4.22183 19.7782C2.65973 18.2161 2.65973 15.6834 4.22183 14.1213L6.34315 12M17.6569 12L19.7782 9.87868C21.3403 8.31658 21.3403 5.78392 19.7782 4.22183C18.2161 2.65973 15.6834 2.65973 14.1213 4.22183L12 6.34315",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function X$({ link: n, unsetLink: e, setIsEditing: t }) {
  return /* @__PURE__ */ j(ln, { children: [
    /* @__PURE__ */ b("div", { className: "w-[220px] truncate", children: /* @__PURE__ */ b(
      "a",
      {
        href: n,
        target: "_blank",
        className: "text-brand-primary px-3 truncate underline",
        children: n
      }
    ) }),
    /* @__PURE__ */ j("div", { className: "flex", children: [
      /* @__PURE__ */ b(ae, { onClick: e, children: /* @__PURE__ */ b(OR, { className: "main-transition-colors stroke-text-primary group-hover:stroke-red h-3.5 w-3.5" }) }),
      /* @__PURE__ */ b(ae, { onClick: () => t(!0), children: /* @__PURE__ */ b(TR, { className: he(!1) }) })
    ] })
  ] });
}
function Q$({
  newLink: n,
  onChangeLink: e,
  onSaveLink: t,
  openFileSelector: i
}) {
  const r = !yh(n);
  return /* @__PURE__ */ j(ln, { children: [
    /* @__PURE__ */ b(
      mh,
      {
        className: "w-[250px]",
        value: n,
        placeholder: "example.com",
        onChange: e
      }
    ),
    /* @__PURE__ */ j("div", { className: "flex", children: [
      /* @__PURE__ */ b(ae, { onClick: i, children: /* @__PURE__ */ b(CR, { className: he(!1) }) }),
      /* @__PURE__ */ b(ae, { type: "submit", onClick: () => t(n), disabled: r, children: /* @__PURE__ */ b(Cl, { className: he(r) }) })
    ] })
  ] });
}
function ER(n) {
  return /* @__PURE__ */ b("svg", { width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512", ...n, children: /* @__PURE__ */ b("path", { d: "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z" }) });
}
function cl(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M1.92684 0.666649V11.3333M9.92684 0.666649V11.3333M3.26017 0.666649H0.593506M9.92684 5.99998L1.92684 5.99998M3.26017 11.3333H0.593506M11.2602 11.3333H8.59351M11.2602 0.666649H8.59351",
          "stroke-width": "1.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function MR(n) {
  return /* @__PURE__ */ j("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b("path", { opacity: ".5", d: "M2 3h16v1.5H2zm0 12h16v1.5H2z" }),
    /* @__PURE__ */ b("path", { d: "M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z" })
  ] });
}
function $R(n) {
  return /* @__PURE__ */ j("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b("path", { opacity: ".5", d: "M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z" }),
    /* @__PURE__ */ b("path", { d: "M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z" })
  ] });
}
function zR(n) {
  return /* @__PURE__ */ j("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b(
      "path",
      {
        opacity: ".5",
        d: "M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"
      }
    ),
    /* @__PURE__ */ b("path", { d: "M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z" })
  ] });
}
function Fo(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M6.66668 8.66666C6.95298 9.04942 7.31825 9.36612 7.73771 9.59529C8.15717 9.82446 8.62102 9.96074 9.09778 9.99489C9.57454 10.029 10.0531 9.96024 10.5009 9.79319C10.9487 9.62613 11.3554 9.36471 11.6933 9.02666L13.6933 7.02666C14.3005 6.39799 14.6365 5.55598 14.6289 4.68199C14.6213 3.808 14.2708 2.97196 13.6527 2.35394C13.0347 1.73591 12.1987 1.38535 11.3247 1.37775C10.4507 1.37016 9.60869 1.70614 8.98001 2.31333L7.83334 3.45333M9.33334 7.33333C9.04704 6.95058 8.68177 6.63388 8.26231 6.4047C7.84285 6.17553 7.37901 6.03925 6.90224 6.00511C6.42548 5.97096 5.94695 6.03975 5.49911 6.20681C5.05128 6.37387 4.6446 6.63528 4.30668 6.97333L2.30668 8.97333C1.69948 9.602 1.3635 10.444 1.3711 11.318C1.37869 12.192 1.72926 13.028 2.34728 13.6461C2.96531 14.2641 3.80135 14.6147 4.67534 14.6222C5.54933 14.6298 6.39134 14.2939 7.02001 13.6867L8.16001 12.5467",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const Ct = (n) => n ? n.isActive(We.Block) || n.isActive(We.Inline) : !1;
function ez({
  editor: n,
  children: e,
  className: t,
  shouldShow: i,
  tippyOptions: r,
  ...o
}) {
  return /* @__PURE__ */ b(
    X4,
    {
      className: K("bg-background-secondary shadow-3xl rounded-lg", t),
      editor: n,
      shouldShow: i,
      updateDelay: 0,
      tippyOptions: {
        appendTo: "parent",
        duration: [200, 0],
        placement: "bottom",
        offset: [0, 10],
        hideOnClick: !0,
        ...r
      },
      ...o,
      children: e
    }
  );
}
const _d = (n) => {
  var a;
  const e = n == null ? void 0 : n.state, t = e == null ? void 0 : e.selection.from, i = (a = e == null ? void 0 : e.doc.nodeAt(t ?? 0)) == null ? void 0 : a.type.name, r = i ? n == null ? void 0 : n.getAttributes(i).caption : null, o = i ? n == null ? void 0 : n.getAttributes(i).alt : null, s = i ? n == null ? void 0 : n.getAttributes(i).href : null;
  return {
    [le.EditAltMode]: o ?? "",
    [le.EditLinkMode]: s ?? "",
    [le.EditCaptionMode]: r ?? ""
  };
}, AR = ({ editor: n, fileSource: e }) => {
  var A;
  const [t, i] = xe(_d(n)), [r, o] = xe(
    le.InitialMode
  ), [s, a] = xe(!1), l = n == null ? void 0 : n.state, c = l == null ? void 0 : l.selection.from, u = (A = l == null ? void 0 : l.doc.nodeAt(c ?? 0)) == null ? void 0 : A.type.name, d = u ? n == null ? void 0 : n.getAttributes(u).imageMode : null, h = u ? n == null ? void 0 : n.getAttributes(u).isMobileFullWidth : !1, [f, p] = xe(!1);
  if (Ge(() => {
    const z = () => {
      o(le.InitialMode), i(_d(n));
    };
    return z(), () => z();
  }, [c, n]), !n || !(n != null && n.options.editable)) return null;
  const m = (z) => {
    i((I) => ({ ...I, [r]: z }));
  }, g = (z) => {
    if (r === le.InitialMode || r === le.ViewLinkMode || !u)
      return;
    const I = z ?? t[r];
    n.chain().focus().updateAttributes(u, { [r]: I }).run(), o(le.InitialMode);
  }, k = (z) => {
    u && (n.chain().focus().updateAttributes(u, { [z]: null }).run(), i((I) => ({ ...I, [z]: "" })), o(le.InitialMode));
  }, v = (z) => {
    n.chain().focus().toggleImageMode(z).run();
  }, S = () => {
    d === ce.Inline && v(ce.BlockCenter), setTimeout(() => {
      o(le.EditCaptionMode);
    }, 0);
  }, _ = () => {
    u && n.chain().focus().updateAttributes(u, { isMobileFullWidth: !h }).run();
  }, x = t[le.EditAltMode].length > 0, y = t[le.EditCaptionMode].length > 0, w = t[le.EditLinkMode].length > 0, $ = () => {
    switch (r) {
      case le.ViewLinkMode:
        return /* @__PURE__ */ b(
          X$,
          {
            link: t[le.EditLinkMode],
            unsetLink: () => k(le.EditLinkMode),
            setIsEditing: () => o(le.EditLinkMode)
          }
        );
      case le.EditLinkMode:
        return /* @__PURE__ */ b(
          Q$,
          {
            newLink: t[le.EditLinkMode],
            onChangeLink: m,
            onSaveLink: g,
            openFileSelector: () => {
              a(!0);
            }
          }
        );
      case le.EditCaptionMode:
      case le.EditAltMode: {
        const z = t[r];
        let I = "";
        switch (r) {
          case le.EditCaptionMode: {
            I = M.t("caption");
            break;
          }
          case le.EditAltMode:
            I = M.t("alt_text");
            break;
        }
        return /* @__PURE__ */ j(ln, { children: [
          /* @__PURE__ */ b(
            Kz,
            {
              placeholder: I,
              value: z,
              onChange: (L) => m(L.target.value)
            }
          ),
          /* @__PURE__ */ b(ae, { type: "submit", onClick: () => g(), children: /* @__PURE__ */ b(Cl, { className: he(!1) }) })
        ] });
      }
      case le.InitialMode:
      default:
        return /* @__PURE__ */ j(ln, { children: [
          /* @__PURE__ */ b(
            ne,
            {
              label: M.t("image_in_line"),
              anchor: "left",
              disabled: f,
              ...re,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => v(ce.Inline),
                  className: Ee(d === ce.Inline && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    $R,
                    {
                      className: Ee(
                        d === ce.Inline ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            ne,
            {
              label: M.t("image_center"),
              anchor: "left",
              disabled: f,
              ...re,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => v(ce.BlockCenter),
                  className: Ee(d === ce.BlockCenter && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    MR,
                    {
                      className: Ee(
                        d === ce.BlockCenter ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            ne,
            {
              label: M.t("image_side"),
              anchor: "left",
              disabled: f,
              ...re,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => v(ce.BlockRight),
                  className: Ee(d === ce.BlockRight && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    zR,
                    {
                      className: Ee(
                        d === ce.BlockRight ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            ne,
            {
              disabled: f,
              label: M.t("image_change_alt_text"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => o(le.EditAltMode),
                  className: Ee(x && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    cl,
                    {
                      className: Ee(
                        "main-transition-colors",
                        x ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(ne, { label: M.t("image_change_caption"), anchor: "left", ...re, children: /* @__PURE__ */ b(
            ae,
            {
              className: Ee(y && "bg-brand-primary/10"),
              onClick: S,
              children: /* @__PURE__ */ b(
                ER,
                {
                  className: Ee(
                    y ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ b(
            ne,
            {
              disabled: f,
              label: M.t("image_change_link"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ b(
                ae,
                {
                  className: Ee("main-transition-colors", w && "bg-brand-primary/10"),
                  onClick: () => o(
                    w ? le.ViewLinkMode : le.EditLinkMode
                  ),
                  children: /* @__PURE__ */ b(
                    Fo,
                    {
                      className: Ee(
                        "main-transition-colors",
                        w ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            ne,
            {
              disabled: f,
              label: M.t("image_change_mobile_full_width"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ b(
                ae,
                {
                  className: Ee(
                    "main-transition-colors",
                    h && "bg-brand-primary/10"
                  ),
                  onClick: _,
                  children: /* @__PURE__ */ b(
                    K$,
                    {
                      className: Ee(
                        "main-transition-colors",
                        h ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          )
        ] });
    }
  };
  return /* @__PURE__ */ j("div", { children: [
    /* @__PURE__ */ b(
      ez,
      {
        className: Ee(s && "hidden"),
        editor: n,
        tippyOptions: {
          maxWidth: 400,
          onHide() {
            o(le.InitialMode), p(!0);
          },
          onShow() {
            p(!1);
          },
          hideOnClick: !1
        },
        shouldShow: ({ editor: z }) => Ct(z) ? (z == null ? void 0 : z.getAttributes(We.Block).showBubbleMenu) || (z == null ? void 0 : z.getAttributes(We.Inline).showBubbleMenu) : !1,
        children: /* @__PURE__ */ b(
          "form",
          {
            onSubmit: (z) => z.preventDefault(),
            className: K(
              "flex items-center p-2",
              r === le.InitialMode && "gap-0.5"
            ),
            children: $()
          }
        )
      }
    ),
    /* @__PURE__ */ b(
      xl,
      {
        uploadingFromSource: e,
        initialSearchFilters: {
          source: [e],
          name: "",
          type: []
        },
        opened: s,
        onClose: () => {
          a(!1);
        },
        onSelect: (z) => {
          m(z.path), g(z.path), a(!1);
        }
      }
    )
  ] });
}, tz = (n) => {
  if (!n) return !1;
  const { from: e, to: t } = n.state.selection;
  let i = !1;
  return n.state.doc.nodesBetween(e, t, (r) => {
    r.isText && r.marks.find((s) => s.type.name === "link") && (i = !0);
  }), i;
}, LR = ({ editor: n, fileSource: e }) => {
  const t = n == null ? void 0 : n.getAttributes("link").href, i = Oi(t), [r, o] = xe(""), [s, a] = xe(!1), [l, c] = xe(!1);
  Ge(() => {
    i.current = t, o(i.current || ""), a(!i.current);
  }, [t]);
  const u = () => n == null ? void 0 : n.chain().focus().extendMarkRange("link").unsetLink().setMeta("addToHistory", !1).run(), d = (p) => {
    a(!0), o(p);
  }, h = (p) => {
    n && (a(!1), n.chain().extendMarkRange("link").setLink({ href: p }).run());
  }, f = () => {
    i.current ? (o((p) => i.current || p), a(!1)) : (u(), o(""));
  };
  return !n || !(n != null && n.options.editable) ? null : /* @__PURE__ */ j("div", { children: [
    /* @__PURE__ */ b(
      ez,
      {
        className: Ee(l && "hidden"),
        editor: n,
        shouldShow: ({ editor: p }) => tz(p),
        tippyOptions: {
          onHide: f
        },
        children: /* @__PURE__ */ b("form", { onSubmit: (p) => p.preventDefault(), className: "flex items-center p-2", children: s ? /* @__PURE__ */ b(
          Q$,
          {
            newLink: r,
            onChangeLink: d,
            onSaveLink: h,
            openFileSelector: () => {
              n.commands.blur(), c(!0);
            }
          }
        ) : /* @__PURE__ */ b(X$, { link: r, unsetLink: u, setIsEditing: a }) })
      }
    ),
    /* @__PURE__ */ b(
      xl,
      {
        uploadingFromSource: e,
        initialSearchFilters: {
          source: [e],
          name: "",
          type: []
        },
        opened: l,
        onClose: () => {
          c(!1);
        },
        onSelect: (p) => {
          h(p.path), c(!1);
        }
      }
    )
  ] });
}, NR = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", DR = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", ul = "numeric", dl = "ascii", hl = "alpha", rr = "asciinumeric", Gi = "alphanumeric", fl = "domain", nz = "emoji", RR = "scheme", IR = "slashscheme", ya = "whitespace";
function PR(n, e) {
  return n in e || (e[n] = []), e[n];
}
function Qn(n, e, t) {
  e[ul] && (e[rr] = !0, e[Gi] = !0), e[dl] && (e[rr] = !0, e[hl] = !0), e[rr] && (e[Gi] = !0), e[hl] && (e[Gi] = !0), e[Gi] && (e[fl] = !0), e[nz] && (e[fl] = !0);
  for (const i in e) {
    const r = PR(i, t);
    r.indexOf(n) < 0 && r.push(n);
  }
}
function jR(n, e) {
  const t = {};
  for (const i in e)
    e[i].indexOf(n) >= 0 && (t[i] = !0);
  return t;
}
function rt(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
rt.groups = {};
rt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let i = 0; i < e.jr.length; i++) {
      const r = e.jr[i][0], o = e.jr[i][1];
      if (o && r.test(n))
        return o;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, i) {
    for (let r = 0; r < n.length; r++)
      this.tt(n[r], e, t, i);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, i) {
    i = i || rt.groups;
    let r;
    return e && e.j ? r = e : (r = new rt(e), t && i && Qn(e, t, i)), this.jr.push([n, r]), r;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, i) {
    let r = this;
    const o = n.length;
    if (!o)
      return r;
    for (let s = 0; s < o - 1; s++)
      r = r.tt(n[s]);
    return r.tt(n[o - 1], e, t, i);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, i) {
    i = i || rt.groups;
    const r = this;
    if (e && e.j)
      return r.j[n] = e, e;
    const o = e;
    let s, a = r.go(n);
    if (a ? (s = new rt(), Object.assign(s.j, a.j), s.jr.push.apply(s.jr, a.jr), s.jd = a.jd, s.t = a.t) : s = new rt(), o) {
      if (i)
        if (s.t && typeof s.t == "string") {
          const l = Object.assign(jR(s.t, i), t);
          Qn(o, l, i);
        } else t && Qn(o, t, i);
      s.t = o;
    }
    return r.j[n] = s, s;
  }
};
const J = (n, e, t, i, r) => n.ta(e, t, i, r), ve = (n, e, t, i, r) => n.tr(e, t, i, r), bd = (n, e, t, i, r) => n.ts(e, t, i, r), E = (n, e, t, i, r) => n.tt(e, t, i, r), Xt = "WORD", pl = "UWORD", iz = "ASCIINUMERICAL", rz = "ALPHANUMERICAL", Er = "LOCALHOST", ml = "TLD", gl = "UTLD", po = "SCHEME", Ci = "SLASH_SCHEME", cc = "NUM", _l = "WS", uc = "NL", or = "OPENBRACE", sr = "CLOSEBRACE", qo = "OPENBRACKET", Ho = "CLOSEBRACKET", Vo = "OPENPAREN", Uo = "CLOSEPAREN", Wo = "OPENANGLEBRACKET", Ko = "CLOSEANGLEBRACKET", Zo = "FULLWIDTHLEFTPAREN", Go = "FULLWIDTHRIGHTPAREN", Jo = "LEFTCORNERBRACKET", Yo = "RIGHTCORNERBRACKET", Xo = "LEFTWHITECORNERBRACKET", Qo = "RIGHTWHITECORNERBRACKET", es = "FULLWIDTHLESSTHAN", ts = "FULLWIDTHGREATERTHAN", ns = "AMPERSAND", is = "APOSTROPHE", rs = "ASTERISK", yn = "AT", ss = "BACKSLASH", as = "BACKTICK", ls = "CARET", Sn = "COLON", dc = "COMMA", cs = "DOLLAR", Lt = "DOT", us = "EQUALS", hc = "EXCLAMATION", gt = "HYPHEN", ar = "PERCENT", ds = "PIPE", hs = "PLUS", fs = "POUND", lr = "QUERY", fc = "QUOTE", oz = "FULLWIDTHMIDDLEDOT", pc = "SEMI", Nt = "SLASH", cr = "TILDE", ps = "UNDERSCORE", sz = "EMOJI", ms = "SYM";
var az = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: rz,
  AMPERSAND: ns,
  APOSTROPHE: is,
  ASCIINUMERICAL: iz,
  ASTERISK: rs,
  AT: yn,
  BACKSLASH: ss,
  BACKTICK: as,
  CARET: ls,
  CLOSEANGLEBRACKET: Ko,
  CLOSEBRACE: sr,
  CLOSEBRACKET: Ho,
  CLOSEPAREN: Uo,
  COLON: Sn,
  COMMA: dc,
  DOLLAR: cs,
  DOT: Lt,
  EMOJI: sz,
  EQUALS: us,
  EXCLAMATION: hc,
  FULLWIDTHGREATERTHAN: ts,
  FULLWIDTHLEFTPAREN: Zo,
  FULLWIDTHLESSTHAN: es,
  FULLWIDTHMIDDLEDOT: oz,
  FULLWIDTHRIGHTPAREN: Go,
  HYPHEN: gt,
  LEFTCORNERBRACKET: Jo,
  LEFTWHITECORNERBRACKET: Xo,
  LOCALHOST: Er,
  NL: uc,
  NUM: cc,
  OPENANGLEBRACKET: Wo,
  OPENBRACE: or,
  OPENBRACKET: qo,
  OPENPAREN: Vo,
  PERCENT: ar,
  PIPE: ds,
  PLUS: hs,
  POUND: fs,
  QUERY: lr,
  QUOTE: fc,
  RIGHTCORNERBRACKET: Yo,
  RIGHTWHITECORNERBRACKET: Qo,
  SCHEME: po,
  SEMI: pc,
  SLASH: Nt,
  SLASH_SCHEME: Ci,
  SYM: ms,
  TILDE: cr,
  TLD: ml,
  UNDERSCORE: ps,
  UTLD: gl,
  UWORD: pl,
  WORD: Xt,
  WS: _l
});
const Jt = /[a-z]/, Vi = new RegExp("\\p{L}", "u"), va = new RegExp("\\p{Emoji}", "u"), Yt = /\d/, xa = /\s/, kd = "\r", Sa = `
`, BR = "️", FR = "‍", wa = "￼";
let Yr = null, Xr = null;
function qR(n = []) {
  const e = {};
  rt.groups = e;
  const t = new rt();
  Yr == null && (Yr = yd(NR)), Xr == null && (Xr = yd(DR)), E(t, "'", is), E(t, "{", or), E(t, "}", sr), E(t, "[", qo), E(t, "]", Ho), E(t, "(", Vo), E(t, ")", Uo), E(t, "<", Wo), E(t, ">", Ko), E(t, "（", Zo), E(t, "）", Go), E(t, "「", Jo), E(t, "」", Yo), E(t, "『", Xo), E(t, "』", Qo), E(t, "＜", es), E(t, "＞", ts), E(t, "&", ns), E(t, "*", rs), E(t, "@", yn), E(t, "`", as), E(t, "^", ls), E(t, ":", Sn), E(t, ",", dc), E(t, "$", cs), E(t, ".", Lt), E(t, "=", us), E(t, "!", hc), E(t, "-", gt), E(t, "%", ar), E(t, "|", ds), E(t, "+", hs), E(t, "#", fs), E(t, "?", lr), E(t, '"', fc), E(t, "/", Nt), E(t, ";", pc), E(t, "~", cr), E(t, "_", ps), E(t, "\\", ss), E(t, "・", oz);
  const i = ve(t, Yt, cc, {
    [ul]: !0
  });
  ve(i, Yt, i);
  const r = ve(i, Jt, iz, {
    [rr]: !0
  }), o = ve(i, Vi, rz, {
    [Gi]: !0
  }), s = ve(t, Jt, Xt, {
    [dl]: !0
  });
  ve(s, Yt, r), ve(s, Jt, s), ve(r, Yt, r), ve(r, Jt, r);
  const a = ve(t, Vi, pl, {
    [hl]: !0
  });
  ve(a, Jt), ve(a, Yt, o), ve(a, Vi, a), ve(o, Yt, o), ve(o, Jt), ve(o, Vi, o);
  const l = E(t, Sa, uc, {
    [ya]: !0
  }), c = E(t, kd, _l, {
    [ya]: !0
  }), u = ve(t, xa, _l, {
    [ya]: !0
  });
  E(t, wa, u), E(c, Sa, l), E(c, wa, u), ve(c, xa, u), E(u, kd), E(u, Sa), ve(u, xa, u), E(u, wa, u);
  const d = ve(t, va, sz, {
    [nz]: !0
  });
  E(d, "#"), ve(d, va, d), E(d, BR, d);
  const h = E(d, FR);
  E(h, "#"), ve(h, va, d);
  const f = [[Jt, s], [Yt, r]], p = [[Jt, null], [Vi, a], [Yt, o]];
  for (let m = 0; m < Yr.length; m++)
    _n(t, Yr[m], ml, Xt, f);
  for (let m = 0; m < Xr.length; m++)
    _n(t, Xr[m], gl, pl, p);
  Qn(ml, {
    tld: !0,
    ascii: !0
  }, e), Qn(gl, {
    utld: !0,
    alpha: !0
  }, e), _n(t, "file", po, Xt, f), _n(t, "mailto", po, Xt, f), _n(t, "http", Ci, Xt, f), _n(t, "https", Ci, Xt, f), _n(t, "ftp", Ci, Xt, f), _n(t, "ftps", Ci, Xt, f), Qn(po, {
    scheme: !0,
    ascii: !0
  }, e), Qn(Ci, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((m, g) => m[0] > g[0] ? 1 : -1);
  for (let m = 0; m < n.length; m++) {
    const g = n[m][0], v = n[m][1] ? {
      [RR]: !0
    } : {
      [IR]: !0
    };
    g.indexOf("-") >= 0 ? v[fl] = !0 : Jt.test(g) ? Yt.test(g) ? v[rr] = !0 : v[dl] = !0 : v[ul] = !0, bd(t, g, g, v);
  }
  return bd(t, "localhost", Er, {
    ascii: !0
  }), t.jd = new rt(ms), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, az)
  };
}
function lz(n, e) {
  const t = HR(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), i = t.length, r = [];
  let o = 0, s = 0;
  for (; s < i; ) {
    let a = n, l = null, c = 0, u = null, d = -1, h = -1;
    for (; s < i && (l = a.go(t[s])); )
      a = l, a.accepts() ? (d = 0, h = 0, u = a) : d >= 0 && (d += t[s].length, h++), c += t[s].length, o += t[s].length, s++;
    o -= d, s -= h, c -= d, r.push({
      t: u.t,
      // token type/name
      v: e.slice(o - c, o),
      // string value
      s: o - c,
      // start index
      e: o
      // end index (excluding)
    });
  }
  return r;
}
function HR(n) {
  const e = [], t = n.length;
  let i = 0;
  for (; i < t; ) {
    let r = n.charCodeAt(i), o, s = r < 55296 || r > 56319 || i + 1 === t || (o = n.charCodeAt(i + 1)) < 56320 || o > 57343 ? n[i] : n.slice(i, i + 2);
    e.push(s), i += s.length;
  }
  return e;
}
function _n(n, e, t, i, r) {
  let o;
  const s = e.length;
  for (let a = 0; a < s - 1; a++) {
    const l = e[a];
    n.j[l] ? o = n.j[l] : (o = new rt(i), o.jr = r.slice(), n.j[l] = o), n = o;
  }
  return o = new rt(t), o.jr = r.slice(), n.j[e[s - 1]] = o, o;
}
function yd(n) {
  const e = [], t = [];
  let i = 0, r = "0123456789";
  for (; i < n.length; ) {
    let o = 0;
    for (; r.indexOf(n[i + o]) >= 0; )
      o++;
    if (o > 0) {
      e.push(t.join(""));
      for (let s = parseInt(n.substring(i, i + o), 10); s > 0; s--)
        t.pop();
      i += o;
    } else
      t.push(n[i]), i++;
  }
  return e;
}
const Mr = {
  defaultProtocol: "http",
  events: null,
  format: vd,
  formatHref: vd,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function mc(n, e = null) {
  let t = Object.assign({}, Mr);
  n && (t = Object.assign(t, n instanceof mc ? n.o : n));
  const i = t.ignoreTags, r = [];
  for (let o = 0; o < i.length; o++)
    r.push(i[o].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = r;
}
mc.prototype = {
  o: Mr,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const i = e != null;
    let r = this.o[n];
    return r && (typeof r == "object" ? (r = t.t in r ? r[t.t] : Mr[n], typeof r == "function" && i && (r = r(e, t))) : typeof r == "function" && i && (r = r(e, t.t, t)), r);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let i = this.o[n];
    return typeof i == "function" && e != null && (i = i(e, t.t, t)), i;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function vd(n) {
  return n;
}
function cz(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
cz.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), i = n.get("format", e, this);
    return t && i.length > t ? i.substring(0, t) + "…" : i;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = Mr.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), i = n.get("formatHref", t, this), r = n.get("tagName", t, e), o = this.toFormattedString(n), s = {}, a = n.get("className", t, e), l = n.get("target", t, e), c = n.get("rel", t, e), u = n.getObj("attributes", t, e), d = n.getObj("events", t, e);
    return s.href = i, a && (s.class = a), l && (s.target = l), c && (s.rel = c), u && Object.assign(s, u), {
      tagName: r,
      attributes: s,
      content: o,
      eventListeners: d
    };
  }
};
function Ps(n, e) {
  class t extends cz {
    constructor(r, o) {
      super(r, o), this.t = n;
    }
  }
  for (const i in e)
    t.prototype[i] = e[i];
  return t.t = n, t;
}
const xd = Ps("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Sd = Ps("text"), VR = Ps("nl"), Qr = Ps("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = Mr.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Er && n[1].t === Sn;
  }
}), mt = (n) => new rt(n);
function UR({
  groups: n
}) {
  const e = n.domain.concat([ns, rs, yn, ss, as, ls, cs, us, gt, cc, ar, ds, hs, fs, Nt, ms, cr, ps]), t = [is, Sn, dc, Lt, hc, ar, lr, fc, pc, Wo, Ko, or, sr, Ho, qo, Vo, Uo, Zo, Go, Jo, Yo, Xo, Qo, es, ts], i = [ns, is, rs, ss, as, ls, cs, us, gt, or, sr, ar, ds, hs, fs, lr, Nt, ms, cr, ps], r = mt(), o = E(r, cr);
  J(o, i, o), J(o, n.domain, o);
  const s = mt(), a = mt(), l = mt();
  J(r, n.domain, s), J(r, n.scheme, a), J(r, n.slashscheme, l), J(s, i, o), J(s, n.domain, s);
  const c = E(s, yn);
  E(o, yn, c), E(a, yn, c), E(l, yn, c);
  const u = E(o, Lt);
  J(u, i, o), J(u, n.domain, o);
  const d = mt();
  J(c, n.domain, d), J(d, n.domain, d);
  const h = E(d, Lt);
  J(h, n.domain, d);
  const f = mt(xd);
  J(h, n.tld, f), J(h, n.utld, f), E(c, Er, f);
  const p = E(d, gt);
  E(p, gt, p), J(p, n.domain, d), J(f, n.domain, d), E(f, Lt, h), E(f, gt, p);
  const m = E(f, Sn);
  J(m, n.numeric, xd);
  const g = E(s, gt), k = E(s, Lt);
  E(g, gt, g), J(g, n.domain, s), J(k, i, o), J(k, n.domain, s);
  const v = mt(Qr);
  J(k, n.tld, v), J(k, n.utld, v), J(v, n.domain, s), J(v, i, o), E(v, Lt, k), E(v, gt, g), E(v, yn, c);
  const S = E(v, Sn), _ = mt(Qr);
  J(S, n.numeric, _);
  const x = mt(Qr), y = mt();
  J(x, e, x), J(x, t, y), J(y, e, x), J(y, t, y), E(v, Nt, x), E(_, Nt, x);
  const w = E(a, Sn), $ = E(l, Sn), A = E($, Nt), z = E(A, Nt);
  J(a, n.domain, s), E(a, Lt, k), E(a, gt, g), J(l, n.domain, s), E(l, Lt, k), E(l, gt, g), J(w, n.domain, x), E(w, Nt, x), E(w, lr, x), J(z, n.domain, x), J(z, e, x), E(z, Nt, x);
  const I = [
    [or, sr],
    // {}
    [qo, Ho],
    // []
    [Vo, Uo],
    // ()
    [Wo, Ko],
    // <>
    [Zo, Go],
    // （）
    [Jo, Yo],
    // 「」
    [Xo, Qo],
    // 『』
    [es, ts]
    // ＜＞
  ];
  for (let L = 0; L < I.length; L++) {
    const [P, q] = I[L], W = E(x, P);
    E(y, P, W), E(W, q, x);
    const B = mt(Qr);
    J(W, e, B);
    const Z = mt();
    J(W, t), J(B, e, B), J(B, t, Z), J(Z, e, B), J(Z, t, Z), E(B, q, x), E(Z, q, x);
  }
  return E(r, Er, v), E(r, uc, VR), {
    start: r,
    tokens: az
  };
}
function WR(n, e, t) {
  let i = t.length, r = 0, o = [], s = [];
  for (; r < i; ) {
    let a = n, l = null, c = null, u = 0, d = null, h = -1;
    for (; r < i && !(l = a.go(t[r].t)); )
      s.push(t[r++]);
    for (; r < i && (c = l || a.go(t[r].t)); )
      l = null, a = c, a.accepts() ? (h = 0, d = a) : h >= 0 && h++, r++, u++;
    if (h < 0)
      r -= u, r < i && (s.push(t[r]), r++);
    else {
      s.length > 0 && (o.push(Ca(Sd, e, s)), s = []), r -= h, u -= h;
      const f = d.t, p = t.slice(r - u, r);
      o.push(Ca(f, e, p));
    }
  }
  return s.length > 0 && o.push(Ca(Sd, e, s)), o;
}
function Ca(n, e, t) {
  const i = t[0].s, r = t[t.length - 1].e, o = e.slice(i, r);
  return new n(o, t);
}
const KR = typeof console < "u" && console && console.warn || (() => {
}), ZR = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", ge = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function GR() {
  return rt.groups = {}, ge.scanner = null, ge.parser = null, ge.tokenQueue = [], ge.pluginQueue = [], ge.customSchemes = [], ge.initialized = !1, ge;
}
function wd(n, e = !1) {
  if (ge.initialized && KR(`linkifyjs: already initialized - will not register custom scheme "${n}" ${ZR}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  ge.customSchemes.push([n, e]);
}
function JR() {
  ge.scanner = qR(ge.customSchemes);
  for (let n = 0; n < ge.tokenQueue.length; n++)
    ge.tokenQueue[n][1]({
      scanner: ge.scanner
    });
  ge.parser = UR(ge.scanner.tokens);
  for (let n = 0; n < ge.pluginQueue.length; n++)
    ge.pluginQueue[n][1]({
      scanner: ge.scanner,
      parser: ge.parser
    });
  return ge.initialized = !0, ge;
}
function gc(n) {
  return ge.initialized || JR(), WR(ge.parser.start, n, lz(ge.scanner.start, n));
}
gc.scan = lz;
function uz(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const i = new mc(t), r = gc(n), o = [];
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    a.isLink && (!e || a.t === e) && i.check(a) && o.push(a.toFormattedObject(i));
  }
  return o;
}
function YR(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function XR(n) {
  return new $e({
    key: new Ve("autolink"),
    appendTransaction: (e, t, i) => {
      const r = e.some((c) => c.docChanged) && !t.doc.eq(i.doc), o = e.some((c) => c.getMeta("preventAutolink"));
      if (!r || o)
        return;
      const { tr: s } = i, a = o6(t.doc, [...e]);
      if (p6(a).forEach(({ newRange: c }) => {
        const u = sp(i.doc, c, (f) => f.isTextblock);
        let d, h;
        if (u.length > 1 ? (d = u[0], h = i.doc.textBetween(d.pos, d.pos + d.node.nodeSize, void 0, " ")) : u.length && i.doc.textBetween(c.from, c.to, " ", " ").endsWith(" ") && (d = u[0], h = i.doc.textBetween(d.pos, c.to, void 0, " ")), d && h) {
          const f = h.split(" ").filter((k) => k !== "");
          if (f.length <= 0)
            return !1;
          const p = f[f.length - 1], m = d.pos + h.lastIndexOf(p);
          if (!p)
            return !1;
          const g = gc(p).map((k) => k.toObject(n.defaultProtocol));
          if (!YR(g))
            return !1;
          g.filter((k) => k.isLink).map((k) => ({
            ...k,
            from: m + k.start + 1,
            to: m + k.end + 1
          })).filter((k) => i.schema.marks.code ? !i.doc.rangeHasMark(k.from, k.to, i.schema.marks.code) : !0).filter((k) => n.validate(k.value)).filter((k) => n.shouldAutoLink(k.value)).forEach((k) => {
            Jl(k.from, k.to, i.doc).some((v) => v.mark.type === n.type) || s.addMark(k.from, k.to, n.type.create({
              href: k.href
            }));
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function QR(n) {
  return new $e({
    key: new Ve("handleClickLink"),
    props: {
      handleClick: (e, t, i) => {
        var r, o;
        if (i.button !== 0 || !e.editable)
          return !1;
        let s = i.target;
        const a = [];
        for (; s.nodeName !== "DIV"; )
          a.push(s), s = s.parentNode;
        if (!a.find((h) => h.nodeName === "A"))
          return !1;
        const l = ap(e.state, n.type.name), c = i.target, u = (r = c == null ? void 0 : c.href) !== null && r !== void 0 ? r : l.href, d = (o = c == null ? void 0 : c.target) !== null && o !== void 0 ? o : l.target;
        return c && u ? (window.open(u, d), !0) : !1;
      }
    }
  });
}
function eI(n) {
  return new $e({
    key: new Ve("handlePasteLink"),
    props: {
      handlePaste: (e, t, i) => {
        const { state: r } = e, { selection: o } = r, { empty: s } = o;
        if (s)
          return !1;
        let a = "";
        i.content.forEach((c) => {
          a += c.textContent;
        });
        const l = uz(a, { defaultProtocol: n.defaultProtocol }).find((c) => c.isLink && c.value === a);
        return !a || !l ? !1 : n.editor.commands.setMark(n.type, {
          href: l.href
        });
      }
    }
  });
}
const tI = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function Un(n, e) {
  const t = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((i) => {
    const r = typeof i == "string" ? i : i.scheme;
    r && t.push(r);
  }), !n || n.replace(tI, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const nI = Vt.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        wd(n);
        return;
      }
      wd(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    GR();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!Un(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!Un(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!Un(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", ke(this.options.HTMLAttributes, n), 0] : [
      "a",
      ke(this.options.HTMLAttributes, { ...n, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (i) => !!Un(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (i) => !!Un(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Ni({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: i } = this.options, r = uz(n).filter((o) => o.isLink && this.options.isAllowedUri(o.value, {
              defaultValidate: (s) => !!Un(s, t),
              protocols: t,
              defaultProtocol: i
            }));
            r.length && r.forEach((o) => e.push({
              text: o.value,
              data: {
                href: o.href
              },
              index: o.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(XR({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (i) => this.options.isAllowedUri(i, {
        defaultValidate: (r) => !!Un(r, e),
        protocols: e,
        defaultProtocol: t
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && n.push(QR({
      type: this.type
    })), this.options.linkOnPaste && n.push(eI({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), n;
  }
}), zt = (n) => Object.entries(n).map(([e, t]) => `${e.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${t}`).join("; "), Cd = (n) => nI.extend({
  addAttributes() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      color: {
        default: n ? n.color : "rgb(17 85 204)"
      }
    };
  },
  renderHTML({ HTMLAttributes: e, mark: t }) {
    const r = {
      color: t.attrs.color,
      textDecorationLine: "underline"
    };
    return [
      "a",
      ke(e, {
        style: zt(r)
      }),
      0
    ];
  }
}), iI = (n, e) => {
  const { state: t } = n, i = t.tr;
  let r = !1;
  t.doc.descendants((o, s) => {
    const a = s + o.nodeSize;
    o.marks.forEach((l) => {
      if (l.type.name === "link") {
        const c = l.type.create({
          ...l.attrs,
          color: e
        });
        i.removeMark(s, a, l.type).addMark(s, a, c), r = !0;
      }
    });
  }), r && n.view.dispatch(i);
}, rI = (n, e) => {
  Ge(() => {
    n && e && iI(n, e);
  }, [e]);
}, _c = /* @__PURE__ */ new Set(), oI = (n) => {
  _c.add(n);
}, sI = (n) => _c.has(n), aI = (n) => {
  _c.add(n);
}, bc = (n) => n.type.name === We.Block || n.type.name === We.Inline, Td = (n) => {
  var e;
  return bc(n) && !!((e = n.attrs) != null && e.src) && !n.attrs.uploadingProps;
}, Od = (n) => {
  var t;
  return ((t = n.split("/").pop()) == null ? void 0 : t.split("?")[0]) || "image";
}, Ed = (n, e) => {
  if (/\.\w+$/.test(n)) return n;
  const t = e.split("/")[1] || "png";
  return `${n}.${t}`;
}, dz = (n) => n.startsWith("file:///"), Ta = (n, e) => {
  n.state.doc.descendants((t, i) => {
    var r;
    return bc(t) && ((r = t.attrs.uploadingProps) == null ? void 0 : r.id) === e ? (n.dispatch(n.state.tr.delete(i, i + t.nodeSize).setMeta("addToHistory", !1)), !1) : !0;
  });
}, lI = async (n) => {
  if (dz(n))
    return null;
  const e = "image/png";
  try {
    const t = await fetch(n);
    if (!t.ok) throw new Error("Failed to fetch image");
    const i = await t.blob(), r = i.type || e, o = Ed(Od(n), r);
    return new File([i], o, { type: r });
  } catch {
    try {
      const t = new Image();
      t.crossOrigin = "anonymous", await new Promise((r, o) => {
        t.onload = r, t.onerror = o, t.src = n;
      });
      const i = Ed(Od(n), e);
      return await Pz(t, i, e);
    } catch {
      return null;
    }
  }
}, cI = 300, uI = (n) => {
  const { startUploading: e } = jz({
    source: n
  }), t = async (s, a, l) => {
    try {
      const c = await e(s);
      if (!c) {
        ao.error(M.t("global.error")), Ta(l, a);
        return;
      }
      l.state.doc.descendants((u, d) => {
        var f;
        if (bc(u) && ((f = u.attrs.uploadingProps) == null ? void 0 : f.id) === a) {
          const p = {
            ...u.attrs,
            src: c.path,
            uploadingProps: null
          };
          return l.dispatch(
            l.state.tr.setNodeMarkup(d, null, p).setMeta("addToHistory", !1)
          ), oI(c.path), !1;
        }
        return !0;
      });
    } catch {
      ao.error(M.t("global.error")), Ta(l, a);
    }
  }, i = async (s, a, l) => {
    if (s.length === 0) return;
    const c = s.map(async (p) => {
      const m = crypto.randomUUID(), g = URL.createObjectURL(p), k = new Image();
      return k.src = g, await new Promise((v) => {
        k.onload = () => v();
      }), { file: p, id: m, src: g, width: k.naturalWidth, height: k.naturalHeight };
    }), u = await Promise.all(c), { schema: d } = a.state;
    let h = a.state.tr, f = 0;
    u.forEach(({ id: p, src: m, width: g, height: k }) => {
      const v = d.nodes[We.Block].create({
        src: m,
        width: g,
        height: k,
        containerWidth: "auto",
        imageMode: ce.BlockCenter,
        uploadingProps: { isUploading: !0, id: p }
      });
      h = h.insert(l + f, v), f += v.nodeSize;
    }), a.dispatch(h), u.forEach(({ file: p, id: m }) => {
      t(p, m, a);
    });
  };
  return { onDrop: (s, a) => {
    if (!a.dataTransfer) return;
    const l = Array.from(a.dataTransfer.files).filter(
      (u) => yc(u.type, vc.image)
    );
    if (l.length === 0) return !1;
    a.preventDefault();
    const c = s.posAtCoords({ left: a.clientX, top: a.clientY });
    return i(l, s, (c == null ? void 0 : c.pos) ?? 1), !0;
  }, onPaste: (s, a) => {
    if (!a.clipboardData) return;
    const { clipboardData: l } = a, { selection: c } = s.state, { from: u } = c;
    s.state.doc.descendants((p) => (Td(p) && aI(p.attrs.src), !0));
    const d = Array.from(l.files).filter(
      (p) => yc(p.type, vc.image)
    );
    if (d.length > 0)
      return a.preventDefault(), i(d, s, u), !0;
    const h = l.getData("text/html");
    return h && h.includes("<img") && setTimeout(() => {
      const p = [];
      s.state.doc.descendants((m, g) => {
        if (!Td(m)) return !0;
        const k = m.attrs.src;
        if (sI(k)) return !0;
        if (dz(k)) {
          const S = s.state.tr.delete(g, g + m.nodeSize);
          return s.dispatch(S), !0;
        }
        const v = crypto.randomUUID();
        return p.push({ pos: g, src: k, id: v }), !0;
      }), p.length !== 0 && (p.forEach(({ pos: m, id: g }) => {
        const k = s.state.doc.nodeAt(m);
        if (!k) return;
        const v = {
          ...k.attrs,
          uploadingProps: { isUploading: !0, id: g }
        };
        s.dispatch(
          s.state.tr.setNodeMarkup(m, null, v).setMeta("addToHistory", !1)
        );
      }), p.forEach(async ({ id: m, src: g }) => {
        const k = await lI(g);
        if (!k) {
          ao.error(M.t("global.error")), Ta(s, m);
          return;
        }
        t(k, m, s);
      }));
    }, cI), !1;
  } };
}, dI = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, hI = /[\0-\x1F\x7F-\x9F]/, fI = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, pI = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
function mI(n) {
  const e = {};
  n = n || {}, e.src_Any = dI.source, e.src_Cc = hI.source, e.src_Z = pI.source, e.src_P = fI.source, e.src_ZPCc = [e.src_Z, e.src_P, e.src_Cc].join("|"), e.src_ZCc = [e.src_Z, e.src_Cc].join("|");
  const t = "[><｜]";
  return e.src_pseudo_letter = "(?:(?!" + t + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + t + "|" + e.src_ZPCc + ")(?!" + (n["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + t + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (n["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + t + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
}
function bl(n) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(t) {
    t && Object.keys(t).forEach(function(i) {
      n[i] = t[i];
    });
  }), n;
}
function js(n) {
  return Object.prototype.toString.call(n);
}
function gI(n) {
  return js(n) === "[object String]";
}
function _I(n) {
  return js(n) === "[object Object]";
}
function bI(n) {
  return js(n) === "[object RegExp]";
}
function Md(n) {
  return js(n) === "[object Function]";
}
function kI(n) {
  return n.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const hz = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function yI(n) {
  return Object.keys(n || {}).reduce(function(e, t) {
    return e || hz.hasOwnProperty(t);
  }, !1);
}
const vI = {
  "http:": {
    validate: function(n, e, t) {
      const i = n.slice(e);
      return t.re.http || (t.re.http = new RegExp(
        "^\\/\\/" + t.re.src_auth + t.re.src_host_port_strict + t.re.src_path,
        "i"
      )), t.re.http.test(i) ? i.match(t.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(n, e, t) {
      const i = n.slice(e);
      return t.re.no_http || (t.re.no_http = new RegExp(
        "^" + t.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + t.re.src_domain + ")\\.)+" + t.re.src_domain_root + ")" + t.re.src_port + t.re.src_host_terminator + t.re.src_path,
        "i"
      )), t.re.no_http.test(i) ? e >= 3 && n[e - 3] === ":" || e >= 3 && n[e - 3] === "/" ? 0 : i.match(t.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(n, e, t) {
      const i = n.slice(e);
      return t.re.mailto || (t.re.mailto = new RegExp(
        "^" + t.re.src_email_name + "@" + t.re.src_host_strict,
        "i"
      )), t.re.mailto.test(i) ? i.match(t.re.mailto)[0].length : 0;
    }
  }
}, xI = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", SI = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function wI(n) {
  n.__index__ = -1, n.__text_cache__ = "";
}
function CI(n) {
  return function(e, t) {
    const i = e.slice(t);
    return n.test(i) ? i.match(n)[0].length : 0;
  };
}
function $d() {
  return function(n, e) {
    e.normalize(n);
  };
}
function gs(n) {
  const e = n.re = mI(n.__opts__), t = n.__tlds__.slice();
  n.onCompile(), n.__tlds_replaced__ || t.push(xI), t.push(e.src_xn), e.src_tlds = t.join("|");
  function i(a) {
    return a.replace("%TLDS%", e.src_tlds);
  }
  e.email_fuzzy = RegExp(i(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(i(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(i(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(i(e.tpl_host_fuzzy_test), "i");
  const r = [];
  n.__compiled__ = {};
  function o(a, l) {
    throw new Error('(LinkifyIt) Invalid schema "' + a + '": ' + l);
  }
  Object.keys(n.__schemas__).forEach(function(a) {
    const l = n.__schemas__[a];
    if (l === null)
      return;
    const c = { validate: null, link: null };
    if (n.__compiled__[a] = c, _I(l)) {
      bI(l.validate) ? c.validate = CI(l.validate) : Md(l.validate) ? c.validate = l.validate : o(a, l), Md(l.normalize) ? c.normalize = l.normalize : l.normalize ? o(a, l) : c.normalize = $d();
      return;
    }
    if (gI(l)) {
      r.push(a);
      return;
    }
    o(a, l);
  }), r.forEach(function(a) {
    n.__compiled__[n.__schemas__[a]] && (n.__compiled__[a].validate = n.__compiled__[n.__schemas__[a]].validate, n.__compiled__[a].normalize = n.__compiled__[n.__schemas__[a]].normalize);
  }), n.__compiled__[""] = { validate: null, normalize: $d() };
  const s = Object.keys(n.__compiled__).filter(function(a) {
    return a.length > 0 && n.__compiled__[a];
  }).map(kI).join("|");
  n.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + s + ")", "i"), n.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + s + ")", "ig"), n.re.schema_at_start = RegExp("^" + n.re.schema_search.source, "i"), n.re.pretest = RegExp(
    "(" + n.re.schema_test.source + ")|(" + n.re.host_fuzzy_test.source + ")|@",
    "i"
  ), wI(n);
}
function TI(n, e) {
  const t = n.__index__, i = n.__last_index__, r = n.__text_cache__.slice(t, i);
  this.schema = n.__schema__.toLowerCase(), this.index = t + e, this.lastIndex = i + e, this.raw = r, this.text = r, this.url = r;
}
function kl(n, e) {
  const t = new TI(n, e);
  return n.__compiled__[t.schema].normalize(t, n), t;
}
function ft(n, e) {
  if (!(this instanceof ft))
    return new ft(n, e);
  e || yI(n) && (e = n, n = {}), this.__opts__ = bl({}, hz, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = bl({}, vI, n), this.__compiled__ = {}, this.__tlds__ = SI, this.__tlds_replaced__ = !1, this.re = {}, gs(this);
}
ft.prototype.add = function(e, t) {
  return this.__schemas__[e] = t, gs(this), this;
};
ft.prototype.set = function(e) {
  return this.__opts__ = bl(this.__opts__, e), this;
};
ft.prototype.test = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length)
    return !1;
  let t, i, r, o, s, a, l, c, u;
  if (this.re.schema_test.test(e)) {
    for (l = this.re.schema_search, l.lastIndex = 0; (t = l.exec(e)) !== null; )
      if (o = this.testSchemaAt(e, t[2], l.lastIndex), o) {
        this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + o;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (c = e.search(this.re.host_fuzzy_test), c >= 0 && (this.__index__ < 0 || c < this.__index__) && (i = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (s = i.index + i[1].length, (this.__index__ < 0 || s < this.__index__) && (this.__schema__ = "", this.__index__ = s, this.__last_index__ = i.index + i[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (u = e.indexOf("@"), u >= 0 && (r = e.match(this.re.email_fuzzy)) !== null && (s = r.index + r[1].length, a = r.index + r[0].length, (this.__index__ < 0 || s < this.__index__ || s === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = s, this.__last_index__ = a))), this.__index__ >= 0;
};
ft.prototype.pretest = function(e) {
  return this.re.pretest.test(e);
};
ft.prototype.testSchemaAt = function(e, t, i) {
  return this.__compiled__[t.toLowerCase()] ? this.__compiled__[t.toLowerCase()].validate(e, i, this) : 0;
};
ft.prototype.match = function(e) {
  const t = [];
  let i = 0;
  this.__index__ >= 0 && this.__text_cache__ === e && (t.push(kl(this, i)), i = this.__last_index__);
  let r = i ? e.slice(i) : e;
  for (; this.test(r); )
    t.push(kl(this, i)), r = r.slice(this.__last_index__), i += this.__last_index__;
  return t.length ? t : null;
};
ft.prototype.matchAtStart = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
  const t = this.re.schema_at_start.exec(e);
  if (!t) return null;
  const i = this.testSchemaAt(e, t[2], t[0].length);
  return i ? (this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + i, kl(this, 0)) : null;
};
ft.prototype.tlds = function(e, t) {
  return e = Array.isArray(e) ? e : [e], t ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function(i, r, o) {
    return i !== o[r - 1];
  }).reverse(), gs(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, gs(this), this);
};
ft.prototype.normalize = function(e) {
  e.schema || (e.url = "http://" + e.url), e.schema === "mailto:" && !/^mailto:/i.test(e.url) && (e.url = "mailto:" + e.url);
};
ft.prototype.onCompile = function() {
};
const OI = new ft();
function EI(n) {
  const e = OI.match(n);
  if (!e)
    return {
      type: "doc",
      content: [
        {
          type: "paragraph",
          content: [{ type: "text", text: n }]
        }
      ]
    };
  const t = [];
  let i = 0;
  for (const r of e)
    r.index > i && t.push({
      type: "text",
      text: n.slice(i, r.index)
    }), t.push({
      type: "text",
      text: r.raw,
      marks: [
        {
          type: "link",
          attrs: { href: r.url }
        }
      ]
    }), i = r.lastIndex;
  return i < n.length && t.push({
    type: "text",
    text: n.slice(i)
  }), {
    type: "doc",
    content: t
  };
}
const MI = ({ editor: n, content: e, shouldInitialize: t }) => {
  const i = Oi(!1);
  Ge(() => {
    !n || !e || i.current || !t || typeof e != "string" || (n.commands.setContent(EI(e)), i.current = !0);
  }, [n, e, t]);
};
function zd(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "20",
      height: "18",
      viewBox: "0 0 20 18",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b("path", { d: "M3.99992 0C4.26514 1.26282e-07 4.51942 0.105433 4.70696 0.292969L7.70696 3.29297L7.77532 3.36914C8.09567 3.76191 8.07307 4.34092 7.70696 4.70703C7.34084 5.07315 6.76184 5.09574 6.36907 4.77539L6.29289 4.70703L4.99992 3.41406V14.5859L6.29289 13.293C6.68342 12.9024 7.31643 12.9024 7.70696 13.293C8.09748 13.6835 8.09748 14.3165 7.70696 14.707L4.70696 17.707C4.51942 17.8946 4.26514 18 3.99992 18C3.73471 18 3.48043 17.8946 3.29289 17.707L0.292893 14.707C-0.0976311 14.3165 -0.097631 13.6835 0.292893 13.293C0.659009 12.9269 1.23801 12.9043 1.63078 13.2246L1.70696 13.293L2.99992 14.5859V3.41406L1.70696 4.70703C1.31643 5.09756 0.683418 5.09756 0.292893 4.70703C-0.0976311 4.31651 -0.097631 3.68349 0.292893 3.29297L3.29289 0.292969L3.36614 0.226562C3.54409 0.0807275 3.76783 0 3.99992 0ZM18.9999 14C19.5522 14 19.9999 14.4477 19.9999 15C19.9999 15.5523 19.5522 16 18.9999 16H10.9999C10.4476 16 9.99992 15.5523 9.99992 15C9.99992 14.4477 10.4476 14 10.9999 14H18.9999ZM18.9999 10C19.5522 10 19.9999 10.4477 19.9999 11C19.9999 11.5523 19.5522 12 18.9999 12H10.9999C10.4476 12 9.99992 11.5523 9.99992 11C9.99992 10.4477 10.4476 10 10.9999 10H18.9999ZM18.9999 6C19.5522 6 19.9999 6.44772 19.9999 7C19.9999 7.55228 19.5522 8 18.9999 8H10.9999C10.4476 8 9.99992 7.55228 9.99992 7C9.99992 6.44772 10.4476 6 10.9999 6H18.9999ZM18.9999 2C19.5522 2 19.9999 2.44772 19.9999 3C19.9999 3.55228 19.5522 4 18.9999 4H10.9999C10.4476 4 9.99992 3.55228 9.99992 3C9.99992 2.44772 10.4476 2 10.9999 2H18.9999Z" })
    }
  );
}
const $r = "extra-spacing", Ad = (n) => n.attrs[$r], $I = (n, e) => {
  const { from: t, to: i } = (n == null ? void 0 : n.state.selection) || {}, r = we(() => {
    if (!n || t === void 0 || i === void 0) return !1;
    if (t === i)
      return n.isActive("paragraph");
    let l = !1;
    return n.state.doc.nodesBetween(t, i, (c) => {
      if (c.type.name === "paragraph")
        return l = !0, !1;
    }), l;
  }, [n, t, i]), o = !(n != null && n.options.editable) || Ct(n) || !r, s = (() => {
    if (!n || t === void 0 || i === void 0) return !1;
    if (t === i) {
      const c = n.state.doc.resolve(t);
      for (let u = c.depth; u >= 0; u--) {
        const d = c.node(u);
        if (d.type.name === "paragraph")
          return Ad(d);
      }
      return !1;
    }
    let l = !1;
    return n.state.doc.nodesBetween(t, i, (c) => {
      if (c.type.name === "paragraph")
        return l = Ad(c), !1;
    }), l;
  })();
  return we(() => {
    const l = () => {
      n && n.chain().focus().updateAttributes("paragraph", {
        [$r]: !s
      }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: o,
          label: M.t("extra_spacing"),
          ...re,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: o,
              onClick: l,
              className: K(
                s && "bg-brand-primary/10 main-transition-colors"
              ),
              children: /* @__PURE__ */ b(zd, { className: md(o) })
            }
          )
        },
        "paragraph-spacing"
      ),
      tooltipRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: o,
          label: M.t("extra_spacing"),
          ...re,
          children: /* @__PURE__ */ j(
            ae,
            {
              disabled: o,
              onClick: l,
              className: K(
                s && "bg-brand-primary/10 main-transition-colors",
                "flex gap-1"
              ),
              children: [
                /* @__PURE__ */ b(zd, { className: md(o) }),
                M.t("extra_spacing")
              ]
            }
          )
        },
        "paragraph-spacing"
      )
    };
  }, [n, s, o, e]);
};
var un = /* @__PURE__ */ ((n) => (n.BulletList = "bulletList", n.OrderedList = "orderedList", n))(un || {}), He = /* @__PURE__ */ ((n) => (n.Bold = "bold", n.Italic = "italic", n.Underline = "underline", n.Strike = "strike", n))(He || {});
function Wt({ className: n, children: e, disabled: t, open: i }) {
  return /* @__PURE__ */ j(
    "div",
    {
      className: K(
        Nn,
        "main-transition-colors gap-1.5",
        t ? "text-text-secondary" : "text-text-primary hover:text-brand-primary",
        n
      ),
      children: [
        e,
        /* @__PURE__ */ b(
          bh,
          {
            className: K(
              "transition-transform ease-linear duration-200 ",
              i && "rotate-180",
              t ? "stroke-text-secondary" : "stroke-text-primary "
            )
          }
        )
      ]
    }
  );
}
var Bs = /* @__PURE__ */ ((n) => (n.Arial = "Arial, Helvetica, sans-serif", n.ArialBlack = "Arial Black, Gadget, sans-serif", n.Lucida = "Lucida sans unicode,lucida grande,sans-serif", n.Verdana = "verdana,geneva,sans-serif", n.Tahoma = "tahoma,geneva,sans-serif", n.TrebuchetMS = "trebuchet ms,helvetica,sans-serif", n.TimesNewRoman = "times new roman,times,serif", n.Georgia = "georgia, serif", n.Garamond = "garamond, serif", n.CourierNew = "courier new,courier,monospace", n.BrushScriptMT = "brush script mt, cursive", n.Helvetica = "Helvetica, Arial, sans-serif", n.ComicSansMS = "Comic Sans MS, cursive, sans-serif", n.Impact = "Impact, Charcoal, sans-serif", n))(Bs || {});
const je = (n) => n.split(",")[0].toLowerCase().replace(/["']/g, "").replace(/,/g, "_"), zI = (n) => {
  switch (je(n)) {
    case je(
      "Arial, Helvetica, sans-serif"
      /* Arial */
    ):
      return "Arial";
    case je(
      "Arial Black, Gadget, sans-serif"
      /* ArialBlack */
    ):
      return "Arial Black";
    case je(
      "Lucida sans unicode,lucida grande,sans-serif"
      /* Lucida */
    ):
      return "Lucida";
    case je(
      "verdana,geneva,sans-serif"
      /* Verdana */
    ):
      return "Verdana";
    case je(
      "tahoma,geneva,sans-serif"
      /* Tahoma */
    ):
      return "Tahoma";
    case je(
      "trebuchet ms,helvetica,sans-serif"
      /* TrebuchetMS */
    ):
      return "Trebuchet MS";
    case je(
      "times new roman,times,serif"
      /* TimesNewRoman */
    ):
      return "Times New Roman";
    case je(
      "georgia, serif"
      /* Georgia */
    ):
      return "Georgia";
    case je(
      "garamond, serif"
      /* Garamond */
    ):
      return "Garamond";
    case je(
      "courier new,courier,monospace"
      /* CourierNew */
    ):
      return "Courier New";
    case je(
      "brush script mt, cursive"
      /* BrushScriptMT */
    ):
      return "Brush Script MT";
    case je(
      "Helvetica, Arial, sans-serif"
      /* Helvetica */
    ):
      return "Helvetica";
    case je(
      "Comic Sans MS, cursive, sans-serif"
      /* ComicSansMS */
    ):
      return "Comic Sans MS";
    case je(
      "Impact, Charcoal, sans-serif"
      /* Impact */
    ):
      return "Impact";
    default:
      return n;
  }
}, AI = () => Object.values(Bs).map((n) => {
  const e = zI(n);
  return {
    id: je(n),
    fontFamilyValue: n,
    caption: e,
    customCaption: /* @__PURE__ */ b("div", { style: { fontFamily: n }, children: e })
  };
}), LI = (n, e) => {
  const { fontFamilyOptionsData: t, noFontFamilyElement: i, disabled: r } = e ?? {}, o = !(n != null && n.options.editable) || Ct(n) || r, s = n != null && n.getAttributes("textStyle").fontFamily ? je(n == null ? void 0 : n.getAttributes("textStyle").fontFamily) : void 0, a = we(
    () => t ?? AI(),
    [t]
  ), l = we(
    () => i ?? /* @__PURE__ */ b(wl, { label: M.t("font_family.default_hint"), children: M.t("font_family.default") }),
    [i]
  );
  return we(() => {
    const u = (f) => {
      var m;
      if (!n || !f) return null;
      const p = (m = a.find((g) => g.id === f)) == null ? void 0 : m.fontFamilyValue;
      if (!p) return null;
      n.chain().focus().setFontFamily(p).run();
    }, d = () => {
      n && n.chain().focus().unsetFontFamily().run();
    }, h = (f) => {
      const p = a.find((g) => g.id === s), m = (p == null ? void 0 : p.customCaption) ?? (p == null ? void 0 : p.caption);
      return /* @__PURE__ */ b("div", { className: "flex items-center", children: /* @__PURE__ */ j(Wt, { className: "flex gap-1", disabled: o, open: f, children: [
        s ? m : l,
        !!s && /* @__PURE__ */ b(
          kh,
          {
            onClick: (g) => {
              g.stopPropagation(), d();
            },
            className: "fill-text-primary cursor-pointer"
          }
        )
      ] }) });
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ft,
        {
          disabled: o,
          data: a,
          value: s,
          onChange: u,
          children: (f) => /* @__PURE__ */ b(
            ne,
            {
              disabled: o,
              label: M.t("font_family.title"),
              anchor: "left",
              ...re,
              children: h(f)
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ft,
        {
          optionsClassName: "z-40",
          disabled: o,
          data: a,
          value: s,
          onChange: u,
          children: (f) => /* @__PURE__ */ b(
            ne,
            {
              disabled: o,
              label: M.t("font_family.title"),
              anchor: "left",
              ...re,
              children: h(f)
            }
          )
        }
      )
    };
  }, [n, o, s, a, l]);
};
function NI(n) {
  return /* @__PURE__ */ j(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ b("path", { d: "M4.00384 18.1914C3.77528 18.6941 3.18238 18.916 2.67962 18.6875C2.17722 18.4589 1.95528 17.8669 2.18353 17.3643L4.00384 18.1914ZM8.01751 5.38282C8.45246 5.16859 8.96243 5.16864 9.3974 5.38282C9.77416 5.5684 9.97651 5.89497 10.08 6.07716C10.1951 6.27974 10.3148 6.54389 10.4365 6.81153L15.2324 17.3643C15.4606 17.8668 15.2386 18.4589 14.7363 18.6875C14.2335 18.916 13.6406 18.6941 13.412 18.1914L11.6367 14.2861H5.77923L4.00384 18.1914L2.18353 17.3643L6.97943 6.81153C7.10108 6.54389 7.21984 6.27974 7.3349 6.07716C7.43829 5.89512 7.64084 5.56857 8.01751 5.38282ZM6.68841 12.2861H10.7275L8.70794 7.84278L6.68841 12.2861Z" }),
        /* @__PURE__ */ b("path", { d: "M18.6611 4.82422C18.9315 4.82433 19.1907 4.9338 19.3789 5.12793L21.624 7.44434C22.0084 7.84083 21.999 8.47395 21.6025 8.8584C21.206 9.24266 20.5729 9.23235 20.1885 8.83594L19.6611 8.29199V15.7061L20.1885 15.1631C20.5729 14.7668 21.2061 14.7572 21.6025 15.1416C21.999 15.5261 22.0085 16.1592 21.624 16.5557L19.3789 18.8721C19.1907 19.0661 18.9315 19.1757 18.6611 19.1758C18.3906 19.1758 18.1307 19.0663 17.9424 18.8721L15.6973 16.5557C15.3128 16.1592 15.3223 15.5261 15.7187 15.1416C16.1151 14.7572 16.7483 14.7668 17.1328 15.1631L17.6611 15.707V8.29102L17.1328 8.83594L15.6973 7.44434L17.9424 5.12793L18.0166 5.05957C18.1961 4.90837 18.4243 4.82422 18.6611 4.82422ZM17.1328 8.83594C16.7484 9.23238 16.1152 9.24273 15.7187 8.8584C15.3223 8.47397 15.3129 7.84083 15.6973 7.44434L17.1328 8.83594Z" })
      ]
    }
  );
}
const DI = [
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  20,
  22,
  24,
  26,
  28,
  30,
  34,
  38,
  42,
  46,
  50,
  58,
  64,
  72,
  80,
  88,
  96
], Ld = () => DI.map((n) => {
  const e = `${n}px`;
  return {
    id: e,
    caption: e
  };
}), RI = (n, e) => {
  const t = !(n != null && n.options.editable) || Ct(n), i = (n == null ? void 0 : n.getAttributes("textStyle").fontSize) || null;
  return we(() => {
    const o = (a) => {
      if (!n) return null;
      a ? n.chain().focus().setFontSize(a).run() : n.chain().focus().unsetFontSize().run();
    }, s = (a, l) => /* @__PURE__ */ b("div", { className: "flex items-center", children: /* @__PURE__ */ j(Wt, { className: "flex gap-1", disabled: t, open: a, children: [
      i ?? /* @__PURE__ */ j("div", { className: "flex items-center justify-center gap-1", children: [
        /* @__PURE__ */ b(
          NI,
          {
            className: K(
              "main-transition-colors h-3.5 w-3.5 scale-125",
              t ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
            )
          }
        ),
        l
      ] }),
      (e == null ? void 0 : e.clearable) && !!i && /* @__PURE__ */ b(
        kh,
        {
          onClick: (c) => {
            c.stopPropagation(), o(null);
          },
          className: "fill-text-primary cursor-pointer"
        }
      )
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ft,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "min-w-[100px] w-[100px]",
          disabled: t,
          value: i,
          onChange: o,
          data: Ld(),
          children: (a) => /* @__PURE__ */ b(
            ne,
            {
              disabled: t,
              label: M.t("font_size"),
              anchor: "left",
              ...re,
              children: s(a)
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ft,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "z-40 min-w-[100px] w-[100px]",
          disabled: t,
          value: i,
          onChange: o,
          data: Ld(),
          children: (a) => /* @__PURE__ */ b(
            ne,
            {
              disabled: t,
              label: M.t("font_size"),
              anchor: "left",
              ...re,
              children: s(a, M.t("font_size"))
            }
          )
        }
      )
    };
  }, [n, t, i]);
};
var de = /* @__PURE__ */ ((n) => (n[n.Default = 0] = "Default", n[n.H2 = 2] = "H2", n[n.H3 = 3] = "H3", n[n.H4 = 4] = "H4", n))(de || {});
const Oa = (n) => {
  const e = (t) => {
    switch (t) {
      case de.Default:
      default:
        return n("text_level.paragraph");
      case de.H2:
        return n("text_level.header_one");
      case de.H3:
        return n("text_level.header_two");
      case de.H4:
        return n("text_level.header_three");
    }
  };
  return [
    {
      id: de.Default,
      caption: e(de.Default),
      customCaption: /* @__PURE__ */ b("div", { children: e(de.Default) })
    },
    {
      id: de.H2,
      caption: e(de.H2),
      customCaption: /* @__PURE__ */ b(
        "div",
        {
          style: { fontSize: fo[de.H2].fontSize },
          className: "font-bold",
          children: e(de.H2)
        }
      )
    },
    {
      id: de.H3,
      caption: e(de.H3),
      customCaption: /* @__PURE__ */ b(
        "div",
        {
          style: { fontSize: fo[de.H3].fontSize },
          className: "font-bold",
          children: e(de.H3)
        }
      )
    },
    {
      id: de.H4,
      caption: e(de.H4),
      customCaption: /* @__PURE__ */ b(
        "div",
        {
          style: { fontSize: fo[de.H4].fontSize },
          className: "font-semibold",
          children: e(de.H4)
        }
      )
    }
  ];
}, Ea = (n) => {
  if (!n) return;
  const e = n.getAttributes("heading");
  if (e.level)
    switch (e.level) {
      case 2:
        return de.H2;
      case 3:
        return de.H3;
      case 4:
        return de.H4;
    }
  return de.Default;
}, II = (n) => {
  var r;
  const e = (r = Oa(M.t).find(
    (o) => o.id === Ea(n)
  )) == null ? void 0 : r.caption, t = !(n != null && n.options.editable) || Ct(n);
  return we(() => {
    const o = (s) => {
      if (!n) return null;
      if (s === de.Default)
        return n.chain().focus().setParagraph().run();
      n.chain().focus().toggleHeading({ level: s }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ft,
        {
          disabled: t,
          value: Ea(n),
          onChange: o,
          data: Oa(M.t),
          children: (s) => /* @__PURE__ */ b(
            ne,
            {
              disabled: t,
              label: M.t("text_level.title"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ j(
                Wt,
                {
                  className: "flex gap-1",
                  disabled: t,
                  open: s,
                  children: [
                    /* @__PURE__ */ b(cl, { className: he(t) }),
                    e
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ft,
        {
          optionsClassName: "z-40",
          disabled: t,
          value: Ea(n),
          onChange: o,
          data: Oa(M.t),
          children: (s) => /* @__PURE__ */ b(
            ne,
            {
              disabled: t,
              label: M.t("text_level.title"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ j(
                Wt,
                {
                  className: "flex gap-1",
                  disabled: t,
                  open: s,
                  children: [
                    /* @__PURE__ */ b(cl, { className: he(t) }),
                    e
                  ]
                }
              )
            }
          )
        }
      )
    };
  }, [e, n, t]);
};
function eo(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M10.6667 6H1.33337M1.33337 6L6.00004 10.6667M1.33337 6L6.00004 1.33334",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
var Ke = /* @__PURE__ */ ((n) => (n.Left = "left", n.Right = "right", n.Center = "center", n.Justify = "justify", n))(Ke || {});
const PI = () => {
  var e;
  if (typeof window > "u") return;
  if ((e = navigator.userAgentData) != null && e.platform)
    return navigator.userAgentData.platform;
  const n = navigator.userAgent.toLowerCase();
  if (n.includes("mac")) return "macOS";
  if (n.includes("win")) return "Windows";
  if (n.includes("linux")) return "Linux";
}, On = {
  [He.Bold]: {
    toggle: "Mod-B"
  },
  [He.Italic]: {
    toggle: "Mod-I"
  },
  [He.Strike]: {
    toggle: "Mod-Shift-S"
  },
  [He.Underline]: {
    toggle: "Mod-U"
  },
  textAlign: {
    [Ke.Left]: "Mod-Shift-L",
    [Ke.Center]: "Mod-Shift-E",
    [Ke.Right]: "Mod-Shift-R",
    [Ke.Justify]: "Mod-Shift-J"
  },
  list: {
    [un.OrderedList]: "Mod-Shift-7",
    [un.BulletList]: "Mod-Shift-8"
  },
  heading: {
    [de.Default]: "Mod-Alt-0",
    [de.H2]: "Mod-Alt-2",
    [de.H3]: "Mod-Alt-3",
    [de.H4]: "Mod-Alt-4"
  },
  history: {
    undo: "Mod-Z",
    redo: "Shift-Mod-Z"
  }
}, En = (n) => {
  const e = PI();
  return n.replace("Mod", e === "macOS" ? "⌘" : "Ctrl").replace("Alt", e === "macOS" ? "⌥" : "Alt").replace("-", " ");
}, jI = (n) => {
  const e = !(n != null && n.options.editable) || !(n != null && n.can().undo()), t = !(n != null && n.options.editable) || !(n != null && n.can().redo());
  return we(() => [
    {
      toolbarRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: e,
          label: `${M.t("undo")} (${En(On.history.undo)})`,
          ...re,
          children: /* @__PURE__ */ b(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().undo().run(),
              disabled: e,
              children: /* @__PURE__ */ b(eo, { className: he(e) })
            }
          )
        },
        "undo"
      ),
      tooltipRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: e,
          label: En(On.history.undo),
          ...re,
          children: /* @__PURE__ */ j(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().undo().run(),
              className: "flex gap-1",
              disabled: e,
              children: [
                /* @__PURE__ */ b(eo, { className: he(e) }),
                M.t("undo")
              ]
            }
          )
        },
        "undo"
      )
    },
    {
      toolbarRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: t,
          label: `${M.t("redo")} (${En(On.history.redo)})`,
          ...re,
          children: /* @__PURE__ */ b(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().redo().run(),
              disabled: t,
              children: /* @__PURE__ */ b(
                eo,
                {
                  className: K(
                    he(t),
                    "rotate-180"
                  )
                }
              )
            }
          )
        },
        "redo"
      ),
      tooltipRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: t,
          label: En(On.history.redo),
          ...re,
          children: /* @__PURE__ */ j(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().redo().run(),
              className: "flex gap-1",
              disabled: t,
              children: [
                /* @__PURE__ */ b(
                  eo,
                  {
                    className: K(
                      he(t),
                      "rotate-180"
                    )
                  }
                ),
                M.t("redo")
              ]
            }
          )
        },
        "redo"
      )
    }
  ], [n, t, e]);
};
function Nd(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "14",
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M2.84804 12.8186L7.24573 8.42091C7.50974 8.1569 7.64175 8.0249 7.79397 7.97544C7.92786 7.93193 8.0721 7.93193 8.20599 7.97544C8.35821 8.0249 8.49022 8.15691 8.75423 8.42091L13.1226 12.7893M9.33331 9L11.2457 7.08758C11.5097 6.82357 11.6417 6.69156 11.794 6.6421C11.9279 6.5986 12.0721 6.5986 12.206 6.6421C12.3582 6.69156 12.4902 6.82357 12.7542 7.08758L14.6666 9M6.66665 5C6.66665 5.73638 6.06969 6.33333 5.33331 6.33333C4.59693 6.33333 3.99998 5.73638 3.99998 5C3.99998 4.26362 4.59693 3.66667 5.33331 3.66667C6.06969 3.66667 6.66665 4.26362 6.66665 5ZM4.53331 13H11.4666C12.5868 13 13.1468 13 13.5746 12.782C13.951 12.5903 14.2569 12.2843 14.4487 11.908C14.6666 11.4802 14.6666 10.9201 14.6666 9.8V4.2C14.6666 3.0799 14.6666 2.51984 14.4487 2.09202C14.2569 1.71569 13.951 1.40973 13.5746 1.21799C13.1468 1 12.5868 1 11.4666 1H4.53331C3.41321 1 2.85316 1 2.42533 1.21799C2.04901 1.40973 1.74305 1.71569 1.5513 2.09202C1.33331 2.51984 1.33331 3.0799 1.33331 4.2V9.8C1.33331 10.9201 1.33331 11.4802 1.5513 11.908C1.74305 12.2843 2.04901 12.5903 2.42533 12.782C2.85316 13 3.41321 13 4.53331 13Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function Dd({ isDisabled: n, handleSetImage: e }) {
  return /* @__PURE__ */ b(
    go,
    {
      disabled: n,
      anchor: "bottom",
      wrapperClassName: "group px-1.5",
      label: /* @__PURE__ */ b(BI, { handleSetImage: e, isDisabled: n }),
      children: (t) => /* @__PURE__ */ b(
        ne,
        {
          disabled: n,
          className: "content-center",
          label: M.t("image_via_link"),
          wrapperClassName: "h-full",
          ...re,
          children: /* @__PURE__ */ b(
            bh,
            {
              className: K(
                he(n),
                "transition-transform duration-200 ease-linear ",
                "main-transition-colors h-3.5 w-3.5",
                n ? "stroke-text-secondary" : "stroke-text-primary group-hover:stroke-brand-primary",
                t && "rotate-180"
              )
            }
          )
        }
      )
    }
  );
}
function BI({ handleSetImage: n, isDisabled: e }) {
  const [t, i] = xe(""), r = e || !t || !yh(t);
  return /* @__PURE__ */ j("form", { onSubmit: (o) => o.preventDefault(), className: "flex items-end", children: [
    /* @__PURE__ */ b(
      mh,
      {
        inputClassName: "min-w-[200px]",
        placeholder: "example.com/image.png",
        disabled: e,
        label: M.t("image_insert_via_link"),
        value: t,
        onChange: (o) => i(o)
      }
    ),
    /* @__PURE__ */ b(
      ae,
      {
        disabled: r,
        type: "submit",
        onClick: () => n(t),
        className: "mb-[5px]",
        children: /* @__PURE__ */ b(Cl, { className: he(r) })
      }
    )
  ] });
}
const FI = (n, e) => {
  const [t, i] = xe(!1), r = !(n != null && n.options.editable);
  return we(() => {
    const s = (a) => {
      if (!n) return null;
      const l = () => n.chain().focus().run();
      if (!a) return l();
      const c = new Image();
      c.src = a, c.onerror = () => {
        ao.error(M.t("image_error")), l();
      }, c.onload = () => {
        const u = c.naturalWidth, d = c.naturalHeight;
        n.chain().focus().setImage({
          src: a,
          imageMode: ce.BlockCenter,
          containerWidth: "auto",
          width: u,
          height: d
        }).run(), i(!1);
      };
    };
    return {
      toolbarRender: /* @__PURE__ */ j("div", { className: "hover:divide-text-secondary/30 flex divide-x divide-transparent", children: [
        /* @__PURE__ */ b(ne, { disabled: r, label: M.t("image"), ...re, children: /* @__PURE__ */ b(ae, { disabled: r, onClick: () => i(!0), children: /* @__PURE__ */ b(Nd, { className: he(r) }) }) }),
        /* @__PURE__ */ b(Dd, { handleSetImage: s, isDisabled: r })
      ] }),
      tooltipRender: /* @__PURE__ */ j("div", { className: "divide-text-secondary/30 flex divide-x", children: [
        /* @__PURE__ */ j(
          ae,
          {
            className: "gap-1.5",
            disabled: r,
            onClick: () => i(!0),
            children: [
              /* @__PURE__ */ b(Nd, { className: he(r) }),
              M.t("image")
            ]
          }
        ),
        /* @__PURE__ */ b(Dd, { handleSetImage: s, isDisabled: r })
      ] }),
      additionalRender: /* @__PURE__ */ b(
        xl,
        {
          initialSearchFilters: {
            name: "",
            source: [e],
            type: [xc.Image, xc.ImageOther]
          },
          opened: t,
          onClose: () => i(!1),
          onSelect: ({ path: a }) => s(a),
          uploadingFromSource: e,
          disabledFileTypeSelect: !0
        }
      )
    };
  }, [r, t, n, e]);
};
function to(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M13 1.66666H1M13 12.3333H1M7 5.16666H1M7 8.83333H1M12.1467 4.64L9.56889 6.57333C9.37589 6.71808 9.2794 6.79045 9.24489 6.87917C9.21467 6.95689 9.21467 7.04311 9.24489 7.12082C9.2794 7.20954 9.37589 7.28192 9.56889 7.42666L12.1467 9.36C12.4213 9.56599 12.5586 9.66898 12.6736 9.66659C12.7736 9.66451 12.8674 9.61761 12.9291 9.53883C13 9.4483 13 9.27665 13 8.93333V5.06666C13 4.72335 13 4.55169 12.9291 4.46116C12.8674 4.38239 12.7736 4.33548 12.6736 4.3334C12.5586 4.33101 12.4213 4.43401 12.1467 4.64Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function qI(n, e, t) {
  return n < e ? e : n > t ? t : n;
}
var yl = /* @__PURE__ */ ((n) => (n[n.min = 0] = "min", n[n.max = 140] = "max", n[n.more = 20] = "more", n[n.less = -20] = "less", n))(yl || {});
function HI(n) {
  return n.type.name === "bullet_list";
}
function VI(n) {
  return n.type.name === "order_list";
}
function UI(n) {
  return HI(n) || VI(n);
}
function WI(n, e, t) {
  if (!n.doc) return n;
  const i = n.doc.nodeAt(e);
  if (!i) return n;
  const r = 0, o = 140;
  let s = 0;
  typeof i.attrs.indent == "number" ? s = i.attrs.indent : typeof i.attrs.indent == "string" && (s = parseInt(i.attrs.indent) || 0);
  const a = qI(s + t, r, o);
  if (a === s) return n;
  const l = {
    ...i.attrs,
    indent: a
  };
  return n.setNodeMarkup(e, i.type, l, i.marks);
}
function Rd(n, e) {
  const { doc: t, selection: i } = n;
  if (!t || !i || !(i instanceof Y || i instanceof ot))
    return n;
  const { from: r, to: o } = i;
  return t.nodesBetween(r, o, (s, a) => {
    const l = s.type;
    return l.name === "paragraph" || l.name === "heading" ? (n = WI(n, a, e), !1) : !UI(s);
  }), n;
}
const KI = Ce.create({
  name: "indent",
  addOptions() {
    return {
      types: ["heading", "paragraph"],
      indentLevels: [0, 20, 40, 60, 80, 100, 120, 140],
      defaultIndentLevel: 0
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: this.options.defaultIndentLevel,
            renderHTML: (n) => ({
              style: `margin-left: ${typeof n.indent == "number" ? n.indent : parseInt(String(n.indent)) || this.options.defaultIndentLevel}px;`
            }),
            parseHTML: (n) => {
              const e = n.style.marginLeft;
              let t = this.options.defaultIndentLevel;
              if (e && typeof e == "string") {
                const i = parseInt(e.replace(/[^\d.-]/g, ""));
                isNaN(i) || (t = i);
              }
              return t;
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      indent: () => ({ tr: n, state: e, dispatch: t }) => {
        const { selection: i } = e;
        return n = n.setSelection(i), n = Rd(
          n,
          20
          /* more */
        ), n.docChanged ? (t && t(n), !0) : !1;
      },
      outdent: () => ({ tr: n, state: e, dispatch: t }) => {
        const { selection: i } = e;
        return n = n.setSelection(i), n = Rd(
          n,
          -20
          /* less */
        ), n.docChanged ? (t && t(n), !0) : !1;
      }
    };
  }
}), ZI = (n) => {
  const t = (() => {
    if (!n) return 0;
    const s = ["paragraph", "heading", "bulletList", "orderedList"];
    for (const a of s) {
      const l = n.getAttributes(a);
      if (l && typeof l.indent == "number")
        return l.indent;
    }
    return 0;
  })(), i = !(n != null && n.options.editable) || Ct(n) || t <= yl.min, r = !(n != null && n.options.editable) || Ct(n) || t >= yl.max;
  return we(() => {
    const s = () => n == null ? void 0 : n.chain().focus().outdent().run(), a = () => n == null ? void 0 : n.chain().focus().indent().run();
    return [
      {
        toolbarRender: /* @__PURE__ */ b(
          ne,
          {
            disabled: i,
            label: M.t("decrease_intent"),
            ...re,
            children: /* @__PURE__ */ b(
              ae,
              {
                className: "flex gap-1",
                onClick: s,
                disabled: i,
                children: /* @__PURE__ */ b(to, { className: he(i) })
              }
            )
          },
          "outdent"
        ),
        tooltipRender: /* @__PURE__ */ j(
          ae,
          {
            className: "flex gap-1",
            onClick: s,
            disabled: i,
            children: [
              /* @__PURE__ */ b(to, { className: he(i) }),
              M.t("decrease_intent")
            ]
          }
        )
      },
      {
        toolbarRender: /* @__PURE__ */ b(
          ne,
          {
            disabled: r,
            label: M.t("increase_intent"),
            ...re,
            children: /* @__PURE__ */ b(
              ae,
              {
                className: "flex gap-1",
                onClick: a,
                disabled: r,
                children: /* @__PURE__ */ b(
                  to,
                  {
                    className: K(
                      he(r),
                      "rotate-180"
                    )
                  }
                )
              }
            )
          },
          "indent"
        ),
        tooltipRender: /* @__PURE__ */ j(
          ae,
          {
            className: "flex gap-1",
            onClick: a,
            disabled: r,
            children: [
              /* @__PURE__ */ b(
                to,
                {
                  className: K(
                    he(r),
                    "rotate-180"
                  )
                }
              ),
              M.t("increase_intent")
            ]
          }
        )
      }
    ];
  }, [n, r, i]);
}, GI = (n, e) => {
  const t = tz(n), i = !(n != null && n.options.editable) || Ct(n);
  return we(() => {
    const o = () => {
      if (!n) return null;
      n.isActive("link") ? n.chain().focus() : n.chain().focus().extendMarkRange("link").setLink({ href: "" }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: i,
          label: M.t("link"),
          ...re,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: i,
              className: K(
                t && "bg-brand-primary/10 main-transition-colors"
              ),
              onClick: o,
              children: /* @__PURE__ */ b(Fo, { className: he(i) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ j(
        ae,
        {
          disabled: i,
          className: K(
            t && "bg-brand-primary/10 main-transition-colors",
            "flex gap-1"
          ),
          onClick: o,
          children: [
            /* @__PURE__ */ b(Fo, { className: he(i) }),
            M.t("link")
          ]
        }
      )
    };
  }, [n, t, i, e]);
};
function JI(n) {
  return /* @__PURE__ */ j(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: [
        /* @__PURE__ */ b("path", { d: "M6.66663 3H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b("path", { d: "M6.66663 6.33334H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b("path", { d: "M6.66663 9.66666H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b("path", { d: "M6.66663 13H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M2 9.66666H4V10.6667L2 12.6667V13H4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M2.33337 3.66667L3.00004 3V6.33333M3.00004 6.33333H2.33337M3.00004 6.33333H3.66671",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        )
      ]
    }
  );
}
function YI(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const XI = ({ listType: n, editor: e }) => {
  if (e)
    switch (n) {
      case un.BulletList:
        e.chain().focus().toggleBulletList().run();
        break;
      case un.OrderedList:
        e.chain().focus().toggleOrderedList().run();
        break;
    }
}, QI = ({ listType: n }) => {
  switch (n) {
    case un.BulletList:
      return YI;
    case un.OrderedList:
      return JI;
  }
}, fz = (n) => {
  switch (n) {
    case 0:
      return "disc";
    case 1:
      return "circle";
    default:
      return "square";
  }
}, pz = (n) => {
  switch (n) {
    case 0:
      return "decimal";
    case 1:
      return "lower-latin";
    case 2:
      return "lower-roman";
    case 3:
      return "upper-latin";
    default:
      return "upper-roman";
  }
}, Id = (n, e) => {
  const t = !(n != null && n.options.editable), i = n == null ? void 0 : n.isActive(e);
  return we(() => {
    const o = () => XI({ editor: n, listType: e }), s = QI({ listType: e });
    return {
      toolbarRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: t,
          label: `${M.t(`${e}`)} (${En(On.list[e])})`,
          ...re,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: t,
              className: K(
                Nn,
                i && "bg-brand-primary/10",
                "main-transition-colors"
              ),
              onClick: o,
              children: /* @__PURE__ */ b(s, { className: he(t) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: t,
          label: En(On.list[e]),
          ...re,
          children: /* @__PURE__ */ j(
            ae,
            {
              disabled: t,
              className: K(
                Nn,
                i && "bg-brand-primary/10",
                "main-transition-colors",
                "flex gap-1"
              ),
              onClick: o,
              children: [
                /* @__PURE__ */ b(s, { className: he(t) }),
                M.t(`${e}`)
              ]
            }
          )
        }
      )
    };
  }, [n, i, t, e]);
}, Pd = [
  {
    name: "special_characters.dollar",
    code: "U+0024",
    symbol: "$"
  },
  {
    name: "special_characters.euro",
    code: "U+20ac",
    symbol: "€"
  },
  {
    name: "special_characters.yen",
    code: "U+00a5",
    symbol: "¥"
  },
  {
    name: "special_characters.pound",
    code: "U+00a3",
    symbol: "£"
  },
  {
    name: "special_characters.cent",
    code: "U+00a2",
    symbol: "¢"
  },
  {
    name: "special_characters.euro_currency",
    code: "U+20a0",
    symbol: "₠"
  },
  {
    name: "special_characters.colon",
    code: "U+20a1",
    symbol: "₡"
  },
  {
    name: "special_characters.cruzeiro",
    code: "U+20a2",
    symbol: "₢"
  },
  {
    name: "special_characters.french_franc",
    code: "U+20a3",
    symbol: "₣"
  },
  {
    name: "special_characters.lira",
    code: "U+20a4",
    symbol: "₤"
  },
  {
    name: "special_characters.currency",
    code: "U+00a4",
    symbol: "¤"
  },
  {
    name: "special_characters.bitcoin",
    code: "U+20bf",
    symbol: "₿"
  },
  {
    name: "special_characters.mill",
    code: "U+20a5",
    symbol: "₥"
  },
  {
    name: "special_characters.mill",
    code: "U+20a6",
    symbol: "₦"
  },
  {
    name: "special_characters.peseta",
    code: "U+20a7",
    symbol: "₧"
  },
  {
    name: "special_characters.rupee",
    code: "U+20a8",
    symbol: "₨"
  },
  {
    name: "special_characters.won",
    code: "U+20a9",
    symbol: "₩"
  },
  {
    name: "special_characters.new_sheqel",
    code: "U+20aa",
    symbol: "₪"
  },
  {
    name: "special_characters.dong",
    code: "U+20ab",
    symbol: "₫"
  },
  {
    name: "special_characters.kip",
    code: "U+20ad",
    symbol: "₭"
  },
  {
    name: "special_characters.tugrik",
    code: "U+20ae",
    symbol: "₮"
  },
  {
    name: "special_characters.drachma",
    code: "U+20af",
    symbol: "₯"
  },
  {
    name: "special_characters.german_penny",
    code: "U+20b0",
    symbol: "₰"
  },
  {
    name: "special_characters.peso",
    code: "U+20b1",
    symbol: "₱"
  },
  {
    name: "special_characters.guarani",
    code: "U+20b2",
    symbol: "₲"
  },
  {
    name: "special_characters.austral",
    code: "U+20b3",
    symbol: "₳"
  },
  {
    name: "special_characters.hryvnia",
    code: "U+20b4",
    symbol: "₴"
  },
  {
    name: "special_characters.cedi",
    code: "U+20b5",
    symbol: "₵"
  },
  {
    name: "special_characters.livre_tournois",
    code: "U+20b6",
    symbol: "₶"
  },
  {
    name: "special_characters.spesmilo",
    code: "U+20b7",
    symbol: "₷"
  },
  {
    name: "special_characters.tenge",
    code: "U+20b8",
    symbol: "₸"
  },
  {
    name: "special_characters.indian_rupee",
    code: "U+20b9",
    symbol: "₹"
  },
  {
    name: "special_characters.turkish_lira",
    code: "U+20ba",
    symbol: "₺"
  },
  {
    name: "special_characters.nordic_mark",
    code: "U+20bb",
    symbol: "₻"
  },
  {
    name: "special_characters.manat",
    code: "U+20bc",
    symbol: "₼"
  },
  {
    name: "special_characters.ruble",
    code: "U+20bd",
    symbol: "₽"
  }
], jd = [
  {
    name: "special_characters.left_pointing_angle_quotation_mark",
    code: "U+2039",
    symbol: "‹"
  },
  {
    name: "special_characters.right_pointing_angle_quotation_mark",
    code: "U+203a",
    symbol: "›"
  },
  {
    name: "special_characters.left_pointing_double_angle_quotation_mark",
    code: "U+00ab",
    symbol: "«"
  },
  {
    name: "special_characters.right_pointing_double_angle_quotation_mark",
    code: "U+00bb",
    symbol: "»"
  },
  {
    name: "special_characters.left_single_quotation_mark",
    code: "U+2018",
    symbol: "‘"
  },
  {
    name: "special_characters.right_single_quotation_mark",
    code: "U+2019",
    symbol: "’"
  },
  {
    name: "special_characters.left_double_quotation_mark",
    code: "U+201c",
    symbol: "“"
  },
  {
    name: "special_characters.right_double_quotation_mark",
    code: "U+201d",
    symbol: "”"
  },
  {
    name: "special_characters.single_low_quotation_mark",
    code: "U+201a",
    symbol: "‚"
  },
  {
    name: "special_characters.double_low_quotation_mark",
    code: "U+201e",
    symbol: "„"
  },
  {
    name: "special_characters.inverted_exclamation_mark",
    code: "U+00a1",
    symbol: "¡"
  },
  {
    name: "special_characters.inverted_question_mark",
    code: "U+00bf",
    symbol: "¿"
  },
  {
    name: "special_characters.two_dot_leader",
    code: "U+2025",
    symbol: "‥"
  },
  {
    name: "special_characters.horizontal_ellipsis",
    code: "U+2026",
    symbol: "…"
  },
  {
    name: "special_characters.double_dagger",
    code: "U+2021",
    symbol: "‡"
  },
  {
    name: "special_characters.per_mille_sign",
    code: "U+2030",
    symbol: "‰"
  },
  {
    name: "special_characters.per_ten_thousand_sign",
    code: "U+2031",
    symbol: "‱"
  },
  {
    name: "special_characters.double_exclamation_mark",
    code: "U+203c",
    symbol: "‼"
  },
  {
    name: "special_characters.question_exclamation_mark",
    code: "U+2048",
    symbol: "⁈"
  },
  {
    name: "special_characters.exclamation_question_mark",
    code: "U+2049",
    symbol: "⁉"
  },
  {
    name: "special_characters.double_question_mark",
    code: "U+2047",
    symbol: "⁇"
  },
  {
    name: "special_characters.copyright_sign",
    code: "U+00a9",
    symbol: "©"
  },
  {
    name: "special_characters.registered_sign",
    code: "U+00ae",
    symbol: "®"
  },
  {
    name: "special_characters.trade_mark_sign",
    code: "U+2122",
    symbol: "™"
  },
  {
    name: "special_characters.section_sign",
    code: "U+00a7",
    symbol: "§"
  },
  {
    name: "special_characters.paragraph_sign",
    code: "U+00b6",
    symbol: "¶"
  },
  {
    name: "special_characters.reversed_paragraph_sign",
    code: "U+204b",
    symbol: "⁋"
  }
], ki = {
  currency: Pd,
  text: jd,
  all: [...Pd, ...jd]
};
var ur = /* @__PURE__ */ ((n) => (n.Text = "text", n.Currency = "currency", n.All = "all", n))(ur || {});
function Bd(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      className: "ck ck-icon ck-reset_all-excluded ck-icon_inherit-color ck-button__icon",
      viewBox: "0 0 20 20",
      width: 14,
      height: 14,
      ...n,
      children: /* @__PURE__ */ b("path", { d: "M10 2.5a7.47 7.47 0 0 1 4.231 1.31 7.268 7.268 0 0 1 2.703 3.454 7.128 7.128 0 0 1 .199 4.353c-.39 1.436-1.475 2.72-2.633 3.677h2.013c0-.226.092-.443.254-.603a.876.876 0 0 1 1.229 0c.163.16.254.377.254.603v.853c0 .209-.078.41-.22.567a.873.873 0 0 1-.547.28l-.101.006h-4.695a.517.517 0 0 1-.516-.518v-1.265c0-.21.128-.398.317-.489a5.601 5.601 0 0 0 2.492-2.371 5.459 5.459 0 0 0 .552-3.693 5.53 5.53 0 0 0-1.955-3.2A5.71 5.71 0 0 0 10 4.206 5.708 5.708 0 0 0 6.419 5.46 5.527 5.527 0 0 0 4.46 8.663a5.457 5.457 0 0 0 .554 3.695 5.6 5.6 0 0 0 2.497 2.37.55.55 0 0 1 .317.49v1.264c0 .286-.23.518-.516.518H2.618a.877.877 0 0 1-.614-.25.845.845 0 0 1-.254-.603v-.853c0-.226.091-.443.254-.603a.876.876 0 0 1 1.228 0c.163.16.255.377.255.603h1.925c-1.158-.958-2.155-2.241-2.545-3.678a7.128 7.128 0 0 1 .199-4.352 7.268 7.268 0 0 1 2.703-3.455A7.475 7.475 0 0 1 10 2.5z" })
    }
  );
}
const Fd = (n) => [
  {
    caption: n("special_characters.select_text"),
    id: ur.Text
  },
  {
    caption: n("special_characters.select_currency"),
    id: ur.Currency
  },
  {
    caption: n("special_characters.select_all"),
    id: ur.All
  }
], eP = (n) => {
  const [e, t] = xe(ur.All), [i, r] = xe(null), o = !(n != null && n.options.editable);
  return we(() => {
    const a = (l) => {
      if (!n) return null;
      n.chain().focus().insertContent(l).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        go,
        {
          className: K("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: o,
          anchor: "bottom",
          label: /* @__PURE__ */ j("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ j(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: M.t("special_characters.title") }),
                  /* @__PURE__ */ b(
                    Sc,
                    {
                      optionsClassName: "z-50",
                      onChange: (l) => l && t(l),
                      value: e,
                      data: Fd(M.t),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ b("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: ki[e].map((l, c) => /* @__PURE__ */ b(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => a(l.symbol),
                onMouseEnter: () => r(c),
                onMouseLeave: () => r(null),
                children: /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: l.symbol })
              },
              l.code
            )) }),
            /* @__PURE__ */ b("div", { className: "mt-3 flex h-5 items-center justify-between", children: i !== null && /* @__PURE__ */ j(ln, { children: [
              /* @__PURE__ */ b("span", { className: "text-xs", children: M.t(ki[e][i].name) }),
              " ",
              /* @__PURE__ */ b("span", { className: "text-xs", children: ki[e][i].code })
            ] }) })
          ] }),
          children: (l) => /* @__PURE__ */ b(
            ne,
            {
              disabled: o,
              label: M.t("special_characters.title"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ b(Wt, { disabled: o, open: l, children: /* @__PURE__ */ b(
                Bd,
                {
                  className: Ee(
                    o ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              ) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        go,
        {
          className: K("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: o,
          anchor: "bottom",
          label: /* @__PURE__ */ j("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ j(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: M.t("special_characters.title") }),
                  /* @__PURE__ */ b(
                    Sc,
                    {
                      optionsClassName: "z-50",
                      onChange: (l) => l && t(l),
                      value: e,
                      data: Fd(M.t),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ b("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: ki[e].map((l, c) => /* @__PURE__ */ b(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => a(l.symbol),
                onMouseEnter: () => r(c),
                onMouseLeave: () => r(null),
                children: /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: l.symbol })
              },
              l.code
            )) }),
            /* @__PURE__ */ b("div", { className: "mt-3 flex h-5 items-center justify-between", children: i !== null && /* @__PURE__ */ j(ln, { children: [
              /* @__PURE__ */ b("span", { className: "text-xs", children: M.t(ki[e][i].name) }),
              " ",
              /* @__PURE__ */ b("span", { className: "text-xs", children: ki[e][i].code })
            ] }) })
          ] }),
          children: (l) => /* @__PURE__ */ b(
            ne,
            {
              disabled: o,
              label: M.t("special_characters.title"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ j(Wt, { className: "flex gap-1", disabled: o, open: l, children: [
                /* @__PURE__ */ b(
                  Bd,
                  {
                    className: Ee(
                      o ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                      "main-transition-colors"
                    )
                  }
                ),
                M.t("special_characters.title")
              ] })
            }
          )
        }
      )
    };
  }, [n, i, o, e]);
}, tP = (n, e) => {
  const t = !(n != null && n.options.editable);
  return we(() => {
    const r = (o) => {
      if (!n) return null;
      o && n.chain().focus().insertContent(o).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ft,
        {
          value: void 0,
          disabled: t,
          data: e,
          onChange: r,
          children: (o) => /* @__PURE__ */ b(
            ne,
            {
              disabled: t,
              label: M.t("substitute_variables"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ b(Wt, { open: o, disabled: t, children: M.t("substitutions") })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ft,
        {
          optionsClassName: "z-40",
          value: void 0,
          disabled: t,
          data: e,
          onChange: r,
          children: (o) => /* @__PURE__ */ b(
            ne,
            {
              disabled: t,
              label: M.t("substitute_variables"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ b(Wt, { open: o, disabled: t, children: M.t("substitutions") })
            }
          )
        }
      )
    };
  }, [n, t, e]);
};
function mz(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M18 10H6M21 6H3M21 14H3M18 18H6",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function gz(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "20",
      height: "14",
      viewBox: "0 0 20 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M19 5H1M19 13H1M19 1H1M19 9H1",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function _z(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "19",
      height: "14",
      viewBox: "0 0 19 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M14 5H1M18 1H1M18 9H1M14 13H1",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function bz(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "19",
      height: "14",
      viewBox: "0 0 19 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M18 5H5M18 1H1M18 9H1M18 13H5",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const vl = (n) => {
  const e = (t) => {
    const i = K(
      "stroke-text-primary",
      "group-hover:stroke-background-secondary",
      n === t && "stroke-background-secondary"
    );
    switch (t) {
      case Ke.Left:
        return /* @__PURE__ */ b(_z, { className: i });
      case Ke.Right:
        return /* @__PURE__ */ b(bz, { className: i });
      case Ke.Center:
        return /* @__PURE__ */ b(mz, { className: i });
      case Ke.Justify:
        return /* @__PURE__ */ b(gz, { className: i });
    }
  };
  return Object.values(Ke).map((t) => ({
    id: t,
    caption: t,
    customCaption: e(t)
  }));
}, Ma = (n) => {
  if (!n) return Ke.Left;
  const e = vl().find(({ id: t }) => n.isActive({ textAlign: t }));
  return e ? e.id : Ke.Left;
}, nP = (n) => {
  const e = Ma(n), t = !(n != null && n.options.editable) || Ct(n);
  return we(() => {
    const r = () => {
      const s = he(t);
      switch (e) {
        case Ke.Right:
          return /* @__PURE__ */ b(bz, { className: s });
        case Ke.Center:
          return /* @__PURE__ */ b(mz, { className: s });
        case Ke.Justify:
          return /* @__PURE__ */ b(gz, { className: s });
        case Ke.Left:
        default:
          return /* @__PURE__ */ b(_z, { className: s });
      }
    }, o = (s) => {
      if (!n || !s) return null;
      n.chain().focus().setTextAlign(s).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ft,
        {
          disabled: t,
          value: Ma(n),
          data: vl(e),
          onChange: o,
          optionClassName: "group",
          children: (s) => /* @__PURE__ */ b(
            ne,
            {
              disabled: t,
              label: M.t("text_align"),
              anchor: "left",
              ...re,
              children: /* @__PURE__ */ b(Wt, { disabled: t, open: s, children: r() })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ft,
        {
          optionsClassName: "z-40",
          disabled: t,
          value: Ma(n),
          data: vl(e),
          onChange: o,
          optionClassName: "group",
          children: (s) => /* @__PURE__ */ j(
            Wt,
            {
              className: K("flex gap-1"),
              disabled: t,
              open: s,
              children: [
                r(),
                M.t("text_align")
              ]
            }
          )
        }
      )
    };
  }, [n, t, e]);
};
function qd(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M10.6665 7.33334L1.33313 7.33334M6.66647 2.66667L5.33313 1.33334M9.33313 14.6667L1.33313 14.6667M14.6665 10.6667C14.6665 11.403 14.0695 12 13.3331 12C12.5968 12 11.9998 11.403 11.9998 10.6667C11.9998 9.93029 13.3331 8.66667 13.3331 8.66667C13.3331 8.66667 14.6665 9.93029 14.6665 10.6667ZM5.9998 2L10.5789 6.57909C10.8429 6.8431 10.9749 6.97511 11.0244 7.12732C11.0679 7.26122 11.0679 7.40545 11.0244 7.53935C10.9749 7.69157 10.8429 7.82357 10.5789 8.08758L7.50829 11.1582C6.98027 11.6862 6.71626 11.9502 6.41182 12.0491C6.14403 12.1361 5.85557 12.1361 5.58778 12.0491C5.28334 11.9502 5.01933 11.6862 4.4913 11.1582L2.17496 8.84183C1.64694 8.31381 1.38293 8.0498 1.28401 7.74536C1.197 7.47757 1.197 7.1891 1.28401 6.92131C1.38293 6.61688 1.64694 6.35286 2.17496 5.82484L5.9998 2Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const iP = (n, e) => {
  const { shouldHideTooltip: t, showAlpha: i = !0 } = e ?? {}, r = n == null ? void 0 : n.getAttributes("textStyle").backgroundColor, o = r ? Tl(r) : yR, s = !(n != null && n.options.editable) || Ct(n), a = !!(n != null && n.getAttributes("textStyle").backgroundColor);
  return we(() => {
    const c = (f) => {
      if (!n) return null;
      n.chain().setBackgroundColor(f).run();
    }, u = () => {
      if (!n) return null;
      n.chain().focus().setBackgroundColor(o).run();
    }, d = () => {
      if (!n) return null;
      n.chain().focus().unsetBackgroundColor().run();
    }, h = () => /* @__PURE__ */ b(vh, { features: ko.None, children: /* @__PURE__ */ j("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ b(
        gh,
        {
          className: "w-full",
          neutralType: _h.danger,
          disabled: !a,
          onClick: d,
          children: M.t("global.clear")
        }
      ),
      /* @__PURE__ */ b(bo, { className: "w-full", onClick: u, children: M.t("global.apply") })
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ b(
        _o,
        {
          disabled: s,
          additionalPopoverChildren: h,
          color: o,
          onChange: c,
          showAlpha: i,
          children: () => /* @__PURE__ */ b(
            ne,
            {
              disabled: t || s,
              label: M.t("background_color"),
              ...re,
              children: /* @__PURE__ */ j(
                "div",
                {
                  className: K(
                    Nn,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ b(qd, { className: he(s) }),
                    a && /* @__PURE__ */ b(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: o }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        _o,
        {
          disabled: s,
          focusTrapFeatures: ko.FocusLock,
          additionalPopoverChildren: h,
          color: o,
          onChange: c,
          showAlpha: i,
          children: () => /* @__PURE__ */ j(
            "div",
            {
              className: K(
                Nn,
                "gap-1.5",
                "relative",
                "flex gap-1",
                Z$(s)
              ),
              children: [
                /* @__PURE__ */ b(qd, { className: he(s) }),
                M.t("background_color"),
                a && /* @__PURE__ */ b(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: o }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [o, n, a, s, t, i]);
};
function Hd(n) {
  return /* @__PURE__ */ j(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: [
        /* @__PURE__ */ b(
          "path",
          {
            d: "M1.33337 8C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667C9.10461 14.6667 10 13.7712 10 12.6667V12.3333C10 12.0237 10 11.8689 10.0172 11.739C10.1353 10.8415 10.8415 10.1353 11.739 10.0171C11.869 10 12.0238 10 12.3334 10H12.6667C13.7713 10 14.6667 9.10457 14.6667 8C14.6667 4.3181 11.6819 1.33334 8.00004 1.33334C4.31814 1.33334 1.33337 4.3181 1.33337 8Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M4.66671 8.66667C5.0349 8.66667 5.33337 8.36819 5.33337 8C5.33337 7.63181 5.0349 7.33334 4.66671 7.33334C4.29852 7.33334 4.00004 7.63181 4.00004 8C4.00004 8.36819 4.29852 8.66667 4.66671 8.66667Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M10.6667 6C11.0349 6 11.3334 5.70153 11.3334 5.33334C11.3334 4.96515 11.0349 4.66667 10.6667 4.66667C10.2985 4.66667 10 4.96515 10 5.33334C10 5.70153 10.2985 6 10.6667 6Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M6.66671 5.33334C7.0349 5.33334 7.33337 5.03486 7.33337 4.66667C7.33337 4.29848 7.0349 4 6.66671 4C6.29852 4 6.00004 4.29848 6.00004 4.66667C6.00004 5.03486 6.29852 5.33334 6.66671 5.33334Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        )
      ]
    }
  );
}
const rP = (n, e) => {
  const { shouldHideTooltip: t, showAlpha: i = !0 } = e ?? {}, r = n == null ? void 0 : n.getAttributes("textStyle").color, o = r ? Tl(r) : bR, s = !!(n != null && n.getAttributes("textStyle").color), a = !(n != null && n.options.editable) || Ct(n);
  return we(() => {
    const c = (f) => {
      if (!n) return null;
      n.chain().setColor(f).run();
    }, u = () => {
      if (!n) return null;
      n.chain().focus().setColor(o).run();
    }, d = () => {
      if (!n) return null;
      n.chain().focus().unsetColor().run();
    }, h = () => /* @__PURE__ */ b(vh, { features: ko.None, children: /* @__PURE__ */ j("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ b(
        gh,
        {
          className: "w-full",
          neutralType: _h.danger,
          disabled: !s,
          onClick: d,
          children: M.t("global.clear")
        }
      ),
      /* @__PURE__ */ b(bo, { className: "w-full", onClick: u, children: M.t("global.apply") })
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ b(
        _o,
        {
          color: o,
          onChange: c,
          additionalPopoverChildren: h,
          disabled: a,
          showAlpha: i,
          children: () => /* @__PURE__ */ b(
            ne,
            {
              disabled: t || a,
              label: M.t("font_color"),
              ...re,
              children: /* @__PURE__ */ j(
                "div",
                {
                  className: K(
                    Nn,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ b(Hd, { className: he(a) }),
                    s && /* @__PURE__ */ b(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: o }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        _o,
        {
          focusTrapFeatures: ko.FocusLock,
          color: o,
          onChange: c,
          additionalPopoverChildren: h,
          disabled: a,
          showAlpha: i,
          children: () => /* @__PURE__ */ j(
            "div",
            {
              className: K(
                Nn,
                "gap-1.5",
                "relative",
                "flex gap-1",
                Z$(a)
              ),
              children: [
                /* @__PURE__ */ b(Hd, { className: he(a) }),
                M.t("font_color"),
                s && /* @__PURE__ */ b(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: o }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [o, n, s, a, t, i]);
};
function oP(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "11",
      height: "14",
      viewBox: "0 0 11 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M1 7H6.33333C7.80609 7 9 5.80609 9 4.33333C9 2.86057 7.80609 1.66666 6.33333 1.66666H1V7ZM1 7H7C8.47276 7 9.66667 8.1939 9.66667 9.66666C9.66667 11.1394 8.47276 12.3333 7 12.3333H1V7Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function sP(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "12",
      height: "14",
      viewBox: "0 0 12 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M10.6667 1.66666H4.66671M7.33337 12.3333H1.33337M8.00004 1.66666L4.00004 12.3333",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function aP(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M3 9.66666C3 11.1394 4.19391 12.3333 5.66667 12.3333H8.33333C9.80609 12.3333 11 11.1394 11 9.66666C11 8.1939 9.80609 7 8.33333 7M11 4.33333C11 2.86057 9.80609 1.66666 8.33333 1.66666H5.66667C4.19391 1.66666 3 2.86057 3 4.33333M1 7H13",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function lP(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M11 1.66666V6.33333C11 8.54247 9.2091 10.3333 6.99996 10.3333C4.79082 10.3333 2.99996 8.54247 2.99996 6.33333V1.66666M1.66663 13H12.3333",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const cP = ({
  formatType: n,
  editor: e
}) => {
  if (e)
    switch (n) {
      case He.Bold:
        e.chain().focus().toggleBold().run();
        break;
      case He.Italic:
        e.chain().focus().toggleItalic().run();
        break;
      case He.Underline:
        e.chain().focus().toggleUnderline().run();
        break;
      case He.Strike:
        e.chain().focus().toggleStrike().run();
        break;
    }
}, uP = ({ formatType: n }) => {
  switch (n) {
    case He.Bold:
      return oP;
    case He.Italic:
      return sP;
    case He.Underline:
      return lP;
    case He.Strike:
      return aP;
  }
}, no = (n, e, t) => {
  const i = !(n != null && n.options.editable) || Ct(n), r = n == null ? void 0 : n.isActive(e);
  return we(() => {
    const s = () => cP({ formatType: e, editor: n }), a = uP({ formatType: e });
    return {
      toolbarRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: i,
          label: `${M.t(`${e}`)} (${En(On[e].toggle)})`,
          ...re,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: i,
              onClick: s,
              className: K(
                r && "bg-brand-primary/10 main-transition-colors"
              ),
              children: /* @__PURE__ */ b(a, { className: he(i) })
            }
          )
        },
        e
      ),
      tooltipRender: /* @__PURE__ */ b(
        ne,
        {
          disabled: i,
          label: En(On[e].toggle),
          ...re,
          children: /* @__PURE__ */ j(
            ae,
            {
              disabled: i,
              onClick: s,
              className: K(
                r && "bg-brand-primary/10 main-transition-colors",
                "flex gap-1"
              ),
              children: [
                /* @__PURE__ */ b(a, { className: he(i) }),
                M.t(`${e}`)
              ]
            }
          )
        },
        e
      )
    };
  }, [n, e, r, i, t]);
}, dP = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, hP = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, fP = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, pP = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, mP = Vt.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      vr({
        find: dP,
        type: this.type
      }),
      vr({
        find: fP,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ni({
        find: hP,
        type: this.type
      }),
      Ni({
        find: pP,
        type: this.type
      })
    ];
  }
}), gP = "listItem", Vd = "textStyle", Ud = /^\s*([-+*])\s$/, _P = xt.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(gP, this.editor.getAttributes(Vd)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Lo({
      find: Ud,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Lo({
      find: Ud,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Vd),
      editor: this.editor
    })), [
      n
    ];
  }
}), bP = Ce.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (n) => n.length,
      wordCounter: (n) => n.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc;
      if (((n == null ? void 0 : n.mode) || this.options.mode) === "textSize") {
        const i = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(i);
      }
      return e.nodeSize;
    }, this.storage.words = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc, t = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let n = !1;
    return [
      new $e({
        key: new Ve("characterCount"),
        appendTransaction: (e, t, i) => {
          if (n)
            return;
          const r = this.options.limit;
          if (r == null || r === 0) {
            n = !0;
            return;
          }
          const o = this.storage.characters({ node: i.doc });
          if (o > r) {
            const s = o - r, a = 0, l = s;
            console.warn(`[CharacterCount] Initial content exceeded limit of ${r} characters. Content was automatically trimmed.`);
            const c = i.tr.deleteRange(a, l);
            return n = !0, c;
          }
          n = !0;
        },
        filterTransaction: (e, t) => {
          const i = this.options.limit;
          if (!e.docChanged || i === 0 || i === null || i === void 0)
            return !0;
          const r = this.storage.characters({ node: t.doc }), o = this.storage.characters({ node: e.doc });
          if (o <= i || r > i && o > i && o <= r)
            return !0;
          if (r > i && o > i && o > r || !e.getMeta("paste"))
            return !1;
          const a = e.selection.$head.pos, l = o - i, c = a - l, u = a;
          return e.deleteRange(c, u), !(this.storage.characters({ node: e.doc }) > i);
        }
      })
    ];
  }
}), kP = xt.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function yP(n = {}) {
  return new $e({
    view(e) {
      return new vP(e, n);
    }
  });
}
class vP {
  constructor(e, t) {
    var i;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (i = t.width) !== null && i !== void 0 ? i : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((r) => {
      let o = (s) => {
        this[r](s);
      };
      return e.dom.addEventListener(r, o), { name: r, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, i, r = this.editorView.dom, o = r.getBoundingClientRect(), s = o.width / r.offsetWidth, a = o.height / r.offsetHeight;
    if (t) {
      let d = e.nodeBefore, h = e.nodeAfter;
      if (d || h) {
        let f = this.editorView.nodeDOM(this.cursorPos - (d ? d.nodeSize : 0));
        if (f) {
          let p = f.getBoundingClientRect(), m = d ? p.bottom : p.top;
          d && h && (m = (m + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let g = this.width / 2 * a;
          i = { left: p.left, right: p.right, top: m - g, bottom: m + g };
        }
      }
    }
    if (!i) {
      let d = this.editorView.coordsAtPos(this.cursorPos), h = this.width / 2 * s;
      i = { left: d.left - h, right: d.left + h, top: d.top, bottom: d.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let c, u;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      c = -pageXOffset, u = -pageYOffset;
    else {
      let d = l.getBoundingClientRect(), h = d.width / l.offsetWidth, f = d.height / l.offsetHeight;
      c = d.left - l.scrollLeft * h, u = d.top - l.scrollTop * f;
    }
    this.element.style.left = (i.left - c) / s + "px", this.element.style.top = (i.top - u) / a + "px", this.element.style.width = (i.right - i.left) / s + "px", this.element.style.height = (i.bottom - i.top) / a + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), i = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), r = i && i.type.spec.disableDropCursor, o = typeof r == "function" ? r(this.editorView, t, e) : r;
    if (t && !o) {
      let s = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = Zh(this.editorView.state.doc, s, this.editorView.dragging.slice);
        a != null && (s = a);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const xP = Ce.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      yP(this.options)
    ];
  }
}), Wd = xt.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", ke(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: i }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: r, storedMarks: o } = t;
          if (r.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: a } = i.extensionManager, l = o || r.$to.parentOffset && r.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && s) {
              const d = l.filter((h) => a.includes(h.type.name));
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), SP = xt.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => G6({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var _s = 200, Re = function() {
};
Re.prototype.append = function(e) {
  return e.length ? (e = Re.from(e), !this.length && e || e.length < _s && this.leafAppend(e) || this.length < _s && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Re.prototype.prepend = function(e) {
  return e.length ? Re.from(e).append(this) : this;
};
Re.prototype.appendInner = function(e) {
  return new wP(this, e);
};
Re.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Re.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Re.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Re.prototype.forEach = function(e, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length), t <= i ? this.forEachInner(e, t, i, 0) : this.forEachInvertedInner(e, t, i, 0);
};
Re.prototype.map = function(e, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length);
  var r = [];
  return this.forEach(function(o, s) {
    return r.push(e(o, s));
  }, t, i), r;
};
Re.from = function(e) {
  return e instanceof Re ? e : e && e.length ? new kz(e) : Re.empty;
};
var kz = /* @__PURE__ */ (function(n) {
  function e(i) {
    n.call(this), this.values = i;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(r, o) {
    return r == 0 && o == this.length ? this : new e(this.values.slice(r, o));
  }, e.prototype.getInner = function(r) {
    return this.values[r];
  }, e.prototype.forEachInner = function(r, o, s, a) {
    for (var l = o; l < s; l++)
      if (r(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(r, o, s, a) {
    for (var l = o - 1; l >= s; l--)
      if (r(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(r) {
    if (this.length + r.length <= _s)
      return new e(this.values.concat(r.flatten()));
  }, e.prototype.leafPrepend = function(r) {
    if (this.length + r.length <= _s)
      return new e(r.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
})(Re);
Re.empty = new kz([]);
var wP = /* @__PURE__ */ (function(n) {
  function e(t, i) {
    n.call(this), this.left = t, this.right = i, this.length = t.length + i.length, this.depth = Math.max(t.depth, i.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
  }, e.prototype.forEachInner = function(i, r, o, s) {
    var a = this.left.length;
    if (r < a && this.left.forEachInner(i, r, Math.min(o, a), s) === !1 || o > a && this.right.forEachInner(i, Math.max(r - a, 0), Math.min(this.length, o) - a, s + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(i, r, o, s) {
    var a = this.left.length;
    if (r > a && this.right.forEachInvertedInner(i, r - a, Math.max(o, a) - a, s + a) === !1 || o < a && this.left.forEachInvertedInner(i, Math.min(r, a), o, s) === !1)
      return !1;
  }, e.prototype.sliceInner = function(i, r) {
    if (i == 0 && r == this.length)
      return this;
    var o = this.left.length;
    return r <= o ? this.left.slice(i, r) : i >= o ? this.right.slice(i - o, r - o) : this.left.slice(i, o).append(this.right.slice(0, r - o));
  }, e.prototype.leafAppend = function(i) {
    var r = this.right.leafAppend(i);
    if (r)
      return new e(this.left, r);
  }, e.prototype.leafPrepend = function(i) {
    var r = this.left.leafPrepend(i);
    if (r)
      return new e(r, this.right);
  }, e.prototype.appendInner = function(i) {
    return this.left.depth >= Math.max(this.right.depth, i.depth) + 1 ? new e(this.left, new e(this.right, i)) : new e(this, i);
  }, e;
})(Re);
const CP = 500;
class Mt {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let i = this.items.length;
    for (; ; i--)
      if (this.items.get(i - 1).selection) {
        --i;
        break;
      }
    let r, o;
    t && (r = this.remapping(i, this.items.length), o = r.maps.length);
    let s = e.tr, a, l, c = [], u = [];
    return this.items.forEach((d, h) => {
      if (!d.step) {
        r || (r = this.remapping(i, h + 1), o = r.maps.length), o--, u.push(d);
        return;
      }
      if (r) {
        u.push(new Dt(d.map));
        let f = d.step.map(r.slice(o)), p;
        f && s.maybeStep(f).doc && (p = s.mapping.maps[s.mapping.maps.length - 1], c.push(new Dt(p, void 0, void 0, c.length + u.length))), o--, p && r.appendMap(p, o);
      } else
        s.maybeStep(d.step);
      if (d.selection)
        return a = r ? d.selection.map(r.slice(o)) : d.selection, l = new Mt(this.items.slice(0, i).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: s, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, i, r) {
    let o = [], s = this.eventCount, a = this.items, l = !r && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), h = new Dt(e.mapping.maps[u], d, t), f;
      (f = l && l.merge(h)) && (h = f, u ? o.pop() : a = a.slice(0, a.length - 1)), o.push(h), t && (s++, t = void 0), r || (l = h);
    }
    let c = s - i.depth;
    return c > OP && (a = TP(a, c), s -= c), new Mt(a.append(o), s);
  }
  remapping(e, t) {
    let i = new pr();
    return this.items.forEach((r, o) => {
      let s = r.mirrorOffset != null && o - r.mirrorOffset >= e ? i.maps.length - r.mirrorOffset : void 0;
      i.appendMap(r.map, s);
    }, e, t), i;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Mt(this.items.append(e.map((t) => new Dt(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let i = [], r = Math.max(0, this.items.length - t), o = e.mapping, s = e.steps.length, a = this.eventCount;
    this.items.forEach((h) => {
      h.selection && a--;
    }, r);
    let l = t;
    this.items.forEach((h) => {
      let f = o.getMirror(--l);
      if (f == null)
        return;
      s = Math.min(s, f);
      let p = o.maps[f];
      if (h.step) {
        let m = e.steps[f].invert(e.docs[f]), g = h.selection && h.selection.map(o.slice(l + 1, f));
        g && a++, i.push(new Dt(p, m, g));
      } else
        i.push(new Dt(p));
    }, r);
    let c = [];
    for (let h = t; h < s; h++)
      c.push(new Dt(o.maps[h]));
    let u = this.items.slice(0, r).append(c).append(i), d = new Mt(u, a);
    return d.emptyItemCount() > CP && (d = d.compress(this.items.length - i.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), i = t.maps.length, r = [], o = 0;
    return this.items.forEach((s, a) => {
      if (a >= e)
        r.push(s), s.selection && o++;
      else if (s.step) {
        let l = s.step.map(t.slice(i)), c = l && l.getMap();
        if (i--, c && t.appendMap(c, i), l) {
          let u = s.selection && s.selection.map(t.slice(i));
          u && o++;
          let d = new Dt(c.invert(), l, u), h, f = r.length - 1;
          (h = r.length && r[f].merge(d)) ? r[f] = h : r.push(d);
        }
      } else s.map && i--;
    }, this.items.length, 0), new Mt(Re.from(r.reverse()), o);
  }
}
Mt.empty = new Mt(Re.empty, 0);
function TP(n, e) {
  let t;
  return n.forEach((i, r) => {
    if (i.selection && e-- == 0)
      return t = r, !1;
  }), n.slice(t);
}
class Dt {
  constructor(e, t, i, r) {
    this.map = e, this.step = t, this.selection = i, this.mirrorOffset = r;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new Dt(t.getMap().invert(), t, this.selection);
    }
  }
}
class vn {
  constructor(e, t, i, r, o) {
    this.done = e, this.undone = t, this.prevRanges = i, this.prevTime = r, this.prevComposition = o;
  }
}
const OP = 20;
function EP(n, e, t, i) {
  let r = t.getMeta(oi), o;
  if (r)
    return r.historyState;
  t.getMeta(zP) && (n = new vn(n.done, n.undone, null, 0, -1));
  let s = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (s && s.getMeta(oi))
    return s.getMeta(oi).redo ? new vn(n.done.addTransform(t, void 0, i, mo(e)), n.undone, Kd(t.mapping.maps), n.prevTime, n.prevComposition) : new vn(n.done, n.undone.addTransform(t, void 0, i, mo(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), l = n.prevTime == 0 || !s && n.prevComposition != a && (n.prevTime < (t.time || 0) - i.newGroupDelay || !MP(t, n.prevRanges)), c = s ? $a(n.prevRanges, t.mapping) : Kd(t.mapping.maps);
    return new vn(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, i, mo(e)), Mt.empty, c, t.time, a ?? n.prevComposition);
  } else return (o = t.getMeta("rebased")) ? new vn(n.done.rebased(t, o), n.undone.rebased(t, o), $a(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new vn(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), $a(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function MP(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((i, r) => {
    for (let o = 0; o < e.length; o += 2)
      i <= e[o + 1] && r >= e[o] && (t = !0);
  }), t;
}
function Kd(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((i, r, o, s) => e.push(o, s));
  return e;
}
function $a(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let i = 0; i < n.length; i += 2) {
    let r = e.map(n[i], 1), o = e.map(n[i + 1], -1);
    r <= o && t.push(r, o);
  }
  return t;
}
function $P(n, e, t) {
  let i = mo(e), r = oi.get(e).spec.config, o = (t ? n.undone : n.done).popEvent(e, i);
  if (!o)
    return null;
  let s = o.selection.resolve(o.transform.doc), a = (t ? n.done : n.undone).addTransform(o.transform, e.selection.getBookmark(), r, i), l = new vn(t ? a : o.remaining, t ? o.remaining : a, null, 0, -1);
  return o.transform.setSelection(s).setMeta(oi, { redo: t, historyState: l });
}
let za = !1, Zd = null;
function mo(n) {
  let e = n.plugins;
  if (Zd != e) {
    za = !1, Zd = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        za = !0;
        break;
      }
  }
  return za;
}
const oi = new Ve("history"), zP = new Ve("closeHistory");
function AP(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new $e({
    key: oi,
    state: {
      init() {
        return new vn(Mt.empty, Mt.empty, null, 0, -1);
      },
      apply(e, t, i) {
        return EP(t, i, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let i = t.inputType, r = i == "historyUndo" ? vz : i == "historyRedo" ? xz : null;
          return r ? (t.preventDefault(), r(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function yz(n, e) {
  return (t, i) => {
    let r = oi.getState(t);
    if (!r || (n ? r.undone : r.done).eventCount == 0)
      return !1;
    if (i) {
      let o = $P(r, t, n);
      o && i(e ? o.scrollIntoView() : o);
    }
    return !0;
  };
}
const vz = yz(!1, !0), xz = yz(!0, !0), LP = Ce.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => vz(n, e),
      redo: () => ({ state: n, dispatch: e }) => xz(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      AP(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), NP = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, DP = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, RP = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, IP = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, PP = Vt.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      vr({
        find: NP,
        type: this.type
      }),
      vr({
        find: RP,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ni({
        find: DP,
        type: this.type
      }),
      Ni({
        find: IP,
        type: this.type
      })
    ];
  }
}), jP = "listItem", Gd = "textStyle", Jd = /^(\d+)\.\s$/, BP = xt.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", ke(this.options.HTMLAttributes, t), 0] : ["ol", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(jP, this.editor.getAttributes(Gd)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Lo({
      find: Jd,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Lo({
      find: Jd,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(Gd) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), FP = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, qP = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, HP = Vt.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      vr({
        find: FP,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ni({
        find: qP,
        type: this.type
      })
    ];
  }
}), VP = xt.create({
  name: "text",
  group: "inline"
}), UP = Ce.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (n) => {
              const e = n.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (n) => n.textAlign ? { style: `text-align: ${n.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (n) => ({ commands: e }) => this.options.alignments.includes(n) ? this.options.types.map((t) => e.updateAttributes(t, { textAlign: n })).every((t) => t) : !1,
      unsetTextAlign: () => ({ commands: n }) => this.options.types.map((e) => n.resetAttributes(e, "textAlign")).every((e) => e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), WP = Vt.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), KP = (n) => {
  if (!n.children.length)
    return;
  const e = n.querySelectorAll("span");
  e && e.forEach((t) => {
    var i, r;
    const o = t.getAttribute("style"), s = (r = (i = t.parentElement) === null || i === void 0 ? void 0 : i.closest("span")) === null || r === void 0 ? void 0 : r.getAttribute("style");
    t.setAttribute("style", `${s};${o}`);
  });
}, ZP = Vt.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !1
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && KP(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, i) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((r) => r.type === this.type).some((r) => Object.values(r.attrs).some((o) => !!o)) || n.removeMark(i, i + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), Fs = (n, e, t, i) => {
  const { selection: r } = e, { from: o, to: s } = r, a = [];
  return e.doc.nodesBetween(o, s, (l, c) => {
    l.isText && l.marks.forEach((u) => {
      u.type.name === "textStyle" && u.attrs[n] && a.push({ mark: u, pos: c, size: l.nodeSize });
    });
  }), a.forEach(({ mark: l, pos: c, size: u }) => {
    const d = { ...l.attrs, [n]: null }, h = Math.max(o, c), f = Math.min(s, c + u);
    if (t.removeMark(h, f, l.type), Object.entries(d).some(
      ([m, g]) => m !== n && g !== null && g !== void 0
    )) {
      const m = e.schema.marks.textStyle.create(d);
      t.addMark(h, f, m);
    }
  }), i && i(t), !0;
}, GP = Ce.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (n) => {
              var e;
              return (e = n.style.fontFamily) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.fontFamily ? {
              style: `font-family: ${n.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (n) => ({ chain: e }) => e().setMark("textStyle", { fontFamily: n }).run(),
      unsetFontFamily: () => ({ tr: n, state: e, dispatch: t }) => Fs("fontFamily", e, n, t)
    };
  }
}), JP = new Ve("defaultFontSize"), YP = Ce.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"],
      defaultFontSize: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (n) => n.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (n) => n.fontSize ? {
              style: `font-size: ${n.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (n) => ({ chain: e }) => e().setMark("textStyle", { fontSize: n }).run(),
      unsetFontSize: () => ({ tr: n, state: e, dispatch: t }) => Fs("fontSize", e, n, t)
    };
  },
  addProseMirrorPlugins() {
    const n = this.options.defaultFontSize;
    return n ? [
      new $e({
        key: JP,
        appendTransaction: (e, t, i) => {
          if (!e.some((a) => a.docChanged))
            return null;
          const o = i.tr;
          let s = !1;
          return i.doc.descendants((a, l) => {
            if (!a.isText)
              return;
            const u = i.doc.resolve(l).parent, d = u.type.name === "paragraph", h = u.type.name === "listItem", f = u.type.name === "heading";
            if (!d && !h || f)
              return;
            const p = a.marks.find((g) => g.type.name === "textStyle");
            if (!(p == null ? void 0 : p.attrs.fontSize)) {
              const g = l, k = l + a.nodeSize, v = i.schema.marks.textStyle.create({
                ...p == null ? void 0 : p.attrs,
                fontSize: n
              });
              o.addMark(g, k, v), s = !0;
            }
          }), s ? o : null;
        }
      })
    ] : [];
  }
}), XP = xt.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", ke(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), QP = new Ve("listItemStyle"), ej = ({ node: n }) => {
  const e = {};
  return n.attrs.fontSize && (e.fontSize = n.attrs.fontSize), n.attrs.fontFamily && (e.fontFamily = n.attrs.fontFamily), n.attrs.color && (e.color = n.attrs.color), n.attrs.textAlign && (e.textAlign = n.attrs.textAlign), /* @__PURE__ */ b(lc, { as: "li", style: e, children: /* @__PURE__ */ b(Rs, {}) });
}, tj = XP.extend({
  content: "block*",
  addAttributes() {
    var n;
    return {
      ...(n = this.parent) == null ? void 0 : n.call(this),
      fontSize: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      },
      fontFamily: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      },
      color: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      }
    };
  },
  addNodeView() {
    return ji(ej);
  },
  addProseMirrorPlugins() {
    return [
      new $e({
        key: QP,
        appendTransaction: (n, e, t) => {
          if (!n.some((l) => l.docChanged))
            return null;
          const r = t.tr;
          let o = !1;
          const s = (l) => l == null ? void 0 : l.find((c) => c.type.name === "textStyle"), a = (l) => {
            const c = l.firstChild;
            if (!c)
              return null;
            if (c.isText)
              return s(c.marks);
            const u = c.firstChild;
            return u != null && u.isText ? s(u.marks) : null;
          };
          return t.doc.descendants((l, c) => {
            if (l.type.name === "listItem") {
              let u = null, d = null, h = null;
              const f = a(l), p = t.selection, g = p.anchor >= c && p.anchor < c + l.nodeSize || p.head >= c && p.head < c + l.nodeSize ? s(t.storedMarks) : null, k = f || g;
              k && (u = k.attrs.fontSize, d = k.attrs.fontFamily, h = k.attrs.color), (l.attrs.fontSize !== u || l.attrs.fontFamily !== d || l.attrs.color !== h) && (r.setNodeMarkup(c, void 0, {
                ...l.attrs,
                fontSize: u,
                fontFamily: d,
                color: h
              }), o = !0);
            }
          }), o ? r : null;
        }
      })
    ];
  },
  renderHTML({ HTMLAttributes: n, node: e }) {
    const t = {};
    return e.attrs.fontSize && (t.fontSize = e.attrs.fontSize), e.attrs.fontFamily && (t.fontFamily = e.attrs.fontFamily), e.attrs.color && (t.color = e.attrs.color), e.attrs.textAlign && (t.textAlign = e.attrs.textAlign), [
      "li",
      ke(n, {
        ...Object.keys(t).length > 0 ? { style: zt(t) } : {}
      }),
      0
    ];
  }
}), Sz = ({
  editor: n,
  getPos: e,
  nodeName: t
}) => {
  const [i, r] = xe(0);
  return Ge(() => {
    const s = (() => {
      let a = 0;
      const l = n.state.doc.resolve(e());
      for (let c = l.depth; c >= 0; c--) {
        const u = l.node(c);
        t ? (u == null ? void 0 : u.type.name) === t && a++ : a++;
      }
      return a;
    })();
    i !== s && r(s);
  }, [n.state.doc, e, t, i]), { realDepth: i };
}, nj = ({ getPos: n, editor: e, updateAttributes: t }) => {
  const { realDepth: i } = Sz({ editor: e, getPos: n, nodeName: "bulletList" });
  return Ge(() => {
    setTimeout(() => {
      t({ depth: i });
    });
  }, [i, t]), /* @__PURE__ */ b(
    lc,
    {
      as: "ul",
      style: {
        ...Bo,
        listStyleType: fz(i)
      },
      children: /* @__PURE__ */ b(Rs, {})
    }
  );
}, ij = ({ getPos: n, editor: e, updateAttributes: t }) => {
  const { realDepth: i } = Sz({ editor: e, getPos: n, nodeName: "orderedList" });
  return Ge(() => {
    setTimeout(() => {
      t({ depth: i });
    });
  }, [i, t]), /* @__PURE__ */ b(
    lc,
    {
      as: "ol",
      style: {
        ...Bo,
        listStyleType: pz(i)
      },
      children: /* @__PURE__ */ b(Rs, {})
    }
  );
}, rj = Ce.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (n) => n.style.backgroundColor,
            renderHTML: (n) => n.backgroundColor ? {
              style: `background-color: ${n.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (n) => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: n }).run(),
      unsetBackgroundColor: () => ({ tr: n, state: e, dispatch: t }) => Fs("backgroundColor", e, n, t)
    };
  }
}), oj = Ce.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (n) => {
              var e;
              return (e = n.style.color) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.color ? {
              style: `color: ${n.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (n) => ({ chain: e }) => e().setMark("textStyle", { color: n }).run(),
      unsetColor: () => ({ tr: n, state: e, dispatch: t }) => Fs("color", e, n, t)
    };
  }
});
var sj = /* @__PURE__ */ (function() {
  var n = function(e, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, r) {
      i.__proto__ = r;
    } || function(i, r) {
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (i[o] = r[o]);
    }, n(e, t);
  };
  return function(e, t) {
    n(e, t);
    function i() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
  };
})(), Oe = function() {
  return Oe = Object.assign || function(n) {
    for (var e, t = 1, i = arguments.length; t < i; t++) {
      e = arguments[t];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, Oe.apply(this, arguments);
}, Yd = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, Xd = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, io = {
  width: "20px",
  height: "20px",
  position: "absolute"
}, aj = {
  top: Oe(Oe({}, Yd), { top: "-5px" }),
  right: Oe(Oe({}, Xd), { left: void 0, right: "-5px" }),
  bottom: Oe(Oe({}, Yd), { top: void 0, bottom: "-5px" }),
  left: Oe(Oe({}, Xd), { left: "-5px" }),
  topRight: Oe(Oe({}, io), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: Oe(Oe({}, io), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: Oe(Oe({}, io), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: Oe(Oe({}, io), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, lj = (
  /** @class */
  (function(n) {
    sj(e, n);
    function e() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.onMouseDown = function(i) {
        t.props.onResizeStart(i, t.props.direction);
      }, t.onTouchStart = function(i) {
        t.props.onResizeStart(i, t.props.direction);
      }, t;
    }
    return e.prototype.render = function() {
      return Kn.createElement("div", { className: this.props.className || "", style: Oe(Oe({ position: "absolute", userSelect: "none" }, aj[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, e;
  })(Kn.PureComponent)
), cj = /* @__PURE__ */ (function() {
  var n = function(e, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, r) {
      i.__proto__ = r;
    } || function(i, r) {
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (i[o] = r[o]);
    }, n(e, t);
  };
  return function(e, t) {
    n(e, t);
    function i() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
  };
})(), Rt = function() {
  return Rt = Object.assign || function(n) {
    for (var e, t = 1, i = arguments.length; t < i; t++) {
      e = arguments[t];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, Rt.apply(this, arguments);
}, uj = {
  width: "auto",
  height: "auto"
}, ro = function(n, e, t) {
  return Math.max(Math.min(n, t), e);
}, Qd = function(n, e, t) {
  var i = Math.round(n / e);
  return i * e + t * (i - 1);
}, yi = function(n, e) {
  return new RegExp(n, "i").test(e);
}, oo = function(n) {
  return !!(n.touches && n.touches.length);
}, dj = function(n) {
  return !!((n.clientX || n.clientX === 0) && (n.clientY || n.clientY === 0));
}, eh = function(n, e, t) {
  t === void 0 && (t = 0);
  var i = e.reduce(function(o, s, a) {
    return Math.abs(s - n) < Math.abs(e[o] - n) ? a : o;
  }, 0), r = Math.abs(e[i] - n);
  return t === 0 || r < t ? e[i] : n;
}, Aa = function(n) {
  return n = n.toString(), n === "auto" || n.endsWith("px") || n.endsWith("%") || n.endsWith("vh") || n.endsWith("vw") || n.endsWith("vmax") || n.endsWith("vmin") ? n : n + "px";
}, so = function(n, e, t, i) {
  if (n && typeof n == "string") {
    if (n.endsWith("px"))
      return Number(n.replace("px", ""));
    if (n.endsWith("%")) {
      var r = Number(n.replace("%", "")) / 100;
      return e * r;
    }
    if (n.endsWith("vw")) {
      var r = Number(n.replace("vw", "")) / 100;
      return t * r;
    }
    if (n.endsWith("vh")) {
      var r = Number(n.replace("vh", "")) / 100;
      return i * r;
    }
  }
  return n;
}, hj = function(n, e, t, i, r, o, s) {
  return i = so(i, n.width, e, t), r = so(r, n.height, e, t), o = so(o, n.width, e, t), s = so(s, n.height, e, t), {
    maxWidth: typeof i > "u" ? void 0 : Number(i),
    maxHeight: typeof r > "u" ? void 0 : Number(r),
    minWidth: typeof o > "u" ? void 0 : Number(o),
    minHeight: typeof s > "u" ? void 0 : Number(s)
  };
}, fj = function(n) {
  return Array.isArray(n) ? n : [n, n];
}, pj = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], th = "__resizable_base__", mj = (
  /** @class */
  (function(n) {
    cj(e, n);
    function e(t) {
      var i, r, o, s, a = n.call(this, t) || this;
      return a.ratio = 1, a.resizable = null, a.parentLeft = 0, a.parentTop = 0, a.resizableLeft = 0, a.resizableRight = 0, a.resizableTop = 0, a.resizableBottom = 0, a.targetLeft = 0, a.targetTop = 0, a.appendBase = function() {
        if (!a.resizable || !a.window)
          return null;
        var l = a.parentNode;
        if (!l)
          return null;
        var c = a.window.document.createElement("div");
        return c.style.width = "100%", c.style.height = "100%", c.style.position = "absolute", c.style.transform = "scale(0, 0)", c.style.left = "0", c.style.flex = "0 0 100%", c.classList ? c.classList.add(th) : c.className += th, l.appendChild(c), c;
      }, a.removeBase = function(l) {
        var c = a.parentNode;
        c && c.removeChild(l);
      }, a.state = {
        isResizing: !1,
        width: (r = (i = a.propsSize) === null || i === void 0 ? void 0 : i.width) !== null && r !== void 0 ? r : "auto",
        height: (s = (o = a.propsSize) === null || o === void 0 ? void 0 : o.height) !== null && s !== void 0 ? s : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, a.onResizeStart = a.onResizeStart.bind(a), a.onMouseMove = a.onMouseMove.bind(a), a.onMouseUp = a.onMouseUp.bind(a), a;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || uj;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "size", {
      get: function() {
        var t = 0, i = 0;
        if (this.resizable && this.window) {
          var r = this.resizable.offsetWidth, o = this.resizable.offsetHeight, s = this.resizable.style.position;
          s !== "relative" && (this.resizable.style.position = "relative"), t = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : r, i = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : o, this.resizable.style.position = s;
        }
        return { width: t, height: i };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sizeStyle", {
      get: function() {
        var t = this, i = this.props.size, r = function(a) {
          var l;
          if (typeof t.state[a] > "u" || t.state[a] === "auto")
            return "auto";
          if (t.propsSize && t.propsSize[a] && (!((l = t.propsSize[a]) === null || l === void 0) && l.toString().endsWith("%"))) {
            if (t.state[a].toString().endsWith("%"))
              return t.state[a].toString();
            var c = t.getParentSize(), u = Number(t.state[a].toString().replace("px", "")), d = u / c[a] * 100;
            return d + "%";
          }
          return Aa(t.state[a]);
        }, o = i && typeof i.width < "u" && !this.state.isResizing ? Aa(i.width) : r("width"), s = i && typeof i.height < "u" && !this.state.isResizing ? Aa(i.height) : r("height");
        return { width: o, height: s };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var t = this.appendBase();
      if (!t)
        return { width: 0, height: 0 };
      var i = !1, r = this.parentNode.style.flexWrap;
      r !== "wrap" && (i = !0, this.parentNode.style.flexWrap = "wrap"), t.style.position = "relative", t.style.minWidth = "100%", t.style.minHeight = "100%";
      var o = {
        width: t.offsetWidth,
        height: t.offsetHeight
      };
      return i && (this.parentNode.style.flexWrap = r), this.removeBase(t), o;
    }, e.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, e.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, e.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var t = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: t.flexBasis !== "auto" ? t.flexBasis : void 0
        });
      }
    }, e.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, e.prototype.createSizeForCssProperty = function(t, i) {
      var r = this.propsSize && this.propsSize[i];
      return this.state[i] === "auto" && this.state.original[i] === t && (typeof r > "u" || r === "auto") ? "auto" : t;
    }, e.prototype.calculateNewMaxFromBoundary = function(t, i) {
      var r = this.props.boundsByDirection, o = this.state.direction, s = r && yi("left", o), a = r && yi("top", o), l, c;
      if (this.props.bounds === "parent") {
        var u = this.parentNode;
        u && (l = s ? this.resizableRight - this.parentLeft : u.offsetWidth + (this.parentLeft - this.resizableLeft), c = a ? this.resizableBottom - this.parentTop : u.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (l = s ? this.resizableRight : this.window.innerWidth - this.resizableLeft, c = a ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (l = s ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), c = a ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return l && Number.isFinite(l) && (t = t && t < l ? t : l), c && Number.isFinite(c) && (i = i && i < c ? i : c), { maxWidth: t, maxHeight: i };
    }, e.prototype.calculateNewSizeFromDirection = function(t, i) {
      var r = this.props.scale || 1, o = fj(this.props.resizeRatio || 1), s = o[0], a = o[1], l = this.state, c = l.direction, u = l.original, d = this.props, h = d.lockAspectRatio, f = d.lockAspectRatioExtraHeight, p = d.lockAspectRatioExtraWidth, m = u.width, g = u.height, k = f || 0, v = p || 0;
      return yi("right", c) && (m = u.width + (t - u.x) * s / r, h && (g = (m - v) / this.ratio + k)), yi("left", c) && (m = u.width - (t - u.x) * s / r, h && (g = (m - v) / this.ratio + k)), yi("bottom", c) && (g = u.height + (i - u.y) * a / r, h && (m = (g - k) * this.ratio + v)), yi("top", c) && (g = u.height - (i - u.y) * a / r, h && (m = (g - k) * this.ratio + v)), { newWidth: m, newHeight: g };
    }, e.prototype.calculateNewSizeFromAspectRatio = function(t, i, r, o) {
      var s = this.props, a = s.lockAspectRatio, l = s.lockAspectRatioExtraHeight, c = s.lockAspectRatioExtraWidth, u = typeof o.width > "u" ? 10 : o.width, d = typeof r.width > "u" || r.width < 0 ? t : r.width, h = typeof o.height > "u" ? 10 : o.height, f = typeof r.height > "u" || r.height < 0 ? i : r.height, p = l || 0, m = c || 0;
      if (a) {
        var g = (h - p) * this.ratio + m, k = (f - p) * this.ratio + m, v = (u - m) / this.ratio + p, S = (d - m) / this.ratio + p, _ = Math.max(u, g), x = Math.min(d, k), y = Math.max(h, v), w = Math.min(f, S);
        t = ro(t, _, x), i = ro(i, y, w);
      } else
        t = ro(t, u, d), i = ro(i, h, f);
      return { newWidth: t, newHeight: i };
    }, e.prototype.setBoundingClientRect = function() {
      var t = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var i = this.parentNode;
        if (i) {
          var r = i.getBoundingClientRect();
          this.parentLeft = r.left * t, this.parentTop = r.top * t;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var o = this.props.bounds.getBoundingClientRect();
        this.targetLeft = o.left * t, this.targetTop = o.top * t;
      }
      if (this.resizable) {
        var s = this.resizable.getBoundingClientRect(), a = s.left, l = s.top, c = s.right, u = s.bottom;
        this.resizableLeft = a * t, this.resizableRight = c * t, this.resizableTop = l * t, this.resizableBottom = u * t;
      }
    }, e.prototype.onResizeStart = function(t, i) {
      if (!(!this.resizable || !this.window)) {
        var r = 0, o = 0;
        if (t.nativeEvent && dj(t.nativeEvent) ? (r = t.nativeEvent.clientX, o = t.nativeEvent.clientY) : t.nativeEvent && oo(t.nativeEvent) && (r = t.nativeEvent.touches[0].clientX, o = t.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var s = this.props.onResizeStart(t, i, this.resizable);
          if (s === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var a, l = this.window.getComputedStyle(this.resizable);
        if (l.flexBasis !== "auto") {
          var c = this.parentNode;
          if (c) {
            var u = this.window.getComputedStyle(c).flexDirection;
            this.flexDir = u.startsWith("row") ? "row" : "column", a = l.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var d = {
          original: {
            x: r,
            y: o,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: Rt(Rt({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(t.target).cursor || "auto" }),
          direction: i,
          flexBasis: a
        };
        this.setState(d);
      }
    }, e.prototype.onMouseMove = function(t) {
      var i = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && oo(t))
          try {
            t.preventDefault(), t.stopPropagation();
          } catch {
          }
        var r = this.props, o = r.maxWidth, s = r.maxHeight, a = r.minWidth, l = r.minHeight, c = oo(t) ? t.touches[0].clientX : t.clientX, u = oo(t) ? t.touches[0].clientY : t.clientY, d = this.state, h = d.direction, f = d.original, p = d.width, m = d.height, g = this.getParentSize(), k = hj(g, this.window.innerWidth, this.window.innerHeight, o, s, a, l);
        o = k.maxWidth, s = k.maxHeight, a = k.minWidth, l = k.minHeight;
        var v = this.calculateNewSizeFromDirection(c, u), S = v.newHeight, _ = v.newWidth, x = this.calculateNewMaxFromBoundary(o, s);
        this.props.snap && this.props.snap.x && (_ = eh(_, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (S = eh(S, this.props.snap.y, this.props.snapGap));
        var y = this.calculateNewSizeFromAspectRatio(_, S, { width: x.maxWidth, height: x.maxHeight }, { width: a, height: l });
        if (_ = y.newWidth, S = y.newHeight, this.props.grid) {
          var w = Qd(_, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), $ = Qd(S, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), A = this.props.snapGap || 0, z = A === 0 || Math.abs(w - _) <= A ? w : _, I = A === 0 || Math.abs($ - S) <= A ? $ : S;
          _ = z, S = I;
        }
        var L = {
          width: _ - f.width,
          height: S - f.height
        };
        if (p && typeof p == "string") {
          if (p.endsWith("%")) {
            var P = _ / g.width * 100;
            _ = P + "%";
          } else if (p.endsWith("vw")) {
            var q = _ / this.window.innerWidth * 100;
            _ = q + "vw";
          } else if (p.endsWith("vh")) {
            var W = _ / this.window.innerHeight * 100;
            _ = W + "vh";
          }
        }
        if (m && typeof m == "string") {
          if (m.endsWith("%")) {
            var P = S / g.height * 100;
            S = P + "%";
          } else if (m.endsWith("vw")) {
            var q = S / this.window.innerWidth * 100;
            S = q + "vw";
          } else if (m.endsWith("vh")) {
            var W = S / this.window.innerHeight * 100;
            S = W + "vh";
          }
        }
        var B = {
          width: this.createSizeForCssProperty(_, "width"),
          height: this.createSizeForCssProperty(S, "height")
        };
        this.flexDir === "row" ? B.flexBasis = B.width : this.flexDir === "column" && (B.flexBasis = B.height);
        var Z = this.state.width !== B.width, V = this.state.height !== B.height, pe = this.state.flexBasis !== B.flexBasis, me = Z || V || pe;
        me && ph(function() {
          i.setState(B);
        }), this.props.onResize && me && this.props.onResize(t, h, this.resizable, L);
      }
    }, e.prototype.onMouseUp = function(t) {
      var i, r, o = this.state, s = o.isResizing, a = o.direction, l = o.original;
      if (!(!s || !this.resizable)) {
        var c = {
          width: this.size.width - l.width,
          height: this.size.height - l.height
        };
        this.props.onResizeStop && this.props.onResizeStop(t, a, this.resizable, c), this.props.size && this.setState({ width: (i = this.props.size.width) !== null && i !== void 0 ? i : "auto", height: (r = this.props.size.height) !== null && r !== void 0 ? r : "auto" }), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: Rt(Rt({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, e.prototype.updateSize = function(t) {
      var i, r;
      this.setState({ width: (i = t.width) !== null && i !== void 0 ? i : "auto", height: (r = t.height) !== null && r !== void 0 ? r : "auto" });
    }, e.prototype.renderResizer = function() {
      var t = this, i = this.props, r = i.enable, o = i.handleStyles, s = i.handleClasses, a = i.handleWrapperStyle, l = i.handleWrapperClass, c = i.handleComponent;
      if (!r)
        return null;
      var u = Object.keys(r).map(function(d) {
        return r[d] !== !1 ? Kn.createElement(lj, { key: d, direction: d, onResizeStart: t.onResizeStart, replaceStyles: o && o[d], className: s && s[d] }, c && c[d] ? c[d] : null) : null;
      });
      return Kn.createElement("div", { className: l, style: a }, u);
    }, e.prototype.render = function() {
      var t = this, i = Object.keys(this.props).reduce(function(s, a) {
        return pj.indexOf(a) !== -1 || (s[a] = t.props[a]), s;
      }, {}), r = Rt(Rt(Rt({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (r.flexBasis = this.state.flexBasis);
      var o = this.props.as || "div";
      return Kn.createElement(
        o,
        Rt({ style: r, className: this.props.className }, i, {
          // `ref` is after `extendsProps` to ensure this one wins over a version
          // passed in
          ref: function(s) {
            s && (t.resizable = s);
          }
        }),
        this.state.isResizing && Kn.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    }, e.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, e;
  })(Kn.PureComponent)
);
function nh(n) {
  return /* @__PURE__ */ b("svg", { width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", ...n, children: /* @__PURE__ */ b("path", { d: "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z" }) });
}
const wz = ({ node: n, selected: e, editor: t, getPos: i, updateAttributes: r }) => {
  const {
    src: o,
    alt: s,
    title: a,
    caption: l,
    width: c,
    height: u,
    containerWidth: d,
    href: h,
    imageMode: f,
    uploadingProps: p,
    isMobileFullWidth: m
  } = n.attrs, [g, k] = xe(!1), [v, S] = xe(!1), [_, x] = xe(i() === 0), [y, w] = xe(t.view.hasFocus()), $ = y && e;
  Ge(() => {
    const G = () => {
      x(i() === 0);
    };
    return t.on("update", G), () => {
      t.off("update", G);
    };
  }, [t, i]), Ge(() => {
    const G = () => {
      w(t.view.hasFocus());
    };
    return t.on("focus", G), t.on("blur", G), () => {
      t.off("focus", G), t.off("blur", G);
    };
  }, [t]);
  const A = (t == null ? void 0 : t.options.editable) && !p, z = f === ce.Inline, I = f === ce.BlockCenter, L = f === ce.BlockRight, P = (G) => {
    if (G.preventDefault(), typeof i == "function") {
      const Q = i();
      t.commands.setNodeSelection(Q), t.commands.focus();
    }
  }, q = (G, Q, X) => {
    var be;
    const ze = X.style.width, Te = (be = X.parentElement) == null ? void 0 : be.offsetWidth;
    if (!Te) return;
    const Ae = X.querySelector("img");
    if (!Ae) return;
    let oe;
    if (ze.includes("%"))
      oe = ze;
    else if (ze.includes("px")) {
      const Pe = ze.split("px")[0];
      oe = Number(Pe) / Te * 100 + "%";
    } else
      oe = Number(Ae.naturalWidth) / Te * 100 + "%";
    r({
      containerWidth: oe
    });
  }, W = (G) => {
    if (!t) return;
    const Q = i();
    if (Q === null) return;
    let X = 0;
    switch (G) {
      case Zi.Before:
        X = Q > 0 ? Q - 1 : 0;
        break;
      case Zi.After:
        X = Q + n.nodeSize;
    }
    t.chain().insertContentAt(X, {
      type: "paragraph"
    }).focus().run();
  }, { onDragStart: B } = ac(), Z = (G) => {
    const Q = K(
      $ || g ? "bg-brand-primary" : v ? "bg-yellow" : "bg-transparent",
      "main-transition-colors"
    ), X = 2;
    return /* @__PURE__ */ j(
      mj,
      {
        "data-node-view-wrapper": "",
        onDragStart: B,
        style: {
          ...I && G$,
          ...L && J$(_)
        },
        as: z ? "span" : "figure",
        size: { width: d, height: "100%" },
        handleClasses: {
          top: Q,
          bottom: Q,
          left: Q,
          right: Q
        },
        handleStyles: {
          top: {
            height: X,
            top: -X,
            width: `calc(100% + ${X}px)`,
            left: -X
          },
          bottom: {
            height: X,
            bottom: -X,
            width: `calc(100% + ${X}px)`,
            right: -X
          },
          left: {
            width: X,
            left: -X,
            height: `calc(100% + ${X}px)`,
            bottom: -X
          },
          right: {
            width: X,
            right: -X,
            height: `calc(100% + ${X}px)`,
            top: -X
          }
        },
        enable: A ? void 0 : !1,
        onResize: q,
        minWidth: 50,
        minHeight: 50,
        maxWidth: "100%",
        lockAspectRatio: !0,
        onResizeStart: () => {
          k(!0), r({
            showBubbleMenu: !1
          });
        },
        onResizeStop: () => {
          k(!1);
        },
        className: K(
          z ? "inline-flex" : "flex",
          "flex-col",
          h ? "cursor-pointer" : "cursor-default",
          L && "justify-end",
          I && "justify-center"
        ),
        children: [
          G,
          l && /* @__PURE__ */ b("figcaption", { style: Y$, children: l })
        ]
      }
    );
  }, V = (G) => /* @__PURE__ */ b(
    "img",
    {
      src: o,
      alt: s ?? "",
      title: a ?? "",
      width: c,
      height: u,
      style: {
        minWidth: "100%",
        maxWidth: "100%",
        aspectRatio: c && u ? `${c}/${u}` : void 0
      },
      ...G
    }
  );
  return p != null && p.isUploading ? Z(V({ className: "animate-pulse" })) : Z(((G) => h ? /* @__PURE__ */ b("a", { className: "flex h-full w-full", href: h, onClick: (Q) => Q.preventDefault(), children: G }) : G)((() => {
    const G = d.includes("%") ? Number(d.split("%")[0]).toFixed(2) : void 0;
    return /* @__PURE__ */ j(ln, { children: [
      V({
        onMouseEnter: () => S(!0),
        onMouseLeave: () => S(!1),
        onClick: P,
        onMouseDownCapture: () => r({
          showBubbleMenu: !0
        }),
        "data-drag-handle": ""
      }),
      A && $ && !z && /* @__PURE__ */ j(ln, { children: [
        /* @__PURE__ */ b(
          bo,
          {
            onMouseDown: (Q) => Q.preventDefault(),
            className: K(
              "z-1 absolute -top-2.5 left-[5%] flex min-h-[24px] min-w-[24px] p-1"
            ),
            onClick: () => W(Zi.Before),
            children: /* @__PURE__ */ b(nh, { className: K("fill-background-secondary rotate-90") })
          }
        ),
        /* @__PURE__ */ b(
          bo,
          {
            onMouseDown: (Q) => Q.preventDefault(),
            className: K(
              "z-1 absolute -bottom-2.5 right-[5%] flex min-h-[24px] min-w-[24px] p-1"
            ),
            onClick: () => W(Zi.After),
            children: /* @__PURE__ */ b(nh, { className: K("fill-background-secondary rotate-90") })
          }
        )
      ] }),
      /* @__PURE__ */ j("div", { className: "absolute right-3 top-3 flex flex-col items-center justify-center gap-1.5", children: [
        h && /* @__PURE__ */ b(
          Fo,
          {
            className: "stroke-background-secondary h-[20px] w-[20px] rounded-sm bg-black/30"
          }
        ),
        m && /* @__PURE__ */ b(
          K$,
          {
            className: "stroke-background-secondary h-[20px] w-[20px] rounded-sm bg-black/30"
          }
        )
      ] }),
      g && G && /* @__PURE__ */ j(
        "span",
        {
          className: "text-background-secondary absolute left-3 bottom-3 bg-black/70 px-1 text-[10px]",
          children: [
            G,
            "%"
          ]
        }
      )
    ] });
  })()));
}, Cz = (n) => {
  var e, t;
  return n.style.cssText ? ((t = (e = n.style.cssText.split(";").map((i) => i.trim()).find((i) => i.startsWith("width"))) == null ? void 0 : e.split(":")[1]) == null ? void 0 : t.trim()) ?? "auto" : "auto";
}, Tz = (n) => {
  const e = n == null ? void 0 : n.getAttribute("src"), t = n == null ? void 0 : n.getAttribute("alt"), i = n == null ? void 0 : n.getAttribute("title"), r = n == null ? void 0 : n.getAttribute("width"), o = n == null ? void 0 : n.getAttribute("height");
  return {
    src: e,
    alt: t,
    title: i,
    width: r,
    height: o
  };
}, Oz = (n, e) => typeof (e == null ? void 0 : e.href) == "string" ? ["a", e, ["img", n]] : ["img", n], Ez = xt.create({
  name: "image",
  addOptions() {
    return {
      inline: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      imageMode: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      href: {
        default: null
      },
      containerWidth: {
        default: "auto"
      },
      showBubbleMenu: {
        default: !1
      },
      caption: {
        default: null
      },
      uploadingProps: {
        default: null
      },
      isMobileFullWidth: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["img", ke(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setImage: (n) => ({ commands: e }) => {
        let t;
        switch (n.imageMode) {
          case ce.Inline: {
            t = We.Inline;
            break;
          }
          case ce.BlockRight:
          case ce.BlockCenter: {
            t = We.Block;
            break;
          }
          default: {
            t = "image";
            break;
          }
        }
        return e.insertContent({
          type: t,
          attrs: n
        });
      },
      toggleImageMode: (n) => ({ tr: e, commands: t }) => {
        const { doc: i, selection: r } = e, { from: o, to: s } = r, a = sp(
          i,
          { from: o, to: s },
          (c) => c.type.name === We.Inline || c.type.name === We.Block
        );
        if (!a.length)
          return !1;
        const l = new Y6(e);
        return t.forEach(a, ({ node: c, pos: u }) => {
          const d = l.map(u);
          if (d.deleted)
            return !1;
          const h = {
            from: d.position,
            to: d.position + c.nodeSize
          }, f = t.insertContentAt(h, {
            type: n === ce.Inline ? We.Inline : We.Block,
            attrs: {
              ...c.attrs,
              imageMode: n,
              caption: n === ce.Inline ? void 0 : c.attrs.caption,
              float: n === ce.BlockRight ? "right" : null
            }
          }), p = d.position - 1;
          if (p >= 0) {
            const m = e.doc.nodeAt(p);
            (m == null ? void 0 : m.type.name) === "paragraph" && m.nodeSize === 2 && e.delete(p, p + m.nodeSize);
          }
          return n === ce.Inline && (c.attrs.imageMode === ce.BlockCenter || c.attrs.imageMode === ce.BlockRight) && t.setNodeSelection(o + 1), f;
        });
      }
    };
  }
}), gj = Ez.extend({
  name: We.Block,
  addNodeView() {
    return ji(wz);
  },
  parseHTML() {
    return [
      {
        // skip ckeditor's legacy - tables https://app.shortcut.com/systeme/story/53281/he-has-a-problem-with-one-of-his-campaigns-in-the-classic-editor-where-he-can-no-longer-find-the-content-of-his-emails
        tag: "figure:not(.table)",
        getAttrs: (n) => {
          const e = n.querySelector("img"), t = n.querySelector("a"), i = n.querySelector("figcaption"), r = t == null ? void 0 : t.getAttribute("href"), o = Tz(e), s = Cz(n), a = n.hasAttribute("is-mobile-full-width");
          return {
            imageMode: n != null && n.style.float ? ce.BlockRight : ce.BlockCenter,
            href: r,
            containerWidth: s,
            caption: i == null ? void 0 : i.textContent,
            isMobileFullWidth: a,
            ...o
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: {
      caption: n,
      href: e,
      imageMode: t,
      alt: i,
      src: r,
      title: o,
      width: s,
      height: a,
      containerWidth: l,
      uploadingProps: c,
      isMobileFullWidth: u
    }
  }) {
    if (c) return ["span", { style: "display: none;" }];
    const d = { ...wR };
    s && a && (d.aspectRatio = `${s}/${a}`), l !== "auto" && (d.width = l);
    const h = ke({
      src: r,
      alt: i,
      title: o,
      width: s,
      style: zt(d)
    }), p = [Oz(h, { href: e })];
    n && p.push([
      "figcaption",
      {
        style: zt(Y$)
      },
      n
    ]);
    const m = t === ce.BlockCenter ? {
      ...G$,
      ...l && { width: l }
    } : {
      ...J$(!1),
      ...l && { width: l }
    }, k = {
      style: zt(m)
    };
    u && (k["is-mobile-full-width"] = "true");
    const v = ["figure", k, ...p];
    return u ? [
      "div",
      { class: "is-mobile-full-width" },
      ["head", {}, ["style", { type: "text/css" }, xR]],
      v
    ] : v;
  }
}), _j = Ez.configure({ inline: !0 }).extend({
  name: We.Inline,
  inline: !0,
  addNodeView() {
    return ji(wz);
  },
  parseHTML() {
    return [
      {
        tag: "img",
        getAttrs: (n) => {
          const e = n.closest("a"), t = e == null ? void 0 : e.getAttribute("href"), i = Tz(n), r = Cz(n), o = n.closest("span.inline-image-wrapper"), s = (o == null ? void 0 : o.hasAttribute("is-mobile-full-width")) || !1;
          return {
            imageMode: ce.Inline,
            ...i,
            href: t,
            containerWidth: r,
            isMobileFullWidth: s
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: { href: n, alt: e, title: t, width: i, height: r, containerWidth: o, src: s, isMobileFullWidth: a }
  }) {
    const l = {};
    i && r && (l.aspectRatio = `${i}/${r}`), o !== "auto" && (l.width = o);
    const c = ke({
      src: s,
      alt: e,
      title: t,
      width: i,
      style: zt(l)
    }), u = Oz(c, { href: n });
    return a ? [
      "span",
      { class: "inline-image-wrapper is-mobile-full-width" },
      ["head", {}, ["style", { type: "text/css" }, SR]],
      u
    ] : u;
  }
}), bj = xt.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), Mz = (n = !1) => ({
  ...vR,
  ...n ? { marginTop: "1rem", marginBottom: "1rem" } : { marginTop: "0", marginBottom: "0" }
}), kj = ({ node: n }) => {
  const { textAlign: e, indent: t } = n.attrs, i = n.attrs[$r];
  return /* @__PURE__ */ b(
    "p",
    {
      "data-node-view-wrapper": "",
      style: {
        ...Mz(i),
        textAlign: e,
        marginLeft: `${t}px`
      },
      dir: "auto",
      children: /* @__PURE__ */ b(Rs, { as: "span" })
    }
  );
}, ih = (n) => n !== "0" && n !== "0px" && n !== "0rem" && n !== "0em" && n !== 0 && n !== "" && n !== null && n !== void 0 && n !== " ", yj = bj.extend({
  addAttributes() {
    return {
      [$r]: {
        default: !1,
        parseHTML: (n) => {
          if (!n.style) return !1;
          const e = ih(n.style.marginTop), t = ih(n.style.marginBottom);
          return e && t;
        }
      }
    };
  },
  addNodeView() {
    return ji(kj);
  },
  renderHTML({ HTMLAttributes: n, node: e }) {
    const t = e.attrs[$r], i = e.content.size === 0;
    return [
      "p",
      ke(n, {
        dir: "auto",
        style: zt(Mz(t))
      }),
      i ? ["br", { class: "trailingBreak" }] : 0
    ];
  }
}), vj = new Ve("restoreMarks"), xj = ZP.extend({
  addProseMirrorPlugins() {
    return [Sj()];
  }
}), Sj = () => new $e({
  key: vj,
  appendTransaction: (n, e, t) => {
    const i = n.some((l) => l.docChanged), r = !e.selection.eq(t.selection);
    if (!i && !r)
      return null;
    const { selection: o } = t, { $head: s } = o;
    if (s.parent.content.size === 0 || s.parent.content.size === 1 && s.parent.textContent === "") {
      let l = t.storedMarks || s.marks();
      if (!l || l.length === 0) {
        let c = s.pos - 1;
        for (; c > 0; ) {
          const d = t.doc.resolve(c).marks();
          if (d.length > 0) {
            l = d;
            break;
          }
          c--;
        }
      }
      if (l && l.length > 0) {
        const c = [
          "bold",
          "italic",
          "strike",
          "underline",
          "textStyle",
          "textColor",
          "textBackgroundColor",
          "fontSize",
          "fontFamily"
        ], u = l.filter((d) => c.includes(d.type.name));
        if (u.length > 0) {
          const d = t.tr;
          return d.setStoredMarks(u), d;
        }
      }
    }
    return null;
  }
}), $z = (n, e) => {
  var i;
  const t = {
    [T.Document]: kP,
    [T.Paragraph]: yj,
    [T.Text]: VP,
    [T.TextStyle]: xj,
    [T.FontFamily]: GP.configure({
      types: ["textStyle"]
    }),
    [T.Heading]: SP.extend({
      renderHTML({ node: r, HTMLAttributes: o }) {
        const a = [2, 3, 4].includes(r.attrs.level) ? r.attrs.level : 2;
        return [
          `h${a}`,
          ke(o, {
            dir: "auto",
            style: zt(fo[a])
          }),
          0
        ];
      }
    }),
    [T.Bold]: mP,
    [T.Italic]: PP,
    [T.Strike]: HP,
    [T.Underline]: WP,
    [T.BulletList]: _P.extend({
      addAttributes() {
        return {
          depth: {
            default: 0
          }
        };
      },
      addNodeView() {
        return ji(nj);
      },
      renderHTML({ HTMLAttributes: r }) {
        const { depth: o } = r;
        return [
          "ul",
          ke(r, {
            style: zt({
              ...Bo,
              listStyleType: fz(o)
            })
          }),
          0
        ];
      }
    }),
    [T.OrderedList]: BP.extend({
      addAttributes() {
        return {
          depth: {
            default: 0
          }
        };
      },
      addNodeView() {
        return ji(ij);
      },
      renderHTML({ HTMLAttributes: r }) {
        const { depth: o } = r;
        return [
          "ol",
          ke(r, {
            style: zt({
              ...Bo,
              listStyleType: pz(o)
            })
          }),
          0
        ];
      }
    }),
    [T.ListItem]: tj,
    [T.TextAlign]: UP.configure({
      types: ["heading", "paragraph", "listItem"],
      alignments: ["left", "center", "right", "justify"]
    }),
    [T.Link]: Cd(e == null ? void 0 : e[T.Link]).configure({
      openOnClick: !1
    }),
    [T.SimpleLink]: Cd(e == null ? void 0 : e[T.Link]).configure({
      HTMLAttributes: {
        rel: "noopener noreferrer"
      }
    }),
    [T.History]: LP,
    [T.TextColor]: oj,
    [T.TextBackgroundColor]: rj,
    [T.FontSize]: YP.configure({
      defaultFontSize: (i = e == null ? void 0 : e[T.FontSize]) != null && i.clearable ? null : kR
    }),
    [T.Indent]: KI,
    [T.HardBreak]: Wd.extend({
      addAttributes() {
        return {
          class: {
            default: null,
            parseHTML: (r) => r.getAttribute("class"),
            renderHTML: (r) => r.class ? { class: r.class } : {}
          }
        };
      }
    }),
    [T.SimpleHardBreak]: Wd.extend({
      addKeyboardShortcuts() {
        return {
          Enter: () => this.editor.commands.setHardBreak()
        };
      }
    }),
    [T.Substitution]: null,
    [T.SpecialCharacters]: null,
    [T.Image]: [gj, _j],
    [T.DropCursor]: xP,
    [T.CharacterCount]: bP
  };
  return n.flatMap((r) => {
    const o = t[r];
    return Array.isArray(o) ? o : [o];
  }).filter((r) => r !== null);
}, zz = (n) => Object.values(T).reduce(
  (e, t) => ({
    ...e,
    [`has${T[t]}`]: n.includes(t)
  }),
  {}
), bs = [
  T.History,
  [
    T.Heading,
    T.FontFamily,
    T.FontSize,
    T.TextColor,
    T.TextBackgroundColor
  ],
  [
    T.Paragraph,
    T.Indent,
    T.TextAlign,
    T.Substitution
  ],
  [
    T.Bold,
    T.Italic,
    T.Underline,
    T.Strike,
    T.BulletList,
    T.OrderedList
  ],
  [T.Link, T.Image, T.SpecialCharacters]
], rh = ({
  extension: n,
  source: e,
  skipRef: t,
  withRightBorder: i,
  inTooltip: r
}) => {
  const o = e.filter((s) => s.key === n);
  return o.length ? o.map((s, a) => /* @__PURE__ */ b(
    "div",
    {
      ref: t ? void 0 : s.ref,
      className: Ee(
        a === o.length - 1 && i && "border-r border-text-secondary/30 last-of-type:border-r-0",
        "flex items-center",
        !r && "px-px first-of-type:pl-0 last-of-type:pr-0"
      ),
      children: r ? s.toolbarItem.tooltipRender : s.toolbarItem.toolbarRender
    },
    `${s.key}-${a}`
  )) : null;
}, La = ({
  source: n,
  skipBorder: e,
  skipRef: t,
  inTooltip: i
}) => bs.flatMap((r, o) => {
  const s = o === bs.length - 1;
  return Array.isArray(r) ? r.flatMap((a, l) => rh({
    extension: a,
    source: n,
    skipRef: t,
    withRightBorder: !e && !s && l === r.length - 1,
    inTooltip: i
  })) : rh({
    extension: r,
    source: n,
    skipRef: t,
    withRightBorder: !e && !s,
    inTooltip: i
  });
}), wj = ({
  substitutions: n,
  extensions: e,
  editor: t,
  toolbarStyles: i,
  fileSource: r,
  toolbarClassName: o,
  showAllItems: s = !1,
  extensionOption: a
}) => {
  const {
    hasHistory: l,
    hasHeading: c,
    hasIndent: u,
    hasTextAlign: d,
    hasLink: h,
    hasTextColor: f,
    hasFontSize: p,
    hasTextBackgroundColor: m,
    hasFontFamily: g,
    hasSubstitution: k,
    hasSpecialCharacters: v,
    hasImage: S,
    hasOrderedList: _,
    hasBulletList: x,
    hasListItem: y,
    hasBold: w,
    hasItalic: $,
    hasUnderline: A,
    hasStrike: z,
    hasParagraph: I,
    hasSimpleHardBreak: L
  } = zz(e), P = Oi(null), q = Oi(null), [W, B] = xe([]), [, Z] = Hz(), V = Oi([]), pe = FI(t, r), me = jI(t), G = ZI(t), Q = GI(t), X = nP(t), ze = II(t), Te = tP(t, n), Ae = no(t, He.Bold), oe = no(t, He.Italic), be = no(t, He.Underline), Pe = no(t, He.Strike), tt = RI(
    t,
    a == null ? void 0 : a[T.FontSize]
  ), Kt = Id(t, un.OrderedList), jn = Id(t, un.BulletList), dn = LI(
    t,
    a == null ? void 0 : a[T.FontFamily]
  ), Bn = rP(
    t,
    a == null ? void 0 : a[T.TextColor]
  ), Fn = iP(
    t,
    a == null ? void 0 : a[T.TextBackgroundColor]
  ), hn = eP(t), fn = $I(t), nt = we(() => {
    const ye = [], te = (it, Et) => {
      Array.isArray(it) ? it.forEach((ct) => {
        ye.push({
          toolbarItem: ct,
          ref: _e.createRef(),
          key: Et
        });
      }) : ye.push({
        toolbarItem: it,
        ref: _e.createRef(),
        key: Et
      });
    };
    return I && !L && te(fn, T.Paragraph), l && te(me, T.History), S && te(pe, T.Image), h && te(Q, T.Link), u && te(G, T.Indent), d && te(X, T.TextAlign), c && te(ze, T.Heading), k && te(Te, T.Substitution), w && te(Ae, T.Bold), $ && te(oe, T.Italic), A && te(be, T.Underline), z && te(Pe, T.Strike), p && te(tt, T.FontSize), _ && y && te(Kt, T.OrderedList), x && y && te(jn, T.BulletList), g && te(dn, T.FontFamily), f && te(Bn, T.TextColor), m && te(Fn, T.TextBackgroundColor), v && te(hn, T.SpecialCharacters), ye;
  }, [
    I,
    L,
    fn,
    l,
    me,
    S,
    pe,
    h,
    Q,
    u,
    G,
    d,
    X,
    c,
    ze,
    k,
    Te,
    w,
    Ae,
    $,
    oe,
    A,
    be,
    z,
    Pe,
    p,
    tt,
    _,
    y,
    Kt,
    x,
    jn,
    g,
    dn,
    f,
    Bn,
    m,
    Fn,
    v,
    hn
  ]), qn = (ye, te) => ye.length === te.length && ye.every((it, Et) => it === te[Et]);
  Ge(() => {
    const ye = () => {
      var Ir;
      if (!P.current) return;
      if (s) {
        const At = nt.map((gn) => gn.key);
        qn(V.current, At) || (V.current = At, Z(() => B(At)));
        return;
      }
      const it = P.current.clientWidth, Et = [...nt].sort(
        (At, gn) => bs.flatMap((Hn) => Hn).indexOf(At.key) - bs.flatMap((Hn) => Hn).indexOf(gn.key)
      ), ct = [];
      let pn = 0, mn = !1;
      const qs = ((Ir = q.current) == null ? void 0 : Ir.offsetWidth) ?? 0;
      for (const At of Et) {
        const gn = At.ref.current;
        if (!gn) continue;
        const Hn = gn.offsetWidth, C = pn + Hn;
        !mn && C <= it ? (ct.push(At.key), pn = C) : mn = !0;
      }
      mn && ct.length > 0 && pn + qs > it && ct.pop(), qn(V.current, ct) || (V.current = ct, Z(() => B(ct)));
    }, te = new ResizeObserver(ye);
    return P.current && te.observe(P.current), ye(), () => {
      te.disconnect();
    };
  }, [nt, s]);
  const Tt = we(
    () => nt.filter((ye) => W.includes(ye.key)),
    [nt, W]
  ), Ot = we(
    () => nt.filter((ye) => !W.includes(ye.key)),
    [nt, W]
  );
  return /* @__PURE__ */ j(
    "div",
    {
      style: i,
      className: K(
        "border-text-secondary/30 z-sticky bg-background-secondary sticky top-0 flex items-center rounded-t-lg border border-b-0 p-1",
        o
      ),
      children: [
        /* @__PURE__ */ j(
          "div",
          {
            ref: P,
            className: K("flex w-full", s && "flex-wrap gap-1"),
            children: [
              La({ source: Tt, skipRef: !0 }),
              /* @__PURE__ */ b(
                "div",
                {
                  ref: q,
                  className: Ee(
                    "ml-auto flex items-center",
                    Ot.length > 0 ? "visible" : "invisible",
                    s && "hidden"
                  ),
                  children: /* @__PURE__ */ b(
                    go,
                    {
                      anchor: "bottom end",
                      className: "main-transition-colors data-[open]:bg-brand-primary/10 group h-7 rounded-lg px-2",
                      label: /* @__PURE__ */ b(ln, { children: La({
                        source: Ot,
                        skipRef: !0,
                        skipBorder: !0,
                        inTooltip: !0
                      }) }),
                      children: /* @__PURE__ */ b(Zz, { className: "group-hover:fill-brand-primary main-transition-colors" })
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ b("div", { className: "pointer-events-none absolute left-0 top-0 flex h-0 overflow-hidden opacity-0", children: La({ source: nt }) }),
        nt.filter(({ toolbarItem: ye }) => ye.additionalRender).map(({ toolbarItem: ye, key: te }) => /* @__PURE__ */ b(Vz, { children: ye.additionalRender }, `${te}-additional-render`))
      ]
    }
  );
}, Cj = ({
  mode: n = "html",
  content: e,
  isPreFetching: t,
  isEditable: i = !0,
  substitutions: r,
  extensions: o = ks,
  className: s,
  fileSource: a = Bz.TextEditor,
  toolbarStyles: l,
  characterCountHint: c,
  style: u,
  toolbarClassName: d,
  extensionOption: h,
  showAllItems: f,
  skeletonClassName: p,
  defaultFont: m = Bs.TimesNewRoman,
  onBlur: g,
  onChange: k
}) => {
  var P;
  const { onDrop: v, onPaste: S } = uI(a), [_, x] = xe(!1), y = n === "html" ? "getHTML" : "getText", w = Array.from(new Set(o)), { hasLink: $, hasImage: A, hasCharacterCount: z, hasSimpleLink: I } = zz(w), L = J4({
    content: e,
    immediatelyRender: !1,
    onCreate: () => x(!0),
    extensions: $z(w, h),
    onUpdate: ({ editor: q }) => _ && k(q.isEmpty ? "" : q[y]()),
    onBlur: ({ editor: q }) => _ && (g == null ? void 0 : g(q.isEmpty ? "" : q[y]())),
    editorProps: {
      handlePaste: A ? S : void 0,
      handleDrop: A ? v : void 0,
      attributes: {
        class: K(
          "border",
          "border-text-secondary/30",
          "main-transition-colors",
          "min-h-[500px]",
          "w-full",
          "focus:outline-hidden",
          "focus:border-brand-primary",
          "overflow-auto",
          "rounded-b-lg",
          !i && "pointer-events-none cursor-default",
          s
        ),
        style: zt({
          paddingLeft: gd,
          paddingRight: gd,
          fontFamily: m,
          ...u
        })
      }
    }
  });
  return MI({
    editor: L,
    content: e,
    shouldInitialize: I && n === "text"
  }), Ge(() => {
    L && L.setOptions({ editable: i && !t });
  }, [i, t, L]), Ge(() => {
    if (!L) return;
    const q = s5(() => {
      L[y]() !== e && L.commands.setContent(e ?? "", !1);
    }, 300);
    return q(), () => {
      q.cancel();
    };
  }, [e, L, y]), rI(L, (P = h == null ? void 0 : h[T.Link]) == null ? void 0 : P.color), L != null && L.isInitialized ? /* @__PURE__ */ j("div", { className: "relative", children: [
    o.length !== 0 && /* @__PURE__ */ b(
      wj,
      {
        editor: L,
        substitutions: r,
        extensions: w,
        toolbarStyles: l,
        fileSource: a,
        toolbarClassName: d,
        showAllItems: f,
        extensionOption: h
      }
    ),
    /* @__PURE__ */ b(B4, { editor: L }),
    $ && /* @__PURE__ */ b(LR, { editor: L, fileSource: a }),
    A && /* @__PURE__ */ b(AR, { fileSource: a, editor: L }),
    z && /* @__PURE__ */ b(
      a5,
      {
        editor: L,
        hint: c,
        className: "ml-auto mt-2 mr-2 w-fit"
      }
    )
  ] }) : /* @__PURE__ */ b(
    "div",
    {
      className: K(
        "bg-background-tertiary h-[500px] w-full animate-pulse rounded-lg",
        p
      )
    }
  );
}, Tj = (n, e, t) => {
  const i = n[e];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((r, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      o.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, Az = "common", Oj = Sl(null), Ej = async (n) => {
  try {
    const e = await Tj(/* @__PURE__ */ Object.assign({ "../translations/locales/ar/common.json": () => Promise.resolve().then(() => B5), "../translations/locales/cs/common.json": () => Promise.resolve().then(() => F5), "../translations/locales/da/common.json": () => Promise.resolve().then(() => q5), "../translations/locales/de/common.json": () => Promise.resolve().then(() => H5), "../translations/locales/el/common.json": () => Promise.resolve().then(() => V5), "../translations/locales/en/common.json": () => Promise.resolve().then(() => U5), "../translations/locales/es/common.json": () => Promise.resolve().then(() => W5), "../translations/locales/fr/common.json": () => Promise.resolve().then(() => K5), "../translations/locales/hi/common.json": () => Promise.resolve().then(() => Z5), "../translations/locales/hu/common.json": () => Promise.resolve().then(() => G5), "../translations/locales/id/common.json": () => Promise.resolve().then(() => J5), "../translations/locales/it/common.json": () => Promise.resolve().then(() => Y5), "../translations/locales/ja/common.json": () => Promise.resolve().then(() => X5), "../translations/locales/nl/common.json": () => Promise.resolve().then(() => Q5), "../translations/locales/no/common.json": () => Promise.resolve().then(() => eR), "../translations/locales/pl/common.json": () => Promise.resolve().then(() => tR), "../translations/locales/pt/common.json": () => Promise.resolve().then(() => nR), "../translations/locales/ro/common.json": () => Promise.resolve().then(() => iR), "../translations/locales/ru/common.json": () => Promise.resolve().then(() => rR), "../translations/locales/sk/common.json": () => Promise.resolve().then(() => oR), "../translations/locales/sl/common.json": () => Promise.resolve().then(() => sR), "../translations/locales/sq/common.json": () => Promise.resolve().then(() => aR), "../translations/locales/sr/common.json": () => Promise.resolve().then(() => lR), "../translations/locales/sv/common.json": () => Promise.resolve().then(() => cR), "../translations/locales/th/common.json": () => Promise.resolve().then(() => uR), "../translations/locales/tr/common.json": () => Promise.resolve().then(() => dR), "../translations/locales/uk/common.json": () => Promise.resolve().then(() => hR), "../translations/locales/zh/common.json": () => Promise.resolve().then(() => fR) }), `../translations/locales/${n}/common.json`, 5);
    return M.addResourceBundle(n, Az, e.default), e;
  } catch (e) {
    return console.warn(`Failed to load language bundle for ${n}`, e), null;
  }
}, Jj = ({
  children: n,
  languageCode: e
}) => {
  const [t, i] = xe(e), r = Uz((o) => {
    M.hasResourceBundle(o, Az) ? (M.changeLanguage(o), i(o)) : Ej(o).then(() => {
      M.changeLanguage(o), i(o);
    });
  }, []);
  return Ge(() => {
    M.isInitialized && r(e);
  }, [e, r]), /* @__PURE__ */ b(Oj.Provider, { value: { currentLanguageCode: t, changeLocale: r }, children: n });
};
function an(n, e) {
  if (!n && !e)
    throw new Error("Cannot add a null child to a null parent.");
  return e && (n.content || (n.content = []), Array.isArray(e) ? n.content.push.apply(n.content, e) : n.content.push(e)), n;
}
function oh(n, e) {
  if (!n && !e)
    throw new Error("Cannot add a null mark to a null node.");
  return e && (n.marks || (n.marks = []), Array.isArray(e) ? n.marks.push.apply(n.marks, e) : n.marks.push(e)), n;
}
function Se(n, e) {
  return { type: n, ...e };
}
function Mj() {
  return { type: "doc", content: [] };
}
function dr(n, e) {
  return { type: "text", text: n, marks: e || [] };
}
function $j(n) {
  return "style" in n;
}
function zj(n) {
  return !!(n && (n.type === "bulletList" || n.type === "orderedList"));
}
var sh = function({
  doc: n,
  getCurrentBlock: e,
  entityMap: t,
  peek: i,
  next: r,
  converter: o
}) {
  var a, l;
  const s = e().type === "unordered-list-item" ? Se("bulletList") : Se("orderedList");
  for (; ; ) {
    let c = s;
    const u = e();
    let d = 0;
    for (; d < u.depth; ) {
      (a = c.content) != null && a.length || (c.content = []);
      let f = c.content[c.content.length - 1];
      f || (f = Se("listItem"), an(c, f));
      let p = (l = f.content) == null ? void 0 : l[f.content.length - 1];
      if (zj(p))
        c = p, d++;
      else {
        p = u.type === "unordered-list-item" ? Se("bulletList") : Se("orderedList"), an(f, p), c = p;
        break;
      }
    }
    an(
      c,
      Se("listItem", {
        content: [
          Se("paragraph", {
            content: o.splitTextByEntityRangesAndInlineStyleRanges({
              doc: n,
              block: e(),
              entityMap: t
            })
          })
        ]
      })
    );
    const h = i();
    if (!(h && h.type === "unordered-list-item" || h && h.type === "ordered-list-item") || h && h.type !== u.type)
      break;
    r();
  }
  return s;
}, vi = function({
  block: n,
  entityMap: e,
  converter: t,
  doc: i
}) {
  const r = {
    "header-one": 1,
    "header-two": 2,
    "header-three": 3,
    "header-four": 4,
    "header-five": 5,
    "header-six": 6
  }[n.type];
  return Se("heading", {
    attrs: { level: r || 1 },
    content: t.splitTextByEntityRangesAndInlineStyleRanges({
      block: n,
      entityMap: e,
      doc: i
    })
  });
}, Aj = function({
  doc: n,
  getCurrentBlock: e,
  entityMap: t,
  converter: i,
  peek: r,
  next: o
}) {
  var c;
  const s = Se("table");
  let a = Se("tableRow"), l = e();
  do {
    if (l.depth + 1 !== e().depth && (a = Se("tableRow"), an(s, a)), an(
      a,
      Se("tableCell", {
        content: [
          Se("paragraph", {
            content: i.splitTextByEntityRangesAndInlineStyleRanges({
              doc: n,
              block: e(),
              entityMap: t
            })
          })
        ]
      })
    ), ((c = r()) == null ? void 0 : c.type) !== "table-cell")
      break;
    l = o();
  } while (!0);
  return s;
}, ah = {
  atomic({ doc: n, block: e, entityMap: t, converter: i }) {
    if (e.entityRanges.length === 0 && e.inlineStyleRanges.length === 0)
      return dr(e.text);
    const r = Se("paragraph"), o = e.entityRanges.map((s) => i.mapEntityToNode({
      doc: n,
      block: e,
      range: s,
      entityMap: t,
      converter: i
    })).filter(Boolean);
    return o.length === 0 ? null : an(r, o);
  },
  "code-block"({ block: n }) {
    return Se("codeBlock", {
      content: [dr(n.text)]
    });
  },
  blockquote({ doc: n, block: e, entityMap: t, converter: i }) {
    return Se("blockquote", {
      content: [
        Se("paragraph", {
          content: i.splitTextByEntityRangesAndInlineStyleRanges({
            doc: n,
            block: e,
            entityMap: t
          })
        })
      ]
    });
  },
  unstyled({ doc: n, block: e, entityMap: t, converter: i }) {
    const r = Se("paragraph");
    return e.inlineStyleRanges.length === 0 && e.entityRanges.length === 0 ? an(r, dr(e.text)) : an(
      r,
      i.splitTextByEntityRangesAndInlineStyleRanges({
        doc: n,
        block: e,
        entityMap: t
      })
    );
  },
  "unordered-list-item": sh,
  "ordered-list-item": sh,
  "header-one": vi,
  "header-two": vi,
  "header-three": vi,
  "header-four": vi,
  "header-five": vi,
  "header-six": vi,
  "table-cell": Aj
}, Lj = function(n) {
  const e = n.getCurrentBlock();
  return ah[e.type] ? ah[e.type](n) : null;
}, lh = {
  LINK: ({ entity: n }) => ({
    type: "link",
    attrs: {
      href: n.data.url,
      target: n.data.target
    }
  })
}, Nj = function({
  range: { key: n },
  entityMap: e,
  converter: t
}) {
  return lh[e[n].type] ? lh[e[n].type]({
    entity: e[n],
    converter: t
  }) : null;
}, ch = {
  HORIZONTAL_RULE: () => Se("horizontalRule"),
  IMAGE: ({ entity: n }) => Se("image", {
    attrs: {
      src: n.data.src,
      alt: n.data.alt
    }
  })
}, Dj = function({
  range: { key: n },
  entityMap: e,
  converter: t
}) {
  return ch[e[n].type] ? ch[e[n].type]({
    entity: e[n],
    converter: t
  }) : null;
}, uh = {
  BOLD: { type: "bold" },
  CODE: { type: "code" },
  KEYBOARD: { type: "code" },
  ITALIC: { type: "italic" },
  STRIKETHROUGH: { type: "strike" },
  UNDERLINE: { type: "underline" },
  SUBSCRIPT: { type: "subscript" },
  SUPERSCRIPT: { type: "superscript" },
  HIGHLIGHT: { type: "highlight" }
}, Rj = function({
  range: { style: n }
}) {
  return uh[n] ? uh[n] : n.startsWith("bgcolor-") ? {
    type: "highlight",
    attrs: {
      color: n.replace("bgcolor-", "")
    }
  } : n.startsWith("fontfamily-") ? {
    type: "textStyle",
    attrs: {
      fontFamily: n.replace("fontfamily-", "")
    }
  } : null;
}, dh = class {
  constructor(n) {
    /**
     * Any unmatched blocks, entities, or inline styles that were not converted.
     */
    Zt(this, "unmatched", {
      blocks: [],
      entities: {},
      inlineStyles: []
    });
    Zt(this, "options");
    Zt(this, "createNode", Se);
    Zt(this, "addChild", an);
    Zt(this, "createText", dr);
    Zt(this, "addMark", oh);
    Zt(this, "mapBlockToNode", (n) => {
      let e = null;
      try {
        e = this.options.mapBlockToNode.call(this, n) ?? null;
      } catch (t) {
        console.error(t);
      }
      return e === null && this.unmatched.blocks.push(n.getCurrentBlock()), e;
    });
    Zt(this, "mapEntityToNode", ({ range: n, entityMap: e, doc: t, block: i }) => {
      try {
        const r = this.options.mapEntityToNode({
          range: n,
          entityMap: e,
          converter: this,
          doc: t,
          block: i
        });
        if (r)
          return r;
      } catch (r) {
        console.error(r);
      }
      return this.unmatched.entities[n.key] = e[n.key], null;
    });
    this.options = {
      mapBlockToNode: Lj,
      mapInlineStyleToMark: Rj,
      mapEntityToMark: Nj,
      mapEntityToNode: Dj,
      ...n
    };
  }
  mapRangeToMark({
    range: n,
    entityMap: e,
    doc: t,
    block: i
  }) {
    if ($j(n)) {
      try {
        const r = this.options.mapInlineStyleToMark({
          range: n,
          converter: this,
          doc: t,
          block: i
        }) ?? null;
        if (r)
          return r;
      } catch (r) {
        console.error(r);
      }
      return this.unmatched.inlineStyles.push(n), null;
    }
    try {
      const r = this.options.mapEntityToMark({
        range: n,
        entityMap: e,
        converter: this,
        doc: t,
        block: i
      }) ?? null;
      if (r)
        return r;
    } catch (r) {
      console.error(r);
    }
    return this.unmatched.entities[n.key] = e[n.key], null;
  }
  /**
   * This function splits a text into Nodes based on the entity ranges and inline style ranges.
   * Applying them as marks to the text. Which may overlap in their ranges.
   */
  splitTextByEntityRangesAndInlineStyleRanges(n) {
    const e = [
      ...n.block.entityRanges,
      ...n.block.inlineStyleRanges
    ].sort((a, l) => a.offset === l.offset ? a.length - l.length : a.offset - l.offset);
    let t = [], i = {};
    for (let a of e)
      for (let l = a.offset; l < a.offset + a.length; l++)
        i[l] || (i[l] = []), i[l].push(a);
    let r = [], o = "";
    const s = Array.from(n.block.text);
    for (let a = 0; a < s.length; a++) {
      let l = i[a] || [];
      (l.length !== r.length || !l.every((c) => r.includes(c))) && (o && t.push({ text: o, ranges: r }), o = "", r = l), o += s[a];
    }
    return o && t.push({ text: o, ranges: r }), t.map(({ text: a, ranges: l }) => {
      const c = dr(a);
      return l.forEach(
        (u) => oh(
          c,
          this.mapRangeToMark({
            range: u,
            entityMap: n.entityMap,
            doc: n.doc,
            block: n.block
          })
        )
      ), c;
    });
  }
  convert(n) {
    this.unmatched = {
      blocks: [],
      entities: {},
      inlineStyles: []
    };
    const e = Mj();
    let t = 0;
    const i = {
      get index() {
        return t;
      },
      setIndex: (r) => {
        t = r;
      },
      get block() {
        return n.blocks[t];
      },
      allBlocks: n.blocks,
      get doc() {
        return e;
      },
      entityMap: n.entityMap,
      peek: () => n.blocks[t + 1] || null,
      peekPrev: () => n.blocks[t - 1] || null,
      getCurrentBlock: () => n.blocks[t],
      next: () => n.blocks[t++] || null,
      prev: () => n.blocks[t--] || null,
      converter: this
    };
    for (; t < n.blocks.length; t++) {
      const r = this.mapBlockToNode.call(this, i);
      typeof r != "boolean" && r && this.addChild(e, r);
    }
    return e;
  }
};
const Lz = (n) => (Array.isArray(n.content) && (n.content = n.content.map(Lz).filter((e) => !(e.type === "text" && (!e.text || e.text === "")))), n), Nz = (n, e) => {
  var t;
  if (Array.isArray(n.content) && (n.content = n.content.map((i) => Nz(i, e))), (n.type === "paragraph" || n.type === "listItem" || n.type === "heading") && (e != null && e.textAlign) && (n.attrs = {
    ...n.attrs,
    textAlign: e.textAlign
  }), n.type === "text") {
    const i = ((t = n.marks) == null ? void 0 : t.slice()) || [], r = i.filter((a) => a.type === "textStyle"), o = i.filter((a) => a.type !== "textStyle"), s = r.reduce(
      (a, l) => ({
        ...a,
        ...l.attrs
      }),
      {}
    );
    if (e != null && e.fontFamily && (s.fontFamily = e.fontFamily), Object.keys(s).length > 0) {
      const a = {
        type: "textStyle",
        attrs: s
      };
      n.marks = [...o, a];
    } else
      n.marks = o;
  }
  return n;
}, Yj = ({
  draftContent: n,
  extension: e,
  additionalStyles: t,
  options: i
}) => {
  const r = new dh(), o = r.options.mapInlineStyleToMark;
  try {
    const s = typeof n == "string" ? JSON.parse(n) : n;
    s.blocks = s.blocks.map((h) => {
      var f;
      return h.type === "section" ? { ...h, type: "unstyled" } : h.type === "code-block" ? ((f = i == null ? void 0 : i.logger) == null || f.call(i, "code-block converted to paragraph (no code block node in schema)"), { ...h, type: "unstyled" }) : h;
    });
    const l = new dh({
      mapBlockToNode: (h) => {
        var f, p;
        return (p = (f = r.options).mapBlockToNode) == null ? void 0 : p.call(f, h);
      },
      mapInlineStyleToMark: (h) => {
        var f, p, m;
        return (f = h.range.style) != null && f.includes("rgba") ? {
          type: "textStyle",
          attrs: {
            color: Tl(h.range.style)
          }
        } : (p = h.range.style) != null && p.startsWith("FONT_SIZE_") ? {
          type: "textStyle",
          attrs: {
            fontSize: h.range.style.replace("FONT_SIZE_", "") + "px"
          }
        } : h.range.style === "CODE" ? ((m = i == null ? void 0 : i.logger) == null || m.call(i, "CODE inline style converted to plain text (no code mark in schema)"), null) : o == null ? void 0 : o(h);
      }
    }).convert(s), c = Nz(l, t), u = Array.from(new Set(e.list));
    return c6(
      Lz(c),
      $z(u, e.options)
    );
  } catch (s) {
    if (i != null && i.throwErrors)
      throw s;
    return console.error(s), "";
  }
}, Xj = (n) => {
  var e, t, i;
  return /* @__PURE__ */ b(
    Cj,
    {
      defaultFont: Bs.Arial,
      ...n,
      extensionOption: {
        ...n.extensionOption,
        [T.TextColor]: {
          ...(e = n.extensionOption) == null ? void 0 : e[T.TextColor],
          showAlpha: !1
        },
        [T.TextBackgroundColor]: {
          ...(t = n.extensionOption) == null ? void 0 : t[T.TextBackgroundColor],
          showAlpha: !1
        },
        [T.FontFamily]: {
          ...(i = n.extensionOption) == null ? void 0 : i[T.FontFamily],
          noFontFamilyElement: /* @__PURE__ */ b(wl, { label: M.t("font_family.mailbox_default_hint"), children: M.t("font_family.mailbox_default") })
        }
      }
    }
  );
};
export {
  T as EditorExtensionEnum,
  Bs as FontFamilyEnum,
  Cj as TipTapEditor,
  Xj as TipTapEmailEditor,
  Jj as TipTapLocaleProvider,
  Jz as advancedTextEditorExtensions,
  ks as baseExtensions,
  Yj as convertDraftToTiptap,
  Kj as emailTextExtensions,
  Zj as extensionsForSms,
  je as getFontFamilyCode,
  zI as getFontFamilyLabel,
  AI as getFontFamilyOptionsData,
  Gz as simpleTextExtensions
};
